<!-- компонент List: список -->
<template>
<!-- строим содержимое только если пользователь аутентифицирован -->
<div v-if="this.$store.state.is_auth">
	<!-- если нет никаких ошибок -->
	<template v-if="!form_ErrorMessage">
	
		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>

		<!-- заголовки таблицы (не для всех) -->
		<h4 v-if="listData && listData.title && (crud === 'ipptrpool' || crud === 'iphistory')" style="margin-top: 20px">{{ listData.title | ftc }}</h4>

		<!-- ГЛАВНЫЙ БЛОК КОМПОНЕНТА -->
		<div v-if="listConfig" key="mainBlock">
			<!-- Блок быстрого поиска и фильтров -->
			<div class="search-and-filters">
				<!-- Быстрый поиск -->
				<div v-if="listConfig['fast_search'] !== false" class="form-inline fast-search">
					<Field
						:isVisibleRow="true"
						:crud="crud"
						action="list"
						name="fastSearch"
						ref="fastSearch"
						v-model="fastSearchValue"
						:Field="{ _field_name: 'fastSearch', type: 'text', title: 'main/all_fields_search', '_visible': true }"
						:removeRightPadding="true"
						:clearButton="true" @event_ClearButtonClicked="fastSearchClear"
						class="fast-search-input"
						:class="{ 'logs': $store.state.user_type === 'admin' && crud === 'logs' }"
						@fastSearchInput="fastSearchEvent" />

					<Field v-if="$store.state.user_type === 'admin' && crud === 'logs'"
						:isVisibleRow="true"
						:crud="crud"
						action="list"
						name="ipBlackList"
						ref="ipBlackList"
						v-model="ipBlackListValue"
						:Field="{ _field_name: 'ipBlackList', type: 'text', title: 'main/ip', '_visible': true }"
						:removeRightPadding="true"
						:searchButton="true" @event_SearchButtonClicked="ipBlackListClick"
						@enterKeyDown="ipBlackListClick"
						class="ip-list-input" />
				</div>

				<!-- ссылки на фильтры -->
				<div class="form-inline filter-links-block">
					<!-- ссылка на фильтр по периоду -->
					<span
						v-if="listConfig && listConfig['filters'] && listConfig['filters']['period'] && filters['period']['visible'] !== -1"
						@click="toggleFilter('period')"
						class="widget-link"
						:class="{ 'widget-link-grayed': filters['period']['visible'] === true }">
						{{ 'filter/period' | ftc }}
					</span>
					<!-- ссылка на фильтры-radio (их может быть несколько) -->
					<template v-if="listConfig && listConfig['filters'] && listConfig['filters']['radio'] && filters.radio">
						<template v-for="(radio, idx) in filters.radio">
							<span v-if="radio.visible !== -1"
								@click="toggleFilter('radio', idx)"
								class="widget-link"
								:key="'radio-filter' + idx"
								:class="{ 'widget-link-grayed': filters['radio'][idx]['visible'] === true }">
								{{ radio.title | ftc | capitalize }}
							</span>
						</template>
					</template>
					<!-- ссылка на фильтры-select (их может быть несколько) -->
					<template v-if="listConfig && listConfig['filters'] && listConfig['filters']['select'] && filters.select">
						<template v-for="(select, idx) in filters.select">
							<span v-if="select.visible !== -1"
								@click="toggleFilter('select', idx)"
								class="widget-link"
								:key="'select-filter' + idx"
								:class="{ 'widget-link-grayed': filters['select'][idx]['visible'] === true, 'hidden': crud === 'document' && $store.state.user_type === 'admin' && !accountGlobalFilter }">
								{{ select.title | ftc | capitalize }}
							</span>
						</template>
					</template>
					<!-- ссылка на фильтр ticket-label -->
					<span
						v-if="listConfig && listConfig['filters'] && listConfig['filters']['ticketLabel'] && filters['ticketLabel']['visible'] !== -1"
						@click="toggleFilter('ticketLabel')"
						class="widget-link"
						:class="{ 'widget-link-grayed': filters['ticketLabel']['visible'] === true }">
						{{ 'ticket/label' | ftc }}
					</span>
					<!-- ссылка на фильтр disk-type -->
					<span
						v-if="listConfig && listConfig['filters'] && listConfig['filters']['diskType'] && filters['diskType']['visible'] !== -1"
						@click="toggleFilter('diskType')"
						class="widget-link"
						:class="{ 'widget-link-grayed': filters['diskType']['visible'] === true }">
						{{ 'main/type' | ftc }}
					</span>
					<!-- ссылка на фильтр my-tickets -->
					<span
						v-if="listConfig && listConfig['filters'] && listConfig['filters']['myTickets'] && !isCrudFilterOnMyTicket"
						@click="myTicketsActivate"
						class="widget-link">
						{{ 'ticket/mine_tickets' | ftc }}
					</span>
					<!-- ссылка на фильтр plan-params -->
					<span
						v-if="listConfig && listConfig['filters'] && listConfig['filters']['planParams'] && filters['planParams']['visible'] !== -1"
						@click.stop="toggleFilter('planParams')"
						class="widget-link"
						:class="{ 'widget-link-grayed': filters['planParams']['visible'] === true }">
						{{ 'main/parameters' | ftc }}
					</span>
					<!-- сам фильтр типа Bool -->
					<filterBool
						v-if="listConfig && listConfig['filters'] && listConfig['filters']['bool'] && filters.bool.visible !== -1"
						name="switcher"
						:titleTrue="listConfig['filters']['bool']['title_true']"
						:titleFalse="listConfig['filters']['bool']['title_false']"
						:value="filters.bool.value"
						@input="filterBoolEvent" />
					<!-- ссылка на фильтры-logs -->
					<span
						v-if="listConfig && listConfig['filters'] && listConfig['filters']['logs'] && filters['logs']['visible'] !== -1"
						@click="toggleFilter('logs')"
						class="widget-link"
						:class="{ 'widget-link-grayed': filters['logs']['visible'] === true }">
						{{ 'logs/action' | ftc }}
					</span>
					<!-- кнопка "пометить все прочитанным" -->
					<span
						v-if="crud === 'ticket' && $store.state.user_type === 'client' && isUnreadedTickets && isAccess('ticket/update')"
						class="widget-link"
						:title="'ticket/mark_all_as_readed_title' | ftc"
						@click.stop="markTicketsAsReaded">
						{{ 'ticket/mark_all_as_readed' | ftc }}
					</span>
					<!-- кнопка на тройной фильтр в финансах -->
					<span
						v-if="crud === 'operation' && $store.state.user_type === 'admin'"
						class="widget-link"
						:title="'operation/convert_title' | ftc"
						@click.stop="operationTripleFilter">
						{{ 'operation/convert_title' | ftc }}
					</span>
					<!-- кнопка закрыть все фильтры -->
					<font-awesome-icon v-if="countActiveFilters > 1" icon="times-circle" class="remove-all-filters" :title="'main/close' | ftc " @click="closeAllFilters" />
					<!-- ============================= -->
				</div>
				<!-- ============================= -->

				<!-- сами фильтры -->
				<div class="widgets-filters-wrapper">					
					<!-- <transition-group name="fade"> -->
						<!-- фильтр по периоду -->
						<filterPeriod key="filterPeriod"
							v-if="listConfig && listConfig['filters'] && listConfig['filters']['period'] && listData && listData['filters']"
							v-show="filters.period.visible"
							:valueBegin="filters.period.valueBegin"
							:valueEnd="filters.period.valueEnd"
							@closeFilter="toggleFilter('period')"
							@input="filterPeriodEvent" />
						<!-- фильтры-radio -->
						<template v-if="listConfig && listConfig['filters'] && listConfig['filters']['radio'] && filters.radio && listData && listData['filters']">
							<filterRadio
								v-for="(radio, idx) in filters.radio"
								:list="listData['filters'][radio.field]"
								:crud="crud"
								:key="'radio_filter_' + idx"
								:name="filters.radio[idx].field"
								v-show="filters.radio[idx].visible"
								v-model="filters.radio[idx].value"
								@closeFilter="toggleFilter('radio', idx)"
								@input="PreRequestListDataRadioFilter(filters.radio[idx])" />
						</template>
						<!-- фильтры-select -->
						<template v-if="listConfig && listConfig['filters'] && listConfig['filters']['select'] && filters.select && listData && listData['filters']">
							<filterSelect
								v-for="(select, idx) in filters.select"
								:list="listData['filters'][select.field]"
								:key="'select_filter_' + idx"
								:name="filters.select[idx].field"
								:startVisible="filters.select[idx].visible"
								:multiselect="filters.select[idx].multiselect"
								:crud="crud"
								v-show="filters.select[idx].visible"
								v-model="filters.select[idx].value"
								@closeFilter="toggleFilter('select', idx)"
								@input="PreRequestListDataSelectFilter(filters.select[idx])" />
						</template>
						<!-- фильтр по логам -->
						<filterLogs
							v-if="listConfig && listConfig['filters'] && listConfig['filters']['logs'] && filters.logs && listData && listData['filters']"
							key="filterLogs"
							:list="listData['filters'][listConfig['filters']['logs']['field']]"
							v-show="filters.logs.visible"
							v-model="filters.logs.value"
							@closeFilter="toggleFilter('logs')"
							@input="filterLogsEvent" />
						<!-- фильтр по ticket-label -->
						<filterLabel
							v-if="listConfig && listConfig['filters'] && listConfig['filters']['ticketLabel'] && filters.ticketLabel && listData && listData['filters'] && listData['filters']['ticket_label'] && listData['filters']['ticket_label']['list']"
							key="filterLabel"
							:items="listData['filters']['ticket_label']['list']"
							v-show="filters.ticketLabel.visible"
							v-model="filters.ticketLabel.value"
							@input="filterTicketLabelEvent" />
						<!-- фильтр по disk-type -->
						<filterDisk
							v-if="listConfig && listConfig['filters'] && listConfig['filters']['diskType'] && listData && listData['filters'] && listData['filters']['service_type_id'] && listData['filters']['service_type_id']['list']"
							key="filterDisk"
							:items="listData['filters']['service_type_id']['list']"
							:value="filters.diskType.value"
							v-show="filters.diskType.visible"
							@closeFilter="toggleFilter('diskType')"
							@input="filterDiskTypeEvent" />
						<!-- фильтр по plan-params -->
						<filterParams
							v-if="listConfig &&
								listConfig['filters'] &&
								listConfig['filters']['planParams'] &&
								filters.planParams &&
								listData &&
								listData['filters'] &&
								listData['filters']['cpu_min'] &&
								listData['filters']['cpu_max'] &&
								listData['filters']['ram_min'] &&
								listData['filters']['ram_max'] &&
								listData['filters']['disk_min'] &&
								listData['filters']['disk_max']"
							key="filterParams"
							:params="{
								cpu_min: listData['filters']['cpu_min'],
								cpu_max: listData['filters']['cpu_max'],
								ram_min: listData['filters']['ram_min'],
								ram_max: listData['filters']['ram_max'],
								disk_min: listData['filters']['disk_min'],
								disk_max: listData['filters']['disk_max']
							}"
							:visible="filters.planParams.visible"
							v-show="filters.planParams.visible"
							v-model="filters.planParams.value"
							@closeDirectlyFilter="closeDirectlyFilter('planParams')"
							@input="filterParamsEvent" />
						<!-- ============================= -->
					<!-- </transition-group> -->
				</div>

				<!-- отдельные фильтры -->
				<div class="other-filters">
					<!-- отдельный фильтр по CRUD -->
					<div v-if="crudFilter && crud === crudFilter['crud']" class="alert alert-info w5-crud-filter-object">
						{{ 'main/set_filter' | ftc }}
						<span class="label label-primary">{{ crudFilter['text'] | ftc }}</span>
						<button type="button" class="close" @click="clearCrudFilter">×</button>
						<span class="clearfix"></span>
					</div>
					<!-- глобальный фильтр по аккаунту -->
					<div v-if="accountGlobalFilter && (crud !== 'iphistory' && crud !== 'ipptrpool')" class="alert alert-success w5-account-global-filter">
						{{ accountGlobalFilter.title }}
						<span class="label label-success">{{ accountGlobalFilter.text }}</span>
						<button type="button" class="close" @click="clearAccountGlobalFilter">×</button>
						<span class="clearfix"></span>
					</div>
					<!-- HTTP-GET фильтр по CRUD -->
					<div v-if="crudHttpGetFilter && crud === crudHttpGetFilter['__crud']" class="alert alert-info w5-crud-filter-object">
						{{ 'main/set_filter' | ftc }}
						<span class="label label-primary">{{ crudHttpFilterTitle | ftc }}</span>
						<button type="button" class="close" @click="clearHttpCrudFilter">×</button>
						<span class="clearfix"></span>
					</div>
				</div>
				<!-- ================================= -->
			</div>
			<!-- ================================= -->

			<!-- Блок кнопок -->
			<div v-if="listConfig && listConfig['buttons'] && Object.keys(listConfig['buttons']).length > 0" class="w5-list-buttons-block">
				<template v-for="(button, btn) in listConfig['buttons']">
					<template v-if="btn === 'create' && buttonCreateVisibe === true">
						<span v-if="crud === 'vds' && isAccess('service/create')"
							:key="'button-' + btn"
							ref="buttonVdsCreate"
							@click="buttonsClick($event, btn)"
							:class="buttonsClass(btn)">
							<font-awesome-icon icon="plus" class="on-btn" />
							{{ button | ftc }}
						</span>
						<span v-else-if="crud === 'backups' && isAccess('service/create')"
							:key="'button-for-backups-' + btn"
							@click="buttonsClick($event, btn)"
							:class="buttonsClass(btn)">
							<font-awesome-icon icon="plus" class="on-btn" />
							{{ button | ftc }}
						</span>
						<router-link v-else
							:key="'button-in-upper-block' + btn"
							:class="buttonsClass(btn)"
							:to="buttonsUrl(btn)">
							<font-awesome-icon icon="plus" class="on-btn" />
							{{ button | ftc }}
						</router-link>
					</template>
					<span v-else-if="btn === 'balance' && isAccess('operation/create')"
						:key="'button-' + btn"
						ref="buttonBalance"
						@click="buttonsClick($event, btn)"
						class="btn-client-balance"
						:class="buttonsClass(btn)">
						<font-awesome-icon icon="plus" class="on-btn" />
						{{ button | ftc }}
					</span>
					<span v-else-if="btn === 'calculator'"
						:key="'button-calc-' + btn"
						ref="buttonCalculator"
						@click="buttonsClick($event, btn)"
						class="btn-calc"
						:class="buttonsClass(btn)"
						:title="'service/calculator' | ftc">
						{{ 'service/calculator' | ftc }}
					</span>
					<template v-else-if="btn === 'transfer'">
						<div v-if="crud === 'partner' && $store.state.user_balance" class="w5-transfer-wrapper" :key="'button-in-upper-block' + btn">
							<!-- в партнерке клиента выводить остаток -->
							<span v-if="crud === 'partner' && $store.state.user_balance"
								class="w5-partner-balance"><span>{{ 'operation/partner_balance' | ftc }}: <Money :value="formater_FormatMoney($store.state.user_balance.partner)" class="font-weight-500" /> <span class="font-weight-500" v-withSafeTags="localeFtc('main/ruble')"></span></span>
								<span v-if="clientPartnerData && 'total' in clientPartnerData && 'active' in clientPartnerData">
									<span v-withSafeTags="localeFtc('partner/additional_info').replace('{total}', clientPartnerData.total).replace('{active}', clientPartnerData.active) + (clientPartnerData && 'last_year' in clientPartnerData ? ` (${clientPartnerData.last_year})` : '')"></span>
									<notice :text="'partner/additional_info_notice' | ftc" :small="true" />
								</span>
							</span>						
							<!-- кнопки -->
							<span v-if="$store.state.user_balance && isAccess('operation/convert')">
								<!-- кнопка истории -->
								<span 
									:class="buttonsClass(btn)"
									:disabled="!clientPartnerData || !('total' in clientPartnerData) || clientPartnerData.total == 0"
									class="margin-right-10"
									@click="clientToOperationHistory">
									<font-awesome-icon icon="dollar-sign" class="on-btn" />
									{{ 'operation/operations' | ftc }}
								</span>
								<!-- кнопка трансфера -->
								<span
									:key="'button-' + btn"
									@click="buttonsClick($event, btn)"
									:class="buttonsClass(btn)"
									:disabled="$store.state.user_balance.partner == 0">
									<font-awesome-icon icon="exchange-alt" class="on-btn" />
									{{ button | ftc }}
								</span>
							</span>
						</div>
					</template>
					<template v-else>
						<!--
						<span
							v-if="buttons[btn] && buttons[btn]['visible'] && (btn === 'r_on' || btn === 'r_off')"
							@click="buttonsClick($event, btn)"
							:key="'button-in-upper-block' + btn"
							:title="buttons[btn]['active'] && buttons[btn]['title'] ? localeFtc(buttons[btn]['title']) : null"
							class="register-server pull-right"
							:class="btn + (buttons[btn]['active'] === true ? ' w5-list-button-active' : '')">R<font-awesome-icon :icon="buttons[btn]['icone']" :class="buttonsClass(btn)" /></span>
						-->
						<font-awesome-icon
							v-if="buttons[btn] && buttons[btn]['visible'] && (btn === 'r_on' || btn === 'r_off')"
							@click="buttonsClick($event, btn)"
							:key="'button-in-upper-block-' + btn"
							:icon="buttons[btn]['icone']"
							:class="buttonsClass(btn)"
							:title="buttons[btn]['active'] && buttons[btn]['title'] ? localeFtc(buttons[btn]['title']) : null"
							:transform="buttons[btn]['icone'] === 'stop' ? 'grow-2' : null"
							class="pull-right"
							fixed-width
						/>
						<font-awesome-icon
							v-else-if="buttons[btn] && buttons[btn]['visible'] && (btn === 'ip_on' || btn === 'ip_off')"
							@click="buttonsClick($event, btn)"
							:key="'button-in-upper-block-for-ip-' + btn"
							:icon="buttons[btn]['icone']"
							:class="buttonsClass(btn)"
							:title="buttons[btn]['active'] && buttons[btn]['title'] ? localeFtc(buttons[btn]['title']) : null"
							:transform="buttons[btn]['icone'] === 'stop' ? 'grow-2' : null"
							class="pull-right"
							fixed-width
						/>
						<font-awesome-icon
							v-else-if="buttons[btn] && buttons[btn]['visible'] && btn === 'doc_status'"
							@click="buttonsClick($event, btn)"
							:key="'button-in-upper-block-for-ip-' + btn"
							:icon="buttons[btn]['icone']"
							:class="buttonsClass(btn)"
							:title="buttons[btn]['active'] && buttons[btn]['title'] ? localeFtc(buttons[btn]['title']) : null"
							:transform="buttons[btn]['icone'] === 'stop' ? 'grow-2' : null"
							class="pull-right"
							fixed-width
						/>
						<font-awesome-layers v-else-if="buttons[btn] && buttons[btn]['visible'] && btn === 'blockTicket'"
							@click="buttonsClick($event, btn)"
							:key="'button-in-upper-block-for-tickets-' + btn"
							:class="buttonsClass(btn)"
							:title="buttons[btn]['active'] && buttons[btn]['title'] ? localeFtc(buttons[btn]['title']) : null"
							class="pull-right">
							<font-awesome-icon icon="circle" fixed-width transform="grow-1" />
							<font-awesome-icon icon="times" fixed-width transform="shrink-6" />
						</font-awesome-layers>
						<font-awesome-icon
							v-else-if="buttons[btn] && buttons[btn]['visible'] && btn === 'closeTicket'"
							v-show="showCloseTicketButton"
							@click="buttonsClick($event, btn)"
							:key="'button-in-upper-block-for-tickets-close-' + btn"
							:icon="buttons[btn]['icone']"
							:class="buttonsClass(btn)"
							:title="buttons[btn]['active'] && buttons[btn]['title'] ? localeFtc(buttons[btn]['title']) + '!!!' : null"
							:transform="buttons[btn]['icone'] === 'stop' ? 'grow-2' : null"
							class="pull-right"
							fixed-width
						/>
						<font-awesome-icon
							v-else-if="buttons[btn] && buttons[btn]['visible']"
							@click="buttonsClick($event, btn)"
							:key="'button-in-upper-block-other-' + btn"
							:icon="buttons[btn]['icone']"
							:class="buttonsClass(btn)"
							:title="buttons[btn]['active'] && buttons[btn]['title'] ? localeFtc(buttons[btn]['title']) : null"
							:transform="buttons[btn]['icone'] === 'stop' ? 'grow-2' : null"
							class="pull-right"
							fixed-width
						/>
					</template>
				</template>
				
				<!-- чистка стилей -->
				<span class="clearfix"></span>
			</div>
			<!-- ================================= -->

			<!-- подсказка-ссылка -->
			<div v-if="listData && linkHint && linkHint.position === 'before-list'" class="w5-info-link">
				<font-awesome-icon icon="link" />
				<a :href="linkHint.link" target="_blank">{{ linkHint.title | ftc }}</a>
				<span v-if="linkHint.afterText" class="font-weight-500"> {{ linkHint.afterText | ftc }}</span>
			</div>
			<!-- ======================================== -->

			<!-- Блок таблицы -->
			<div v-if="listData" :class="table_Loading ? 'w5-table-wrapper-loading' : 'w5-table-wrapper'">
				<!-- блок спинера - построение таблицы -->
				<div v-show="buildTableSpiner" class="ajax-backdrop-loader"><img :src="stylePathToLoader || '/static/img/loader.gif'" /><span>{{ 'main/table_rendering' | ftc }}</span></div>
				<!-- сама таблица -->
				<table>
					<thead>
						<tr>
							<template v-for="(col, c) in listConfig['columns']">
								<th v-if="verifyForGlobalFilter(c)"
									:key="'col-' + c"
									:class="col['class-col'] ? col['class-col'] : false"
									:style="col['style-col'] ? col['style-col'] : false">
									<span v-if="isColumnInData(c) && c !== 'ticket_label'" :class="{ 'w5-column-sort': col['sort'] === true }" @click="sortTable(c, col)">
										{{ col['title'] ? col['title'] : listData.columns[c] | ftc }}
									</span>
								</th>
							</template>
							<!-- колонка операций над строкой -->
							<th v-if="listConfig['opers'] || listConfig['oneOper']" class="w5-column-opers"
								:style="listConfig['oneOper'] ? ('width: ' + (listConfig['oneOper']['columnWidth'] ? listConfig['oneOper']['columnWidth'] : '26px')) : ''">&nbsp;</th>
						</tr>
					</thead>
					<tbody :data-crud="crud" :data-user="this.$store.state.user_type">
						<tr v-for="(row, index) in renderRows"
							:key="'row-' + row[listConfig['column_id']]"
							:class="{ 'w5-list-selected-row': row['w5-row-selected'] === true, 'w5-table-last-worked-record': row[listConfig['column_id']] == lastWorkedRowID }"
							@click="selectRowInTable($event, row[listConfig['column_id']])">
							<template v-for="(col, c) in listConfig['columns']">
							<td v-if="isColumnInData(c)"
								:key="'cell-' + row[listConfig['column_id']] + '_' + c"
								:class="cellClass(c, col)"
								:style="col['style-row'] ? col['style-row'] : false"
								:aria-label="localeFtc(col['title'] ? col['title'] : listData.columns[c])">
								<span class="w5-table-cell">
									<!-- тип просмотра сервера -->
									<span v-if="('server_view_type' in row) && (c === 'server' || c === 'server_name')" :class="'color-type-' + String(row['server_view_type'])" style="font-size: 13px">&#9679;</span>
									<!-- статус перед значением -->
									<span v-if="col['online-status-before']" class="online-status-before" :class="{ active: row[col['online-status-before']] === true }"> &#9679;</span>
									<!-- форматированные ячейки -->
									<!-- ссылка -->
									<template v-if="col['component-row'] === 'linkComponent'">
										<font-awesome-icon v-if="$store.state.user_type === 'admin' && !accountGlobalFilter && (c === 'account_name' || c === 'owner_account_name') && row[c] && (row['account_id'] || row['owner_account_id']) && String(row[c]).trim() !== '' && crud !== 'iphistory'"
											class="global-filter-button"
											:title="'account/filter' | ftc"
											@click="setAccountGlobalFilter(row, c)"
											icon="filter"
										/>
										<font-awesome-icon v-if="$store.state.user_type === 'admin' && !accountGlobalFilter && crud === 'logs' && c === 'user_email' && row['account_name'] && row['account_id'] && String(row['account_name']).trim() !== ''"
											class="global-filter-button"
											:title="'account/filter' | ftc"
											@click="setAccountGlobalFilter(row)"
											icon="filter"
										/>
										<font-awesome-icon v-if="crud == 'rackdevice' && (!crudFilter || !crudFilter.crud != 'rackdevice' || !crudFilter.field != 'rack_id') && c === 'rack_name' && row[c] && String(row[c]).trim() !== ''"
											class="global-filter-button"
											:title="'account/filter' | ftc"
											@click="GoTo(row, 'rackdevice', '', 'rack_id')"
											icon="filter"
										/>
										<linkComponent
											:url="col['component-param-url'](row, listData)"
											:text="col['component-param-text'] ? col['component-param-text'](row, listData) : row[c]"
											:fontawesomeicon="col['component-param-icon'] ? col['component-param-icon'](row) : null"
											:flagicon="col['component-param-flagicon'] ? col['component-param-flagicon'](row) : null"
											:class="col['function-cell-class'] ? col['function-cell-class'](row) : false"
											:status="col['component-param-statusService'] ? col['component-param-statusService'](row) : false"
											:statusText="col['component-param-statusServiceText'] ? col['component-param-statusServiceText'](row) : false"
											:srcData="row"
											v-highlightFastSearch="fastSearchValue">
										</linkComponent>
									</template>
									<!-- картинка -->
									<img
										v-else-if="col['component-row'] === 'image'"
										:alt="row['service_data'] && row['service_data']['template'] && row['service_data']['template']['name'] ? String(row['service_data']['template']['name']) : false"
										:title="row['service_data'] && row['service_data']['template'] && row['service_data']['template']['name'] ? localeFtc(String(row['service_data']['template']['name'])) : false"
										:class="/vds$/.test(crud) ? 'vds' : crud"
										:src="col['component-param-url'](row, listData)" />
									<!-- картинка группы VDS -->
									<img
										v-else-if="col['component-row'] === 'imageGroupVds'"
										class="vds-group"
										:title="localeFtc(col['component-param-title'](row, listData))"
										:src="col['component-param-url'](row)" />
									<!-- Услуга VDS -->
									<span v-else-if="col['component-row'] === 'vds_info'" class="w5-list-vds">
										<span class="flag-icon" :class="'flag-icon-' + col['component-param-flag'](row, listData)"
											:alt="col['component-param-flag-name'](row, listData)"
											:title="localeFtc(col['component-param-flag-name'](row, listData))"></span>
										<linkComponent
											:url="col['component-param-url'](row)"
											:text="col['component-param-text'] ? col['component-param-text'](row, listData) : row[c]"
											:status="col['component-param-statusService'] ? col['component-param-statusService'](row) : false"
											:statusText="col['component-param-statusServiceText'] ? col['component-param-statusServiceText'](row) : false"
											class="w5-vds-view-link linkified"
											v-highlightFastSearch="fastSearchValue"></linkComponent>
										<div class="w5-vds-data-info">{{ col['component-param-data'](row) }}</div>
									</span>
									<!-- Услуга бэкап -->
									<span v-else-if="col['component-row'] === 'backup_name'" class="w5-list-backup">
										<span class="flag-icon" :class="'flag-icon-' + col['component-param-flag'](row, listData)"
											:alt="localeFtc(col['component-param-flag-name'](row, listData))"
											:title="localeFtc(col['component-param-flag-name'](row, listData))"></span>
										<linkComponent
											:url="col['component-param-url'](row)"
											:text="col['component-param-text'] ? col['component-param-text'](row, listData) : row[c]"
											:status="col['component-param-statusService'] ? col['component-param-statusService'](row) : false"
											:statusText="col['component-param-statusServiceText'] ? col['component-param-statusServiceText'](row) : false"
											class="w5-backup-view-link linkified"
											v-highlightFastSearch="fastSearchValue"></linkComponent>
									</span>
									<!-- Услуга ISO -->
									<div v-else-if="col['component-row'] === 'iso_info'" class="w5-list-iso">
										<template v-if="row['service_data'] && row['service_data']['iso'] && row['service_data']['iso']['attached'] === true">
												<button v-if="!row['service_status_text']" class="btn btn-default w5-eject-iso-button" :title="'service/iso_eject' | ftc" @click="ejectISO(row, $event)">
													<font-awesome-icon icon="eject" />
												</button> &nbsp;
												<div class="hidden-ellipsis"><linkComponent :url="'/vds/view/' + row['parent_id']" :text="row['parent_name']"></linkComponent></div>
										</template>
										<span v-else>{{ 'main/no' | ftc | lower }}</span>
									</div>
									<!-- Услуга Внешний диск -->
									<div v-else-if="col['component-row'] === 'outer_disk_info'" class="w5-list-iso">
										<template v-if="row['service_data'] && row['service_data']['extdisk'] && row['service_data']['extdisk']['attached'] === true">
												<button v-if="!row['service_status_text']" class="btn btn-default w5-eject-iso-button" :title="'main/detach' | ftc" @click="ejectOuterDiskFromTable(row, $event)">
													<font-awesome-icon icon="eject" />
												</button> &nbsp;
												<div class="hidden-ellipsis"><linkComponent :url="'/vds/view/' + row['parent_id']" :text="row['parent_name']"></linkComponent></div>
										</template>
										<span v-else>{{ 'main/no' | ftc | lower }}</span>
									</div>
									<!-- Информация о заметке -->
									<span v-else-if="col['component-row'] === 'note_info'" class="w5-list-note">
										<span>{{ col['component-param-date'](row) }}</span>
										<template v-if="row['account_name']">
											<br>
											<font-awesome-icon v-if="$store.state.user_type === 'admin' && !accountGlobalFilter && row['account_name'] && row['account_id'] && String(row['account_name']).trim() !== ''"
												class="global-filter-button"
												:title="'account/filter' | ftc"
												@click="setAccountGlobalFilter(row)"
												icon="filter"
											/>
											<linkComponent
												:url="col['component-param-url1'](row)"
												:text="col['component-param-text1'] ? col['component-param-text1'](row, listData) : row[c]"
												v-highlightFastSearch="fastSearchValue">
											</linkComponent>
										</template>
										<br>
										<linkComponent
											:url="col['component-param-url2'](row)"
											:text="col['component-param-text2'] ? col['component-param-text2'](row, listData) : row[c]"
											v-highlightFastSearch="fastSearchValue">
										</linkComponent>
									</span>
									<!-- Код партнерки -->
									<span v-else-if="col['component-row'] === 'partner_code' && row[c] !== null && row[c] !== undefined" class="w5-list-p2a">
										<span v-if="row['status'] === false" class="btn btn-submit btn-submut-extra-small" @click="partnerActivate(row)">
											{{ 'main/activate'| ftc }}
										</span>
										<a v-else :href="AppServerUrl + '/?partner=' + row[c]" target="_blank" class="linkified">
											<span v-highlightFastSearch="fastSearchValue">{{ AppServerUrl + '/?partner=' + row[c] }}</span>
										</a>
									</span>
									<!-- HTTP-реферер -->
									<span v-else-if="col['component-row'] === 'http_referer' && row[c] !== null && row[c] !== undefined" class="w5-http-referer">
										<a :href="row[c]" target="_blank">{{ row[c] }}</a>
									</span>
									<!-- Document-HTML -->
									<template v-else-if="col['component-row'] === 'document_html'">
										<span v-if="row['html'] !== null && row['html'] !== undefined" class="w5-http-referer" @click.stop>
											<span class="w5-modal-link" style="font-weight: 500" @click="openDocumentModalDialog(row['html'], row['pdf'], row['xml'])">{{ row[c] }}</span>
											<template v-if="row['payer_id'] && row['payer_name']">
												<br/>
												<linkComponent
													:url="'/payer/view/' + row['payer_id']"
													:text="row['payer_name']"
													v-highlightFastSearch="fastSearchValue">
												</linkComponent>
											</template>
										</span>
										<linkComponent v-else
											:url="'/document/view/' + row['document_id']"
											:text="row[c]"
											@click.stop
											v-highlightFastSearch="fastSearchValue">
										</linkComponent>
									</template>
									<!-- Отформатированная сумма -->
									<span v-else-if="col['component-row'] === 'formated_number' && row[c] !== null && row[c] !== undefined" class="w5-format-number" :class="col['component-param-cell-class'] ? col['component-param-cell-class'](row) : false"><Money :value="col['component-param-cell'](row, countDigits)" /></span>
									<!-- Статус -->
									<span v-else-if="col['component-row'] === 'status_info'"
										class="w5-list-status"
										:class="col['function-cell-class'] ? col['function-cell-class'](row) : false">
										<template v-if="col['function-row'](row, listData)['loader']">
											<div>
												<span style="white-space: normal;">{{ col['function-row'](row, listData)['status'] }}</span>
												<img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" />
											</div>
										</template>
										<template v-else-if="col['function-row'](row, listData)['timer']">
											<div>
												<span style="white-space: normal;">{{ col['function-row'](row, listData)['status'] }}</span>
												<font-awesome-icon icon="clock" style="margin-left: 6px" />
											</div>
										</template>
										<span v-else style="white-space: normal; word-break: break-word;">{{ col['function-row'](row, listData)['status'] }}</span>
										<!-- дополнительный статус - когда VDS клонируется -->
										<div v-if="vdsCloneVdsInProcess(row['service_id'])" class="vds-clone-status-in-table">
											<font-awesome-layers class="vds-clone-status" @click.stop="vdsCloneShowProcessData(row['service_id'])">
												<font-awesome-icon icon="server" />
												<font-awesome-icon icon="clone" />
											</font-awesome-layers>

											<font-awesome-icon v-if="vdsCloneVdsInProcess(row['service_id']).error" icon="exclamation-circle" class="error" @click.stop="vdsCloneShowProcessData(row['service_id'])" />
											<img v-else src="../../assets/img/loading-hor16.gif" />
										</div>
									</span>
									<!-- редирект с фильтром на другой список CRUD -->
									<span v-else-if="col['component-row'] === 'CrudListFilter' && col['component-param-src-field'] && col['component-param-crud'] && col['component-param-filter-field']"
										class="w5-link" @click.stop="GoTo(row, col['component-param-crud'], col['component-param-object'], col['component-param-filter-field'])">
										<template v-if="col['function-row']">{{ col['function-row'](row, listData) }}</template>
										<template v-else>{{ row[col['component-param-src-field']] }}</template>
									</span>
									<!-- Лейбл тикета -->
									<template v-else-if="col['component-row'] === 'ticket_label'">
										<div v-if="row['ticket_label'] === 'loading'" style="height: 23px"><img src="../../assets/img/loading-hor16.gif" /></div>
										<div v-else class="w5-list-ticket-label"
											:ref="'ticket-label-' + row['ticket_id']"
											:class="col['function-cell-class'] ? col['function-cell-class'](row) : false"
											:style="col['function-cell-style'] ? col['function-cell-style'](row) : false"
											@click.stop="changeTicketLabel(row)" />
									</template>
									<!-- Прочитан тикет или нет -->
									<template v-else-if="col['component-row'] === 'ticket_read'">
										<font-awesome-layers v-if="'message_unread_count' in row && row['message_unread_count'] > 0" class="ticket-read">
											<font-awesome-icon icon="envelope" />
											<font-awesome-icon icon="asterisk" />
										</font-awesome-layers>
										<font-awesome-layers v-else class="ticket-read">
											<font-awesome-icon icon="envelope" />
											<font-awesome-icon icon="check" />
										</font-awesome-layers>
									</template>
									<!-- Стоимость услуги -->
									<template v-else-if="col['component-row'] === 'service_type_cost'">
										<span v-if="col['function-row'](row, listData)['cost']"><Money :value="col['function-row'](row, listData)['cost']" /> <span v-html="localeFtc('main/ruble')"></span></span>
										<span v-if="col['function-row'](row, listData)['cost'] && col['function-row'](row, listData)['for']">/</span>
										<span v-if="col['function-row'](row, listData)['for']">{{ col['function-row'](row, listData)['for'] }}</span>
										<span v-if="col['function-row'](row, listData)['for'] && col['function-row'](row, listData)['period']">/</span>
										<span v-if="col['function-row'](row, listData)['period']">{{ col['function-row'](row, listData)['period'] }}</span>
									</template>
									<!-- Тариф -->
									<template v-else-if="col['component-row'] === 'plan_cost'">
										<Money :value="col['function-row'](row, listData)['cost']" /> <span v-html="localeFtc('main/ruble')"></span> / {{ col['function-row'](row, listData)['period'] }}
									</template>
									<!-- Тема тикета -->
									<template v-else-if="col['component-row'] === 'ticket_subject'">
										<linkComponent
											:url="'/ticket/view/' + row['ticket_id']"
											:text="row['ticket_subject']"
											v-highlightFastSearch="fastSearchValue">
										</linkComponent>
										<span v-if="$store.state.user_type === 'admin' && row['message_count'] > 0" class="badge ticket-message-count-badge admin margin-left-6" @mouseover="ticketLastCommentatorShow(row, $event)" @mouseleave="ticketLastCommentatorHide()">
											{{ row['message_count'] }}
										</span>
										<span v-if="$store.state.user_type === 'client' && row['message_unread_count'] > 0" class="badge ticket-message-count-badge margin-left-6">
											{{ row['message_unread_count'] }}
										</span>
									</template>
									<!-- Группа серверов -->
									<span v-else-if="col['component-row'] === 'server_groups' && row[c] !== null && row[c] !== undefined && Array.isArray(row[c])" class="w5-list-groups">
										<template v-for="(server, s) in row[c]">
											<span v-if="s > 0" :key="'del-grp-' + s">, </span>
											<linkComponent
												:key="'server_group_' + s"
												:url="'/servergroup/view/' + server['group_id']"
												:text="server['group_name']"
												v-highlightFastSearch="fastSearchValue" />
										</template>
									</span>
									<!-- Просмотр группы серверов -->
									<span v-else-if="col['component-row'] === 'server_groups_view' && row[c] !== null && row[c] !== undefined && row['server_group_id'] && row['server_group_name']" class="w5-list-groups">
										<linkComponent
											:url="'/servergroup/view/' + row['server_group_id']"
											:text="row['server_group_name']"
											v-highlightFastSearch="fastSearchValue" />
									</span>
									<!-- Просмотр группы тарифов -->
									<span v-else-if="col['component-row'] === 'plan_groups_view' && row[c] !== null && row[c] !== undefined && row['plan_group_id'] && row['plan_group_name']" class="w5-list-groups">
										<linkComponent
											:url="'/plangroup/view/' + row['plan_group_id']"
											:text="row['plan_group_name']"
											v-highlightFastSearch="fastSearchValue" />
									</span>
									<!-- Просмотр группы шаблонов -->
									<span v-else-if="col['component-row'] === 'template_groups_view' && row[c] !== null && row[c] !== undefined && row['template_group_id'] && row['template_group_name']" class="w5-list-groups">
										<linkComponent
											:url="'/templategroup/view/' + row['template_group_id']"
											:text="row['template_group_name']"
											v-highlightFastSearch="fastSearchValue" />
									</span>
									<!-- Роли сотрудников -->
									<span v-else-if="col['component-row'] === 'admin_roles' && row[c] !== null && row[c] !== undefined && Array.isArray(row[c])" class="w5-list-roles">
										<span
											v-for="(role, r) in row[c]"
											:key="'admin_roles_' + r"											
											v-highlightFastSearch="fastSearchValue"><span v-if="r > 0">,</span>
											 {{ role | ftc }}</span>
									</span>
									<!-- Статус платежа -->
									<template v-else-if="col['component-row'] === 'operation_status'">
										<linkComponent
											v-if="$store.state.user_type === 'client' && row['operation_status'] === 0 && row['can_pay'] === true"
											class="btn btn-submit btn-submut-extra-small"
											:url="'/operation/select/' + row['operation_id']"
											:text="'operation/pay' | ftc | lower"></linkComponent>
										<span v-else
											:class="col['component-param-cell-class'] ? col['component-param-cell-class'](row) : false"
											v-highlightFastSearch="fastSearchValue">{{ col['component-param-data'](row, listData) }}</span>
									</template>
									<!-- форматирование через указанную функцию -->
									<span
										v-else-if="col['function-row']"
										:class="col['function-cell-class'] ? col['function-cell-class'](row) : false"
										v-highlightFastSearch="fastSearchValue"><span v-if="col['function-flagicon']" class="flag-icon" :class="col['function-flagicon'](row)"></span>{{ col['function-row'](row, listData, localeFtc) }}</span>
									<!-- форматирование через функцию-форматер -->
									<span v-else-if="col['formater-row']"
										:class="col['function-cell-class'] ? col['function-cell-class'](row) : false"
										:style="col['function-cell-style'] ? col['function-cell-style'](row) : false"
										v-highlightFastSearch="fastSearchValue">{{ formater(col['formater-row'], row[c]) }}</span>
									<!-- без форматирования -->
									<span v-else
										:class="col['function-cell-class'] ? col['function-cell-class'](row) : false"
										:style="col['function-cell-style'] ? col['function-cell-style'](row) : false"
										v-highlightFastSearch="fastSearchValue">{{ row[c] | ftc }}</span>

									<!-- дополнения к ячейке -->
									<span v-if="col['user-online-status'] && row[col['user-online-status']] === true" class="online-status-is-on"> &#9679;</span>
									<span v-if="col['domain-online-status'] && col['domain-online-status'](row)" class="online-status-is-on"> &#9679;</span>
								</span>
							</td>
							</template>

							<!-- колонка операций над строкой -->
							<td v-if="listConfig['opers']" class="w5-column-opers">
								<dropDownButton :dataConfig="listConfig['opers']" :row="row" :index="index" :crud="crud" @action="actionOperButton" />
							</td>
							<!-- колонка одной операции над строкой -->
							<td v-if="listConfig['oneOper']" class="w5-column-opers">
								<oneOperButton :dataConfig="listConfig['oneOper']" :row="row" :index="index" :crud="crud" @action="actionOperButton" />
							</td>
						</tr>
						<!-- итог для финансов -->
						<tr v-if="listData && listData.rows && listData.rows.length && crud === 'operation' && 'totalSumm' in listData">
							<td colspan="3" class="text-right">{{ 'operation/total_summ' | ftc }}: &nbsp;
								<span class="font-weight-500" :class="{ 'color-red': listData.totalSumm < 0 }"><Money :value="totalSummFormat(listData.totalSumm)" /></span>
							</td>
							<td class="padding-left-0 font-weight-500" :class="{ 'color-red': listData.totalSumm < 0 }"><span v-html="localeFtc('main/ruble')"> </span></td>
							<td :colspan="this.$store.state.user_type !== 'client' ? ($store.state.accountGlobalFilter ? 3 : 4) : 2"></td>
						</tr>
						<!-- итог для партнерки -->
						<tr v-if="listData && listData.rows && listData.rows.length && crud === 'partneractions' && 'totalSumm' in listData">
							<td :colspan="$store.state.accountGlobalFilter ? 6 : 7" class="text-right">{{ 'operation/total_summ' | ftc }}: &nbsp;
								<span class="font-weight-500" :class="{ 'color-red': listData.totalSumm < 0 }"><Money :value="totalSummFormat(listData.totalSumm)" /></span>
								<span class="font-weight-500" :class="{ 'color-red': listData.totalSumm < 0 }"><span v-html="localeFtc('main/ruble')"> </span></span>
							</td>
						</tr>
						<!-- если таблица пустая -->
						<tr v-show="listData && listData.rows && listData.rows.length === 0">
							<td :colspan="Object.keys(listConfig['columns']).length + (listConfig['opers'] ? 1 : 0)" class="text-center">
								<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
								<br>
								<span class="font-size-110 w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
							</td>
						</tr>
						<!-- ======================= -->
						
					</tbody>
				</table>					
			</div>
			<!-- блок таблицы окончен ================================= -->

			<!-- блок количества найденых записей и выбора количества записей на страницу -->
			<div v-if="listData && listData.rows && listData.rows.length" class="margin-15-0">
				<!-- Найдено -->
				<span
					v-if="listData && listData.rows && listData.rows.length"
					class="font-size-80 font-weight-500 list-total">
					{{ 'main/list_total' | ftc }}:
				</span>
				<span
					v-if="listData && listData.rows && listData.rows.length"
					class="font-size-80 list-total">
					{{ listData.totalCount }}
				</span>

				<!-- выделено -->
				<span v-show="totalSelectedRowsCount && totalSelectedRowsCount > 0">
					, <span class="font-size-80 font-weight-500">{{ 'main/selected' | ftc }}:</span>
					<span class="font-size-80">{{ totalSelectedRowsCount }}</span>
				</span>

				<!-- Выбор -->
				<span class="widget-page-size">
					<span class="font-size-80 font-weight-500">{{ 'main/list_size' | ftc }}: </span>
					<span v-for="size in Config.pageSizes"
						@click="setPageSize(size)"
						:key="'page-size-' + size"
						:class="{ 'w5-link': size !== listData.pageSize, 'font-weight-500': size === listData.pageSize }"
						class="font-size-80">
						&nbsp;{{ size }}&nbsp;
					</span>
				</span>
			</div>
			<!-- ========================================================================= -->

			<!-- блок пагинации -->
			<div v-if="listData && listData.rows && listData.rows.length && paginationPages.length > 0">
				<paginator v-if="crud === 'vds'" :baseUrl="'/vds/' + action" :pages="paginationPages" :curPage="page" :lastPage="lastPage" />
				<paginator v-else :baseUrl="'/' + crud + '/' + action + (crud === 'ticket' && action === 'department' ? '/' + ticketDepartmentId : '')" :pages="paginationPages" :curPage="page" :lastPage="lastPage" :queryString="getAllQueryParams()" />
			</div>
			<!-- ======================================== -->

			<!-- подсказка-ссылка -->
			<div v-if="listData && linkHint && linkHint.position === 'bottom'" class="w5-info-link margin-top-20">
				<font-awesome-icon icon="link" />
				<a :href="linkHint.link" target="_blank">{{ linkHint.title | ftc }}</a>
				<span v-if="linkHint.afterText" class="font-weight-500"> {{ linkHint.afterText | ftc }}</span>
			</div>
			<!-- ======================================== -->
				
		</div>
		<!-- ГЛАВНЫЙ БЛОК окончен ================================= -->

		<!-- диалог удаления записи -->
		<transition name="modal">
			<div v-show="showDeleteModal" @click="hideDeleteModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ deleteModalTitle ? deleteModalTitle : '' | ftc }}</span>
							<button type="button" class="close" @click="hideDeleteModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body"><p class="padding-0-5" v-withSafeTags="localeFtc(deleteModalText)"></p></div>

						<!-- подвал -->
						<div class="modal-footer"  :class="{ 'flbx': reserveIpLocalData >= 1, 'r': reserveIpLocalData && typeof reserveIpLocalData === 'object' }">
							<!-- резервирование IP -->
							<div v-if="reserveIpLocalData && typeof reserveIpLocalData === 'object'" class="tab-pane-command-wrapper" style="margin: 0 0 15px; padding: 5px 10px 10px 10px; text-align: initial">
								<div class="control-wrapper">
									<input type="checkbox" class="w5-checkbox-field" v-model="reserveIpValue" style="display: none" />
									<label @click="reserveIpStart" :class="{ 'disable': reserveIpProcessing || (deleteModalTimer && deleteModalTimer > 0) }" style="display: inline-block; height: 3em; line-height: 3em;">
										{{ 'main/save ippool/ippool' | ftc }}
									</label>
									<div class="warning-message" v-withSafeTags="localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', reserveIpCost)" style="margin-bottom: 0; font-size: 90%"></div>
								</div>
							</div>
							<div v-if="reserveIpLocalData === 1">
								<img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" />
							</div>

							<!-- кнопка -->
							<span class="btn btn-submit btn-submit-danger pull-right" :disabled="deleteModalTimer && deleteModalTimer > 0 ? 'disabled' : false" @click="deleteModalCallback">{{ modalDeleteButtonTitle }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог on-off записи -->
		<transition name="modal">
			<div v-show="showBlockModal" @click="hideBlockModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ blockModalTitle ? blockModalTitle : '' | ftc }}</span>
							<button type="button" class="close" @click="hideBlockModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="padding: 10px 15px; text-align: left;">
							<!-- вопрос -->
							<p v-withSafeTags="localeFtc(blockModalText)" style="margin: 10px 0"></p>

							<!-- форма -->
							<form class="w5-from" v-show="blockModalNoteRequired !== false"><fieldset>
								<!-- select -->
								<div class="w5-form-row">
									<Field
										:isVisibleRow="true"
										:crud="crud"
										action="list"
										name="blockModalSelectNote"
										ref="blockModalSelectNote"
										v-model="blockModalSelectNoteValue"
										:listBlockToOut="1"
										:fieldInModal="true"
										@valueChanged="blockModalValueChanged"
										:Field="{ _field_name: 'blockModalSelectNote', type: 'list', title: 'notes/choice_note', '_visible': true, '_is_modal': true, url: '/text/list?search=template&category=notes&q=' }"
										:removeRightPadding="true" />
								</div>

								<!-- заметка -->
								<div class="w5-form-row">
									<Field
										:isVisibleRow="true"
										:crud="crud"
										action="list"
										name="blockModalTextNote"
										ref="blockModalTextNote"
										v-model="blockModalTextNoteValue"
										:Field="blockModalTextField"
										:removeRightPadding="true"
										:fieldInModal="true"
										@focus="blockModalTextFieldFocus" />
								</div>
							</fieldset></form>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" @click="blockRowsInModalDialog">{{ blockModalButtonTitle | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог register/unregister серверов -->
		<transition name="modal">
			<div v-show="showRegisterModal" @click="hideRegisterModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" :class="{ 'wide': registerModalWhat === 'ip_off' }" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ registerModalTitle ? registerModalTitle : 'server/register' | ftc }}</span>
							<button type="button" class="close" @click="hideRegisterModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="padding: 10px 15px; text-align: left;">
							<!-- вопрос -->
							<p v-withSafeTags="localeFtc(registerModalText)" style="margin: 10px 0"></p>
							<!-- если это блокировка ip-pool - требуются так же радиобутоны -->
							<template v-if="registerModalWhat === 'ip_off'">
								<radioListComponent
									placeholder=""
									v-model="ippoolBlockValue"
									:title = "'main/status'"
									:required="true"
									:items="ippoolBlockStatuses" />
							</template>
							<!-- если это статус document - требуются так же радиобутоны -->
							<template v-if="registerModalWhat === 'doc_status'">
								<radioListComponent
									placeholder=""
									v-model="documentStatusValue"
									:title = "'main/status'"
									:required="true"
									:items="documentStatuses" />
							</template>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" @click="registerRowsInModalDialog">{{ registerModalButtonTitle | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог отключения фильтров VDS -->
		<transition name="modal">
			<div v-show="showRemoveFilterModal" @click="hideRemoveFilterModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'service/remove_filter' | ftc }}</span>
							<button type="button" class="close" @click="hideRemoveFilterModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="padding: 10px 15px; text-align: left;">
								<radioListComponent
									placeholder=""
									v-model="removeFilterValue"
									:title = "'main/status'"
									:required="true"
									:items="[
										{ id: 'no-spamming', name: 'service/remove_filter_spam' },
										{ id: 'block-services', name: 'service/remove_filter_service' },
										{ id: 'no-dns', name: 'menu/dns' },
									]" />
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" @click="removeFilterProcessStart">{{ 'main/detach' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- даилог копирования бэкапа в другой ДЦ -->
		<transition name="modal">
			<div v-show="showCopyToDcModal" @click="hideCopyToDcModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'backup/copy' | ftc }}</span>
							<button type="button" class="close" @click="hideCopyToDcModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<!-- блок с общим сообщением об ошибке -->
							<transition name="fadeControl" key="transitionError">
								<div v-show="copyToDcErrorMessage !== ''" class="alert alert-danger" role="alert" style="margin: 5px 0 10px 0">
									<button @click="copyToDcErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
									<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(copyToDcErrorMessage)"></span>
								</div>
							</transition>

							<template v-if="copyToDcFields && copyToDcFields.fields">
								<div v-for="(row, index) in copyToDcFields.fields" :key="'copy_to_dc_field_' + index" :class="{ 'w5-form-row': isVisibleField(row) }">
									<template v-if="row">
										<Field v-for="field in row"
											:key="'field_' + field._field_name"
											:isVisibleRow="isVisibleField(row)"
											crud="backups"
											action="copy"
											:Field="field"
											v-model="field.value"
											:listBlockToOut="field.type === 'list' ? 1 : false"
											:removeRightPadding="true"
											:fieldInModal="true"
											@valueChanged="onChangedField(field)"
											@blur="onBlurField(field)"
											@focus="onFocusField(field)"
											@enterKeyDown="onEnterKeyDownForm('copyToDcProcessStart')" />
									</template>
								</div>
							</template>

							<p v-if="copyToDcCostInfo" v-html="copyToDcCostInfo"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" @click="copyToDcProcessStart">{{ 'main/copy' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог клонирования VDS через копирования бэкапа в другой ДЦ -->
		<transition name="modal">
			<div v-show="showVdsCloneModal" @click="hideVdsCloneModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'main/clone' | ftc }}</span>
							<button type="button" class="close" @click="hideVdsCloneModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">

							<!-- предупреждение о создании бэкапа -->
							<div class="alert alert-warning margin-0">
								<p class="padding-0-5" v-withSafeTags="localeFtc('main/vds_clone_note')"></p>
							</div>

							<!-- предупреждение что бы не закрывали окно браузера -->
							<div class="alert alert-warning margin-top-10">
								<p class="padding-0-5" v-withSafeTags="localeFtc('main/vds_clone_warning')"></p>
							</div>

							<!-- поле - оставлять ли бэкап после процесса -->
							<div class="w5-form-row">
								<Field
									:isVisibleRow="true"
									:crud="crud"
									action="list"
									name="vdsCloneModalFieldBoolean"
									ref="vdsCloneModalFieldBoolean"
									v-model="vdsCloneModalFieldBooleanValue"
									:Field="vdsCloneModalFieldBoolean"
									:removeRightPadding="true"
									:fieldInModal="true" />
							</div>

							<!-- в какой ДЦ клонировать -->
							<div class="w5-form-row">
								<Field
									:isVisibleRow="true"
									:crud="crud"
									action="list"
									name="vdsCloneModalFieldList"
									ref="vdsCloneModalFieldList"
									v-model="vdsCloneModalFieldListValue"
									:listBlockToOut="1"
									:Field="vdsCloneModalFieldList"
									:removeRightPadding="true"
									:fieldInModal="true"
									@focus="vdsCloneModalFieldList._errMsg = ''" />
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" @click="vdsCloneProcessStep2">{{ 'main/begin' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог инфорамции о текущем процессе клонирования VDS -->
		<transition name="modal">
			<div v-show="vdsCloneShowProcessDataValue" @click="hideVdsCloneProcessInfoModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'main/clone' | ftc }}</span>
							<button type="button" class="close" @click="hideVdsCloneProcessInfoModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" v-if="vdsCloneShowProcessDataInfo && vdsCloneShowProcessDataInfo.id">
							<template v-if="vdsCloneShowProcessDataInfo.error">
								<div class="alert alert-warning margin-top-10">
									<p class="padding-0-5" v-withSafeTags="localeFtc('main/vds_clone_process_warning')"></p>
								</div>

								<div class="margin-bottom-15"><strong>{{ 'main/status' | ftc }}</strong>: <span>{{ vdsCloneShowProcessDataInfo.step | ftc | lower }}</span></div>
								<div class="margin-bottom-15"><strong>{{ 'service/status_error' | ftc }}</strong>: <span style="color: red" v-withSafeTags="localeFtc(vdsCloneShowProcessDataInfo.error)"></span></div>
							</template>
							<template v-else-if="vdsCloneShowProcessDataInfo.finish">
								<strong>{{ 'operation/converted' | ftc }}</strong>
							</template>
							<template v-else>
								<div class="margin-bottom-15"><strong>{{ 'server/server' | ftc }}</strong>: <span>{{ vdsCloneShowProcessDataInfo.params.nm }}</span></div>
								<div class="margin-bottom-15"><strong>{{ 'main/status' | ftc }}</strong>: <span>{{ vdsCloneShowProcessDataInfo.step | ftc | lower }}</span></div>
								<div class="margin-bottom-15"><strong>{{ 'main/state' | ftc }}</strong>: <span>{{ vdsCloneShowProcessDataInfo.status | ftc | lower }}</span></div>
							</template>
						</div>

						<!-- подвал для ошибочного процесса -->
						<div v-if="vdsCloneShowProcessDataInfo && vdsCloneShowProcessDataInfo.id && vdsCloneShowProcessDataInfo.error" class="modal-footer">
							<span class="btn btn-submit pull-right" @click="deleteVdsCloneProcess(vdsCloneShowProcessDataInfo.id)">{{ 'main/vds_clone_process_terminate' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог migrate записи -->
		<transition name="modal">
			<div v-show="showMigrateModal" @click="hideMigrateModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop style="width: 60%">

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'service/migrate' | ftc }}</span>
							<button type="button" class="close" @click="hideMigrateModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="text-align: left">
							<div class="w5-migrate-wrapper">
								<!-- список выбранных VDS -->
								<div class="w5-migrate-vds-list scrollable">
									<div v-for="(vds, indx) in migrateRows"
										class="w5-migrate-vds-list-item scrollable"
										:key="'migrate-row-' + indx"
										:class="{ 'w5-migrate-vds-list-item-selected': vds['migrate_active'] === true }"
										:style="migrateRows.length <= 1 ? 'padding: 14px 8px;' : 'padding: 4px 8px;'">
										{{ vds[listConfig['buttons']['migrate']] }}
									</div>
								</div>

								<!-- стрелочка -->
								<div class="w5-migrate-arrow">
									<font-awesome-icon icon="arrow-right" class="hidden-xs" />
									<font-awesome-icon icon="arrow-down" class="visible-xs" />
								</div>

								<!-- список серверов -->
								<div class="w5-migrate-server-list">
									<form class="w5-from"><fieldset>
										<!-- select -->
										<div class="w5-form-row">
											<Field
												:isVisibleRow="true"
												:crud="crud"
												action="list"
												name="migrateModalSelectServer"
												ref="migrateModalSelectServer"
												v-model="migrateModalSelectServerValue"
												@valueChanged="migrateModalValueChanged"
												:listBlockToOut="1"
												:fieldInModal="true"
												:Field="migrateModalServerField"
												:removeRightPadding="true" />
										</div>
									</fieldset></form>
								</div>
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" :disabled="migrateModalButtonDisabled ? 'disabled' : false" @click="migrateInModalDialog">{{ 'service/migrate' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог перемещения услуги -->
		<transition name="modal">
			<div v-show="showServiceMoveModal" @click="hideServiceMoveModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop style="width: 60%">

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'service/move' | ftc }}</span>
							<button type="button" class="close" @click="hideServiceMoveModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="text-align: left">
							<div class="w5-migrate-wrapper">
								<!-- список выбранных VDS -->
								<div class="w5-migrate-vds-list scrollable">
									<div v-for="(service, indx) in serviceMoveRows"
										class="w5-migrate-vds-list-item scrollable"
										:key="'service-move-row-' + indx"
										:class="{ 'w5-migrate-vds-list-item-selected': service['move_active'] === true }"
										:style="serviceMoveRows.length <= 1 ? 'padding: 14px 8px;' : 'padding: 4px 8px;'">
										{{ service[listConfig['buttons']['serviceMove']] }}
									</div>
								</div>

								<!-- стрелочка -->
								<div class="w5-migrate-arrow">
									<font-awesome-icon icon="arrow-right" class="hidden-xs" />
									<font-awesome-icon icon="arrow-down" class="visible-xs" />
								</div>

								<!-- список серверов -->
								<div class="w5-migrate-server-list">
									<form class="w5-from"><fieldset>
										<!-- select -->
										<div class="w5-form-row">
											<Field
												:isVisibleRow="true"
												:crud="crud"
												action="list"
												name="serviceMoveModalSelectServer"
												ref="serviceMoveModalSelectServer"
												v-model="serviceMoveModalSelectAccountValue"
												@valueChanged="serviceMoveModalValueChanged"
												:Field="serviceMoveModalAccountField"
												:listBlockToOut="1"
												:fieldInModal="true"
												:removeRightPadding="true" />
										</div>
									</fieldset></form>
								</div>
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" :disabled="serviceMoveModalButtonDisabled ? 'disabled' : false" @click="serviceMoveInModalDialog">{{ serviceMoveModalButtonTitle | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог массового удаления услуг -->
		<transition name="modal">
			<div v-show="showServiceBulkDelModal" @click="hideServiceBulkDelModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'main/deleting' | ftc }}</span>
							<button type="button" class="close" @click="hideServiceBulkDelModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="text-align: left">
							{{ 'main/delete_selected_records' | ftc }}?
							<br>
							{{ 'main/delete_selected_records_note' | ftc }}
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" :disabled="serviceBulkDelModalButtonDisabled ? 'disabled' : false" @click="serviceBulkDelInModalDialog">{{ serviceBulkDelModalButtonTitle | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог перемещения тикетов -->
		<transition name="modal">
			<div v-show="showTicketMoveModal" @click="hideTicketMoveModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop style="width: 60%">

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'ticketrule/action_move' | ftc }}</span>
							<button type="button" class="close" @click="hideTicketMoveModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="text-align: left">
							<div class="w5-ticket-move-wrapper">
								<!-- список выбранных тикетов -->
								<div class="w5-ticket-move-tickets-list">
									<div v-for="(ticket, indx) in ticketRows"
										class="w5-ticket-move-tickets-list-item"
										:key="'ticket-move-row-' + indx"
										:class="{ 'w5-ticket-move-tickets-list-item-selected': ticket['ticket_move_active'] === true }"
										:style="ticketRows.length <= 1 ? 'padding: 14px 8px;' : 'padding: 4px 8px;'">
										{{ ticket['ticket_subject'] }}
									</div>
								</div>

								<!-- стрелочка -->
								<div class="w5-ticket-move-arrow">
									<font-awesome-icon icon="arrow-right" class="hidden-xs" />
									<font-awesome-icon icon="arrow-down" class="visible-xs" />
								</div>

								<!-- список отделов -->
								<div class="w5-ticket-move-departments-list">
									<form class="w5-from"><fieldset>
										<!-- select -->
										<div class="w5-form-row">
											<Field
												:isVisibleRow="true"
												:crud="crud"
												action="list"
												name="ticketMoveModalSelectDepartment"
												ref="ticketMoveModalSelectDepartment"
												v-model="ticketMoveModalSelectDepartmentValue"
												@valueChanged="ticketMoveModalValueChanged"
												:listBlockToOut="1"
												:fieldInModal="true"
												:Field="ticketMoveModalDepartmentField"
												:removeRightPadding="true" />
										</div>
									</fieldset></form>
								</div>
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" :disabled="ticketMoveModalButtonDisabled ? 'disabled' : false" @click="ticketMoveInModalDialog">{{ 'ticketrule/action_move' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог блокировки тикетов -->
		<transition name="modal">
			<div v-show="showTicketBlockModal" @click="hideTicketBlockModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container blacklist" @click.stop style="width: 60%">

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'ticketrule/blacklist' | ftc }}</span>
							<button type="button" class="close" @click="hideTicketBlockModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="text-align: left">
							{{ ticketBlockModalBody }}
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" :disabled="ticketBlockModalTimer && ticketBlockModalTimer > 0 ? 'disabled' : false" @click="ticketBlockInModalDialog">{{ ticketBlockModalButtonTitle }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог детача ISO -->
		<transition name="modal">
			<div v-show="showISOModal" @click="hideISOModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ isoModalTitle | ftc }}</span>
							<button type="button" class="close" @click="hideISOModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<p class="padding-0-5" v-withSafeTags="localeFtc(isoModalText)"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" :disabled="blockModalTimer && blockModalTimer > 0 ? 'disabled' : false" @click="detachIsoBegin">{{ isoBlockModalButtonTitle | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог генерации ссылки для скачивания бэкапа -->
		<transition v-if="crud === 'backups'" name="modal">
			<div v-show="showDownloadBackupModal" @click="hideDownloadBackupModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'backup/download_title' | ftc }}</span>
							<button type="button" class="close" @click="hideDownloadBackupModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<p class="padding-0-5" v-withSafeTags="localeFtc('backup/download_info')"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" @click="downloadBackupProcessStart">{{ 'main/download' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог перевода средств -->
		<transition name="modal">
			<div v-show="showPaymentModal" @click="hidePaymentModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'operation/convert_title' | ftc }}</span>
							<button type="button" class="close" @click="hidePaymentModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div v-if="paymentFields && paymentFields.fields" class="modal-body">
							<div v-for="(row, index) in paymentFields.fields" :key="'payment_field_' + index" :class="{ 'w5-form-row': isVisiblePaymentField(row) }">
								<template v-if="row">
									<Field v-for="field in row"
										:key="'field_' + field._field_name"
										:isVisibleRow="isVisiblePaymentField(row)"
										crud="operation"
										action="convert"
										:Field="field"
										v-model="field.value"
										:listBlockToOut="field.type === 'list' ? 1 : false"
										:removeRightPadding="true"
										:fieldInModal="true"
										@valueChanged="fieldChangedPayment(field)"
										@input="fieldPaymentInput(field)"
										@blur="onBlurPayment(field)"
										@focus="onFocusPayment(field)"
										@enterKeyDown="onEnterKeyDownPayment" />
								</template>
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="pull-left text-left">
									<span :style="PaymentWarrning ? 'color: red' : false">{{ 'payment/min' | ftc }}: <strong><Money :value="paymentMin" /> <span v-withSafeTags="localeFtc('main/ruble')"></span></strong></span>
									<template v-if="PaymentWarrningAdditional">
										<br>
										<span class="payment-warrning-text">{{ PaymentWarrningAdditional | ftc }}</span>
									</template>
									<br>
									<span>{{ 'payment/max' | ftc }}: <strong><Money :value="paymentMax" /> <span v-withSafeTags="localeFtc('main/ruble')"></span></strong></span>
							</span>
							<span class="btn btn-submit pull-right" :disabled="isPaymentModalButtonDisabled" @click="paymentConvertBegin">{{ 'operation/convert' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>


		<!-- диалог калькулятора -->
		<calculator v-if="crud == 'operation'" :visible="showCalcModal" @onClose="hideCalcModal" />

		<!-- диалог стойки оборудования -->
		<rackGraphic v-if="crud == 'rack'"
			:visible="showRackGraphicModal"
			:rack="rackGraphicModalData"
			:filters="listData && listData.filters && listData.filters.rack_type ? listData.filters : null"
			@onClose="hideRackGraphicModal" />


		<!-- диалог пополнения баланса клиентов -->
		<transition name="modal">
			<div v-if="showBalancePopup" @mousedown="maskModalFlag = true" @mouseup="() => this.hideBalancePopup(false)" class="popup-mask">
				<div class="popup-wrapper">
					<div class="popup-container" :style="balanceContainerStyle" @mousedown.stop="maskModalFlag = false" @mouseup.stop="maskModalFlag = false">
						<Field
							:isVisibleRow="true"
							:crud="crud"
							action="list"
							name="clientBalance"
							ref="clientBalance"
							v-model="balanceValue"
							:needButtonSubmit="true"
							:Field="balanceField"
							:fieldInModal="true"
							@enterKeyDown="onBalanceSubmit"
							@onSubmit="onBalanceSubmit"
							@focus="balanceField._errMsg = ''" />						
					</div>
				</div>
			</div>
		</transition>


		<!-- блок смены метки -->
		<div v-if="crud === 'ticket'" ref="ticketChoiceLabelBlock" v-show="showChoiceTicketLabelBlock === true" class="widget-filter-ticket-label-choice" :style="ticketLabelBlockStyle">
			<template v-for="(val, idx) in ticketLabelItems">
				<div v-if="String(val) !== ''"
					class="w5-list-ticket-label cursor-pointer"
					:key="'label-change-block-' + idx"
					:class="'ticket-label-color-' + String(val).toLowerCase()"
					:style="'background-color: ' + String(val).toLowerCase()"
					@click="onChangeTicketLabel(val)"></div>
			</template>
		</div>


		<!-- диалог отметки всех тикетов прочитанным -->
		<transition name="modal">
			<div v-show="showMarkTicketsAsReadedDialog" @click="showMarkTicketsAsReadedDialog = false" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'ticket/mark_all_as_readed' | ftc }}</span>
							<button type="button" class="close" @click="showMarkTicketsAsReadedDialog = false">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">{{ 'ticket/mark_all_as_readed_warning' | ftc }}</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" @click="markTicketsAsReadedStart">{{ 'main/confirm' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>


		<!-- диалог подтверждения -->
		<transition name="modal">
			<div v-show="showConfirmModalDialog" @click="hideConfirmModalDialog" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ confirmModalDialogTitle ? confirmModalDialogTitle : '' | ftc }}</span>
							<button type="button" class="close" @click="hideConfirmModalDialog">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body"><p class="padding-0-5" v-withSafeTags="localeFtc(confirmModalDialogText)"></p></div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" @click="confirmModalDialogCallback">{{ 'main/confirm' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>


		<!-- диалог объединения тикетов -->
		<transition name="modal">
			<div v-show="showMergeTicketsDialog" @click="showMergeTicketsDialog = false" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'ticket/merge' | ftc }}</span>
							<button type="button" class="close" @click="showMergeTicketsDialog = false">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<!-- select -->
							<div class="w5-form-row">
								<Field
									:isVisibleRow="true"
									:crud="crud"
									action="list"
									name="mergeTicketsSelectTicket"
									ref="mergeTicketsSelectTicket"
									v-model="mergeTicketsField.value"
									:listBlockToOut="1"
									:Field="mergeTicketsField"
									:removeRightPadding="true"
									:fieldInModal="true"
									@focus="mergeTicketsField._errMsg = ''" />
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" @click="mergeTicketsStart">{{ 'main/continue' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог показа ссылки для оплаты -->
		<transition name="modal">
			<div v-show="showPaymentLinkDialog" @click="hidePaymentLinkDialog" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container not-so-wide" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'operation/payment_link' | ftc }}</span>
							<button type="button" class="close" @click="hidePaymentLinkDialog">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<!-- text -->
							<div class="w5-form-row">
								<p class="payment-link">{{ 'operation/payment_link_description' | ftc }}</p>
							</div>
							<!-- link -->
							<div class="w5-form-row">
								<a ref="paymentLinkUrl" :href="paymentLinkUrl" target="_blank" class="payment-link">{{ paymentLinkUrl }}</a>
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" @click="copyPaymentLink">{{ 'main/copy_to_clipboard' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог показа документа -->
		<transition name="modal">
			<div v-show="showDocumentModalDialog" @click="hideDocumentModalDialog" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container for-document" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'document/document' | ftc }}</span>
							<button type="button" class="close" @click="hideDocumentModalDialog">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<div class="document-wrapper">
								<iframe width="100%" frameborder="0" id="documentFrame" name="documentFrame" seamless>
									Ваш браузер не поддерживает показ документа
								</iframe>
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span v-if="isPrintReady" class="btn btn-submit pull-left" @click="documentPrint">{{ 'main/print' | ftc }}</span>
							<a v-if="documentModalDialogLinkXml" :href="documentModalDialogLinkXml" class="btn btn-submit pull-right" download="download">{{ 'main/download XML' | ftc }}</a>
							<a v-if="documentModalDialogLinkPdf" :href="documentModalDialogLinkPdf" class="btn btn-submit pull-right" download="download">{{ 'main/download PDF' | ftc }}</a>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалога создания/восстановления бэкапа -->
		<backupDialog v-if="crud === 'backups'"
			:visible="showBackupDialog"
			:type="backupDialogType"
			:user-type="$store.state.user_type"
			:account-id="backupDialogAccount"
			:backup-id="backupDialogId"
			:backup-name="backupDialogName"
			@onClose="hideBackupDialog"
			@onAction="backupDialogStartProcess" />

		<!-- диалог переименования бэкапа -->
		<transition name="modal">
			<div v-show="showRenameBackupDialog" @click="hideRenameBackupDialog" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'main/name' | ftc }}</span>
							<button type="button" class="close" @click="hideRenameBackupDialog">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="padding: 10px 15px; text-align: left;">
							<!-- форма -->
							<form class="w5-from"><fieldset>
								<!-- заметка -->
								<div class="w5-form-row">
									<Field
										:isVisibleRow="true"
										:crud="crud"
										action="list"
										v-model="renameBackupValue"
										:Field="renameBackupField"
										:removeRightPadding="true"
										:fieldInModal="true"
										@enterKeyDown="renameBackupKeyDown"
										@focus="renameBackupField._errMsg = ''" />
								</div>
							</fieldset></form>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" @click="renameBackupStart">{{ 'service/rename_action' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог восстановления бэкапа во внешний диск -->
		<transition name="modal">
			<div v-show="showRestoreBackupOuterDiskDialog" @click="hideRestoreBackupOuterDiskDialog" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'service/restore' | ftc }}</span>
							<button type="button" class="close" @click="hideRestoreBackupOuterDiskDialog">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="padding: 10px 15px; text-align: left;">
							<!-- форма -->
							<form class="w5-from"><fieldset>
								<!-- поле -->
								<div class="w5-form-row">
									<Field
										:isVisibleRow="true"
										:crud="crud"
										action="list"
										v-model="restoreBackupOuterDiskValue"
										:Field="restoreBackupOuterDiskField"
										:removeRightPadding="true"
										:fieldInModal="true"
										:listBlockToOut="1"
										@focus="restoreBackupOuterDiskField._errMsg = ''"
										@input="restoreBackupOuterDiskFieldChanged" />
								</div>

								<div v-if="restoreBackupOuterDiskWarning" class="w5-form-row">
									<p v-withSafeTags="localeFtc(restoreBackupOuterDiskWarning)"></p>
								</div>
							</fieldset></form>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" @click="restoreBackupOuterDiskStart">{{ 'main/restore' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог создания/редактирования расписания бэкапов -->
		<transition name="modal">
			<div v-show="showBackupScheduleModal" @click="hideBackupScheduleModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container modal-form" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title' | ftc }}</span>
							<button type="button" class="close" @click="hideBackupScheduleModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div v-if="backupScheduleForm && backupScheduleForm.fields" class="modal-body">
							<!-- форма редактирования -->
							<form class="w5-from">
							<fieldset :disabled="form_Loading">

								<!-- поля -->
								<div v-for="(row, index) in backupScheduleForm.fields" :key="index" :class="{ 'w5-form-row': isVisibleScheduleField(row) }">
									<template v-if="row">
										<Field v-for="field in row"
											:key="field._field_name"
											:isVisibleRow="isVisibleScheduleField(row)"
											:fieldInModal="true"
											:action="backupScheduleMode"
											:Field="field"
											:listBlockToOut="1"
											crud="backupschedule"
											v-model="field.value"
											@valueChanged="fieldScheduleChanged(field)" />
									</template>
								</div>

							</fieldset>
							</form>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" :disabled="createScheduleEmpty" @click="createBackupScheduleBegin">{{ backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- диалог подключения внешнего диска/ISO -->
		<transition name="modal">
			<div v-show="showConnectOuterDiskDialog" @click="hideConnectOuterDiskDialog" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container wide" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ connectOuterDiskDialogMode == 'disk' ? 'main/attach main/disk' : 'service/iso_insert' | ftc }}</span>
							<button type="button" class="close" @click="hideConnectOuterDiskDialog">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body" style="padding: 10px 15px; text-align: left;">
							<!-- форма -->
							<form class="w5-from"><fieldset>
								<!-- заметка -->
								<div class="w5-form-row">
									<Field
										:isVisibleRow="true"
										:crud="crud"
										action="list"
										v-model="connectOuterDiskValue"
										:Field="connectOuterDiskField"
										:removeRightPadding="true"
										:fieldInModal="true"
										:listBlockToOut="1"
										@focus="connectOuterDiskField._errMsg = ''" />
								</div>
							</fieldset></form>

							<div class="margin-top-15 margin-bottom-10 margin-right-10">
								<p v-withSafeTags="localeFtc('service/iso_operation_warning')"></p>
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span
								class="btn btn-submit pull-right"
								@click="() => connectOuterDiskDialogMode == 'disk' ? connectOuterDiskDialogStartProcess() : connectISOOperDialogStartProcess()">{{ 'main/attach' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>


		<!-- просмотра данных -->
		<transition v-if="crud === 'logs' && $store.state.user_type === 'admin'" name="modal">
			<div v-show="showViewModal" @click="hideViewModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ viewData && viewData.title ? viewData.title : 'ippool/ippool' | ftc }}</span>
							<button type="button" class="close" @click="hideViewModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div v-if="viewKeys && viewKeys.length" class="modal-body">
							<!-- поля -->
							<div v-for="row in viewKeys" :key="row" class="w5-form-row">
								<viewComponent
									v-for="(field, idx) in viewSortDATA[row]" :key="row + '_' + idx"
									:data="viewData"
									:rowCount="viewSortDATA[row].length"
									:y="row"
									:x="idx"
									:field="field"
									crud="logsIpBlackList"
									realCrudName="logsIpBlackList"
									:firstElement="viewSortDATA && viewSortDATA['1'] && viewSortDATA['1'][0] ? viewSortDATA['1'][0] : null"
								/>
							</div>
							<!-- ===================================== -->
						</div>

						<!-- подвал -->
						<div v-if="viewData && viewData.__ip && viewData.__ip.can_flush === true" class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" @click="viewButtonProcedure">{{ 'main/delete' | ftc }}</span>
						</div>
						<div v-else class="padding-top-10"></div>
					</div>
				</div>
			</div>
		</transition>

		
		<!-- блок с локальным сообщением об успехе -->
		<transition name="fallingBlock" key="transitionSuccess">
			<div v-show="localSuccessMessage !== ''" class="alert alert-success font-size-90 falling-block" role="alert" style="margin-right: 10px; word-break: break-word;">
				<button @click="localSuccessMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				{{ localSuccessMessage | ftc }}
			</div>
		</transition>

		<!-- блок с последним комменитатором тикета -->
		<span class="ticket-last-commentator" :style="ticketLastCommentatorStyle"><span>{{ 'ticket/last_message_from: ' | ftc }}</span><strong>{{ ticketLastCommentator | ftc }}</strong></span>

	</template>
	<errorAlert v-else :message="form_ErrorMessage" />
</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import Helper from '../../helper/helper'
import filterPeriod from '@/components/widgets/filterPeriod'
import filterRadio from '@/components/widgets/filterRadio'
import filterBool from '@/components/widgets/filterBool'
import filterSelect from '@/components/widgets/filterSelect'
import filterLogs from '@/components/widgets/filterLogs'
import filterLabel from '@/components/widgets/filterLabel'
import filterDisk from '@/components/widgets/filterDisk'
import filterParams from '@/components/widgets/filterParams'
import paginator from '@/components/widgets/paginator'
import dropDownButton from '@/components/elements/btndropdown'
import oneOperButton from '@/components/elements/oneoper'
import Field from '@/components/elements/formfield'
import Money from '@/components/elements/money'
import backupDialog from '@/components/elements/backupdialog'
import calculator from '@/components/elements/calc'
import rackGraphic from '@/components/elements/rack'
import radioListComponent from '@/components/elements/radio'
import viewComponent from '@/components/elements/view'
import mixins from '@/mixins'
import { EventBus } from '@/bus.js'
import debounce from 'debounce'
import notice from '@/components/elements/notice'
import AdditionalServicesFilter from '@/helper/additional-services-filters'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'List',
	//=========================================================================
	// mixin'ы
	//=========================================================================
	mixins: [mixins],
	//=========================================================================
	// изменяемые локальные свойства
	//=========================================================================
	data() {
		return {
			// закешированные данные GET-запроса
			listData: false,

			// наименование CRUD-объекта (например: 'bonus')
			crud: null,

			// действие - по умолчани "list"
			action: 'list',

			// текущая страница в пагинаторе
			page: 1,
			// страницы в пагинаторе
			paginationPages: [],
			// последняя страница
			lastPage: 1,

			// локальное сообщение об ошибке
			localErrorMessage: '',
			// и об успехе
			localSuccessMessage: '',
			localSuccessMessageTimer: null,

			// индикатор загрузки таблицы
			table_Loading: false,

			// хендлер таймера тихого рефреша
			silenceRequestTimer: null,
			// здесь считаем сколько уже накопилось запросов
			silenceRequestTimerCounter: 0,

			// строки таблицы которые рендерятся
			// по таймауту сюда добавляются еше строки
			renderRows: false,
			initRows: false,
			// показывает/скрывает спинер при построении длинной таблицы
			buildTableSpiner: false,

			// быстрый поиск - записывается в localStorage
			fastSearchValue: '',

			// значение для черного списка IP
			ipBlackListValue: '',

			// данные для просмотра
			viewData: null,
			viewSortDATA: null,
			viewKeys: null,
			showViewModal: false,

			// фильтры - записывается в localStorage
			filters: {
				period: {
					visible: -1,
					// тут всегда СТРОКИ вида "2017-03-01 23:59:59" либо false
					valueBegin: false,
					valueEnd: false
				},
				radio: [],
				bool: {
					visible: -1,
					value: false
				},
				select: [],
				logs: {
					visible: -1,
					value: false
				},
				ticketLabel: {
					visible: -1,
					value: null
				},
				diskType: {
					visible: -1,
					value: null
				},
				planParams: {
					visible: -1,
					value: {
						cpu_min: null,
						cpu_max: null,
						ram_min: null,
						ram_max: null,
						disk_min: null,
						disk_max: null
					}
				}
			},

			// колонка по которой отсортирована таблица - записывается в localStorage
			sortedColumn: false,

			// активность кнопок
			buttons: {
				'on': {
					visible: false,
					active: false,
					icone: 'play'
				},
				'off': {
					visible: false,
					active: false,
					icone: 'stop'
				},
				'close': {
					visible: false,
					active: false,
					icone: 'lock'
				},
				'blockTicket': {
					visible: false,
					active: false,
					icone: 'times-circle',
					title: 'ticket/blacklist'
				},
				'migrate': {
					visible: false,
					active: false,
					icone: 'upload',
					title: 'service/migrate'
				},
				'closeTicket': {
					visible: false,
					active: false,
					icone: 'lock',
					title: 'main/closing'
				},
				'replaceTicket': {
					visible: false,
					active: false,
					icone: 'upload',
					title: 'ticketrule/action_move'
				},
				'serviceMove': {
					visible: false,
					active: false,
					icone: 'share-square',
					title: 'service/move'
				},
				'bulkDel': {
					visible: false,
					active: false,
					icone: 'trash-alt',
					title: 'main/deleting'
				},
				'exportCsv': {
					visible: false,
					active: false,
					icone: 'file-csv',
					title: 'main/export CSV'
				},
				'r_on': {
					visible: false,
					active: false,
					icone: 'play'
				},
				'r_off': {
					visible: false,
					active: false,
					icone: 'stop'
				},
				'ip_on': {
					visible: false,
					active: false,
					icone: 'play'
				},
				'ip_off': {
					visible: false,
					active: false,
					icone: 'stop'
				},
				'doc_status': {
					visible: false,
					active: false,
					icone: 'play'
				}
			},
			// видимость кнопки создания
			buttonCreateVisibe: false,

			// последняя запись с которой работали
			lastWorkedRowID: false,

			// количество выделенных записей на странице
			totalSelectedRowsCount: 0,

			// диалог удаления записи
			showDeleteModal: false,
			deleteModalTitle: '',
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,
			deleteRecordIdInProcess: [],
			// колбак функция диалога удаления по умолчанию
			deleteModalCallback: () => {},

			// даилог подтверждения действия
			showConfirmModalDialog: false,
			confirmModalDialogTitle: '',
			confirmModalDialogText: '',
			confirmModalDialogCallback: () => {},

			// флаг активности процесса перезагрузки домена
			domainRebootProcessing: false,

			// флаг активности процесса клонирования внешнего диска
			outerDiskCloneProcessing: {},

			// диалог блокировки/разблокировки записи
			showBlockModal: false,
			blockModalNoteRequired: false,
			blockModalWhat: '',
			blockRows: [],
			blockModalTitle: '',
			blockModalText: '',
			blockModalButtonTitle: '',
			blockModalSelectNoteValue: '',
			blockModalTextNoteValue: '',
			blockModalTextField: {
				type: 'textarea',
				title: 'notes/write_note',
				_field_name: 'blockModalTextNoteValue',
				_visible: true,
				_errMsg: ''
			},

			// диалог регистрации/нерегистрации серверами
			showRegisterModal: false,
			registerRows: [],
			registerModalWhat: '',
			registerModalText: '',
			registerModalButtonTitle: '',
			registerModalTitle: '',
			// значение блокировки ippool
			ippoolBlockValue: null,
			// значение статуса document
			documentStatusValue: null,

			// диалог миграции vds
			showMigrateModal: false,
			migrateRows: [],
			migrateModalSelectServerValue: false,
			migrateModalButtonDisabled: true,
			migrateModalServerField: {
				required: true,
				type: 'list',
				list: [],
				title: 'server/server',
				_field_name: 'migrateModalServerValue',
				_is_short: true,
				_visible: true,
				_errMsg: ''
			},

			// диалог переноса услуги
			showServiceMoveModal: false,
			serviceMoveRows: [],
			serviceMoveModalSelectAccountValue: false,
			serviceMoveModalButtonDisabled: true,
			serviceMoveModalButtonCounter: 0,
			serviceMoveModalButtonHandler: null,
			serviceMoveModalButtonTitle: 'service/move',
			serviceMoveModalAccountField: {
				required: true,
				type: 'list',
				list: [],
				title: 'account/account',
				url: '/service/move?search=account&q=',
				_field_name: 'serviceMoveModalAccountValue',
				_is_short: true,
				_visible: true,
				_errMsg: ''
			},

			// массовое удаление
			serviceBulkDelRows: [],
			showServiceBulkDelModal: false,
			serviceBulkDelModalButtonDisabled: true,
			serviceBulkDelModalButtonCounter: 0,
			serviceBulkDelModalButtonHandler: null,
			serviceBulkDelModalButtonTitle: '',

			// диалог перемещения тикетов
			showTicketMoveModal: false,
			ticketRows: [],
			ticketMoveModalSelectDepartmentValue: false,
			ticketMoveModalButtonDisabled: true,
			ticketMoveModalDepartmentField: {
				required: true,
				type: 'list',
				list: [],
				title: 'department/department',
				_field_name: 'ticketMoveModalDepartmentValue',
				_is_short: true,
				_visible: true,
				_errMsg: ''
			},

			// диалог блокировки тикетов
			showTicketBlockModal: false,
			ticketBlockRows: [],
			ticketBlockModalBody: '',
			ticketBlockModalTimer: 0,
			ticketBlockModalButtonTitle: '',
			ticketBlockModalTimerHandle: null,

			// диалог показа документа
			showDocumentModalDialog: false,
			documentModalDialogLinkPdf: null,
			documentModalDialogLinkXml: null,

			// данные для фильтра в любом CRUD
			crudFilter: false,

			// данные фильтра, полученного из HTTP-GET параметров
			httpGetFilter: false,
			// сам фильтр
			crudHttpGetFilter: false,

			// данные для глобального фильтра по аккаунту
			accountGlobalFilter: false,

			// диалог извлечения ISO
			isoModalTitle: '',
			showISOModal: false,
			isoModalText: '',
			isoID: null,
			isoParentID: null,
			isoBlockModalButtonTitle: '',

			// общий таймер блокировки диалога
			blockModalTimer: null,
			blockModalTimerHandler: null,

			// диалог конвертации для клиентов
			showPaymentModal: false,
			paymentFields: null,
			paymentMax: 0,
			paymentMin: 0,
			PaymentWarrning: false,
			PaymentWarrningAdditional: false,
			isPaymentModalButtonDisabled: false,

			// даилог калькулятора
			showCalcModal: false,

			// диалог стойки оборудования
			showRackGraphicModal: false,
			rackGraphicModalData: null,

			// popup-диалог пополнения баланса
			showBalancePopup: false,
			balanceValue: 0,
			balanceContainerStyle: false,
			balanceField: {
				required: true,
				type: 'money',
				title: 'operation/summa',
				_field_name: 'summa',
				_visible: true,
				_is_short: true,
				_errMsg: '',
				value: 0
			},

			// текущая позиция окна
			curWindowY: 0,

			// выбор метки для тикета
			showChoiceTicketLabelBlock: false,
			ticketLabelBlockStyle: '',
			ticketLabelItems: {},
			ticketLabelId: null,

			ticketDepartmentId: false,

			// пометка тикетов как прочитанные
			showMarkTicketsAsReadedDialog: false,

			// объединение тикетов
			showMergeTicketsDialog: false,
			mergeTicketsField: {
				required: true,
				_field_name: 'mergeTicketsSelectTicket',
				type: 'list',
				title: 'ticket/ticket',
				_visible: true,
				_is_modal: true,
				_errMsg: '',
				url: '/ticket/update/%ID%?search=ticket&q=',
				value: null
			},
			mergeTicketsOldId: null,

			// количество знаков после запятой
			countDigits: 2,

			// признак процесса пролонгации
			canProlongProcessing: false,

			// диалог ссылки для оплаты
			showPaymentLinkDialog: false,
			paymentLinkUrl: '',

			// таймер для запросов быстрого поиска
			fastSearchTimer: null,

			// последний комментатор
			ticketLastCommentator: '',
			ticketLastCommentatorStyle: { display: 'none', top: 0, left: 0 },

			// диалог подключения внешнего диска/ISO
			showConnectOuterDiskDialog: false,
			connectOuterDiskDialogMode: 'disk',
			connectOuterDiskDialogId: false,
			connectOuterDiskValue: '',
			connectOuterDiskField: {
				required: true,
				type: 'list',
				title: 'service/vds',
				_field_name: 'vdsId',
				_visible: true,
				_is_short: true,
				_errMsg: '',
				list: [],
				value: ''
			},

			// диалог создания/восстановления бэкапа
			showBackupDialog: false,
			backupDialogType: 'create-backup',
			backupDialogAccount: false,
			backupDialogId: false,
			backupDialogName: '',
			backupDialogCsrf: '',

			// даилог переименования
			showRenameBackupDialog: false,
			renameBackupId: false,
			renameBackupValue: '',
			renameBackupField: {
				required: true,
				type: 'text',
				title: 'service/backup',
				_field_name: 'backupName',
				_visible: true,
				_is_short: true,
				_errMsg: '',
				value: ''
			},

			// диалог восстановления бэкапа во внешний диск
			showRestoreBackupOuterDiskDialog: false,
			restoreBackupOuterDiskData: null,
			restoreBackupOuterDiskValue: '',
			restoreBackupOuterDiskField: {
				required: true,
				type: 'list',
				title: 'service/backup',
				_field_name: 'backup_id_for_outer_disk',
				_visible: true,
				_is_short: true,
				_errMsg: '',
				value: ''
			},
			restoreBackupOuterDiskWarning: '',
			restoreBackupOuterDiskNotice: '',

			// данные партнерки клиента
			clientPartnerData: null,

			// отключение фильтра
			showRemoveFilterModal: false,
			removeFilterValue: null,
			removeFilterID: null,
			removeFilterProcess: false,

			// копирование бэкапа
			showCopyToDcModal: false,
			copyToDcID: null,
			copyToDcForm: null,
			copyToDcFields: null,
			copyToDcCostInfo: '',
			copyToDcErrorMessage: '',

			// клонирование VDS через копирование бэкапа
			showVdsCloneModal: false,
			vdsCloneModalFieldBoolean: {
				type: 'boolean',
				title: 'main/vds_clone_field_boolean_title',
				_field_name: 'vdsCloneFieldBoolean',
				_visible: true,
				_errMsg: '',
				value: false
			},
			vdsCloneModalFieldBooleanValue: false,
			vdsCloneModalFieldList: {
				required: true,
				_field_name: 'vdsCloneFieldList',
				type: 'list',
				title: 'datacenter/datacenter',
				_visible: true,
				_is_modal: true,
				_errMsg: '',
				value: null
			},
			vdsCloneModalFieldListValue: null,
			vdsCloneID: null,
			vdsCloneName: null,
			vdsCloneProcessData: [],
			vdsCloneShowProcessDataValue: false,
			vdsCloneShowProcessDataInfo: null,

			// генерация ссылки на скачивание бэкапа
			showDownloadBackupModal: false,
			downloadBackupID: null,

			// данные в виде FormData
			FD: false,
			FD_count: 0,

			// массив колбаков которые вызываются после запроса данных
			afterRequestDataCallbacks: [],

			// данные для резервирования IP
			reserveIpLocalData: null,
			reserveIpValue: false,
			reserveIpProcessing: false,
			reserveIpCost: '',
			reserveIpVdsId: null,

			// расписания для автоматического бэкапа
			backupScheduleTableTitle: '',
			backupScheduleId: null,
			backupScheduleRows: [],
			backupScheduleMode: 'create',
			showBackupScheduleModal: false,
			backupScheduleForm: null,

			// таймер проверки загрузки файла
			timerDownloadFile: null
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		// если при создании все поля выключены
		createScheduleEmpty() {
			// если это не создание - кнопка включена
			if (this.backupScheduleMode !== 'create') return false

			// если нет формы - кнопка включена (вообще без разницы)
			if (!this.backupScheduleForm || !this.backupScheduleForm.fields || !this.backupScheduleForm.fields.length)
				return false

			// по умолчанию кнопка выключена
			let _result = true
			this.backupScheduleForm.fields.some(row => {
				if (row && row.length)
				{
					let _found = row.some(field => {
						if (field && field.type === 'boolean' && field.value)
						{
							return true
						}
					})

					// если нашли хотя бы один включенный пункт - кнопка включена
					if (_found)
					{
						_result = false
						return true
					}
				}
			})

			return _result
		},
		// список статусов для блокировки IPPOOL
		ippoolBlockStatuses() {
			let _answer = []

			if (!this.form_GetData ||
				!this.form_GetData.filters ||
				!this.form_GetData.filters.ip_status ||
				!this.form_GetData.filters.ip_status.list ||
				typeof this.form_GetData.filters.ip_status.list !== 'object')
				return _answer

			for (let id in this.form_GetData.filters.ip_status.list)
			{
				if (id === 'active') continue
				_answer.push({ id, name: this.form_GetData.filters.ip_status.list[id] })
			}

			return _answer
		},
		// список статусов для документов
		documentStatuses() {
			let _answer = []

			if (!this.form_GetData ||
				!this.form_GetData.filters ||
				!this.form_GetData.filters.document_status ||
				!this.form_GetData.filters.document_status.list ||
				typeof this.form_GetData.filters.document_status.list !== 'object')
				return _answer

			for (let id in this.form_GetData.filters.document_status.list)
			{
				if (id === 'new') continue
				_answer.push({ id, name: this.form_GetData.filters.document_status.list[id] })
			}

			return _answer
		},
		// фильтр crud у нас по "моим тикетам"?
		isCrudFilterOnMyTicket() {
			if (!this.crudFilter || !this.crudFilter.crud) return false

			if (this.crudFilter.crud === 'ticket' &&
				this.crudFilter.field === 'has_user_id' &&
				this.crudFilter.object)
				return true
			else
				return false
		},
		// доступен объект window?
		isPrintReady() {
			return window && window.print
		},
		// конфигурация
		Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig
			else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig
			else return false
		},
		// конфигурация списка
		listConfig() {
			if (this.crud && this.Config && this.Config[this.crud] && this.Config[this.crud]['list']) return this.Config[this.crud]['list']
			return false
		},
		// ссылки-подсказки
		linkHint() {
			if (this.crud && this.action &&
				this.Config &&
				this.Config[this.crud] &&
				this.Config[this.crud]['hint-link'] &&
				this.Config[this.crud]['hint-link'][this.action])
				return this.Config[this.crud]['hint-link'][this.action]

			return false
		},
		// наименование модели CRUD
		model() {
			if (this.crud && this.Config && this.Config[this.crud] && this.Config[this.crud]['model']) return this.Config[this.crud]['model']
			return this.formater_capitalizeFirstChar(this.crud) + 'Search'
		},
		// тип пользователя
		UserType() {
			return this.$store.state.user_type
		},
		// текущий адрес сервера приложения
		AppServerUrl() {
			return Vue.AppServerUrl
		},
		// кнопка на модальном диалоге удаления
		modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('main/delete')
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer)
		},
		// есть ли непрочитанные тикеты в списке
		isUnreadedTickets() {
			// проверка условий
			if (this.crud !== 'ticket' || this.$store.state.user_type !== 'client' ||
				!this.renderRows || !Array.isArray(this.renderRows) || !this.renderRows.length)
				return false

			// ищем хотя бы один тикет с непрочитанными сообщениями
			return this.renderRows.some(row => {
				if ('message_unread_count' in row && row['message_unread_count'] > 0)
					return true
			})
		},
		// заголовок HTTP-GET фильтра
		crudHttpFilterTitle() {
			let _title = ''
			if (this.crudHttpGetFilter)
			{
				if ('has_user_id' in this.crudHttpGetFilter && this.crudHttpGetFilter['has_user_id'] &&
					this.form_GetData && this.form_GetData.filters && this.form_GetData.filters['has_user_id'] && this.form_GetData.filters['has_user_id']['title'] &&
					this.form_GetData.filters['has_user_id']['text'])
				{
					if (_title === '') _title = this.form_GetData.filters['has_user_id']['title'] + ' = ' + this.form_GetData.filters['has_user_id']['text']
					else _title += ', ' + this.form_GetData.filters['has_user_id']['title'] + ' = ' + this.form_GetData.filters['has_user_id']['text']
				}

				if ('server_id' in this.crudHttpGetFilter && this.crudHttpGetFilter['server_id'] &&
					this.form_GetData && this.form_GetData.filters && this.form_GetData.filters['server_id'] && this.form_GetData.filters['server_id']['title'] &&
					this.form_GetData.filters['server_id']['text'])
				{
					if (_title === '') _title = this.form_GetData.filters['server_id']['title'] + ' = ' + this.form_GetData.filters['server_id']['text']
					else _title += ', ' + this.form_GetData.filters['server_id']['title'] + ' = ' + this.form_GetData.filters['server_id']['text']
				}

				if ('service_id' in this.crudHttpGetFilter && this.crudHttpGetFilter['service_id'] &&
					this.form_GetData && this.form_GetData.filters && this.form_GetData.filters['service_id'] && this.form_GetData.filters['service_id']['title'] &&
					this.form_GetData.filters['service_id']['text'])
				{
					if (_title === '') _title = this.form_GetData.filters['service_id']['title'] + ' = ' + this.form_GetData.filters['service_id']['text']
					else _title += ', ' + this.form_GetData.filters['service_id']['title'] + ' = ' + this.form_GetData.filters['service_id']['text']
				}

				if ('bonus_id' in this.crudHttpGetFilter && this.crudHttpGetFilter['bonus_id'] &&
					this.form_GetData && this.form_GetData.filters && this.form_GetData.filters['bonus_id'] && this.form_GetData.filters['bonus_id']['title'] &&
					this.form_GetData.filters['bonus_id']['text'])
				{
					if (_title === '') _title = this.form_GetData.filters['bonus_id']['title'] + ' = ' + this.form_GetData.filters['bonus_id']['text']
					else _title += ', ' + this.form_GetData.filters['bonus_id']['title'] + ' = ' + this.form_GetData.filters['bonus_id']['text']
				}

				if ('p2a_id' in this.crudHttpGetFilter && this.crudHttpGetFilter['p2a_id'] &&
					this.form_GetData && this.form_GetData.filters && this.form_GetData.filters['p2a_id'] && this.form_GetData.filters['p2a_id']['title'] &&
					this.form_GetData.filters['p2a_id']['text'])
				{
					if (_title === '') _title = this.form_GetData.filters['p2a_id']['title'] + ' = ' + this.form_GetData.filters['p2a_id']['text']
					else _title += ', ' + this.form_GetData.filters['p2a_id']['title'] + ' = ' + this.form_GetData.filters['p2a_id']['text']
				}
			}
			return _title
		},
		// количество активных фильтров
		countActiveFilters() {
			let _answer = 0

			for (let _type in this.filters) if (this.filters.hasOwnProperty(_type))
			{
				// получим текущий фильтр
				let _filter = this.filters[_type]
				// пропустим не нужные
				if (typeof _filter !== 'object' || _type === 'bool') continue

				// ищем свойство "visible"
				if ('visible' in _filter)
				{
					if (_filter['visible'] === true) _answer++
				}
				else
				{
					// идем глубже
					for (let _idx in _filter) if (_filter.hasOwnProperty(_idx))
					{
						let __filter = _filter[_idx]
						// ищем свойство "visible"
						if ('visible' in __filter)
						{
							if (__filter['visible'] === true) _answer++
						}
					}
				}
			}

			return _answer
		},
		// поддерживает ли браузер копирование в буфер
		browserSupportCopy() {
			return document.queryCommandSupported('copy') || parseInt(navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2]) >= 42
		},
		showCloseTicketButton() {
			return false
			/*
			let errorDepartmentIds = []
			if (this.AppName === 'vdsina')
			{
				errorDepartmentIds.push('13', '10', '5')
			}

			if (this.AppName === 'vdsina.com')
			{
				errorDepartmentIds.push('3', '2')
			}

			if (this.AppName === 'macloud')
			{
				errorDepartmentIds.push('3', '2')
			}

			return this.$store.state.ticketData && 'currentDepartmentId' in this.$store.state.ticketData &&
				errorDepartmentIds.indexOf(String(this.$store.state.ticketData.currentDepartmentId)) > -1
			*/
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// debounce
		this.afterRequestListData = debounce(this.afterRequestListData, 200)

		// фильтр для additional-services
		AdditionalServicesFilter.init()

		// если не авторизован
		if (!this.$store.state.is_auth)
		{
			// если это список операций
			if (this.$route.path === '/operation/list')
			{
				// получим хеш
				let hash = window && window.sessionStorage ? window.sessionStorage.getItem('operation_hash') : null
				// если хеш есть
				if (hash)
				{
					// редирект в просмотр
					return this.$router.push('/operation/view/' + hash)
				}
				// если хеша нет - будет редирект на страницу логина
			}

			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		this.maskModalFlag = false

		// фильтр по HTTP-GET параметрам - смотрим тут, иначе дальше
		// могут сделать router.replace и параметры потеряются
		this.getFilterFromUrl()

		// инициализация начальных данных по URL
		this.initData(this.$route.path)

		// инициализация фильтров по конфигурации
		this.initFilters()

		// получим данные из localStorage
		this.getLocalStorage()

		// получим данные из глобального состояния
		this.getDataFromVuex()

		// получим данные из GET-параметров
		this.getDataFromUrl()

		// теперь можно запросить данные
		if (this.crud)
		{
			this.requestListData()
			this.getClientPartnerInfo()

			// получим данные о каждом процессе
			this.vdsCloneProcessDataGet()
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
		document.addEventListener('click', this.clickHandler)
		window.addEventListener('scroll', this.windowScroll)
		window.addEventListener('resize', this.windowResize)
		window.addEventListener('storage', this.onLocalStorageEvent)

		// подписка на получение данных пользователя с сервера
		EventBus.$on('w5-user-options-on-server-get', this.getLocalStorage)

		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)

		// подписка на событие - блокировка сообщения
		EventBus.$on('w5-block-application', this.blockApplicationHandler)

		// подписка на событие - сообщение от планировщика
		EventBus.$on('w5-cron-task-answer', this.cronTaskAnswer)

		// сразу идет установка размера окна диалога документа
		this.windowResize()

		// если это бэкапы
		if (this.crud === 'backups')
		{
			// есть ли указание - сразу запустить форму создания бэкапа?
			let _data = window && window.sessionStorage ? window.sessionStorage.getItem('create-backup') : null
			// если есть
			if (_data)
			{
				// сразу удалим из сессии
				window.sessionStorage.removeItem('create-backup')
				// собираем данные для диалога
				this.backupDialogType = 'create-backup'
				this.backupDialogId = false
				this.backupDialogName = ''
				this.backupDialogAccount = false
				if (this.$store.state.user_type !== 'admin')
					// для клиентов можно без аккаунта делать запрос
					this.backupDialogAccount = true
				else
				{
					// для сотрудников, только если установлен глобальный фильтр
					if (this.accountGlobalFilter && this.accountGlobalFilter.text)
					{
						let _numStr = String(this.accountGlobalFilter.text).replace(/\D/g, '')
						let _num = parseInt(_numStr)
						if (!isNaN(_num))
							this.backupDialogAccount = _num
					}
				}

				// показываем диалог - создать бэкап
				this.openBackupDialog()
			}

			// если есть указание сразу запустить диалог копирования бэкапа
			_data = window && window.sessionStorage ? window.sessionStorage.getItem('copy-backup') : null
			// если есть
			if (_data)
			{
				// сразу удалим из сессии
				window.sessionStorage.removeItem('copy-backup')
				this.afterRequestDataCallbacks.push(async () => {
					// сначала запросим данные о бэкапе
					const _result = await this.$http.get(Vue.APIServerUrl + '/service/list?ServiceSearch[service_id]=' + _data)
					if (!_result ||
						!_result.body ||
						_result.body.status !== 'ok' ||
						!_result.body.rows ||
						!_result.body.rows.length) {
						return
					}

					this.copyToDc(_result.body.rows[0])
				})
			}
		}
	},
	//=========================================================================
	// отрендерены все изменения
	//=========================================================================
	updated() {
		// есть ли позиция окна в Vuex
		let _pathRoute = this.crud + this.page
		if (this.$store.state.lastWindowY && this.$store.state.lastWindowY[_pathRoute])
		{
			// установим позицию окна после паузы - так как в паузу могут быть еще изменения в рендеринге
			let _y = this.$store.state.lastWindowY[_pathRoute]
			if (_y) setTimeout(() => window.scrollTo(0, _y), 200)

			// обнулим ее
			this.$store.commit('setLastWindowY', {
				'url': _pathRoute,
				'y': false
			})
		}
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// убираем обработчики событий
		document.removeEventListener('keydown', this.keyDownHandler)
		document.removeEventListener('click', this.clickHandler)
		window.removeEventListener('scroll', this.windowScroll)
		window.removeEventListener('resize', this.windowResize)
		window.removeEventListener('storage', this.onLocalStorageEvent)

		// остановим все таймеры
		this.stopAllTimers()

		// описка от события
		EventBus.$off('w5-user-options-on-server-get', this.getLocalStorage)

		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)

		// отписка
		EventBus.$off('w5-block-application', this.blockApplicationHandler)

		// отписка
		EventBus.$off('w5-cron-task-answer', this.cronTaskAnswer)
	},
	//=========================================================================
	// наблюдаем переходы между CRUD внутри одного и того же компонента
	//=========================================================================
	watch: {
		'$route': function(to, from) {
			// запомним старый CRUD
			let _oldCRUD = this.crud
			let _oldAction = this.action
			let _oldTicketDepartmentId = this.ticketDepartmentId
			let _oldVdsGroupId = from.params['groupId']
			let _oldPage = this.page

			// фильтр по HTTP-GET параметрам - смотрим тут, иначе дальше
			// могут сделать router.replace и параметры потеряются
			this.getFilterFromUrl()

			// инициируем основные данные, в частности и this.crud
			this.initData(to.path)

			// узнаем - произошла ли смена пути
			let _isChanged = false
			// если сменился CRUD - 100% смена пути
			if (_oldCRUD !== this.crud) _isChanged = true
			else
			{
				// если нет смены пути - может есть смена группы?
				if (this.crud === 'certificate' || this.crud === 'domains')
				{
					if (to && to.params && 'groupId' in to.params &&
						from && from.params && 'groupId' in from.params &&
						to.params['groupId'] !== from.params['groupId'])
						// CRUD не сменился, но сменилась группа
						_isChanged = true
				}
			}

			// если произошла смена пути
			if (_isChanged)
			{
				// обнулим закешированные данные
				this.listData = false

				// обнулим записи таблицы для рендера
				this.renderRows = false
				this.initRows = false

				// обнулим быстрый поиск
				this.fastSearchValue = null

				// обнулим колонку сортировки
				this.sortedColumn = false

				// инициализация фильтров по конфигурации
				this.initFilters()

				// получим данные из localStorage
				this.getLocalStorage()

				// получим данные из глобального состояния
				this.getDataFromVuex()
			}

			// получим данные из GET-параметров
			this.getDataFromUrl()

			// теперь можно запросить данные
			if (this.crud)
			{
				// частные случаи: тут могут быть варианты
				if (this.crud === 'ticket')
				{
					// делаем запрос - только если что то существенное поменялось
					if (_oldCRUD !== this.crud ||
						_oldAction !== this.action ||
						_oldTicketDepartmentId !== this.ticketDepartmentId ||
						_oldPage !== this.page)
						this.requestListData()
				}
				else if (this.crud === 'vds' || this.crud === 'certificate' || this.crud === 'domains')
				{
					// делаем запрос - только если что то существенное поменялось
					if (_oldCRUD !== this.crud ||
						_oldAction !== this.action ||
						_oldPage !== this.page ||
						_oldVdsGroupId !== to.params['groupId'])
						this.requestListData()
				}
				// для других случаев делаем запрос без вариантов
				else this.requestListData()

				// для клиентов в партнерке
				this.getClientPartnerInfo()

				// получим данные о каждом процессе клонирования vds
				this.vdsCloneProcessDataGet()
			}
		}
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// приложение заблокировали
		//---------------------------------------------------------------------
		blockApplicationHandler() {
			// остановим все таймеры
			this.stopAllTimers()
		},
		//---------------------------------------------------------------------
		// останавливает все таймеры
		//---------------------------------------------------------------------
		stopAllTimers() {
			// если активен таймер удаления
			if (this.deleteModalTimerHandle)
			{
				clearInterval(this.deleteModalTimerHandle)
				this.deleteModalTimerHandle = null
			}

			if (this.blockModalTimerHandler) {
				clearInterval(this.blockModalTimerHandler)
				this.blockModalTimerHandler = null
			}

			// если активен таймер блокировки тикетов
			if (this.ticketBlockModalTimerHandle)
			{
				clearInterval(this.ticketBlockModalTimerHandle)
				this.ticketBlockModalTimerHandle = null
			}

			// если есть запрос на тихий рефреш
			if (this.silenceRequestTimer)
			{
				clearTimeout(this.silenceRequestTimer)
				this.silenceRequestTimer = null
			}

			// если активен таймер быстрого поиска
			if (this.fastSearchTimer)
			{
				clearTimeout(this.fastSearchTimer)
				this.fastSearchTimer = null
			}

			if (this.serviceMoveModalButtonHandler)
			{
				clearInterval(this.serviceMoveModalButtonHandler)
				this.serviceMoveModalButtonHandler = null
			}

			if (this.serviceBulkDelModalButtonHandler)
			{
				clearInterval(this.serviceBulkDelModalButtonHandler)
				this.serviceBulkDelModalButtonHandler = null
			}

			if (this.timerDownloadFile)
			{
				clearInterval(this.timerDownloadFile)
				this.timerDownloadFile = null
			}
		},
		//---------------------------------------------------------------------
		// получает значение счетчика в партнерке
		//---------------------------------------------------------------------
		getClientPartnerInfo() {
			// для клиентов в партнерке
			if (this.crud === 'partner' && this.$store.state.user_type !== 'admin')
			{
				this.clientPartnerData = null
				this.$http.get(Vue.APIServerUrl + '/partner/list?additional=getCounters')
				.then(res => {
					if (res &&
						res.data &&
						res.data.status === 'ok' &&
						res.data.result && res.data.result.accounts)
					{
						this.clientPartnerData = res.data.result.accounts
					}
				})
				.catch(() => {})
			}
		},
		//---------------------------------------------------------------------
		// есть ли ID VDS в списке процессов клонирования VDS
		//---------------------------------------------------------------------
		vdsCloneVdsInProcess(vdsId) {
			if (this.crud !== 'vds') return null
			if (!this.vdsCloneProcessData || !this.vdsCloneProcessData.length) return null

			for (let i = 0; i < this.vdsCloneProcessData.length; i++)
			{
				if (this.vdsCloneProcessData[i].id === vdsId) return this.vdsCloneProcessData[i]
			}

			return null
		},
		//---------------------------------------------------------------------
		// инициализация кнопки экспорта записей в CSV
		//---------------------------------------------------------------------
		exportCsvButtonInit() {
			// видна всегда и для всех
			this.buttons['exportCsv']['visible'] = true

			// активность
			if (this.$store.state.user_type !== 'admin')
			{
				// для клиентов всегда активна
				this.buttons['exportCsv']['active'] = true
			}
			else
			{
				// для админов активна только когда включен глобальный фильтр
				this.buttons['exportCsv']['active'] = Boolean(this.accountGlobalFilter && this.accountGlobalFilter.text)
			}
		},
		//---------------------------------------------------------------------
		// закрытие всех фильтров
		//---------------------------------------------------------------------
		closeAllFilters() {
			for (let _type in this.filters) if (this.filters.hasOwnProperty(_type))
			{
				// получим текущий фильтр
				let _filter = this.filters[_type]
				// пропустим не нужные
				if (typeof _filter !== 'object' || _type === 'bool') continue

				// ищем свойство "visible"
				if ('visible' in _filter)
				{
					if (_filter['visible'] === true)
						this.toggleFilter(_type)
				}
				else
				{
					// идем глубже
					for (let _idx in _filter) if (_filter.hasOwnProperty(_idx))
					{
						let __filter = _filter[_idx]
						// ищем свойство "visible"
						if ('visible' in __filter)
						{
							if (__filter['visible'] === true)
								this.toggleFilter(_type, _idx)
						}
					}
				}
			}

			// удалим Http фильтр
			this.$set(this, 'crudHttpGetFilter', false)
		},
		//---------------------------------------------------------------------
		// инициализация начальных данных
		//---------------------------------------------------------------------
		initData(path) {
			// обнуляем основные значения
			this.crud = null
			this.localErrorMessage = ''
			this.deleteRecordIdInProcess = []
			// намерено ставим "null", а не "false"
			// тогда в просмотре из "Все" - значение будет null
			this.ticketDepartmentId = null

			// если активен таймер быстрого поиска
			if (this.fastSearchTimer)
			{
				clearTimeout(this.fastSearchTimer)
				this.fastSearchTimer = null
			}

			// если активен таймер удаления
			if (this.deleteModalTimerHandle)
			{
				clearInterval(this.deleteModalTimerHandle)
				this.deleteModalTimerHandle = false
			}

			// если активен таймер блокировки тикетов
			if (this.ticketBlockModalTimerHandle)
			{
				clearInterval(this.ticketBlockModalTimerHandle)
				this.ticketBlockModalTimerHandle = false
			}

			// если активен таймер блокировки диалога
			if (this.blockModalTimerHandler)
			{
				clearInterval(this.blockModalTimerHandler)
				this.blockModalTimerHandler = null
			}

			// если есть запрос на тихий рефреш
			if (this.silenceRequestTimer)
			{
				clearTimeout(this.silenceRequestTimer)
				this.silenceRequestTimer = null
			}

			// прячем наши модальные диалоги
			this.hideDeleteModal()
			this.hideConfirmModalDialog()
			this.hideBlockModal()
			this.hideRegisterModal()
			this.hideRemoveFilterModal()
			this.hideMigrateModal()
			this.hideServiceMoveModal()
			this.hideServiceBulkDelModal()
			this.hideTicketMoveModal()
			this.hideTicketBlockModal()
			this.hideISOModal()
			this.hideViewModal()
			this.hidePaymentModal()
			this.hideCalcModal()
			this.hideRackGraphicModal()
			this.hideBalancePopup()
			this.hideTicketLabelBlock()
			this.hideDocumentModalDialog()
			this.hideBackupDialog()
			this.hideConnectOuterDiskDialog()
			this.hideCopyToDcModal()
			this.hideVdsCloneModal()
			this.hideVdsCloneProcessInfoModal()
			this.hideDownloadBackupModal()
			this.hideRenameBackupDialog()
			this.hideRestoreBackupOuterDiskDialog()
			this.hideBackupScheduleModal()

			// парсим входящий URL
			let _urlParts = path
				.substr(path.charAt(0) === '/' ? 1 : 0)
				.split('/')
			// должны быть минимум две части
			if (_urlParts.length < 2 ||
				!_urlParts[0] || !_urlParts[0].length ||
				!_urlParts[1] || !_urlParts[1].length)
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}
			// если вторая часть это не "list" и не "department"
			if (_urlParts[1] !== 'list' && _urlParts[1] !== 'department')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// получим наименование CRUD и действие
			this.crud = _urlParts[0]
			this.action = _urlParts[1]

			// если это вкладка тикетов по отделу
			if (this.crud === 'ticket' && this.action === 'department')
			{
				// нужно получить ID отдела
				this.ticketDepartmentId = this.$route.params['depid'] && this.$route.params['depid'].length ? parseInt(this.$route.params['depid']) : false
				if (isNaN(this.ticketDepartmentId) || this.ticketDepartmentId <= 0) this.ticketDepartmentId = false

				// если в итоге ID отдела нет
				if (!this.ticketDepartmentId)
				{
					// делаем редирект на общий список
					this.$router.push('/ticket/list')
					return
				}
			}

			// в любом случае сохраним ID отдела в Vuex
			this.$store.commit('setTicketDepartmentId', this.ticketDepartmentId)

			// получим страницу
			this.page = this.$route.params['page'] && this.$route.params['page'].length ? parseInt(this.$route.params['page']) : 1
			if (isNaN(this.page)) this.page = 1
			// если страница отрицательная - изменим на 1
			if (this.page <= 1)
			{
				// уберем страницу
				this.page = 1
				// с вкладки тикетов по отделу
				if (this.crud === 'ticket' && this.action === 'department') this.$router.replace('/ticket/department/' + this.ticketDepartmentId)
				// если это ipptrpool или iphistory
				else if (this.crud === 'ipptrpool' || this.crud === 'iphistory')
				{
					// ничего не делаем
				}
				// в любом другом случае
				else this.$router.replace('/' + _urlParts[0] + (_urlParts[1] ? '/' + _urlParts[1] : ''))
			}
			// сразу сохраним номер страницы в Vuex
			if (this.crud && this.page)
				this.$store.commit('setLastPage', { 'crud': this.crud, 'page': this.page })

			// видимость кнопок
			for (let b in this.listConfig['buttons'])
			{
				// если это кнопка создания
				if (b === 'create') this.buttonCreateVisibe = this.isAccess('/' + this.crud + '/create')

				// рассматриваем кнопки для строк
				if (b in this.buttons)
				{
					// видимы или нет в зависимости от прав
					if (b === 'migrate') this.buttons[b]['visible'] = this.isAccess('service/migrate')
					else if (b === 'serviceMove') this.buttons[b]['visible'] = this.isAccess('service/move')
					else if (b === 'bulkDel') this.buttons[b]['visible'] = this.isAccess('service/delete')
					else this.buttons[b]['visible'] = this.isAccess(this.crud + '/update')
					// по умолчанию всегда неактивны
					this.buttons[b]['active'] = false

					// если это кнопка экспорта
					if (b === 'exportCsv') this.exportCsvButtonInit()
				}
			}

			// обнулим записи для диалогов
			this.blockRows = []
			this.migrateRows = []
			this.serviceMoveRows = []
			this.serviceBulkDelRows = []

			// если такой страницы нет в списке
			if (!this.listConfig)
			{
				this.crud = null
				this.$router.push('/404')
			}
		},
		//---------------------------------------------------------------------
		// инициализация фильтров
		//---------------------------------------------------------------------
		initFilters() {
			// обнулим все фильтры
			// 1. период
			this.filters.period.visible = -1 // -1 значение - скрытый фильтр
			this.filters.period.valueBegin = false
			this.filters.period.valueEnd = false
			// 2. радио
			this.filters.radio = []
			// 3. bool
			this.filters.bool.visible = -1
			this.filters.bool.value = false
			// 4. select
			this.filters.select = []
			// 5. logs
			this.filters.logs.visible = -1
			this.filters.logs.value = false
			// 6. ticket-label
			this.filters.ticketLabel.visible = -1
			this.filters.ticketLabel.value = null
			// 7. disk-type
			this.filters.diskType.visible = -1
			this.filters.diskType.value = null

			// а есть ли вообще фильтры?
			if (!this.listConfig['filters']) return

			// бежим по всем фильтрам
			for (let f in this.listConfig['filters'])
			{
				// одиночные фильтры пропускаем, так как они всегда одини
				if (f === 'period' || f === 'bool' || f === 'logs' || f === 'ticketLabel' || f === 'diskType') continue

				// если это radio
				if (f === 'radio' && typeof this.listConfig['filters']['radio'] === 'object')
				{
					// это должен быть Объект
					let _radio = this.listConfig['filters']['radio']
					// бежим по всем свойствам объекта
					for (let r in _radio)
					{
						this.filters.radio.push({
							'field': r,
							'title': _radio[r],
							'visible': -1,
							// значение будет инициализировано в функции "requestListData"
							'value': null
						})
					}
				}

				// если это select
				if (f === 'select' && typeof this.listConfig['filters']['select'] === 'object')
				{
					// это должен быть Объект
					let _select = this.listConfig['filters']['select']
					// бежим по всем свойствам объекта
					for (let s in _select)
					{
						this.filters.select.push({
							'field': s,
							'title': _select[s],
							'visible': -1,
							'value': { id: -1, name: 'main/list_all' }
						})
					}
				}
			}
		},
		//---------------------------------------------------------------------
		// асинхронное построение таблицы
		//---------------------------------------------------------------------
		moveRows() {
			// если записи закончились
			if (!this.initRows || !this.initRows.length)
			{
				this.initRows = false
				this.buildTableSpiner = false
				this.buttonsForSelectedRow()
				return
			}

			// иначе - запускаем асинхронно переливание
			setTimeout(() => {
				// переливаем записи
				this.renderRows = this.renderRows.concat(this.initRows.slice(0, 50))
				this.initRows = this.initRows.slice(50)

				// покажем спинер
				if (this.renderRows.length > 100) this.buildTableSpiner = true

				// запускам снова
				this.moveRows()
			}, 100)
		},
		//---------------------------------------------------------------------
		// функция - выбор значения radio-фильтра
		//---------------------------------------------------------------------
		PreRequestListDataRadioFilter(data) {
			// частный случай - фильтр в заметках по объекту
			if (this.crud === 'notes' && data['field'] === 'note_object')
			{
				// если есть отдельный фильтр - чистим его
				if (this.crudFilter && this.crudFilter['crud'] === 'notes')
				{
					// чистим везде, где этот фильтр есть
					this.$set(this, 'crudFilter', false)
					this.$store.commit('setCrudFilter', false)
				}
			}

			// теперь можно делать запрос данных
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// функция - выбор значения select-фильтра
		//---------------------------------------------------------------------
		PreRequestListDataSelectFilter(data) {
			// запрос данных
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// инициализация фильтра запроса
		//---------------------------------------------------------------------
		initRequestFilters() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// инициализация объекта параметров запроса
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _getParams = {}
			_getParams[this.model] = {}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим данные фильтров и установим их
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть фильтр по периоду
			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['period'] && this.filters.period.visible !== -1)
			{
				let _filter = this.filters.period
				if (_filter.valueBegin)
					_getParams[this.model][this.listConfig['filters']['period']['begin_field']] = _filter.valueBegin
				if (_filter.valueEnd)
					_getParams[this.model][this.listConfig['filters']['period']['end_field']] = _filter.valueEnd
			}

			// если есть фильтры-radio
			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['radio'] && this.filters.radio)
			{
				// бежим по всем фильтрам
				this.filters.radio.forEach((item) => {
					if (item.visible === true && item.value !== null && item.value !== undefined)
					{
						_getParams[this.model][item.field] = item.value
					}
				})
			}

			// если есть фильтры-select
			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['select'] && this.filters.select)
			{
				// бежим по всем фильтрам
				this.filters.select.forEach((item) => {
					if (item.multiselect)
					{
						if (item.visible === true && item.value !== null && item.value !== undefined && item.value.length)
						{
							//_getParams[this.model][item.field] = item.value.id
							const _filterValue = AdditionalServicesFilter.filterValue(item.value)
							if (_filterValue)
							{
								_getParams[this.model][item.field] = _filterValue
							}
						}
					}
					else
					{
						if (item.visible === true && item.value !== null && item.value !== undefined &&
							item.value.id !== null && item.value.id !== undefined && String(item.value.id) !== '-1')
						{
							_getParams[this.model][item.field] = item.value.id
						}
					}
				})
			}

			// если есть фильтры-bool - устанавливаем значение только при TRUE
			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['bool'] && this.listConfig['filters']['bool']['field'] &&
				this.filters.bool && this.filters.bool.visible !== -1 && this.filters.bool['value'] === true)
			{
				_getParams[this.model][this.listConfig['filters']['bool']['field']] = true
			}

			// если есть фильтр по логам
			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['logs'] && this.listConfig['filters']['logs']['field'] &&
				this.filters.logs && this.filters.logs.visible !== -1 && this.filters.logs.value)
			{
				_getParams[this.model][this.listConfig['filters']['logs']['field']] = this.filters.logs.value
			}

			// если есть фильтр ticket-label
			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['ticketLabel'] &&
				this.filters.ticketLabel && this.filters.ticketLabel.visible !== -1 && this.filters.ticketLabel.value)
			{
				_getParams[this.model]['ticket_label'] = this.filters.ticketLabel.value
			}

			// если есть фильтр disk-type
			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['diskType'])
			{
				if (this.filters.diskType.visible === true && this.filters.diskType.value) {
					_getParams[this.model]['service_type_id'] = this.filters.diskType.value
				} else {
					_getParams[this.model]['service_type_id'] = `${Vue.Constants.SERVICE_TYPE_EXTDISK_HDD},${Vue.Constants.SERVICE_TYPE_EXTDISK_NVME}`
				}
			}

			// если есть фильтр plan-params
			if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['planParams'] &&
				this.filters.planParams && this.filters.planParams.visible !== -1 && this.filters.planParams.value)
			{
				if (this.filters.planParams.value.cpu_min !== null && this.filters.planParams.value.cpu_min !== undefined &&
					this.filters.planParams.value.cpu_max !== null && this.filters.planParams.value.cpu_max !== undefined)
				{
					_getParams[this.model]['cpu_min'] = this.filters.planParams.value.cpu_min
					_getParams[this.model]['cpu_max'] = this.filters.planParams.value.cpu_max
				}

				if (this.filters.planParams.value.ram_min !== null && this.filters.planParams.value.ram_min !== undefined &&
					this.filters.planParams.value.ram_max !== null && this.filters.planParams.value.ram_max !== undefined)
				{
					_getParams[this.model]['ram_min'] = this.filters.planParams.value.ram_min
					_getParams[this.model]['ram_max'] = this.filters.planParams.value.ram_max
				}

				if (this.filters.planParams.value.disk_min !== null && this.filters.planParams.value.disk_min !== undefined &&
					this.filters.planParams.value.disk_max !== null && this.filters.planParams.value.disk_max !== undefined)
				{
					_getParams[this.model]['disk_min'] = this.filters.planParams.value.disk_min
					_getParams[this.model]['disk_max'] = this.filters.planParams.value.disk_max
				}
			}

			// если есть отдельный фильтр
			if (this.crudFilter && this.crudFilter['crud'] === this.crud)
			{
				// фильтров-дупликатов нет - можем ставить отдельный фильтр
				let _crudField = this.crudFilter['field'] ? this.crudFilter['field'] : this.crudFilterField()
				if (this.$store.state.accountGlobalFilter === true && _crudField === 'account_id')
				{
					// ничего не нужно делать
					this.crudFilter = false
				}
				else if (_crudField) _getParams[this.model][_crudField] = this.crudFilter['object']
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть фильтр по модели и он еще не установлен
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.$store.state.modelFilter)
			{
				if (!_getParams[this.model][this.$store.state.modelFilter['field']])
					_getParams[this.model][this.$store.state.modelFilter['field']] = this.$store.state.modelFilter['value']
			}
			// обнулим значение в любом случае
			this.$store.commit('setModelFilter', false)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// частный случай - редиректы со старых URLов списков VDS
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.crud === 'vds' && this.$store.state.filteredGroupId)
			{
				_getParams[this.model]['group_id'] = this.$store.state.filteredGroupId
				this.filters.radio.some(item => {
					if (item.field === 'group_id')
					{
						item.value = this.$store.state.filteredGroupId
						item.visible = true
						return true
					}
				})
				this.setLocalStorage()
				this.$store.commit('setFilteredGroupId', null)
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим данные строки быстрого поиска
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// текст не задан - смотрим в модель
			if (this.fastSearchValue !== null && this.fastSearchValue !== undefined && this.fastSearchValue !== '')
				_getParams[this.model]['fast_search'] = this.fastSearchValue

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть HTTP-GET фильтр - добавим из него данные в фильтр
			// но не перезаписываем поверх уже установленных фильтров
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.crudHttpGetFilter && this.crudHttpGetFilter['__crud'] === this.crud)
			{
				// добавим фильтры из параметров запроса
				for (let _prop in this.crudHttpGetFilter) if (this.crudHttpGetFilter.hasOwnProperty(_prop))
				{
					// служебно поле пропустим
					if (_prop.substr(0, 2) === '__') continue

					// если в фильтре еще нет такого поля - установим значение
					if (!(_prop in _getParams[this.model])) _getParams[this.model][_prop] = this.crudHttpGetFilter[_prop]
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// установим колонку сортировки
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.sortedColumn !== false)
				_getParams['sort'] = this.sortedColumn.charAt(0) === '+' ? this.sortedColumn.substr(1) : this.sortedColumn

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// вернем готовый фильтр
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			return _getParams
		},
		//---------------------------------------------------------------------
		// запрос списка
		//---------------------------------------------------------------------
		requestListData(silenceMode = false) {
			// если CRUD неопределен - не делаем ничего
			if (!this.crud) return

			// загрузка таблицы началась
			if (!silenceMode) this.table_Loading = true
			this.$store.commit('ListTableLoading', true)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// обнуляем основные данные, которые зависят от данных сервера
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.totalSelectedRowsCount = 0

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// по умолчанию - отключаем все кнопки
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			for (let _b in this.buttons) this.buttons[_b]['active'] = false

			// кнопка экспорта в csv
			this.exportCsvButtonInit()

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// запоминаем выделенные строки
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _selectedRows = {}
			if (this.renderRows && this.renderRows.length)
				this.renderRows.forEach(row => {
					if (row && row['w5-row-selected'] === true)
					{
						_selectedRows[String(row[this.listConfig['column_id']])] = 1
					}
				})

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// инициализация объекта параметров запроса
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _getParams = this.initRequestFilters()

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// готовим URL
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _url = '/'
			// crud - отдельные случаи
			if (this.crud === 'vds')
			{
				_url += 'service'
				_getParams[this.model]['service_type_id'] = Vue.Constants.SERVICE_TYPE_VDS
			}
			else if (this.crud === 'iso')
			{
				_url += 'service'
				_getParams[this.model]['service_type_id'] = Vue.Constants.SERVICE_TYPE_ISO
			}
			else if (this.crud === 'backups')
			{
				_url += 'service'
				_getParams[this.model]['service_type_id'] = Vue.Constants.SERVICE_TYPE_BACKUP_VDS
			}
			else if (this.crud === 'disks')
			{
				_url += 'service'
			}
			else if (this.crud === 'additional-services')
			{
				_url += 'service'
				if (!_getParams[this.model]['service_type_id'])
				{
					_getParams[this.model]['service_type_id'] = AdditionalServicesFilter.all_ids
				}
			}
			else if (this.crud === 'certificate')
			{
				_url += 'service'
				_getParams[this.model]['service_type_id'] = Vue.Constants.SERVICE_TYPE_SSL
			}
			else if (this.crud === 'domains')
			{
				_url += 'service'
				_getParams[this.model]['service_type_id'] = Vue.Constants.SERVICE_TYPE_DOMAIN
			}
			else if (this.crud === 'dns')
			{
				_url += 'service'
				_getParams[this.model]['service_type_id'] = Vue.Constants.SERVICE_TYPE_DNS
			}
			else if (this.crud === 'ipptrpool')
			{
				_url += 'ipptrpool'
				_getParams['ip_id'] = this.$route.query.id
			}
			else if (this.crud === 'iphistory')
			{
				_url += 'ippool'
				_getParams['ip_id'] = this.$route.query.id
			}
			else if (this.crud === 'planarchive')
			{
				_url += 'plan'
			}
			else if (this.crud === 'ticket' && this.action === 'department')
			{
				_url += 'ticket'
				_getParams[this.model]['department_id'] = this.ticketDepartmentId
			}
			// crud - по умолчанию
			else _url += this.crud

			// команда - отдельные случаи
			if (this.crud === 'planarchive')
			{
				_url += '/archive'
			}
			else if (this.crud === 'iphistory')
			{
				_url += '/history'
			}
			// команда - по умолчанию
			else _url += '/list'

			// страница
			_url += (this.page > 1 ? '/' + this.page : '')

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// производим запрос
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это список тикетов по отделу и еще нет данных по отделам
			if (this.crud === 'ticket' && this.action === 'department' && !this.$store.state.ticketData.departments.length)
			{
				setTimeout(() => this.requestListData(silenceMode), 200)
				return
			}

			// запомним текущий путь
			let _currentFullPath = this.$router.currentRoute.fullPath

			// теперь точно можно делать запрос
			this.forms_Get(_url, _getParams,
				// успешно получили данные
				(data) => {
					// если изменился путь - ничего не делаем
					if (_currentFullPath !== this.$router.currentRoute.fullPath) return

					// проверим данные
					if (!data || data['status'] !== 'ok' || !data['columns'] || data['rows'] === undefined ||
						(this.crud !== 'chart' && this.crud !== 'role' && !data['filters']) ||
						data['pageCount'] === undefined || data['pageSize'] === undefined || data['totalCount'] === undefined)
					{
						if (!silenceMode)
						{
							// ошибка - некорректные данные
							this.form_ErrorMessage = this.localeFtc('error/api_incorrect')
						}

						this.table_Loading = false
						this.$store.commit('ListTableLoading', false)
					}
					else
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// проверка пришедших данных для каждого CRUD
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						if (this.crud === 'ticket' && this.action === 'department')
						{
							// найдем данные выбранного отдел
							let _departmentData = false
							this.$store.state.ticketData.departments.some(item => {
								if (String(item['id']) === String(this.ticketDepartmentId))
								{
									// нашли
									_departmentData = item
									// поиск успешно закончен
									return true
								}
							})

							// если выбранный отдел иммет тип "alerts"
							if (_departmentData && _departmentData['type'] === 'alerts')
							{
								// скроем кнопки создания тикета и массового переноса
								this.buttonCreateVisibe = false
								this.buttons['replaceTicket']['visible'] = false
							}

							// если массив строк - пуст
							if (!data['rows'] || !Array.isArray(data['rows']) || !data['rows'].length)
							{
								// возможно что отдела такого не существует
								let _foundDepartment = _departmentData && _departmentData['access'] === true
								// если отдел не нашли (или к нему нет доступа) - это ошибка 404
								if (!_foundDepartment)
								{
									this.$router.push('/404')
									return
								}
							}
							else
							{
								// есть массив строк, и приходит он от сервера без данных по отделам
								// добавим эти данные в каждую строку сами
								data['rows'].forEach((item, idx, arr) => {
									arr[idx]['department_id'] = _departmentData['id']
									arr[idx]['department_type'] = _departmentData['type']
								})
							}

							// может прийти без нашего запроса фильтр "мои тикеты"
							if (data['filters'] &&
								data['filters']['has_user_id'] &&
								data['filters']['has_user_id']['value'] !== null &&
								data['filters']['has_user_id']['value'] !== undefined)
							{
								this.crudFilter = {
									'crud': 'ticket',
									'object': data['filters']['has_user_id']['value'],
									'field': 'has_user_id'
								}
								this.setLocalStorage()
								this.$store.commit('setCrudFilter', false)
							}
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// расчет количества знаков после запятой
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// определим количество знаков в списке
						this.countDigits = 2
						if (this.crud === 'operation' && this.$store.state.user_type === 'admin')
						{
							data['rows'].forEach(item => {
								if (item && 'operation_summa' in item && item['operation_summa'] !== null && item['operation_summa'] !== undefined)
									this.recountDigitsForString(item['operation_summa'])
							})
						}
						if (this.crud === 'account' && this.$store.state.user_type === 'admin')
						{
							data['rows'].forEach(item => {
								if (item && 'real_balance' in item && item['real_balance'] !== null && item['real_balance'] !== undefined)
									this.recountDigitsForString(item['real_balance'])
							})
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// восстановим выделенные записи (если они есть)
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						if (Object.keys(_selectedRows).length)
						{
							data['rows'].forEach((item, idx, arr) => {
								let _id = String(item[this.listConfig['column_id']])
								if (_selectedRows[_id])
									arr[idx]['w5-row-selected'] = true
							})
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// данные пришли - корректные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.listData = this.form_GetData

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// инициализируем фильтры
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// зачем это нужно? потому что иногда данные по фильтру сами приходят
						// с сервера, например период по логам
						// 1. период
						/* фильтры теперь не закрываются при обоновлении списка
						this.filters.period.visible = false
						this.filters.period.valueBegin = false
						this.filters.period.valueEnd = false
						*/

						if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['period'])
						{
							if (this.filters.period.visible === -1) this.filters.period.visible = false

							// период - начало
							if (data['filters'][this.listConfig['filters']['period']['begin_field']] &&
								data['filters'][this.listConfig['filters']['period']['begin_field']]['value'])
							{
								this.filters.period.visible = true
								this.filters.period.valueBegin = data['filters'][this.listConfig['filters']['period']['begin_field']]['value']
							}

							// период - конец
							if (data['filters'][this.listConfig['filters']['period']['end_field']] &&
								data['filters'][this.listConfig['filters']['period']['end_field']]['value'])
							{
								this.filters.period.visible = true
								this.filters.period.valueEnd = data['filters'][this.listConfig['filters']['period']['end_field']]['value']
							}
						}

						// 2. radio
						if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['radio'] && this.filters.radio)
						{
							// бежим по всем фильтрам
							this.filters.radio.forEach((item) => {
								// сразу обнуляем фильтр
								/* фильтры теперь не закрываются при обоновлении списка
								item.visible = false
								item.value = null
								*/

								if (data['filters'] && data['filters'][item.field]) {
									if (item.visible === -1) item.visible = false
								}

								// ищем его в пришедших данных
								if (data['filters'] &&
									data['filters'][item.field] &&
									data['filters'][item.field]['value'] !== null &&
									data['filters'][item.field]['value'] !== undefined)
								{
									item.visible = true
									item.value = data['filters'][item.field]['value']

									// частный случай - может быть задан отдельный фильтр в заметках
									if (this.crud === 'notes' && item.field === 'note_object')
									{
										// если значения нет в списке - то это отдельный фильтр
										if (data['filters'][item.field]['list'])
										{
											if (!(item.value in data['filters'][item.field]['list']))
											{
												// значение не из списка - это точно отдельный фильтр
												item.visible = false
												item.value = null
											}
										}
										else
										{
											// спика нет - это точно не этот фильтр
											item.visible = false
											item.value = null
										}
									}
								}
							})
						}

						// 3. bool
						if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['bool'] && this.listConfig['filters']['bool']['field'])
						{
							// сразу обнулим фильтр
							this.filters.bool.value = false

							if (data['filters'] && data['filters'][this.listConfig['filters']['bool']['field']]) {
								if (this.filters.bool['visible'] === -1) this.filters.bool['visible'] = true
							}

							if (data['filters'][this.listConfig['filters']['bool']['field']] &&
								Helper.normalizeBooleanValue(data['filters'][this.listConfig['filters']['bool']['field']]['value']) === true)
							{
								this.filters.bool['value'] = true
							}
						}

						// 4. select
						if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['select'] && this.filters.select)
						{
							// бежим по всем фильтрам
							this.filters.select.forEach((item) => {
								// сразу обнуляем фильтр
								if (data['filters'] && data['filters'][item.field]) {
									if (item.visible === -1) item.visible = false
								}

								// ставим заголовки в частных случаях
								if (this.crud === 'server') {
									// ищем заголовок
									if (data['filters'] &&
										data['filters'][item.field] &&
										data['filters'][item.field]['title']) {
										//item.title = this.localeFtc(data['filters'][item.field]['title'])
										item.title = data['filters'][item.field]['title']
									}
								}

								// ищем его в пришедших данных
								if (data['filters'] &&
									data['filters'][item.field] &&
									data['filters'][item.field]['value'] !== null &&
									data['filters'][item.field]['value'] !== undefined &&
									data['filters'][item.field]['list'] !== null &&
									data['filters'][item.field]['list'] !== undefined)
								{
									let _val = data['filters'][item.field]['value']
									if (_val === null || _val === undefined) _val = -1

									// multiselect
									if (data['filters'][item.field]['multiselect'] === true)
										item.multiselect = true
									else
										item.multiselect = undefined

									if (_val !== -1)
									{
										item.visible = true

										if (item.multiselect)
										{
											if (Array.isArray(_val) && _val.length)
											{
												item.value = []
												_val.forEach(id => {
													let _name = id

													// ищем наименование
													if (Array.isArray(data['filters'][item.field]['list']))
													{
														data['filters'][item.field]['list'].some((itm) => {
															if (String(itm.id) === String(id))
															{
																_name = itm.name
																return true
															}
														})
													}
													else
													{
														for (let o in data['filters'][item.field]['list'])
														{
															if (String(o) === String(id))
															{
																_name = Helper.localeFtc(data['filters'][item.field]['list'][o])
																break
															}
														}
													}

													item.value.push({
														id,
														name: _name
													})
												})
											}
										}
										else
										{
											item.value = { id: _val }

											// ищем наименование
											if (Array.isArray(data['filters'][item.field]['list']))
											{
												data['filters'][item.field]['list'].some((itm) => {
													if (String(itm.id) === String(item.value.id))
													{
														item.value['name'] = itm.name
														return true
													}
												})
											}
											else
											{
												for (let o in data['filters'][item.field]['list'])
												{
													if (String(o) === String(item.value.id))
													{
														item.value['name'] = Helper.localeFtc(data['filters'][item.field]['list'][o])
														break
													}
												}
											}
										}

										// частный случай - additional-services
										if (this.crud === 'additional-services' &&
											item.field === 'service_type_id' &&
											_val &&
											Array.isArray(_val))
										{
											if (AdditionalServicesFilter.is_all_ids(_val) ||
												(_val.length === 1 && String(_val[0]['id'] === '-1')))
											{
												item.visible = false
												item.value = null
											}
										}
									}
								}
							})
						}

						// 5. logs
						if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['logs'] && this.listConfig['filters']['logs']['field'])
						{
							// скроем фильтр
							if (this.filters.logs.visible !== -1) this.filters.logs.visible = false

							if (data['filters'][this.listConfig['filters']['logs']['field']]) {
								if (this.filters.logs.visible === -1) this.filters.logs.visible = false
							}

							if (data['filters'][this.listConfig['filters']['logs']['field']] &&
								data['filters'][this.listConfig['filters']['logs']['field']]['value'])
							{
								this.filters.logs['value'] = data['filters'][this.listConfig['filters']['logs']['field']]['value']
								this.filters.logs.visible = true
							}
						}

						// 6. ticket-label
						if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['ticketLabel'])
						{
							// скроем фильтр
							if (this.filters.ticketLabel.visible !== -1) this.filters.ticketLabel.visible = false

							if (data['filters']['ticket_label']) {
								if (this.filters.ticketLabel.visible === -1) this.filters.ticketLabel.visible = false
							}

							if (data['filters']['ticket_label'] && data['filters']['ticket_label']['value'])
							{
								this.filters.ticketLabel['value'] = data['filters']['ticket_label']['value']
								this.filters.ticketLabel.visible = true
							}
						}

						// 7. disk-type
						if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['diskType'])
						{
							// скроем фильтр
							if (this.filters.diskType.visible !== -1) this.filters.diskType.visible = false

							if (data['filters']['service_type_id']) {
								if (this.filters.diskType.visible === -1) this.filters.diskType.visible = false
							}

							// значение по умолчанию
							this.filters.diskType['value'] = null

							// если пришло какое то конкретное значение
							if (data['filters']['service_type_id'] && data['filters']['service_type_id']['value'])
							{
								if (Array.isArray(data['filters']['service_type_id']['value']) &&
									data['filters']['service_type_id']['value'].length === 1) {
									this.filters.diskType['value'] = String(data['filters']['service_type_id']['value'][0])
									this.filters.diskType.visible = true
								} else if (typeof data['filters']['service_type_id']['value'] === 'string') {
									this.filters.diskType['value'] = data['filters']['service_type_id']['value']
									this.filters.diskType.visible = true
								}
							}
						}

						// plan-params
						if (this.listConfig && this.listConfig['filters'] && this.listConfig['filters']['planParams'])
						{
							// скроем фильтр
							// фильтры теперь не закрываются при обоновлении списка
							//this.filters.planParams.visible = false

							if (data['filters']['cpu_min'] || data['filters']['cpu_max'] ||
								data['filters']['ram_min'] || data['filters']['ram_max'] ||
								data['filters']['disk_min'] || data['filters']['disk_max']) {
								if (this.filters.planParams.visible === -1) this.filters.planParams.visible = false
							}

							// cpu
							if (data['filters']['cpu_min'] && 'value' in data['filters']['cpu_min'] &&
								data['filters']['cpu_min']['value'] !== null && data['filters']['cpu_min']['value'] !== undefined)
							{
								this.filters.planParams['value']['cpu_min'] = data['filters']['cpu_min']['value']
								this.filters.planParams.visible = true
							}
							if (data['filters']['cpu_max'] && 'value' in data['filters']['cpu_max'] &&
								data['filters']['cpu_max']['value'] !== null && data['filters']['cpu_max']['value'] !== undefined)
							{
								this.filters.planParams['value']['cpu_max'] = data['filters']['cpu_max']['value']
								this.filters.planParams.visible = true
							}

							// ram
							if (data['filters']['ram_min'] && 'value' in data['filters']['ram_min'] &&
								data['filters']['ram_min']['value'] !== null && data['filters']['ram_min']['value'] !== undefined)
							{
								this.filters.planParams['value']['ram_min'] = data['filters']['ram_min']['value']
								this.filters.planParams.visible = true
							}
							if (data['filters']['ram_max'] && 'value' in data['filters']['ram_max'] &&
								data['filters']['ram_max']['value'] !== null && data['filters']['ram_max']['value'] !== undefined)
							{
								this.filters.planParams['value']['ram_max'] = data['filters']['ram_max']['value']
								this.filters.planParams.visible = true
							}

							// disk
							if (data['filters']['disk_min'] && 'value' in data['filters']['disk_min'] &&
								data['filters']['disk_min']['value'] !== null && data['filters']['disk_min']['value'] !== undefined)
							{
								this.filters.planParams['value']['disk_min'] = data['filters']['disk_min']['value']
								this.filters.planParams.visible = true
							}
							if (data['filters']['disk_max'] && 'value' in data['filters']['disk_max'] &&
								data['filters']['disk_max']['value'] !== null && data['filters']['disk_max']['value'] !== undefined)
							{
								this.filters.planParams['value']['disk_max'] = data['filters']['disk_max']['value']
								this.filters.planParams.visible = true
							}
						}

						// глобальный фильтр по аккаунту - по умолчанию его нет
						this.accountGlobalFilter = false
						// если задан в данных пришедших с сервера
						if (data['globalFilter'] && data['globalFilter']['id'] && data['globalFilter']['name'])
						{
							// запоминаем
							this.accountGlobalFilter = {
								'title': this.localeFtc('filter/global').replace(' {client}', ''),
								'text': data['globalFilter']['name']
							}
						}
						// обновляем флаг в Vuex о наличии глобального фильтра
						this.$store.commit('accountGlobalFilter', this.accountGlobalFilter !== false)

						// 7. отдельный фильтр
						if (this.crudFilter && this.crudFilter['crud'] === this.crud)
						{
							let _crudField = this.crudFilter['field'] ? this.crudFilter['field'] : this.crudFilterField()
							// если уже есть глобальный фильтр, а локальный фильтр по аккаунту - его нужно обнулить, в Vuex он уже обнулен
							if (this.accountGlobalFilter && _crudField === 'account_id')
							{
								this.crudFilter = false
							}
							// дубляж
							else if (
								(this.crud === 'server' && _crudField === 'datacenter_id') ||
								(this.crud === 'rack' && _crudField === 'datacenter_id')
							)
							{
								// ничего не нужно делать
								this.crudFilter = false
							}
							// нет конфиликта фильтров - установим текст фильтра
							else if (_crudField && data['filters'][_crudField] && data['filters'][_crudField]['value'])
							{
								this.crudFilter['text'] = data['filters'][_crudField]['text']
							}
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// строим данные для пагинатора
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// парсим URL
						let _urlParts = this.$route.path
							.substr(this.$route.path.charAt(0) === '/' ? 1 : 0)
							.split('/')
						if (!_urlParts[0]) _urlParts[0] = this.crud
						// проверка на левую границу уже произведена в "initData"
						// по умолчанию - пагинатор пустой
						this.paginationPages = []
						this.lastPage = 1

						let _total = parseInt(data['totalCount'])
						let _size = parseInt(data['pageSize'])
						// если все же страницы есть
						if (_total > _size)
						{
							// получим общее количество страниц
							let _pagesCount = Math.ceil(_total / _size)
							if (!_pagesCount || isNaN(_pagesCount) || _pagesCount < 1) _pagesCount = 1

							// проверка на правую границу
							if (this.page > _pagesCount)
							{
								this.page = _pagesCount
								// вкладки тикетов по отделу
								if (this.crud === 'ticket' && this.action === 'department') this.$router.replace('/ticket/department/' + this.ticketDepartmentId + '/' + this.page)
								// если это ipptrpool
								else if (this.crud === 'ipptrpool' || this.crud === 'iphistory')
								{
									// ничего не делаем
								}
								// в любом другом случае
								else this.$router.replace('/' + _urlParts[0] + (_urlParts[1] ? '/' + _urlParts[1] + '/' + this.page : ''))
							}

							// если страниц больше одной и это не список отчетов
							if (_pagesCount > 1 && this.crud !== 'chart')
							{
								this.lastPage = _pagesCount

								let _begin = this.page - 8
								if (_begin < 1) _begin = 1
								let _end = this.page + 8
								if (_end > _pagesCount) _end = _pagesCount

								for (let k = _begin; k <= _pagesCount; k++)
								{
									if (k > _end) break
									this.paginationPages.push(k)
								}
							}
						}
						else
						{
							// если страниц вообще нет - уберем параметр страницы
							// с вкладки тикетов по отделу
							if (this.crud === 'ticket' && this.action === 'department') this.$router.replace('/ticket/department/' + this.ticketDepartmentId)
							// если это ipptrpool
							else if (this.crud === 'ipptrpool' || this.crud === 'iphistory')
							{
								// ничего не делаем
							}
							// в любом другом случае
							else this.$router.replace('/' + _urlParts[0] + (_urlParts[1] ? '/' + _urlParts[1] : ''))
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// разделяем строки на части - получим первую часть
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.renderRows = []
						this.initRows = []

						// меняем массивы строк в следующем тике для того что бы они ВСЕ перерисовались
						// а нужна нам это, для того что бы сработала директива "highlightFastSearch"
						this.$nextTick(() => {
							this.renderRows = data['rows'].slice(0, 20)
							// оставшиеся записи
							this.initRows = data['rows'].slice(20)
							// стартуем процесс переливания оставшихся записей в массив для рендеринга
							if (this.initRows && this.initRows.length)
								this.moveRows()
							else
							{
								// если строк меньше 20 - значит все строки сразу перезалиты
								// нужно переинициализировать кнопки
								this.buttonsForSelectedRow()
							}
						})

						// закончился процесс загрузки таблицы
						this.table_Loading = false
						this.$store.commit('ListTableLoading', false)

						// вызываем массив колбаков после успешного запроса
						this.afterRequestListData()
					}
				},
				// ошибка при запросе данных
				(res) => {
					// если изменился путь - ничего не делаем
					if (_currentFullPath !== this.$router.currentRoute.fullPath) return
					// закончился процесс загрузки таблицы
					this.table_Loading = false
					this.$store.commit('ListTableLoading', false)
					// обнуляем массив колбаков для вызова после успешного запроса данных
					this.afterRequestDataCallbacks = []
				}
			)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// показывает фильтр по моим тикетам
		//---------------------------------------------------------------------
		myTicketsActivate() {
			if (this.isCrudFilterOnMyTicket) return

			let _obj = {
				'crud': 'ticket',
				'object': '',
				'field': 'has_user_id'
			}

			this.$store.commit('setCrudFilter', _obj)
			this.$nextTick(() => this.GoTo({ id: this.$store.state.user_id }, 'ticket', '', 'has_user_id'))
		},
		//---------------------------------------------------------------------
		// скрывает/показывает соответствующий фильтр
		//---------------------------------------------------------------------
		async toggleFilter(name, index) {
			if (name === 'period')
			{
				// меняем видимость
				this.filters.period.visible = !this.filters.period.visible
				// если виджет стал невидим
				if (!this.filters.period.visible)
				{
					// если у него были установленные значения
					if (this.filters.period.valueBegin || this.filters.period.valueEnd)
					{
						// обнулим все значения
						this.filters.period.valueBegin = false
						this.filters.period.valueEnd = false
						// и запросим новые данные
						await this.setLocalStorage()
						this.requestListData()
					}
				}
				return
			}

			if (name === 'radio')
			{
				this.filters.radio[index].visible = !this.filters.radio[index].visible

				// если фильтр закрылся
				if (!this.filters.radio[index].visible)
				{
					/*
					if (this.filters.radio[index].value !== null && this.filters.radio[index].value !== undefined)
					{
						this.filters.radio[index].value = null
						this.setLocalStorage()
						this.requestListData()
					}
					*/

					// выясним: нужно ли обновлять таблицу, по умолчанию нет
					// например если просто открыли фильтр, и не устанавливая какого то значения сразу закрыли - обновлять не нужно
					let _needRefresh = false
					if (this.filters.radio[index].value !== null && this.filters.radio[index].value !== undefined)
					{
						// если был установлен какой то фильтр со значением - нужно обновить
						_needRefresh = true
					}

					// при закрытии значение всегда обнуляется
					this.filters.radio[index].value = null
					// всегда перезаписываем в источники
					await this.setLocalStorage(true)
					// если нужно - обновим таблицу
					if (_needRefresh) this.requestListData()
				}
				return
			}

			if (name === 'select')
			{
				this.filters.select[index].visible = !this.filters.select[index].visible
				if (!this.filters.select[index].visible)
				{
					let _needRefresh = false
					let item = this.filters.select[index]
					if (item.value !== undefined && item.value !== null)
					{
						// если записан объект
						if (typeof item.value === 'object' && 'id' in item.value)
						{
							// если есть заданное значение
							if (item.value.id !== undefined &&
								item.value.id !== null &&
								item.value.id !== '' &&
								item.value.id !== -1)
							{
								_needRefresh = true
							}
						}
						else
						{
							// если есть заданное значение
							if (item.value !== undefined &&
								item.value !== null &&
								item.value !== '' &&
								item.value !== -1)
							{
								_needRefresh = true
							}
						}
					}

					this.filters.select[index].value = { id: -1, name: 'main/list_all' }
					await this.setLocalStorage(true)
					if (_needRefresh) this.requestListData()
				}
				return
			}

			if (name === 'logs')
			{
				this.filters.logs.visible = !this.filters.logs.visible
				if (!this.filters.logs.visible)
				{
					if (this.filters.logs.value)
					{
						this.filters.logs.value = false
						await this.setLocalStorage()
						this.requestListData()
					}
				}
				return
			}

			if (name === 'ticketLabel')
			{
				this.filters.ticketLabel.visible = !this.filters.ticketLabel.visible
				if (!this.filters.ticketLabel.visible)
				{
					if (this.filters.ticketLabel.value)
					{
						this.filters.ticketLabel.value = null
						await this.setLocalStorage()
						this.requestListData()
					}
				}
				return
			}

			if (name === 'diskType')
			{
				this.filters.diskType.visible = !this.filters.diskType.visible
				if (!this.filters.diskType.visible)
				{
					if (this.filters.diskType.value)
					{
						this.filters.diskType.value = null
						await this.setLocalStorage()
						this.requestListData()
					}
				}
				return
			}

			if (name === 'planParams')
			{
				this.filters.planParams.visible = !this.filters.planParams.visible
				if (!this.filters.planParams.visible)
				{
					let _needRefresh = false
					if (this.filters.planParams.value.cpu_min || this.filters.planParams.value.cpu_max ||
						this.filters.planParams.value.ram_min || this.filters.planParams.value.ram_max ||
						this.filters.planParams.value.disk_min || this.filters.planParams.value.disk_max)
					{
						_needRefresh = true
					}

					this.filters.planParams.value = {
						cpu_min: null,
						cpu_max: null,
						ram_min: null,
						ram_max: null,
						disk_min: null,
						disk_max: null
					}
					await this.setLocalStorage(true)
					if (_needRefresh) this.requestListData()
				}
				return
			}
		},
		//---------------------------------------------------------------------
		// скрывает соответствующий фильтр
		//---------------------------------------------------------------------
		closeDirectlyFilter(name) {
			if (name === 'planParams')
			{
				let _oldVisibleValue = this.filters.planParams.visible
				this.filters.planParams.visible = false

				this.filters.planParams.value = {
					cpu_min: null,
					cpu_max: null,
					ram_min: null,
					ram_max: null,
					disk_min: null,
					disk_max: null
				}

				// если фильтр не был виден - то и обновлять нечего
				if (_oldVisibleValue === true)
				{
					this.setLocalStorage()
					this.requestListData()
				}
			}
		},
		//---------------------------------------------------------------------
		// функция вызывает указанный форматер и возвращает значение
		//---------------------------------------------------------------------
		formater(formaterName, value) {
			return this[formaterName](value)
		},
		//---------------------------------------------------------------------
		// функция возвращает класс ячейки
		//---------------------------------------------------------------------
		cellClass(field, column) {
			// классов может быть несколько
			let _class = []
			// если в конфиге задан какой то класс - добавляем его
			if (column['class-row']) _class.push(column['class-row'])

			// смотрим на сортировку
			let _sortedCell = false
			// если установлена какая то сортировка
			if (this.sortedColumn)
			{
				// частные случаи
				if (field === 'account_name') _sortedCell = this.sortedColumn.indexOf('account_id') >= 0
				else if (field === 'parent_name_full') _sortedCell = this.sortedColumn.indexOf('parent_id') >= 0
				else if (field === 'owner_account_name') _sortedCell = this.sortedColumn.indexOf('owner_account_id') >= 0
				else _sortedCell = this.sortedColumn.indexOf(field) >= 0
			}
			// пользователь не устанавливал сортировку
			else
			{
				// может есть сортировка по умолчанию - и это она?
				if (this.listData && this.listData.defaultSort)
					_sortedCell = this.listData.defaultSort.indexOf(field) >= 0
			}
			// если в итоге поле отсортировано - добавим соответствующий класс
			if (_sortedCell) _class.push('w5-table-cell-sorted')

			// возвращаем все в виде строки
			return _class.join(' ')
		},
		//---------------------------------------------------------------------
		// функция записывает основные параметры компонента в localStorage
		//---------------------------------------------------------------------
		async setLocalStorage(withHiddeningFiletsr = false) {
			// проверки
			if (!window.localStorage)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('localStorage недоступен')
				return false
			}

			if (!this.$store.state.user_id)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('пользователь неавторизован')
				return false
			}

			if (!this.crud)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('CRUD неопределен')
				return false
			}

			// генерируем ключ в хранилище
			let _key = 'w5_' + this.$store.state.user_id + '_' + this.crud
			// теперь списков VDS может быть несколько
			if ((this.crud === 'certificate' || this.crud === 'domains') && this.$route.params['groupId'])
				_key = 'w5_' + this.$store.state.user_id + '_' + this.crud + '_' + this.$route.params['groupId']

			// готовим данные
			let _model = {}

			// быстрый поиск - записывается в localStorage
			_model['fast_search'] = this.fastSearchValue

			// фильтры - записывается в localStorage
			// фильтр по периоду: если нет дат - делаем его невидимым
			if (!this.filters.period.valueBegin && !this.filters.period.valueEnd) this.filters.period.visible = false
			// записываем вместе с остальными
			_model['filters'] = window.ObjDeepClone(this.filters)

			// теперь фильтры - если нет значения, то делаем невидимыми
			if (withHiddeningFiletsr)
			{
				// radio
				if (_model['filters']['radio'] && _model['filters']['radio'].length)
				{
					// бежим по всем фильтрам
					_model['filters']['radio'].forEach(item => {
						// сразу скрываем фильтр
						item.visible = false

						// если есть заданное значение
						if (item.value !== undefined && item.value !== null)
						{
							// то фильтр все таки виден
							item.visible = true
						}
					})
				}
				// select
				if (_model['filters']['select'] && _model['filters']['select'].length)
				{
					// бежим по всем фильтрам
					_model['filters']['select'].forEach((item) => {
						// сразу скрываем фильтр
						item.visible = false

						// если есть заданное значение
						if (item.value !== undefined && item.value !== null)
						{
							// если записан объект
							if (typeof item.value === 'object' && 'id' in item.value)
							{
								// если есть заданное значение
								if (item.value.id !== undefined &&
									item.value.id !== null &&
									item.value.id !== '' &&
									item.value.id !== -1)
								{
									// то фильтр все таки виден
									item.visible = true
								}
							}
							else
							{
								// если есть заданное значение
								if (item.value !== undefined &&
									item.value !== null &&
									item.value !== '' &&
									item.value !== -1)
								{
									// то фильтр все таки виден
									item.visible = true
								}
							}
						}
					})
				}
				// planParams
				if (_model['filters']['planParams'] && _model['filters']['planParams']['value'])
				{
					// сразу скрываем фильтр
					_model['filters']['planParams'].visible = false

					// cpu
					if ((_model['filters']['planParams']['value']['cpu_min'] !== undefined && _model['filters']['planParams']['value']['cpu_min'] !== null) ||
						(_model['filters']['planParams']['value']['cpu_max'] !== undefined && _model['filters']['planParams']['value']['cpu_max']) !== null)
					{
						// если есть заданное значение
						_model['filters']['planParams'].visible = true
					}

					// ram
					if ((_model['filters']['planParams']['value']['ram_min'] !== undefined && _model['filters']['planParams']['value']['ram_min'] !== null) ||
						(_model['filters']['planParams']['value']['ram_max'] !== undefined && _model['filters']['planParams']['value']['ram_max']) !== null)
					{
						// если есть заданное значение
						_model['filters']['planParams'].visible = true
					}

					// disk
					if ((_model['filters']['planParams']['value']['disk_min'] !== undefined && _model['filters']['planParams']['value']['disk_min'] !== null) ||
						(_model['filters']['planParams']['value']['disk_max'] !== undefined && _model['filters']['planParams']['value']['disk_max']) !== null)
					{
						// если есть заданное значение
						_model['filters']['planParams'].visible = true
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// восстановим "непереведенные" значения в фильтрах
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// select
			if (_model['filters']['select'] && _model['filters']['select'].length)
			{
				// бежим по всем фильтрам
				_model['filters']['select'].forEach((item) => {
					// если есть заданное значение
					if (item.value !== undefined && item.value !== null)
					{
						// если записан объект
						if (typeof item.value === 'object' && 'id' in item.value)
						{
							if (String(item.value.id) === '-1')
							{
								item.value.name = 'main/list_all'
							}
						}
					}
				})
			}

			// колонка по которой отсортирована таблица - записывается в localStorage
			_model['sort'] = this.sortedColumn

			// отдельный фильтр по CRUD - запишем отдельно
			if (this.crudFilter && this.crudFilter['crud'] === this.crud)
				_model['crud'] = this.crudFilter

			// фильтр по HTTP-GET
			if (this.crudHttpGetFilter && this.crudHttpGetFilter['__crud'] === this.crud)
				_model['http'] = this.crudHttpGetFilter

			// все храним в виде строки
			let _modelString = JSON.stringify(_model)

			// записываем данные
			try {
				// в удаленное хранилище
				await this.remoteStorageSet(_key, _modelString)
				// обновляем в хранилище
				this.$store.commit('updateUserOptionsOnServer', {
					key: _key,
					value: _modelString
				})
				// в localStorage
				window.localStorage.setItem(_key, _modelString)
			}
			catch (_err)
			{
				if (this.$store.state.isDebug) window.DEBUG.error(_err.name + ': ' + _err.message)
				return false
			}

			return true
		},
		//---------------------------------------------------------------------
		// функция считывает основные параметры компонента из localStorage
		//---------------------------------------------------------------------
		getLocalStorage() {
			// проверка crud
			if (!this.crud)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('CRUD неопределен')
				return false
			}

			// генерируем ключ в хранилище
			let _key = 'w5_' + this.$store.state.user_id + '_' + this.crud
			// теперь списокв VDS может быть несколько
			if ((this.crud === 'certificate' || this.crud === 'domains') && this.$route.params['groupId'])
				_key = 'w5_' + this.$store.state.user_id + '_' + this.crud + '_' + this.$route.params['groupId']

			// смотрим в хранилище
			let data = this.$store.state.userServerOptions && this.$store.state.userServerOptions[_key]
				? this.$store.state.userServerOptions[_key] : ''

			// проверка наличия данных
			if (!data && !window.localStorage)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('данные недоступны')
				return false
			}

			if (!this.$store.state.user_id)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('пользователь не авторизован')
				return false
			}

			let _json = null
			if (data)
			{
				_json = data
			}
			else
			{
				// считаем данные из localStorage
				_json = window.localStorage.getItem(_key)
				if (!_json) return true
			}

			try {
				// парсим JSON
				let _data = JSON.parse(_json)

				// установим данные
				if (_data)
				{
					// быстрый поиск
					if (_data['fast_search'])
						this.setFastSearchValue(_data['fast_search'])

					// фильтры
					if (_data['filters']) this.restoreFilters(_data['filters'])

					// колонка по которой отсортирована таблица
					if (_data['sort']) this.sortedColumn = _data['sort']

					// отдельный фильтр
					if (_data['crud'] && _data['crud']['crud'] === this.crud)
					{
						// если есть глобальный фильтр и локальный тоже по аккаунту
						if (this.$store.state.accountGlobalFilter === true && _data['crud']['field'] === 'account_id')
						{
							// ничего не нужно делать
						}
						else this.crudFilter = _data['crud']
					}

					// http фильтр
					if (_data['http'] && _data['http']['__crud'] === this.crud) this.crudHttpGetFilter = _data['http']
				}
			}
			catch (_err)
			{
				if (this.$store.state.isDebug) window.DEBUG.error(_err.name + ': ' + _err.message)
				return false
			}

			return true
		},
		//---------------------------------------------------------------------
		// безопасно восстановим значения фиьтров
		//---------------------------------------------------------------------
		restoreFilters(filters) {
			if (!filters) return

			// фильтр по периоду
			if (filters['period'] && 'visible' in filters['period'] && 'valueBegin' in filters['period'] && 'valueEnd' in filters['period'])
			{
				this.filters.period = filters['period']
			}

			// фильтр bool - восстанавливем только если значение TRUE
			if (filters['bool'] && filters['bool']['value'] &&
				this.listConfig['filters'] && this.listConfig['filters']['bool'] && this.listConfig['filters']['bool']['field'] &&
				Helper.normalizeBooleanValue(filters['bool']['value']) === true)
			{
				this.filters.bool = filters['bool']
			}

			// фильтр radio
			if (filters['radio'] && Array.isArray(filters['radio']) &&
				this.listConfig['filters'] && this.listConfig['filters']['radio'] && typeof this.listConfig['filters']['radio'] === 'object')
			{
				this.filters.radio = filters['radio']

				// ищем пустые фильтры и закрываем их автоматом
				if (this.filters.radio && this.filters.radio.length)
				{
					// бежим по всем фильтрам
					this.filters.radio.forEach(item => {
						// сразу скрываем фильтр
						item.visible = false

						// если есть заданное значение
						if (item.value !== undefined && item.value !== null)
						{
							// то фильтр все таки виден
							item.visible = true
						}
					})
				}
			}

			// фильтр select
			if (filters['select'] && Array.isArray(filters['select']) &&
				this.listConfig['filters'] && this.listConfig['filters']['select'] && typeof this.listConfig['filters']['select'] === 'object')
			{
				this.filters.select = filters['select']

				// ищем пустые фильтры и закрываем их автоматом
				if (this.filters.select && this.filters.select.length)
				{
					// бежим по всем фильтрам
					this.filters.select.forEach((item) => {
						// сразу скрываем фильтр
						item.visible = false

						// если есть заданное значение
						if (item.value !== undefined && item.value !== null)
						{
							// если записан объект
							if (typeof item.value === 'object' && 'id' in item.value)
							{
								// если есть заданное значение
								if (item.value.id !== undefined &&
									item.value.id !== null &&
									item.value.id !== '' &&
									item.value.id !== -1)
								{
									// то фильтр все таки виден
									item.visible = true
								}
							}
							else
							{
								// если есть заданное значение
								if (item.value !== undefined &&
									item.value !== null &&
									item.value !== '' &&
									item.value !== -1)
								{
									// то фильтр все таки виден
									item.visible = true
								}
							}
						}
					})
				}
			}

			// фильтр logs
			if (filters['logs'] && 'visible' in filters['logs'] && 'value' in filters['logs'])
			{
				this.filters.logs = filters['logs']
			}

			// фильтр ticket-label
			if (filters['ticketLabel'] && 'visible' in filters['ticketLabel'] && 'value' in filters['ticketLabel'])
			{
				this.filters.ticketLabel = filters['ticketLabel']
			}

			// фильтр disk-type
			if (filters['diskType'] && 'visible' in filters['diskType'] && 'value' in filters['diskType'])
			{
				this.filters.diskType = filters['diskType']
			}

			// фильтр plan-params
			if (filters['planParams'] && 'visible' in filters['planParams'] && filters['planParams']['value'])
			{
				this.filters.planParams = filters['planParams']

				// открыт фильтр или нет
				if (this.filters.planParams && this.filters.planParams['value'])
				{
					// сразу скрываем фильтр
					this.filters.planParams.visible = false

					// cpu
					if ((this.filters.planParams['value']['cpu_min'] !== undefined && this.filters.planParams['value']['cpu_min'] !== null) ||
						(this.filters.planParams['value']['cpu_max'] !== undefined && this.filters.planParams['value']['cpu_max']) !== null)
					{
						// если есть заданное значение
						this.filters.planParams.visible = true
					}

					// ram
					if ((this.filters.planParams['value']['ram_min'] !== undefined && this.filters.planParams['value']['ram_min'] !== null) ||
						(this.filters.planParams['value']['ram_max'] !== undefined && this.filters.planParams['value']['ram_max']) !== null)
					{
						// если есть заданное значение
						this.filters.planParams.visible = true
					}

					// disk
					if ((this.filters.planParams['value']['disk_min'] !== undefined && this.filters.planParams['value']['disk_min'] !== null) ||
						(this.filters.planParams['value']['disk_max'] !== undefined && this.filters.planParams['value']['disk_max']) !== null)
					{
						// если есть заданное значение
						this.filters.planParams.visible = true
					}
				}
			}
		},
		//---------------------------------------------------------------------
		// по типу кнопки генерирует URL кнопки
		//---------------------------------------------------------------------
		buttonsUrl(buttonType) {
			if (buttonType === 'create')
			{
				if (this.crud === 'rackdevice' &&
					this.crudFilter &&
					this.crudFilter.crud === 'rackdevice' &&
					this.crudFilter.field === 'rack_id' &&
					this.crudFilter.object)
				{
					return '/' + this.crud + '/create/' + this.crudFilter.object
				}

				if (this.crud === 'ipptrpool' && this.$route.query.id)
				{
					return '/' + this.crud + '/create/' + this.$route.query.id
				}

				// путь по умолчанию
				return '/' + this.crud + '/create'
			}

			return '#'
		},
		//---------------------------------------------------------------------
		// по типу кнопки генерирует класс
		//---------------------------------------------------------------------
		buttonsClass(buttonType) {
			let _classes = []
			if (buttonType === 'create' || buttonType === 'balance' || buttonType === 'calculator' || buttonType === 'transfer')
				_classes = ['btn', 'btn-submit', 'font-weight-400', 'position-relative']
			else
			{
				// иконка
				_classes.push(this.buttons[buttonType]['icone'])
				// активна или нет
				if (this.buttons[buttonType]['active'] === true)
					_classes.push('w5-list-button-active')
			}

			return _classes.join(' ')
		},
		//---------------------------------------------------------------------
		// клик по кнопке
		//---------------------------------------------------------------------
		buttonsClick(e, buttonType) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это пополнение баланса клиентом
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (buttonType === 'balance')
			{
				if (this.$store.state.user_type === 'client' && this.crud === 'operation')
				{
					// расчитаем положение кнопки
					this.balanceContainerStyle = false
					if (this.$refs && this.$refs['buttonBalance'] && this.$refs['buttonBalance'][0])
					{
						let _coord = this.getElementOffset(this.$refs['buttonBalance'][0])
						this.balanceContainerStyle = 'left:' + _coord.left + 'px; top:' + (_coord.top + 50 - this.curWindowY) + 'px;'
					}
					// ставим сумму по умолчанию
					this.balanceValue = this.AppName === 'vdsina.com' ? 100 : 10000
					this.balanceField['value'] = this.AppName === 'vdsina.com' ? 100 : 10000
					// показываем диалог
					EventBus.$emit('w5-body-scroll-disable')
					this.showBalancePopup = true
					// на этом все
					return
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это калькулятор стоимости
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'calculator')
			{
				if (this.$store.state.user_type === 'client' && this.crud === 'operation')
				{
					EventBus.$emit('w5-body-scroll-disable')
					this.showCalcModal = true
					return
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это перевод средства клиентов с партнерского счета
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'transfer')
			{
				// если средств нет
				if (this.$store.state.user_balance.partner === 0) return

				// запрос формы
				this.$http.get(this.APIServerUrl + '/operation/convert').then(
					// success
					res => {
						// получаем ответ
						let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
						// если ответ корректный
						if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
						{
							// запоминаем данные
							let _flds = this.parseFormData(_dt)
							// это диалог - уберем фейковые поля
							if (_flds && _flds.fields)
								Helper.hideFakeFields(_flds.fields)
							// если в кеше их еще нет
							if (!this.paymentFields) this.paymentFields = _flds
							else
							{
								// копируем данные
								_flds.fields.forEach(row => {
									if (row && Array.isArray(row) && row.length)
									{
										row.forEach(fld => {
											let _f = this.findField(fld['_field_name'])
											if (_f) _f = Object.assign(_f, fld)
										})
									}
								})
							}
							// просто показываем диалог
							EventBus.$emit('w5-body-scroll-disable')
							this.showPaymentModal = true
							// вычисляем условия "showif" в следующем тике
							this.$nextTick(() => {
								// сразу проставим значения
								let _field = this.findField('type')
								// максимальная и минимальная сумма
								if (_field && _field['value'])
								{
									// ищем значение
									_field['list'].some(item => {
										if (String(item['id']) === String(_field['value']))
										{
											this.paymentMax = item['max']
											this.paymentMin = item['min']
											return true
										}
									})
								}
								// поле сумма
								if (this.paymentMax > 0)
								{
									EventBus.$emit('w5-set-money-field-value', {
										'type': 'money',
										'name': 'summa',
										'value': this.paymentMax
									})
								}

								// проверка типа
								let _f = this.findField('type')
								if (_f) this.fieldChangedPayment(_f)

								// showif
								this.showifPayment()
							})
							// на этом все
							return
						}

						// ошибка сервера
						this.localErrorMessage = this.formatRequestError(res)
					},
					// fail
					res => {
						// ошибка сервера
						this.localErrorMessage = this.formatRequestError(res)
					}
				)
				return
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это блокировка/разблокировка
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'on' || buttonType === 'off')
			{
				// проверка прав
				if (!this.isAccess('service/update'))
				{
					this.buttons[buttonType]['active'] = false
					return
				}

				if (this.buttons[buttonType]['active'] === true)
				{
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// проверка конфигурации
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.listConfig['column_id'])
					{
						if (this.$store.state.isDebug) window.DEBUG.error('Lbc0: не задано значение column_id')
						return
					}

					if (!this.listConfig['on-off'])
					{
						if (this.$store.state.isDebug) window.DEBUG.error('Lbc1: не задано значение on-off')
						return
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// соберем выделенные записи
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					let _nameField = this.listConfig['buttons'][buttonType]
					let _nameFieldMinus = false
					if (_nameField.charAt(0) === '-')
					{
						_nameField = _nameField.substr(1)
						_nameFieldMinus = true
					}
					let _selectedNames = []
					this.blockRows = []

					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.forEach((item, idx, arr) => {
						if (item['w5-row-selected'] === true)
						{
							this.blockRows.push(item)
							_selectedNames.push(item[_nameField])
						}
					})

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// если вдруг нет выделенных строк - ничего не делаем
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.blockRows.length) return

					// по умолчанию заметка не нужна
					this.blockModalNoteRequired = false
					// если требуется заметка - значит в конфиге задано непустое поле наименования
					// если заметка не требуется - значит в конфиге поле идет со знаком минус
					if (!_nameFieldMinus) this.blockModalNoteRequired = true

					// запоминаем что нужно сделать
					this.blockModalWhat = buttonType
					// обнулим поля диалога
					this.blockModalSelectNoteValue = { id: null, name: '' }
					this.blockModalTextNoteValue = ''

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// блокировка
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (buttonType === 'off')
					{
						// тексты диалога
						this.blockModalTitle = 'main/block_process'
						this.blockModalText = this.localeFtc('<b>main/block_action:</b> ') + _selectedNames.join(', ') + '?'
						this.blockModalButtonTitle = 'main/block_action'
						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showBlockModal = true
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// разблокировка
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (buttonType === 'on')
					{
						// тексты диалога
						this.blockModalTitle = 'main/unblock_process'
						this.blockModalText = this.localeFtc('<b>main/unblock_action:</b> ') + _selectedNames.join(', ') + '?'
						this.blockModalButtonTitle = 'main/unblock_action'
						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showBlockModal = true
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это блокировка/разблокировка
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'r_on' || buttonType === 'r_off')
			{
				// проверка прав
				if (!this.isAccess('service/update'))
				{
					this.buttons[buttonType]['active'] = false
					return
				}

				if (this.buttons[buttonType]['active'] === true)
				{
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// проверка конфигурации
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.listConfig['column_id'])
					{
						if (this.$store.state.isDebug) window.DEBUG.error('Lbc0: не задано значение column_id')
						return
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// соберем выделенные записи
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					let _nameField = this.listConfig['buttons'][buttonType]
					let _selectedNames = []
					this.registerRows = []

					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.forEach((item, idx, arr) => {
						if (item['w5-row-selected'] === true)
						{
							this.registerRows.push(item)
							_selectedNames.push(item[_nameField])
						}
					})

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// если вдруг нет выделенных строк - ничего не делаем
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.registerRows.length) return

					// запоминаем что нужно сделать
					this.registerModalWhat = buttonType
					// обнулим поля диалога
					this.registerModalText = ''
					this.registerModalTitle = ''

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// блокировка
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (buttonType === 'r_off')
					{
						// тексты диалога
						this.registerModalText = this.localeFtc('<b>main/block_action:</b> ') + _selectedNames.join(', ') + '?'
						this.registerModalButtonTitle = 'main/block_action'
						/*
						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showRegisterModal = true
						*/
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// разблокировка
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (buttonType === 'r_on')
					{
						// тексты диалога
						this.registerModalText = this.localeFtc('<b>main/unblock_action:</b> ') + _selectedNames.join(', ') + '?'
						this.registerModalButtonTitle = 'main/unblock_action'
						/*
						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showRegisterModal = true
						*/
					}

					this.registerRowsInModalDialog()

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это блокировка/разблокировка
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'ip_on' || buttonType === 'ip_off')
			{
				// проверка прав
				if (!this.isAccess('ippool/update'))
				{
					this.buttons[buttonType]['active'] = false
					return
				}

				if (this.buttons[buttonType]['active'] === true)
				{
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// проверка конфигурации
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.listConfig['column_id'])
					{
						if (this.$store.state.isDebug) window.DEBUG.error('Lbc0: не задано значение column_id')
						return
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// соберем выделенные записи
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					let _nameField = this.listConfig['buttons'][buttonType]
					let _selectedNames = []
					this.registerRows = []

					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.forEach((item, idx, arr) => {
						if (item['w5-row-selected'] === true)
						{
							this.registerRows.push(item)
							_selectedNames.push(item[_nameField])
						}
					})

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// если вдруг нет выделенных строк - ничего не делаем
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.registerRows.length) return

					// запоминаем что нужно сделать
					this.registerModalWhat = buttonType
					// обнулим поля диалога
					this.registerModalText = ''
					this.registerModalTitle = ''

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// блокировка
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (buttonType === 'ip_off')
					{
						// тип блокировки по умолчанию
						this.ippoolBlockValue = 'block'

						// тексты диалога
						this.registerModalTitle = 'main/block_process'
						this.registerModalText = this.localeFtc('<b>main/block_action:</b> ') + _selectedNames.join(', ') + '?'
						this.registerModalButtonTitle = 'main/block_action'
						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showRegisterModal = true
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// разблокировка
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (buttonType === 'ip_on')
					{
						// тексты диалога
						this.ippoolBlockValue = null
						this.registerModalTitle = 'main/unblock_process'
						this.registerModalText = this.localeFtc('<b>main/unblock_action:</b> ') + _selectedNames.join(', ') + '?'
						this.registerModalButtonTitle = 'main/unblock_action'
						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showRegisterModal = true
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это изменение статуса документов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'doc_status')
			{
				// проверка прав
				if (!this.isAccess('document/update'))
				{
					this.buttons[buttonType]['active'] = false
					return
				}

				if (this.buttons[buttonType]['active'] === true)
				{
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// проверка конфигурации
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.listConfig['column_id'])
					{
						if (this.$store.state.isDebug) window.DEBUG.error('Lbc0: не задано значение column_id')
						return
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// соберем выделенные записи
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					let _nameField = this.listConfig['buttons'][buttonType]
					let _selectedNames = []
					this.registerRows = []

					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.forEach((item, idx, arr) => {
						if (item['w5-row-selected'] === true)
						{
							this.registerRows.push(item)
							_selectedNames.push(item[_nameField])
						}
					})

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// если вдруг нет выделенных строк - ничего не делаем
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.registerRows.length) return

					// запоминаем что нужно сделать
					this.registerModalWhat = buttonType
					// обнулим поля диалога
					this.registerModalText = ''
					this.registerModalTitle = ''

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// диалог
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// тексты диалога
					this.documentStatusValue = null
					this.registerModalTitle = 'main/status'
					this.registerModalText = (_selectedNames.length <= 1
						? this.localeFtc('document/confirm_update_status')
						: this.localeFtc('document/confirm_update_statuses')) +
						'<br>' +
						_selectedNames.join('<br>')
					this.registerModalButtonTitle = 'main/update'
					// показываем диалог
					EventBus.$emit('w5-body-scroll-disable')
					this.showRegisterModal = true

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это миграция
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'migrate')
			{
				// проверка прав
				if (!this.isAccess('service/migrate'))
				{
					this.buttons[buttonType]['active'] = false
					return
				}

				if (this.buttons[buttonType]['active'] === true)
				{
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// соберем выделенные записи
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.migrateRows = []
					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.forEach((item, idx, arr) => {
						if (item['w5-row-selected'] === true)
							// берем запись с дополнительным полем
							this.migrateRows.push(Object.assign({ 'migrate_active': false }, item))
					})

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// если вдруг нет выделенных строк - ничего не делаем
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.migrateRows.length) return

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// делаем запрос списка серверов
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// не нужно показывать лоадер
					this.$store.commit('needShowLoader', false)
					this.$http.get(this.APIServerUrl + '/service/migrate?search=server&type=vds&q=').then(
						resGet => {
							// лодаер снова нужен
							this.$store.commit('needShowLoader', true)
							// рассмотрим ответ
							let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
							if (_dt && _dt['status'] === 'ok' && _dt['result'] && Array.isArray(_dt['result']))
							{
								if (_dt['result'].length)
								{
									// обновляем список серверов
									this.$set(this.migrateModalServerField, 'list', _dt['result'])
									// устанавливаем первое значение из списка
									this.migrateModalServerField['listValue'] = _dt['result'][0]
									this.migrateModalSelectServerValue = _dt['result'][0]
									// эмуляция выбора первого из списка
									this.migrateModalValueChanged({
										'listValue': this.migrateModalSelectServerValue
									})
									// теперь можно показать диалог
									EventBus.$emit('w5-body-scroll-disable')
									this.showMigrateModal = true
								}
								// пишем что список пуст и все
								else this.localErrorMessage = 'main/data_not_found'

								// на этом все
								return
							}

							// иная ошибка
							this.localErrorMessage = 'error/api_incorrect'
						},
						resGet => {
							// лодаер снова нужен
							this.$store.commit('needShowLoader', true)
							// ошибка запроса
							this.localErrorMessage = 'error/api_incorrect'
						}
					)

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это перенос услуги
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'serviceMove')
			{
				// проверка прав
				if (!this.isAccess('service/move'))
				{
					this.buttons[buttonType]['active'] = false
					return
				}

				if (this.buttons[buttonType]['active'] === true)
				{
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// соберем выделенные записи
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.serviceMoveRows = []
					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.forEach((item, idx, arr) => {
						if (item['w5-row-selected'] === true && item['can_move'] === true)
							// берем запись с дополнительным полем
							this.serviceMoveRows.push(Object.assign({ 'move_active': false }, item))
					})

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// если вдруг нет выделенных строк - ничего не делаем
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.serviceMoveRows.length) return

					// обнуляем поле с аккаунтом
					this.$set(this.serviceMoveModalAccountField, 'list', [])
					this.serviceMoveModalAccountField['listValue'] = false
					this.serviceMoveModalSelectAccountValue = false

					// обнулим хендлеры кнопки
					this.serviceMoveModalButtonCounter = 5
					if (this.serviceMoveModalButtonHandler) clearInterval(this.serviceMoveModalButtonHandler)
					this.serviceMoveModalButtonTitle = 'service/move'

					// теперь можно показать диалог
					EventBus.$emit('w5-body-scroll-disable')
					this.showServiceMoveModal = true

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это массовое удаление услуг
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'bulkDel')
			{
				// проверка прав
				if (!this.isAccess('service/delete'))
				{
					this.buttons[buttonType]['active'] = false
					return
				}

				if (this.buttons[buttonType]['active'] === true)
				{
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// соберем выделенные записи
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.serviceBulkDelRows = []
					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.forEach((item, idx, arr) => {
						if (item['w5-row-selected'] === true && (item['can_delete'] === true || item['can_delete'] === undefined))
							// берем запись с дополнительным полем
							this.serviceBulkDelRows.push(Object.assign({}, item))
					})

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// если вдруг нет выделенных строк - ничего не делаем
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.serviceBulkDelRows.length) return

					// обнулим хендлеры кнопки
					this.serviceBulkDelModalButtonCounter = 10
					if (this.serviceBulkDelModalButtonHandler) clearInterval(this.serviceBulkDelModalButtonHandler)

					// кнопка
					this.serviceBulkDelModalButtonDisabled = true
					this.serviceBulkDelModalButtonTitle = this.localeFtc('main/delete') + ' - ' + this.serviceBulkDelModalButtonCounter

					// теперь можно показать диалог
					EventBus.$emit('w5-body-scroll-disable')
					this.showServiceBulkDelModal = true

					// запускаем таймер
					this.serviceBulkDelModalButtonHandler = setInterval(() => {
						this.serviceBulkDelModalButtonCounter--
						this.serviceBulkDelModalButtonTitle = this.localeFtc('main/delete') + ' - ' + this.serviceBulkDelModalButtonCounter
						if (this.serviceBulkDelModalButtonCounter <= 0)
						{
							this.serviceBulkDelModalButtonTitle = this.localeFtc('main/delete')
							clearInterval(this.serviceBulkDelModalButtonHandler)
							this.serviceBulkDelModalButtonHandler = null
							this.serviceBulkDelModalButtonDisabled = false
						}
					}, 1000)

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это перемещение тикетов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'replaceTicket')
			{
				// проверка прав
				if (!this.isAccess('ticket/update'))
				{
					this.buttons[buttonType]['active'] = false
					return
				}

				if (this.buttons[buttonType]['active'] === true)
				{
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// соберем выделенные записи
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.ticketRows = []
					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.forEach((item, idx, arr) => {
						if (item['w5-row-selected'] === true)
							// берем запись с дополнительным полем
							this.ticketRows.push(Object.assign({ 'ticket_move_active': false }, item))
					})

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// если вдруг нет выделенных строк - ничего не делаем
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.ticketRows.length) return

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// готовим поле со списком отделов
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// обновляем список отделов
					if (!this.ticketMoveModalDepartmentField['list'] ||
						!Array.isArray(this.ticketMoveModalDepartmentField['list']) ||
						!this.ticketMoveModalDepartmentField['list'].length)
						this.ticketMoveModalDepartmentField['list'] = this.$store.state.ticketData.departments
					// установка первого значения
					this.ticketMoveModalDepartmentField['listValue'] = this.$store.state.ticketData.departments[0]
					this.ticketMoveModalSelectDepartmentValue = this.ticketMoveModalDepartmentField['listValue']
					// эмуляция выбора первого из списка
					this.ticketMoveModalValueChanged({
						'listValue': this.ticketMoveModalDepartmentField['listValue']
					})
					// теперь можно показать диалог
					EventBus.$emit('w5-body-scroll-disable')
					this.showTicketMoveModal = true

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это массовое закрытие тикетов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'closeTicket')
			{
				// проверка прав
				if (!this.isAccess('ticket/close'))
				{
					this.buttons[buttonType]['active'] = false
					return
				}

				if (this.buttons[buttonType]['active'] === true)
				{
					// соберем ID выделенных записей
					let _tickets = {}
					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.forEach(item => {
						if (item['w5-row-selected'] === true && item['can_close'] !== false)
							_tickets[item['ticket_id']] = 1
					})

					// первый запрос
					this.$http.get(this.APIServerUrl + '/ticket/close?additional=setClose').then(
						// success
						res => {
							// получаем ответ
							let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
							// если ответ корректный
							if (_dt && _dt['_csrf'])
							{
								let _post = { '_csrf': _dt['_csrf'], tickets: _tickets }

								// второй запрос по тому же URL
								this.$http.post(res.url, Helper.toFormData(_post)).then(
									// success
									resPost => {
										// получаем ответ
										_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
										if (_dt && _dt['status'] === 'ok')
										{
											// гасим кнопку
											this.buttons['closeTicket']['active'] = false
											// тихо рефрешим таблицу
											this.requestListData(true)
											// на этом все
											return
										}

										// ошибка сервера
										this.localErrorMessage = this.formatRequestError(resPost)
									},
									// fail
									resPost => {
										// ошибка сервера
										this.localErrorMessage = this.formatRequestError(resPost)
									}
								)
								// на этом все
								return
							}

							// ошибка сервера
							this.localErrorMessage = this.formatRequestError(res)
						},
						// fail
						res => {
							// ошибка сервера
							this.localErrorMessage = this.formatRequestError(res)
						}
					)
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это массовая блокировка тикетов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'blockTicket')
			{
				// проверка прав
				if (!this.isAccess('ticket/update'))
				{
					this.buttons[buttonType]['active'] = false
					return
				}

				if (this.buttons[buttonType]['active'] === true)
				{
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// соберем выделенные записи
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.ticketBlockRows = []
					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.forEach((item, idx, arr) => {
						if (item['w5-row-selected'] === true && item['can_blacklist'] === true)
							// берем запись с дополнительным полем
							this.ticketBlockRows.push(item)
					})

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// если вдруг нет выделенных строк - ничего не делаем
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					if (!this.ticketBlockRows.length) return

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// готовим поле со списком отделов
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.ticketBlockModalTimer = 5
					this.ticketBlockModalButtonTitle = this.localeFtc('ticketrule/block_timer').replace('{count}', 5)
					if (this.ticketBlockRows.length > 1)
					{
						let txt = []
						this.ticketBlockRows.forEach(item => {
							if (item['ticket_email'])
								txt.push(item['ticket_email'])
							else if (item['ticket_code'])
								txt.push(item['ticket_code'])
							else if (item['ticket_subject'])
								txt.push(item['ticket_subject'])
						})

						this.ticketBlockModalBody = this.localeFtc('ticketrule/blacklist_prompt_plural')
						this.ticketBlockModalBody = this.ticketBlockModalBody.replace('{tickets}', txt.join(', '))
					}
					else
					{
						let txt = ''
						if (this.ticketBlockRows[0]['ticket_email'])
							txt = this.ticketBlockRows[0]['ticket_email']
						else if (this.ticketBlockRows[0]['ticket_code'])
							txt = this.ticketBlockRows[0]['ticket_code']
						else if (this.ticketBlockRows[0]['ticket_subject'])
							txt = this.ticketBlockRows[0]['ticket_subject']

						this.ticketBlockModalBody = this.localeFtc('ticketrule/blacklist_prompt')
						this.ticketBlockModalBody = this.ticketBlockModalBody.replace('{email}', txt)
					}

					// показываем диалог
					EventBus.$emit('w5-body-scroll-disable')
					this.showTicketBlockModal = true

					// запускаем таймер
					this.ticketBlockModalTimerHandle = setInterval(() => {
						this.ticketBlockModalTimer--
						this.ticketBlockModalButtonTitle = this.localeFtc('ticketrule/block_timer').replace('{count}', this.ticketBlockModalTimer)
						if (this.ticketBlockModalTimer <= 0)
						{
							this.ticketBlockModalButtonTitle = this.localeFtc('main/block_action')
							clearInterval(this.ticketBlockModalTimerHandle)
							this.ticketBlockModalTimerHandle = null
						}
					}, 1000)

					// на этом все
					return

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это создание
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'create')
			{
				// тут только частные случаи
				if (this.crud === 'vds')
				{
					// теперь можно перейти в форму создания VDS
					this.$router.push('/vds/create')
				}
				else if (this.crud === 'backups')
				{
					// собираем данные для диалога
					this.backupDialogType = 'create-backup'
					this.backupDialogId = false
					this.backupDialogName = ''
					this.backupDialogAccount = false
					if (this.$store.state.user_type !== 'admin')
						// для клиентов можно без аккаунта делать запрос
						this.backupDialogAccount = true
					else
					{
						// для сотрудников, только если установлен глобальный фильтр
						if (this.accountGlobalFilter && this.accountGlobalFilter.text)
						{
							let _numStr = String(this.accountGlobalFilter.text).replace(/\D/g, '')
							let _num = parseInt(_numStr)
							if (!isNaN(_num))
								this.backupDialogAccount = _num
						}
					}

					// показываем диалог - создать бэкап
					this.openBackupDialog()
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// это экспорт операций в CSV
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (buttonType === 'exportCsv')
			{
				// проверка прав
				let _weCan = false
				if (this.$store.state.user_type !== 'admin')
				{
					// для клиентов всегда активна
					_weCan = true
				}
				else
				{
					// для админов активна только когда включен глобальный фильтр
					_weCan = Boolean(this.accountGlobalFilter && this.accountGlobalFilter.text)
				}
				// прав нет - выходим
				if (!_weCan) return
				// если процесс уже идет
				if (!this.buttons['exportCsv']['active']) return

				// старт процесса
				this.buttons['exportCsv']['active'] = false

				// копируем фильтр для данных
				const data = this.initRequestFilters()

				// запросим файл
				this.$http.get(this.APIServerUrl + '/operation/list/csv', { params: data, responseType: 'arraybuffer' })
				.then(res => {
					let fileName = 'export.csv'
					const contentDisposition = res.headers.get('content-disposition')
					if (contentDisposition)
					{
						const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
						if (fileNameMatch.length === 2) fileName = fileNameMatch[1]
					}

					const blob = new Blob([res.data], { type: res.headers.get('content-type') })
					const url = window.URL.createObjectURL(blob)
					const link = document.createElement('a')
					link.href = url
					link.download = fileName
					document.body.appendChild(link)
					link.click()

					this.buttons['exportCsv']['active'] = true
					this.$nextTick(() => {
						link.remove()
						window.URL.revokeObjectURL(url)
					})
				})
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// поменялось значение у поля выбора заметки диалога блокировки/разблокировки
		//---------------------------------------------------------------------
		blockModalValueChanged(field) {
			if ('listValue' in field && field['listValue'] && typeof field['listValue'] === 'object' && field['listValue']['name'])
			{
				this.$set(this, 'blockModalTextNoteValue', field['listValue']['name'])
			}
		},
		//---------------------------------------------------------------------
		// поменялось значение у поля выбора сервера диалога миграции
		//---------------------------------------------------------------------
		migrateModalValueChanged(field) {
			if ('listValue' in field && field['listValue'] && typeof field['listValue'] === 'object' && field['listValue']['id'])
			{
				// получим ID выбранного сервера
				let _serverID = field['listValue']['id']
				// будем считать количество невыбранных VDS
				let _unselected = 0
				// бежим по всем выбранным VDS
				this.migrateRows.forEach((item, idx, arr) => {
					if (String(item['server_id']) === String(_serverID))
					{
						// если VDS на выбранном сервере - не выбираем такую запись
						_unselected++
						arr[idx]['migrate_active'] = false
					}
					else
					{
						// если VDS на другом сервере - ставим выделение
						arr[idx]['migrate_active'] = true
					}
				})

				// если не выделено ни одного VDS
				if (_unselected === this.migrateRows.length) this.migrateModalButtonDisabled = true
				// если есть выделенные - включаем кнопку
				else this.migrateModalButtonDisabled = false
			}
		},
		//---------------------------------------------------------------------
		// поменялось значение у поля выбора аккаунта диалога переноса услуги
		//---------------------------------------------------------------------
		serviceMoveModalValueChanged(field) {
			// по умолчанию всегда выключаем кнопку
			this.serviceMoveModalButtonDisabled = true

			// обнулим хендлеры кнопки
			this.serviceMoveModalButtonCounter = 5
			if (this.serviceMoveModalButtonHandler) clearInterval(this.serviceMoveModalButtonHandler)
			this.serviceMoveModalButtonTitle = 'service/move'

			// если есть какое то выбранное значение
			if ('listValue' in field && field['listValue'] && typeof field['listValue'] === 'object' && field['listValue']['id'])
			{
				// получим ID выбранного аккаунта
				let _accountID = field['listValue']['id']
				// будем считать количество невыбранных услуг
				let _unselected = 0
				// бежим по всем выбранным усгулам
				this.serviceMoveRows.forEach((item, idx, arr) => {
					if (String(item['account_id']) === String(_accountID))
					{
						// если услуга уже на выбранном аккаунте - не выбираем такую запись
						_unselected++
						arr[idx]['move_active'] = false
					}
					else
					{
						// если услуга на другом аккаунте - ставим выделение
						arr[idx]['move_active'] = true
					}
				})

				// если не выделено ни одного VDS
				if (_unselected === this.serviceMoveRows.length) this.serviceMoveModalButtonDisabled = true
				// если есть выделенные - включаем кнопку
				else
				{
					// надпись с таймером
					this.serviceMoveModalButtonTitle = this.serviceMoveModalButtonCounter + ' - service/move'

					// запускаем таймер
					this.serviceMoveModalButtonHandler = setInterval(() => {
						// уменьшим счетчик
						this.serviceMoveModalButtonCounter--

						// проверим счетчик
						if (this.serviceMoveModalButtonCounter <= 0)
						{
							// сброс таймера
							clearInterval(this.serviceMoveModalButtonHandler)
							// надпись без таймера
							this.serviceMoveModalButtonTitle = 'service/move'
							// включим кнопку
							this.serviceMoveModalButtonDisabled = false
							// на этом все
							return
						}

						// надпись с таймером
						this.serviceMoveModalButtonTitle = this.serviceMoveModalButtonCounter + ' - service/move'
					}, 1000)
				}
			}
		},
		//---------------------------------------------------------------------
		// поменялось значение у поля выбора отдела диалога перемещения тикетов
		//---------------------------------------------------------------------
		ticketMoveModalValueChanged(field) {
			if ('listValue' in field && field['listValue'] && typeof field['listValue'] === 'object' && field['listValue']['id'])
			{
				// получим ID и тип выбранного отдела
				let _ID = field['listValue']['id']
				let _TYPE = field['listValue']['type']
				// будем считать количество невыбранных тикетов
				let _unselected = 0
				// бежим по всем выбранным тикетам
				this.ticketRows.forEach((item, idx, arr) => {
					// по умолчанию - считаем что нельзя переносить
					arr[idx]['ticket_move_active'] = false

					// переносить можно только если это какой то другой отдел
					if (String(item['department_id']) !== String(_ID))
					{
						// если тип тот же
						if (_TYPE === item['department_type'])
							// переносить точно можно
							arr[idx]['ticket_move_active'] = true
						else
						{
							// если это отделы исключения
							if ((item['department_type'] === 'normal' || item['department_type'] === 'silent') &&
								(_TYPE === 'normal' || _TYPE === 'silent'))
								arr[idx]['ticket_move_active'] = true
						}
					}

					// смотрим результат
					if (!arr[idx]['ticket_move_active'])
						_unselected++
				})

				// если не выделено ни одного тикета
				if (_unselected === this.ticketRows.length) this.ticketMoveModalButtonDisabled = true
				// если есть выделенные - включаем кнопку
				else this.ticketMoveModalButtonDisabled = false
			}
		},
		//---------------------------------------------------------------------
		// фокус на поле текста заметки диалога блокировки
		//---------------------------------------------------------------------
		blockModalTextFieldFocus() {
			// чистим ошибку если есть
			this.blockModalTextField['_errMsg'] = ''
		},
		//---------------------------------------------------------------------
		// Миграция
		//---------------------------------------------------------------------
		migrateInModalDialog(e) {
			// если кнопка задизаблена
			if (this.migrateModalButtonDisabled)
			{
				if (e) e.preventDefault()
				return
			}

			// соберем ID выделенных VDS
			let _services = {}
			this.migrateRows.forEach((item) => {
				if (item['migrate_active'] === true)
					_services[item['service_id']] = 1
			})

			// если таких не оказалось - ничего не делаем
			if (!Object.keys(_services).length)
			{
				if (e) e.preventDefault()
				return
			}

			// можно закрыть диалог
			this.hideMigrateModal()

			// формируем параметры для запроса на миграцию
			let _paramsGet = {
				additional: 'setMigrate',
				server_id: this.migrateModalSelectServerValue
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// первый запрос - GET
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$http.get(this.APIServerUrl + '/service/migrate', { 'params': _paramsGet }).then(
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// успешный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// второй запрос - POST
						// готовим данные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						let _paramsPost = {
							'_csrf': _dt['_csrf'],
							services: _services
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// производим сам запрос по тому же URL
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.$http.post(resGet.url, Helper.toFormData(_paramsPost)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// гасим кнопку
									this.buttons['migrate']['active'] = false

									// просто тихо запрашиваем данные заново для некоторых CRUD
									if (this.crud !== 'iso' && this.crud !== 'additional-services' && this.crud !== 'backups')
										this.requestListData(true)

									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// на этом все
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						return
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// ошибка получения CSRF-кода
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// отрицательный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			) // this.$http.get
		},
		//---------------------------------------------------------------------
		// Массовое удаление услуг
		//---------------------------------------------------------------------
		serviceBulkDelInModalDialog(e) {
			// если кнопка задизаблена
			if (this.serviceBulkDelModalButtonDisabled)
			{
				if (e) e.preventDefault()
				return
			}

			// соберем ID выделенных услуг
			let _services = {}
			this.serviceBulkDelRows.forEach((item) => {
				_services[item['service_id']] = 1
			})

			// если таких не оказалось - ничего не делаем
			if (!Object.keys(_services).length)
			{
				if (e) e.preventDefault()
				return
			}

			// можно закрыть диалог
			this.hideServiceBulkDelModal()

			// формируем параметры для запроса на перенос услуги
			let _paramsGet = {
				additional: 'setDelete'
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// первый запрос - GET
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$http.get(this.APIServerUrl + '/service/delete', { 'params': _paramsGet }).then(
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// успешный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// второй запрос - POST
						// готовим данные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						let _paramsPost = {
							'_csrf': _dt['_csrf'],
							services: _services
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// производим сам запрос по тому же URL
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.$http.post(resGet.url, Helper.toFormData(_paramsPost)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' && 'result' in _dt && _dt['result'])
								{
									// гасим кнопку
									this.buttons['bulkDel']['active'] = false

									// просто тихо запрашиваем данные заново для некоторых CRUD
									this.requestListData(true)

									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// на этом все
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						return
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// ошибка получения CSRF-кода
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// отрицательный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			) // this.$http.get
		},
		//---------------------------------------------------------------------
		// Массовый перенос услуг на другой аккаунт
		//---------------------------------------------------------------------
		serviceMoveInModalDialog(e) {
			// если кнопка задизаблена
			if (this.serviceMoveModalButtonDisabled)
			{
				if (e) e.preventDefault()
				return
			}

			// соберем ID выделенных услуг
			let _services = {}
			this.serviceMoveRows.forEach((item) => {
				if (item['move_active'] === true)
					_services[item['service_id']] = 1
			})

			// если таких не оказалось - ничего не делаем
			if (!Object.keys(_services).length)
			{
				if (e) e.preventDefault()
				return
			}

			// можно закрыть диалог
			this.hideServiceMoveModal()

			// формируем параметры для запроса на перенос услуги
			let _paramsGet = {
				additional: 'setMove',
				account_id: this.serviceMoveModalSelectAccountValue
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// первый запрос - GET
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$http.get(this.APIServerUrl + '/service/move', { 'params': _paramsGet }).then(
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// успешный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// второй запрос - POST
						// готовим данные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						let _paramsPost = {
							'_csrf': _dt['_csrf'],
							services: _services
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// производим сам запрос по тому же URL
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.$http.post(resGet.url, Helper.toFormData(_paramsPost)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' && 'result' in _dt && _dt['result'])
								{
									// гасим кнопку
									this.buttons['serviceMove']['active'] = false

									// просто тихо запрашиваем данные заново для некоторых CRUD
									this.requestListData(true)

									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// на этом все
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						return
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// ошибка получения CSRF-кода
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// отрицательный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			) // this.$http.get
		},
		//---------------------------------------------------------------------
		// Массовое перемещение тикетов
		//---------------------------------------------------------------------
		ticketMoveInModalDialog(e) {
			// если кнопка задизаблена
			if (this.ticketMoveModalButtonDisabled)
			{
				if (e) e.preventDefault()
				return
			}

			// соберем ID выделенных тикетов
			let _tickets = {}
			this.ticketRows.forEach((item) => {
				if (item['ticket_move_active'] === true)
					_tickets[item['ticket_id']] = 1
			})

			// если таких не оказалось - ничего не делаем
			if (!Object.keys(_tickets).length)
			{
				if (e) e.preventDefault()
				return
			}

			// можно закрыть диалог
			this.hideTicketMoveModal()

			// формируем параметры для запроса на миграцию
			let _paramsGet = {
				additional: 'setMove',
				department_id: this.ticketMoveModalSelectDepartmentValue
			}

			// определим тип выбранного отдела
			let _depType = null
			if (this.ticketMoveModalDepartmentField['list'] && this.ticketMoveModalDepartmentField['list'].length)
				this.ticketMoveModalDepartmentField['list'].some(dep => {
					if (String(dep.id) === String(this.ticketMoveModalSelectDepartmentValue))
					{
						_depType = dep.type
						return true
					}
				})

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// первый запрос - GET
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$http.get(this.APIServerUrl + '/ticket/update', { 'params': _paramsGet }).then(
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// успешный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// второй запрос - POST
						// готовим данные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						let _paramsPost = {
							'_csrf': _dt['_csrf'],
							tickets: _tickets
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// производим сам запрос по тому же URL
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.$http.post(resGet.url, Helper.toFormData(_paramsPost)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// гасим кнопку
									this.buttons['replaceTicket']['active'] = false

									// если тип отдела silent - запросим счетчики сами (пушей по ним нет)
									if (_depType === 'silent')
										this.$store.dispatch('getTicketCounters')

									// просто тихо запрашиваем данные заново для некоторых CRUD
									this.requestListData(true)

									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// на этом все
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						return
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// ошибка получения CSRF-кода
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// отрицательный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			) // this.$http.get
		},
		//---------------------------------------------------------------------
		// Массовая блокировка тикетов
		//---------------------------------------------------------------------
		ticketBlockInModalDialog(e) {
			// если таймер еще активен
			if (this.ticketBlockModalTimer > 0)
			{
				if (e) e.preventDefault()
				return
			}

			// соберем ID выделенных тикетов
			let _tickets = {}
			this.ticketBlockRows.forEach(item => {
				_tickets[item['ticket_id']] = 1
			})

			// если таких не оказалось - ничего не делаем
			if (!Object.keys(_tickets).length)
			{
				if (e) e.preventDefault()
				return
			}

			// можно закрыть диалог
			this.hideTicketBlockModal()

			// первый запрос
			this.$http.get(this.APIServerUrl + '/ticket/update?additional=setBlacklist')
			.then(
				// success
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						let _post = { '_csrf': _dt['_csrf'], tickets: _tickets }
						// второй запрос по тому же URL
						this.$http.post(res.url, Helper.toFormData(_post))
						.then(
							// success
							resPost => {
								// получаем ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								if (_dt && _dt['status'] === 'ok')
								{
									// гасим кнопку
									this.buttons['blockTicket']['active'] = false
									// тихо рефрешим таблицу
									this.requestListData(true)
									// на этом все
									return
								}

								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// fail
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(res)
				},
				// fail
				res => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(res)
				}
			)
		},
		//---------------------------------------------------------------------
		// Блокирует/разблокирует записи
		//---------------------------------------------------------------------
		blockRowsInModalDialog(e) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если требуется заметка - нужно сделать проверку
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.blockModalNoteRequired)
			{
				// если не задана заметка
				if (!this.blockModalTextNoteValue || String(this.blockModalTextNoteValue).trim() === '')
				{
					this.blockModalTextField['_errMsg'] = 'notes/required_note'
					return
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// закрываем диалог
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.hideBlockModal()

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если не заданы записи
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (!this.blockRows || !Array.isArray(this.blockRows) || !this.blockRows.length)
			{
				this.localErrorMessage = 'main/choose_records'
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// делаем запрос - формируем URL
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _url = this.APIServerUrl + '/' + this.getRealCrud(this.crud) + '/update'
			// параметры
			let _paramsGet = {
				'additional': this.blockModalWhat === 'on' ? 'setUnBlock' : 'setBlock'

			}
			// добавляем ID записей
			let _field = this.listConfig['on-off']
			let _ids = {}
			this.blockRows.forEach((item) => {
				if (item[this.listConfig['column_id']])
					_ids[item[this.listConfig['column_id']]] = 1
			})

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// первый запрос - GET
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$http.get(_url, { 'params': _paramsGet }).then(
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// успешный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// второй запрос - POST
						// готовим данные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						let _paramsPost = {
							'_csrf': _dt['_csrf'],
							[_field]: _ids
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// производим сам запрос по тому же URL
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.$http.post(resGet.url, Helper.toFormData(_paramsPost)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// гасим кнопку
									this.buttons[this.blockModalWhat]['active'] = false

									// если не нужна заметка
									if (!this.blockModalNoteRequired)
									{
										// просто тихо запрашиваем данные заново для некоторых CRUD
										if (this.crud !== 'iso' && this.crud !== 'additional-services' && this.crud !== 'backups')
											this.requestListData(true)
									}
									// заметка нужна - создаем ее для всех записей
									else
									{
										this.createNotesAfterBlock(
											() => {
												// просто тихо запрашиваем данные заново для некоторых CRUD
												if (this.crud !== 'iso' && this.crud !== 'additional-services' && this.crud !== 'backups')
													this.requestListData(true)
											}
										)
									}

									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = 'error/api_incorrect'
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка
								this.localErrorMessage = 'error/api_incorrect'
							}
						)

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// на этом все
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						return
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// ошибка получения CSRF-кода
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.localErrorMessage = 'error/api_incorrect'
				},
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// отрицательный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					this.localErrorMessage = 'error/api_incorrect'
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			) // this.$http.get

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// создает заметки для выделенных записей при блокировке/разблокировке
		//---------------------------------------------------------------------
		createNotesAfterBlock(successCallback, failCallback) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// готовим объект для отправки серверу
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _data = {
				'additional': 'setCreateMultiNote',
				'type': this.getRealCrud(this.crud),
				'text': this.blockModalTextNoteValue,
				'action': this.blockModalWhat === 'on' ? 'unblock' : 'block',
				'objects': {}
			}

			this.blockRows.forEach((item) => {
				if (item[this.listConfig['column_id']])
					_data['objects'][item[this.listConfig['column_id']]] = 1
			})

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// первый запрос - GET
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$http.get(this.APIServerUrl + '/notes/create').then(
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// успешный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						// запоминаем код
						_data['_csrf'] = _dt['_csrf']
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// производим сам запрос по тому же URL
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.$http.post(resGet.url, Helper.toFormData(_data)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// вызовем колбак
									if (successCallback && typeof successCallback === 'function') successCallback()
									// на этом все
									return
								}

								// иная ошибка
								if (failCallback && typeof failCallback === 'function') failCallback()
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка
								if (failCallback && typeof failCallback === 'function') failCallback()
							}
						)

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// на этом все
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						return
					}

					// иная ошибка
					if (failCallback && typeof failCallback === 'function') failCallback()
				},
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// отрицательный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					if (failCallback && typeof failCallback === 'function') failCallback()
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			) // this.$http.get

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// Регистрация/нерегистрация серверов
		//---------------------------------------------------------------------
		registerRowsInModalDialog(e) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// закрываем диалог
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.hideRegisterModal()

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если не заданы записи
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (!this.registerRows || !Array.isArray(this.registerRows) || !this.registerRows.length)
			{
				this.localErrorMessage = 'main/choose_records'
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// делаем запрос - формируем URL
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _url
			let _paramsGet

			if (this.registerModalWhat === 'r_on' || this.registerModalWhat === 'r_off')
			{
				_url = this.APIServerUrl + '/server/update'
				// параметры
				_paramsGet = {
					//'additional': this.registerModalWhat === 'r_on' ? 'setRegister' : 'setUnRegister'
					'additional': this.registerModalWhat === 'r_on' ? 'setActive' : 'setReserve'
				}
			}
			else if (this.registerModalWhat === 'ip_on' || this.registerModalWhat === 'ip_off')
			{
				_url = this.APIServerUrl + '/ippool/update'
				// параметры
				_paramsGet = {
					'additional': this.registerModalWhat === 'ip_on' ? 'setUnBlock' : 'setBlock'
				}
				if (_paramsGet.additional === 'setBlock')
				{
					if (this.ippoolBlockValue !== 'block')
						_paramsGet.type = this.ippoolBlockValue
				}
			}
			else if (this.registerModalWhat === 'doc_status')
			{
				_url = this.APIServerUrl + '/document/update'
				// параметры
				_paramsGet = {
					'additional': 'setStatus',
					'status': this.documentStatusValue
				}
			}

			// добавляем ID записей
			let _field = this.listConfig['on-off']
			let _ids = {}
			this.registerRows.forEach((item) => {
				if (item[this.listConfig['column_id']])
					_ids[item[this.listConfig['column_id']]] = 1
			})

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// первый запрос - GET
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$http.get(_url, { 'params': _paramsGet }).then(
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// успешный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// второй запрос - POST
						// готовим данные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						let _paramsPost = {
							'_csrf': _dt['_csrf'],
							[_field]: _ids
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// производим сам запрос по тому же URL
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.$http.post(resGet.url, Helper.toFormData(_paramsPost)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// гасим кнопку
									this.buttons[this.registerModalWhat]['active'] = false
									// просто тихо запрашиваем данные заново для некоторых CRUD
									this.requestListData(true)
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = 'error/api_incorrect'
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка
								this.localErrorMessage = 'error/api_incorrect'
							}
						)

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// на этом все
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						return
					}

					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					// ошибка получения CSRF-кода
					//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					this.localErrorMessage = 'error/api_incorrect'
				},
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// отрицательный ответ сервера
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resGet => {
					this.localErrorMessage = 'error/api_incorrect'
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			) // this.$http.get

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// выделяет или снимает выделение со строки таблицы
		//---------------------------------------------------------------------
		selectRowInTable(e, rowID) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть ID - запишем его как последную запись, с которой работал пользователь
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.crud && rowID) this.$store.commit('setLastRow', { 'crud': this.crud, 'id': rowID })
			// записываем позицию окна в Vuex
			let _pathRoute = this.crud + this.page
			this.$store.commit('setLastWindowY', {
				'url': _pathRoute,
				'y': this.curWindowY
			})

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если явно задан флаг запрета на выделение записей
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.listConfig['can_select_rows'] === false) return

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// обнулим локально выделение последней строки, с которой работал пользователь
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.lastWorkedRowID === rowID) this.lastWorkedRowID = false

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// статус выделенных строк по умолчанию не определен
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _status = false

			// по умолчанию - отключаем все кнопки
			for (let _b in this.buttons) this.buttons[_b]['active'] = false

			// кнопку экспорта иницилизируем отдельно
			this.exportCsvButtonInit()

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим колонку с ID записи
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _columnID = this.listConfig['column_id']

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// ищем в renderRows эту запись
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _foundIndex = -1
			if (this.renderRows && this.renderRows.length)
			{
				this.renderRows.some((item, index, arr) => {
					if (item[_columnID] && item[_columnID] === rowID)
					{
						// запомним индекс
						_foundIndex = index

						// поменяем состояние - меняем так, так как такого поля еще может и не быть вообще
						if (item['w5-row-selected'] === true)
							item['w5-row-selected'] = false
						else
							item['w5-row-selected'] = true

						return true
					}
				})
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если изменили состояние хотя бы у одной записи
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (_foundIndex >= 0)
			{
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// если была нажата клавиша "Shift"
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				let k = 0
				let _startIndex = -1
				let _len = this.renderRows.length
				let _start = false
				let _end = false

				if (e.shiftKey)
				{
					// ищем выделенную запись выше текущей
					for (k = _foundIndex - 1; k >= 0; k--)
					{
						// если нашли выделенную запись
						if (this.renderRows[k]['w5-row-selected'] === true)
						{
							// запомним индекс
							_startIndex = k
							break
						}
					}

					// если не нашли выше - ищем выделенную запись ниже текущей
					if (_startIndex < 0)
					{
						for (k = _foundIndex + 1; k < _len; k++)
						{
							// если нашли выделенную запись
							if (this.renderRows[k]['w5-row-selected'] === true)
							{
								// запомним индекс
								_startIndex = k
								break
							}
						}
					}

					// определим границы, те что выше или ниже если они есть
					if (_startIndex >= 0)
					{
						_start = _startIndex <= _foundIndex ? _startIndex : _foundIndex
						_end = _startIndex <= _foundIndex ? _foundIndex : _startIndex
					}
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// пересчитаем количество выделенных записей и за одно
				// пометить те что выше если они есть
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				this.totalSelectedRowsCount = 0
				// а так же получим одинаковый статус
				// для этого найдем поле статуса
				let _statusField = false
				if (_len > 0)
				{
					// ищем в первой строке
					for (let _s in this.renderRows[0])
					{
						// если это поле статуса
						if (/_status$/ig.test(_s) && _s !== 'can_status')
						{
							_statusField = _s
							break
						}
					}
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// бежим по всем строкам
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				for (k = 0; k < _len; k++)
				{
					// если определены границы выделения
					if (_start !== false && _end !== false)
					{
						// если запись входит в промежуток
						if (k >= _start && k <= _end && k !== _foundIndex)
							// выделяем запись
							this.renderRows[k]['w5-row-selected'] = true
					}

					// если запись выделена
					if (this.renderRows[k]['w5-row-selected'] === true)
					{
						// подсчитаем ее
						this.totalSelectedRowsCount++
						// получим статус строки
						if (_status !== -1 && _statusField && _statusField in this.renderRows[k])
						{
							// если статус еще неопределен - запоминаем его
							if (!_status) _status = this.renderRows[k][_statusField]
							// если статус уже какой то есть - сверяем его с текущим
							else if (_status !== this.renderRows[k][_statusField])
							{
								// ставим признак того что статус неоднороден
								_status = -1
							}

							// если идет какой то процесс - ставим тоже признак неоднородности
							if (this.renderRows[k]['service_status_text'] !== undefined &&
								this.renderRows[k]['service_status_text'] !== null &&
								String(this.renderRows[k]['service_status_text']).length)
								_status = -1
						}
					}
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// работа с кнопками массовых операций
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// проверяем полученный статус у выделенных строк
				if (_status !== false && _status !== -1)
				{
					// если получен какой-то однородный статус
					if (_status === 'block')
					{
						// по умолчанию включим кнопку
						let _result = true
						// ищем среди выделенных записей - хотя бы одну с выключенным флагом
						if (!this.renderRows || !this.renderRows.length) this.renderRows = []
						this.renderRows.some((item, index, arr) => {
							if (item['w5-row-selected'] === true && item['can_unblock'] === false)
							{
								// нашли такую записи - кнопку не включать
								_result = false
								return true
							}
						})
						// ставим результат
						this.$set(this.buttons['on'], 'active', _result)
					}
					if (_status === 'notpaid')
					{
						// здесь признак - можно ли включить кнопку "on" и "off"
						let _buttonOnTurn = true
						let _buttonOffTurn = true

						// ищем среди всех выделенных записей
						if (!this.renderRows || !this.renderRows.length) this.renderRows = []

						// хотя бы одну с выключенным флагом
						for (let _idx = 0; _idx < this.renderRows.length; _idx++) {
							const item = this.renderRows[_idx]

							// если есть запрет на разблокировку
							if (item['w5-row-selected'] === true && item['can_unblock'] === false)
							{
								// нашли такую записи
								_buttonOnTurn = false
							}

							// если есть запрет на блокировку
							if (item['w5-row-selected'] === true && item['can_block'] === false)
							{
								// нашли такую записи
								_buttonOffTurn = false
							}
						}

						// если можно включить кнопку разблокировки
						if (_buttonOnTurn) {
							// включаем кнопку запуска
							this.$set(this.buttons['on'], 'active', true)
						}

						// если можно включить кнопку блокировки
						if (_buttonOffTurn) {
							// включаем кнопку запуска
							this.$set(this.buttons['off'], 'active', true)
						}

						/*
						// включаем кнопку запуска
						this.$set(this.buttons['on'], 'active', true)
						// по умолчанию включим кнопку "off"
						let _result = true
						// ищем среди выделенных записей - хотя бы одну с выключенным флагом
						if (!this.renderRows || !this.renderRows.length) this.renderRows = []
						this.renderRows.some((item, index, arr) => {
							if (item['w5-row-selected'] === true && item['can_block'] === false)
							{
								// нашли такую записи - кнопку не включать
								_result = false
								return true
							}
						})
						// ставим результат
						this.$set(this.buttons['off'], 'active', _result)
						*/
					}
					if (_status === 'active')
					{
						// по умолчанию включим кнопку
						let _result = true
						// ищем среди выделенных записей - хотя бы одну с выключенным флагом
						if (!this.renderRows || !this.renderRows.length) this.renderRows = []
						this.renderRows.some((item, index, arr) => {
							if (item['w5-row-selected'] === true && item['can_block'] === false)
							{
								// нашли такую записи - кнопку не включать
								_result = false
								return true
							}
						})
						// ставим результат
						this.$set(this.buttons['off'], 'active', _result)
					}
				}
				else
				{
					// статус или неоднороден или вообще нет выделенных строк,
					// нужно отключить кнопки - и они уже отключены
				}

				// запустим рендеринг сами в ручную, так как мы изменили массив объектов впрямую (без $set)
				this.$forceUpdate()
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопка миграции - по умолчанию уже отключена
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть выделенные записи
			if ((this.crud === 'vds' || this.crud === 'hi-cpu-vds') && this.totalSelectedRowsCount > 0)
			{
				// нужно проверить, что бы в них не было "deleted" и со статусом процесса
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				let _found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true &&
						(item['service_status'] === 'deleted' || item['service_status_text']))
						return true
				})

				// с процессом и удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['migrate'], 'active', true)
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопка массового удаления услуг - по умолчанию уже отключена
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$set(this.buttons['bulkDel'], 'active', false)
			// если есть выделенные записи
			if ((this.crud === 'vds' || this.crud === 'certificate' || this.crud === 'domains' || this.crud === 'additional-services' ||
				this.crud === 'iso' || this.crud === 'dns' || this.crud === 'backups' || this.crud === 'disks') && this.totalSelectedRowsCount > 0)
			{
				// нужно проверить, что бы в них не было "deleted" и со статусом процесса
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				let _found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true &&
						(item['service_status'] === 'deleted' || item['service_status_text'] || item['can_delete'] === false)
					)
						return true
				})

				// с процессом и удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['bulkDel'], 'active', true)
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопка переноса услуг - по умолчанию уже отключена
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$set(this.buttons['serviceMove'], 'active', false)
			// если есть выделенные записи
			if ((this.crud === 'vds' || this.crud === 'hi-cpu-vds' || this.crud === 'certificate' || this.crud === 'domains' ||
				this.crud === 'iso' || this.crud === 'dns' || this.crud === 'backups' || this.crud === 'disks') && this.totalSelectedRowsCount > 0)
			{
				// нужно проверить, что бы в них не было "deleted" и со статусом процесса
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				let _found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true &&
						(item['service_status'] === 'deleted' || item['service_status_text']))
						return true
				})

				// с процессом и удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['serviceMove'], 'active', true)
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопки массовых операций над тикетами - по умолчанию уже отключены
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть выделенные записи
			if (this.crud === 'ticket' && this.totalSelectedRowsCount > 0)
			{
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// кнопка массового закрытия тикетов
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// нужно проверить, что бы в них не было "closed" и "deleted"
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				let _found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true &&
						(item['ticket_status'] === 'closed' || item['ticket_status'] === 'deleted'))
						return true
				})

				// закрытых и удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['closeTicket'], 'active', true)

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// кнопка массового переноса тикетов
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// нужно проверить, что бы в них не было "deleted"
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				_found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true && item['ticket_status'] === 'deleted')
						return true
				})

				// удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['replaceTicket'], 'active', true)

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// кнопка массовой блокировки тикетов
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// нужно проверить, что бы в них не было без флага "can_blacklist" и
				// что бы флаг был только положительный
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				_found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true &&
						(!('can_blacklist' in item) || item['can_blacklist'] !== true))
						return true
				})

				// закрытых и удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['blockTicket'], 'active', true)
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопки массовых операций над серверами - по умолчанию уже отключены
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть выделенные записи
			if (this.crud === 'server' && this.totalSelectedRowsCount > 0)
			{
				// определим статус регистрации
				let regStatus = {}

				// бежим по всем строкам таблицы
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				this.renderRows.forEach(item => {
					// если строка выделена
					if (item['w5-row-selected'] === true)
					{
						// используем хеш-таблицу
						//let curStatus = String(item['server_register'])
						let curStatus = String(item['server_status'])
						if (regStatus[curStatus] === undefined) regStatus[curStatus] = 1
						else regStatus[curStatus]++
					}
				})

				// если статус однороден
				let curStatuses = Object.keys(regStatus)
				if (curStatuses.length === 1)
				{
					// включаем соответствующую кнопку
					if (curStatuses[0] === 'active') this.$set(this.buttons['r_off'], 'active', true)
					else if (curStatuses[0] === 'reserve') this.$set(this.buttons['r_on'], 'active', true)
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопки массовых операций над ip-pool - по умолчанию уже отключены
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть выделенные записи
			if (this.crud === 'ippool' && this.totalSelectedRowsCount > 0)
			{
				// определим статус регистрации
				let regStatus = {}

				// бежим по всем строкам таблицы
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				this.renderRows.forEach(item => {
					// если строка выделена
					if (item['w5-row-selected'] === true)
					{
						// используем хеш-таблицу
						let curStatus = String(item['ip_status'])
						if (regStatus[curStatus] === undefined) regStatus[curStatus] = 1
						else regStatus[curStatus]++
					}
				})

				// если статус однороден
				let curStatuses = Object.keys(regStatus)
				// если есть выделенные строки
				if (curStatuses.length)
				{
					// блокировка всегда включена
					this.$set(this.buttons['ip_off'], 'active', true)
					// активация включена только если среди выбранных записей нет со статусом "active"
					let _isActive = curStatuses.some(i => i === 'active')
					if (!_isActive)
						this.$set(this.buttons['ip_on'], 'active', true)
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопки массовых операций над document - по умолчанию уже отключены
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть выделенные записи
			if (this.crud === 'document' && this.totalSelectedRowsCount > 0)
			{
				// определим статус каждой строки
				let regStatus = {}

				// бежим по всем строкам таблицы
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				this.renderRows.forEach(item => {
					// если строка выделена
					if (item['w5-row-selected'] === true)
					{
						// используем хеш-таблицу
						let curStatus = String(item['can_status'])
						if (regStatus[curStatus] === undefined) regStatus[curStatus] = 1
						else regStatus[curStatus]++
					}
				})

				// собрали все статусы как ключи объекта
				let curStatuses = Object.keys(regStatus)
				// если есть выделенные строки
				if (curStatuses.length)
				{
					// активация включена только если все выбранные записи имеют статус "false"
					// ищем первый статус "false"
					let _isFalse = curStatuses.some(i => i === 'false' || i === 'undefined')
					// если таких нет - включаем кнопку
					if (!_isFalse)
						this.$set(this.buttons['doc_status'], 'active', true)
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// проверка статуса каждой кнопки массовой операции
		//---------------------------------------------------------------------
		buttonsForSelectedRow() {
			// по умолчанию - отключаем все кнопки
			for (let _b in this.buttons) this.buttons[_b]['active'] = false

			// кнопка экспорта в csv
			this.exportCsvButtonInit()

			// пересчитаем количество выделенных записей
			this.totalSelectedRowsCount = 0

			// а так же получим одинаковый статус
			let _statusField = false
			let _len = this.renderRows.length
			let _status = false

			// для этого найдем поле статуса
			if (_len > 0)
			{
				// ищем в первой строке
				for (let _s in this.renderRows[0])
				{
					// если это поле статуса
					if (/_status$/ig.test(_s))
					{
						_statusField = _s
						break
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// бежим по всем строкам
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			for (let k = 0; k < _len; k++)
			{
				// если запись выделена
				if (this.renderRows[k]['w5-row-selected'] === true)
				{
					// подсчитаем ее
					this.totalSelectedRowsCount++
					// получим статус строки
					if (_status !== -1 && _statusField && _statusField in this.renderRows[k])
					{
						// если статус еще неопределен - запоминаем его
						if (!_status) _status = this.renderRows[k][_statusField]
						// если статус уже какой то есть - сверяем его с текущим
						else if (_status !== this.renderRows[k][_statusField])
						{
							// ставим признак того что статус неоднороден
							_status = -1
						}
						// если идет какой то процесс - ставим тоже признак неоднородности
						if (this.renderRows[k]['service_status_text'] !== undefined &&
							this.renderRows[k]['service_status_text'] !== null &&
							String(this.renderRows[k]['service_status_text']).length)
							_status = -1
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// работа с кнопками массовых операций
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверяем полученный статус у выделенных строк
			if (_status !== false && _status !== -1)
			{
				// если получен какой-то однородный статус
				if (_status === 'block')
				{
					// по умолчанию включим кнопку
					let _result = true
					// ищем среди выделенных записей - хотя бы одну с выключенным флагом
					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.some((item, index, arr) => {
						if (item['w5-row-selected'] === true && item['can_unblock'] === false)
						{
							// нашли такую записи - кнопку не включать
							_result = false
							return true
						}
					})
					// ставим результат
					this.$set(this.buttons['on'], 'active', _result)
				}
				if (_status === 'notpaid' && (this.crud === 'vds' || this.crud === 'hi-cpu-vds'))
				{
					// включаем кнопку запуска
					this.$set(this.buttons['on'], 'active', true)
					// по умолчанию включим кнопку "off"
					let _result = true
					// ищем среди выделенных записей - хотя бы одну с выключенным флагом
					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.some((item, index, arr) => {
						if (item['w5-row-selected'] === true && item['can_block'] === false)
						{
							// нашли такую записи - кнопку не включать
							_result = false
							return true
						}
					})
					// ставим результат
					this.$set(this.buttons['off'], 'active', _result)
				}
				if (_status === 'active')
				{
					// по умолчанию включим кнопку
					let _result = true
					// ищем среди выделенных записей - хотя бы одну с выключенным флагом
					if (!this.renderRows || !this.renderRows.length) this.renderRows = []
					this.renderRows.some((item, index, arr) => {
						if (item['w5-row-selected'] === true && item['can_block'] === false)
						{
							// нашли такую записи - кнопку не включать
							_result = false
							return true
						}
					})
					// ставим результат
					this.$set(this.buttons['off'], 'active', _result)
				}
			}
			else
			{
				// статус или неоднороден или вообще нет выделенных строк,
				// нужно отключить кнопки - и они уже отключены
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопка миграции - по умолчанию уже отключена
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть выделенные записи
			if ((this.crud === 'vds' || this.crud === 'hi-cpu-vds') && this.totalSelectedRowsCount > 0)
			{
				// нужно проверить, что бы в них не было "deleted" и со статусом процесса
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				let _found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true &&
						(item['service_status'] === 'deleted' || item['service_status_text']))
						return true
				})

				// с процессом и удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['migrate'], 'active', true)
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопка переноса услуг - по умолчанию уже отключена
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$set(this.buttons['serviceMove'], 'active', false)
			// если есть выделенные записи
			if ((this.crud === 'vds' || this.crud === 'hi-cpu-vds' || this.crud === 'certificate' || this.crud === 'domains' ||
				this.crud === 'iso' || this.crud === 'dns' || this.crud === 'backups') && this.totalSelectedRowsCount > 0)
			{
				// нужно проверить, что бы в них не было "deleted" и со статусом процесса
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				let _found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true &&
						(item['service_status'] === 'deleted' || item['service_status_text']))
						return true
				})

				// с процессом и удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['serviceMove'], 'active', true)
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопки массовых операций над тикетами - по умолчанию уже отключены
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть выделенные записи
			if (this.crud === 'ticket' && this.totalSelectedRowsCount > 0)
			{
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// кнопка массового закрытия тикетов
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// нужно проверить, что бы в них не было "closed" и "deleted"
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				let _found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true &&
						(item['ticket_status'] === 'closed' || item['ticket_status'] === 'deleted'))
						return true
				})

				// закрытых и удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['closeTicket'], 'active', true)

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// кнопка массового переноса тикетов
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// нужно проверить, что бы в них не было "deleted"
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				_found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true && item['ticket_status'] === 'deleted')
						return true
				})

				// удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['replaceTicket'], 'active', true)

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// кнопка массовой блокировки тикетов
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// нужно проверить, что бы в них не было без флага "can_blacklist" и
				// что бы флаг был только положительный
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				_found = this.renderRows.some(item => {
					if (item['w5-row-selected'] === true &&
						(!('can_blacklist' in item) || item['can_blacklist'] !== true))
						return true
				})

				// закрытых и удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['blockTicket'], 'active', true)
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопки массовых операций над серверами - по умолчанию уже отключены
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть выделенные записи
			if (this.crud === 'server' && this.totalSelectedRowsCount > 0)
			{
				// определим статус регистрации
				let regStatus = {}

				// бежим по всем строкам таблицы
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				this.renderRows.forEach(item => {
					// если строка выделена
					if (item['w5-row-selected'] === true)
					{
						// используем хеш-таблицу
						//let curStatus = String(item['server_register'])
						let curStatus = String(item['server_status'])
						if (regStatus[curStatus] === undefined) regStatus[curStatus] = 1
						else regStatus[curStatus]++
					}
				})

				// если статус однороден
				let curStatuses = Object.keys(regStatus)
				if (curStatuses.length === 1)
				{
					// включаем соответствующую кнопку
					if (curStatuses[0] === 'active') this.$set(this.buttons['r_off'], 'active', true)
					else if (curStatuses[0] === 'reserve') this.$set(this.buttons['r_on'], 'active', true)
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопки массовых операций над ip-pool - по умолчанию уже отключены
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть выделенные записи
			if (this.crud === 'ippool' && this.totalSelectedRowsCount > 0)
			{
				// определим статус регистрации
				let regStatus = {}

				// бежим по всем строкам таблицы
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				this.renderRows.forEach(item => {
					// если строка выделена
					if (item['w5-row-selected'] === true)
					{
						// используем хеш-таблицу
						let curStatus = String(item['ip_status'])
						if (regStatus[curStatus] === undefined) regStatus[curStatus] = 1
						else regStatus[curStatus]++
					}
				})

				// если статус однороден
				let curStatuses = Object.keys(regStatus)
				// если есть выделенные строки
				if (curStatuses.length)
				{
					// блокировка всегда включена
					this.$set(this.buttons['ip_off'], 'active', true)
					// активация включена только если среди выбранных записей нет со статусом "active"
					let _isActive = curStatuses.some(i => i === 'active')
					if (!_isActive)
						this.$set(this.buttons['ip_on'], 'active', true)
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// кнопка массового удаления услуг
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.$set(this.buttons['bulkDel'], 'active', false)
			// если есть выделенные записи
			if ((this.crud === 'vds' || this.crud === 'certificate' || this.crud === 'domains' || this.crud === 'additional-services' ||
				this.crud === 'iso' || this.crud === 'dns' || this.crud === 'backups') && this.totalSelectedRowsCount > 0)
			{
				// нужно проверить, что бы в них не было "deleted" и со статусом процесса
				// и что бы флаг был корректный
				if (!this.renderRows || !this.renderRows.length) this.renderRows = []
				let _found = this.renderRows.some(item => {
					if (
						item['w5-row-selected'] === true &&
						(
							item['service_status'] === 'deleted' || item['service_status_text'] ||
							('can_delete' in item && item['can_delete'] !== true)
						)
					)
						return true
				})

				// с процессом и удаленных записей нет - можно включать кнопку
				if (!_found) this.$set(this.buttons['bulkDel'], 'active', true)
			}

			// кнопка экспорта в csv
			this.exportCsvButtonInit()

			// запустим рендеринг сами в ручную, так как мы изменили массив объектов впрямую (без $set)
			this.$forceUpdate()
		},
		//---------------------------------------------------------------------
		// черный список IP
		//---------------------------------------------------------------------
		ipBlackListClick() {
			// обнуляем значения
			this.localErrorMessage = ''
			this.localSuccessMessage = ''
			this.viewData = null
			this.viewSortDATA = null
			this.viewKeys = null

			// проверяем наличие данных
			if (!this.ipBlackListValue ||
				!/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.ipBlackListValue) ||
				!Helper.validateIPv4(this.ipBlackListValue))
			{
				this.localErrorMessage = 'server/ip_error'
				return
			}

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/logs/get/' + this.ipBlackListValue
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'ok')
					{
						// свежие данные полей
						this.viewData = _dt
						// удалим дубль
						delete this.viewData.status
						// переименую данные
						this.viewData.__ip = Object.assign({}, this.viewData.ip)
						delete this.viewData.ip
						// сортировка
						this.viewSortDATA = this.makeViewByOrder()
						// ключи полей
						this.viewKeys = Object.keys(this.viewSortDATA).sort(function(a, b) {
							return a - b
						})
						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showViewModal = true
						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// кнопка диалога показа данных
		//---------------------------------------------------------------------
		viewButtonProcedure() {
			// закрываем диалог
			this.hideViewModal()

			// проверка
			if (!this.ipBlackListValue ||
				!/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.ipBlackListValue) ||
				!Helper.validateIPv4(this.ipBlackListValue) ||
				!this.viewData ||
				!this.viewData.__ip ||
				this.viewData.__ip.can_flush !== true)
			{
				this.localErrorMessage = 'server/ip_error'
				return
			}

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/logs/flush/' + this.ipBlackListValue
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// готовим данные POST
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// покадем сообщение об успехе
									this.setLocalSuccessMessage('forget/success')
									// на это все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// закрывает диалог показа данных
		//---------------------------------------------------------------------
		hideViewModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showViewModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// сортирует данные для просмотра согласно порядку
		//---------------------------------------------------------------------
		makeViewByOrder() {
			if (!this.viewData) return null

			let obj
			let __obj
			let ____obj
			let tmp
			let order
			let isLink = 0
			let nm = ''
			let sortDATA = {}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// бежим по всем данным
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			for (let idx in this.viewData) if (this.viewData.hasOwnProperty(idx))
			{
				// текущий объект
				obj = this.viewData[idx]

				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// рассматриваем только объекты
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				if (obj && typeof obj === 'object')
				{
					// если уже есть порядок
					if ('order' in obj && obj['type'] !== 'hidden')
					{
						// получим индекс
						tmp = parseInt(obj['order'])
						order = isNaN(tmp) ? 0 : tmp

						// запомним его
						if (!sortDATA[order])
						{
							sortDATA[order] = []
							sortDATA[order].push(idx)
						}
						else sortDATA[order].push(idx)
					}
					// порядка еще нет - опускаемся на уровень ниже
					else
					{
						// это ссылка?
						isLink = 0
						nm = ''

						for (let i in obj) if (obj.hasOwnProperty(i))
							if (/_name$/i.test(i) || /_id$/i.test(i) || /_login$/i.test(i))
							{
								nm = i.match(/(.*?)_name$/)
								if (nm === null)
								{
									nm = i.match(/(.*?)_id$/)
									if (nm === null)
									{
										nm = i.match(/(.*?)_login$/)
										if (nm == null)
										{
											if (this.$store.state.isDebug) window.DEBUG.error('не найдено поле')
										}
										else nm = nm[1]
									}
									else nm = nm[1]
								}
								else nm = nm[1]

								isLink++
							}

						// если встретили два поля - значит ссылка
						if (isLink === 2 && idx !== this.__realCrudName(this.crud)) isLink = true
						else isLink = false

						// если это ссылка
						if (isLink)
						{
							// получим индекс
							tmp = parseInt(obj[nm + '_id']['order'])
							order = isNaN(tmp) ? 0 : tmp

							// запомним его
							if (!sortDATA[order])
							{
								sortDATA[order] = []
								sortDATA[order].push(idx)
							}
							else sortDATA[order].push(idx)
						}
						// это не ссылка - просто собираем все объекты
						else
						{
							for (let i in obj) if (obj.hasOwnProperty(i))
							{
								// текущий объект
								__obj = obj[i]

								// рассматриваем только объекты
								if (__obj && typeof __obj === 'object' &&
									'order' in __obj &&
									'title' in __obj &&
									'value' in __obj && __obj['value'] !== null && __obj['value'] !== undefined &&
									'type' in __obj && __obj['type'] !== 'hidden')
								{
									// получим индекс
									tmp = parseInt(__obj['order'])
									order = isNaN(tmp) ? 0 : tmp

									// запомним его
									if (!sortDATA[order])
									{
										sortDATA[order] = []
										sortDATA[order].push(i)
									}
									else sortDATA[order].push(i)
								}
								else
								{
									// права для ролей
									if (idx === 'role' && i === 'permissions') sortDATA[9999] = [i]
									// данные услуги в поле service_data
									else if (idx === 'service' && i === 'service_data' && this.$store.state.user_type === 'admin')
									{
										// получим индекс
										tmp = parseInt(__obj['order'])
										order = isNaN(tmp) ? 0 : tmp

										// запомним его
										if (!sortDATA[order])
										{
											sortDATA[order] = []
											sortDATA[order].push(i)
										}
										else sortDATA[order].push(i)
									}
									// это объект, содержащий еще объекты
									else
									{
										// пробежимся по всем свойствам
										for (let w in __obj) if (__obj.hasOwnProperty(w))
										{
											// текущий объект
											____obj = __obj[w]

											// рассматриваем только объекты
											if (____obj && typeof ____obj === 'object' &&
												'order' in ____obj &&
												'title' in ____obj &&
												'value' in ____obj && ____obj['value'] !== null && ____obj['value'] !== undefined &&
												'type' in ____obj && ____obj['type'] !== 'hidden')
											{
												// получим индекс
												tmp = parseInt(____obj['order'])
												order = isNaN(tmp) ? 0 : tmp

												// запомним его
												if (!sortDATA[order])
												{
													sortDATA[order] = []
													sortDATA[order].push(w)
												}
												else sortDATA[order].push(w)
											}
										}
									}
								}
							}
						}
					}
				}

				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// возвращаем результат
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			return sortDATA
		},
		//---------------------------------------------------------------------
		// обнулили строку поля быстрого поиска
		//---------------------------------------------------------------------
		fastSearchClear() {
			this.fastSearchValue = ''
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// обработчик изменения поля быстрого поиска
		//---------------------------------------------------------------------
		fastSearchEvent() {
			// если строка поиска обнулена
			if (this.fastSearchValue === null || this.fastSearchValue === undefined) return
			// если у нас уже есть запущенный таймер - обнулим его
			if (this.fastSearchTimer) clearTimeout(this.fastSearchTimer)
			// заряжаем новый таймер
			this.fastSearchTimer = setTimeout(() => {
				this.fastSearchTimer = null
				this.fastSearchEventStart()
			}, 500)
		},
		//---------------------------------------------------------------------
		// обработчик изменения поля быстрого поиска
		//---------------------------------------------------------------------
		fastSearchEventStart() {
			// нормализуем строку поиска
			let text = String(this.fastSearchValue)
			// если обнулили строку поиска руками
			if (text === '') return this.fastSearchClear()

			// начинаем поиск только при определенных условиях
			let _canRequest = false
			// если есть глобальный фильтр
			if (this.$store.state.accountGlobalFilter === true)
			{
				// можно запрашивать данные в любом случае
				_canRequest = true
			}
			else
			{
				// иначе только при определенных условиях
				if (this.$store.state.user_type !== 'admin')
				{
					// клиенту можно вводить минимум 2 символа
					if (text.length >= 2) _canRequest = true
				}
				else
				{
					// сотруднику минимум 3 символа
					if (text.length >= 3) _canRequest = true
				}
			}

			// если флаг положительный - делаем запрос
			if (_canRequest)
			{
				this.setLocalStorage()
				this.requestListData()
			}
		},
		//---------------------------------------------------------------------
		// обработчик изменения фильтра по периоду
		//---------------------------------------------------------------------
		filterPeriodEvent(value) {
			this.filters.period.valueBegin = value['begin'] ? this.formater_Date2StrDate(value['begin']) + ' 00:00:00' : false
			this.filters.period.valueEnd = value['end'] ? this.formater_Date2StrDate(value['end']) + ' 23:59:59' : false
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// обработчик изменения фильтра типа Bool
		//---------------------------------------------------------------------
		filterBoolEvent(value) {
			this.filters.bool.value = value
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// обработчик изменения фильтра типа Logs
		//---------------------------------------------------------------------
		filterLogsEvent(value) {
			this.filters.logs.value = value
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// обработчик изменения фильтра ticket-label
		//---------------------------------------------------------------------
		filterTicketLabelEvent(value) {
			this.filters.ticketLabel.value = value
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// обработчик изменения фильтра disk-type
		//---------------------------------------------------------------------
		filterDiskTypeEvent(value) {
			this.filters.diskType.value = value === '-1' ? null : value
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// обработчик изменения фильтра plan-params
		//---------------------------------------------------------------------
		filterParamsEvent(value) {
			this.filters.planParams.value = Object.assign({}, value)
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// поменяли группу VDS
		//---------------------------------------------------------------------
		onGroupVdsChanged(value) {
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// включение тройного фильтра для финансов
		//---------------------------------------------------------------------
		operationTripleFilter() {
			// проверка
			if (this.crud !== 'operation') return
			if (this.$store.state.user_type !== 'admin') return

			// установка соответствующих фильтров
			let _find = false
			this.filters.radio.forEach((item, idx, arr) => {
				if (item.field === 'operation_purse')
				{
					_find = true
					arr[idx]['value'] = 'partner'
					arr[idx]['visible'] = true
				}
				else if (item.field === 'operation_type')
				{
					_find = true
					arr[idx]['value'] = '-1'
					arr[idx]['visible'] = true
				}
				else if (item.field === 'operation_status')
				{
					_find = true
					arr[idx]['value'] = '0'
					arr[idx]['visible'] = true
				}
			})

			if (this.filters.period)
			{
				_find = true
				this.filters.period.valueBegin = false
				this.filters.period.valueEnd = false
			}

			if (_find)
			{
				this.setLocalStorage()
				this.requestListData()
			}
		},
		//---------------------------------------------------------------------
		// функция устанавливает размер страницы
		//---------------------------------------------------------------------
		setPageSize(size) {
			// если это тот же размер
			if (size === this.listData.pageSize) return
			// если какой то левый размер
			if (this.Config.pageSizes.indexOf(size) === -1) return
			// можно делать запрос
			let _params = {
				'additional': 'setPageSize',
				'size': size,
				'dontAbort': true
			}
			this.forms_Get('/user/index', _params,
				(data) => {
					if (!data || data['status'] !== 'ok') this.localErrorMessage = this.localeFtc('register/error')
					this.requestListData()
				},
				() => this.requestListData()
			)
		},
		//---------------------------------------------------------------------
		// сортировка таблицы
		//---------------------------------------------------------------------
		sortTable(field, column) {
			// особый случай
			if (field === 'account_name') field = 'account_id'
			if (field === 'parent_name_full') field = 'parent_id'
			if (field === 'owner_account_name') field = 'owner_account_id'
			if (field === 'service_name_full' && this.crud === 'dns') field = 'service_name'
			// если сортировка по этой колонке запрещена - ничего не делаем
			if (column['sort'] !== true) return
			// двухзначный переключатель
			if (this.sortedColumn === false) this.sortedColumn = '-' + field
			else if (this.sortedColumn === '+' + field || this.sortedColumn === field) this.sortedColumn = '-' + field
			else if (this.sortedColumn === '-' + field) this.sortedColumn = '+' + field
			else this.sortedColumn = '-' + field

			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// активация партнерки
		//---------------------------------------------------------------------
		partnerActivate(row) {
			// обнуляем значения
			this.localErrorMessage = ''
			this.localSuccessMessage = ''

			// проверяем наличие данных для активации
			if (!row['account_id'] || !row['program_id'])
			{
				this.localErrorMessage = 'error/required_field'
				return
			}

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/partner/create'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// готовим данные POST
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'account_id': row['account_id'],
							'program_id': row['program_id']
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' &&
									_dt['partner'] && _dt['partner']['p2a_id'])
								{
									// эмуляция пуша для рефреша
									EventBus.$emit('w5-push', 'update partner ' + _dt['partner']['p2a_id'])
									// покадем сообщение об успехе
									this.setLocalSuccessMessage('bonus/converted')
									// на это все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// клик по кнопке из колонки операций
		//---------------------------------------------------------------------
		actionOperButton(data) {
			// если идет загрузка таблицы списка - ничего не делаем
			if (this.$store.state.isListTableLoading) return

			// ошибка
			let _error = []

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим данные
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// должна быть задана строка текущей таблицы
			if (!data['row']) _error.push('"row" not found')

			// должно быть задано наименование операции
			let _actionName = data['action']
			if (!_actionName) _error.push('"name of action" not found')

			// должно быть задано действие операции в формате: <action>:<params>:[additional params]
			let _action = data && data['data'] && data['data']['action'] && data['data']['action'].indexOf(':') >= 0 ? data['data']['action'] : false
			if (!_action) _error.push('"action" not found')

			let _actionParts = _action.split(':')
			if (_actionParts.length < 2) _error.push('"action" is not correct')

			if (_error.length)
			{
				if (this.$store.state.isDebug) window.DEBUG.error(_error.join(', '))
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть ID - запишем его как последную запись, с которой работал пользователь
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _ID = data['row'][this.listConfig['column_id']]
			if (this.crud && _ID) this.$store.commit('setLastRow', { 'crud': this.crud, 'id': _ID })
			// записываем позицию окна в Vuex
			let _pathRoute = this.crud + this.page
			this.$store.commit('setLastWindowY', {
				'url': _pathRoute,
				'y': this.curWindowY
			})

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если просто требуется переход по URL
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (_actionParts[0].toLowerCase() === 'url' && _actionParts[1])
			{
				// если нет первого слеша - добавим
				if (_actionParts[1].charAt(0) !== '/') _actionParts[1] = '/' + _actionParts[1]
				// почти для всех добавляем ID текущей записи
				if (_ID && (_actionParts[1] !== '/options' && _actionParts[1] !== '/ipptrpool/list' && _actionParts[1] !== '/iphistory/list')) _actionParts[1] += '/' + _ID
				// для ipptrpool добавляем ID текущей записи как GET-параметр
				if (_actionParts[1] === '/ipptrpool/list') _actionParts[1] += '?id=' + _ID
				// для iphistory добавляем ID текущей записи как GET-параметр
				if (_actionParts[1] === '/iphistory/list') _actionParts[1] += '?id=' + _ID
				// сам переход
				this.$router.push(_actionParts[1])
				// все
				return
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если требуется переход к списку с определенным фильтром
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (_actionParts[0].toLowerCase() === 'filter' && _actionParts[1])
			{
				// создаем URL для перехода к списку
				let _url = _actionParts[1]
				// если нет первого слеша - добавим
				if (_actionParts[1].charAt(0) !== '/') _url = '/' + _url + '/list'
				// запомним значение фильтра в Vuex
				let _fld = this.listConfig['column_id']
				if (this.crud === 'servergroup') _fld = 'server_group_id'
				if (this.crud === 'plangroup') _fld = 'plan_group_id'
				if (this.crud === 'templategroup') _fld = 'template_group_id'
				let _obj = {
					'field': _fld,
					'value': _ID
				}
				this.$store.commit('setModelFilter', _obj)
				// делаем переход
				this.$router.push(_url)
				// все
				return
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это удаление
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (_actionName === 'delete')
			{
				// для проверки допустимости удаления - получим ID Записи
				let _id = data['row'][this.listConfig['column_id']]
				// если процесс удаления данной записи уже запущен - ничего не делаем
				if (this.deleteRecordIdInProcess && Array.isArray(this.deleteRecordIdInProcess) && this.deleteRecordIdInProcess.indexOf(_id) > -1) return

				// заголовок диалога
				this.deleteModalTitle = 'main/deleting'
				if (data['data']['dialog'] && data['data']['dialog']['header']) this.deleteModalTitle = data['data']['dialog']['header']

				// вопрос диалога
				this.deleteModalText = 'main/delete_msg'
				if (data['data']['dialog'] && data['data']['dialog']['body']) this.deleteModalText = data['data']['dialog']['body']
				// преобразование
				this.deleteModalText = this.localeFtc(this.deleteModalText)
				// замена
				if (data['data']['dialog'] && data['data']['dialog']['name']) this.deleteModalText = this.deleteModalText.replace('{name}', data['row'][data['data']['dialog']['name']])
				else if (data['data']['dialog'] && data['data']['dialog']['note']) this.deleteModalText = this.deleteModalText.replace('{note}', data['row'][data['data']['dialog']['note']])
				// добавление предупреждения
				if (this.crud === 'iso')
				{
					if (data['row'] &&
						data['row']['service_data'] &&
						data['row']['service_data']['iso'] &&
						data['row']['service_data']['iso']['attached'] === true)
						this.deleteModalText += '<br><br>' + this.localeFtc('service/iso_operation_warning')
				} else if (this.crud === 'disks')
				{
					if (data['row'] &&
						data['row']['service_data'] &&
						data['row']['service_data']['extdisk'] &&
						data['row']['service_data']['extdisk']['attached'] === true)
						this.deleteModalText += '<br><br>' + this.localeFtc('service/iso_operation_warning')
				}

				// таймер
				this.deleteModalTimer = false
				if (data['data']['dialog'] && data['data']['dialog']['timer'])
				{
					this.deleteModalTimer = parseInt(data['data']['dialog']['timer'])
					if (isNaN(this.deleteModalTimer) || !this.deleteModalTimer) this.deleteModalTimer = 5
				}

				// определяем колбак для подтверждающей кнопки диалога
				if (_actionParts[0].toLowerCase() === 'func' && _actionParts[1])
				{
					if (_actionParts[1] in this) this.deleteModalCallback = this[_actionParts[1]](data['row'])
				}

				// частный случай - удаление VDS
				this.reserveIpLocalData = null
				this.reserveIpProcessing = false
				this.reserveIpCost = ''
				this.reserveIpVdsId = null

				//  если мы в списке VDS, и статус текущей записи = 'active' и есть доступ к редактированию
				if (this.crud === 'vds' &&
					data['row']['service_status'] === 'active' &&
					!data['row']['service_status_text'] &&
					this.isAccess('service/update'))
				{
					// начали запрос
					this.reserveIpLocalData = 1
					this.reserveIpVdsId = _id

					// делаем запрос формы
					this.$http.get(this.APIServerUrl + '/service/update/' + _id)
					.then(
						// рассматриваем только положительный ответ
						res => {
							// получаем ответ
							let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
							if (_dt && _dt['status'] === 'form' && _dt['fields'] &&
								_dt['fields']['reserve_ip'])
							{
								// данные
								this.reserveIpLocalData = _dt['fields']['reserve_ip']
								// текущее значение
								this.reserveIpValue = 'value' in this.reserveIpLocalData
									? this.reserveIpLocalData.value
									: false

								if ('cost' in this.reserveIpLocalData && this.reserveIpLocalData['cost'] > 0)
								{
									this.reserveIpCost = this.localeFtc('{cost} <b>main/ruble</b> / <b>{period}</b> / <b>1 {for}</b>')
										.replace('{cost}', this.reserveIpLocalData['cost'])
										.replace('{period}', this.localeFtc(this.reserveIpLocalData['period']))
										.replace('{for}', this.localeFtc(this.reserveIpLocalData['for']))
								}
							}
						}
					).catch(() => {
						// ничего не нужно
						this.reserveIpLocalData = null
						this.reserveIpProcessing = false
						this.reserveIpCost = ''
						this.reserveIpVdsId = null
					})
				}

				// показываем диалог
				EventBus.$emit('w5-body-scroll-disable')
				this.showDeleteModal = true

				// если задан таймер - запускаем его
				if (this.deleteModalTimer && this.deleteModalTimer > 0)
				{
					this.deleteModalTimerHandle = setInterval(() => {
						this.deleteModalTimer--
						if (this.deleteModalTimer <= 0)
						{
							clearInterval(this.deleteModalTimerHandle)
							this.deleteModalTimerHandle = false
						}
					}, 1000)
				}

				// все
				return
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это отдельный фильтр в List или глобальный фильтр по аккаунту
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (_actionName === 'log' || _actionName === 'logOver' || _actionName === 'note' ||
					_actionName === 'request' || _actionName === 'serviceRequest' || _actionName === 'operation' || _actionName === 'user' ||
					_actionName === 'partnerAction' || _actionName === 'partner' ||
					_actionName === 'filter' ||
					_actionName === 'vdsReboot' || _actionName === 'vdsPlan' || _actionName === 'vdsReinstall' || _actionName === 'vdsChangePassword' ||
					_actionName === 'prolong' ||
					_actionName === 'account' ||
					_actionName === 'paymentLink' ||
					_actionName === 'domainReboot' ||
					_actionName === 'restoreBackup' || _actionName === 'renameBackup' || _actionName === 'createFromBackup' || _actionName === 'createFromBackupOuterDisk' ||
					_actionName === 'pdfLink' || _actionName === 'xmlLink' || _actionName === 'operLink' || _actionName === 'mailDocument' || _actionName === 'clientTicket' ||
					_actionName === 'removeFilter' ||
					_actionName === 'copyToDc' || _actionName === 'createDevice' || _actionName === 'deviceLinks' || _actionName === 'rackGraphic' ||
					_actionName === 'downloadBackup' ||
					_actionName === 'connectOuterDisk' || _actionName === 'ejectOuterDisk' ||
					_actionName === 'cloneOuterDisk' || _actionName === 'backupOuterDisk' || _actionName === 'restoreBackupOuterDisk' ||
					_actionName === 'scheduleOuterDisk' || _actionName === 'scheduleOuterDiskUpdate' ||
					_actionName === 'connectISOOper' || _actionName === 'ejectISOOper' ||
					_actionName === 'accountReport' ||
					_actionName === 'ipReserve')
			{
				// вызываем функцию из конфига
				if (_actionParts[0].toLowerCase() === 'func' && _actionParts[1])
				{
					if (_actionName === 'accountReport' && data.data && data.data.w)
					{
						data['row']['w'] = data.data.w
						this.accountReport(data['row'])
					}
					else if (_actionParts[1] in this) this[_actionParts[1]](data['row'], _actionParts[2], _actionParts[3], _actionParts[4])
				}
			}
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это создание заметки
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			else if (_actionName === 'createNote' || _actionName === 'ticketMerge' || _actionName === 'bonusActivate' || _actionName === 'vdsClone')
			{
				// вызываем функцию из конфига
				if (_actionParts[0].toLowerCase() === 'func' && _actionParts[1])
				{
					if (_actionParts[1] in this) this[_actionParts[1]](data['row'])
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог подтверждения действия
		//---------------------------------------------------------------------
		hideConfirmModalDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showConfirmModalDialog = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// модальный диалог показа документа
		//---------------------------------------------------------------------
		// показывает диалог
		openDocumentModalDialog(linkHtml, linkPdf, linkXml) {
			// проверка данных - ссылка на документ
			if (!linkHtml) return
			// элемент iframe
			let _frm = document ? document.getElementById('documentFrame') : null
			if (!_frm) return
			// обязательно чистим iframe
			_frm.srcdoc = '<html><body></body></html>'
			// и установим размер
			this.windowResize()
			// запоминаем ссылки на PDF и на XML
			this.documentModalDialogLinkPdf = linkPdf
			this.documentModalDialogLinkXml = linkXml
			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDocumentModalDialog = true
			// начинаем грузить документ
			this.$http.get(linkHtml)
			.then(resGet => {
				let _dt = resGet && resGet.data ? resGet.data : false
				if (!_dt || !_frm) throw new Error()
				_frm.srcdoc = _dt
			})
			.catch(() => {
				_frm.srcdoc = '<html><body>Не удалось получить документ...</body></html>'
			})
		},
		// закрывает диалог
		hideDocumentModalDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showDocumentModalDialog = false
			this.documentModalDialogLinkPdf = null
			this.documentModalDialogLinkXml = null
			this.hideModalMask()
			// обязательно чистим iframe
			let _frm = document ? document.getElementById('documentFrame') : null
			if (!_frm) return
			_frm.srcdoc = '<html><body></body></html>'
		},
		// вывод на печать содержимого iframe
		documentPrint() {
			if (window && window.print)
			{
				let frm = document.getElementById('documentFrame').contentWindow
				frm.focus()
				frm.print()
			}
		},
		//---------------------------------------------------------------------
		// переключатель резервирования IP при удалении VDS
		//---------------------------------------------------------------------
		reserveIpStart() {
			// если еще активен таймер удаления
			if (this.deleteModalTimer && this.deleteModalTimer > 0) return
			// если нет ID текущего VDS
			if (!this.reserveIpVdsId) return
			// если контрол задизаблен - ничего не делаем
			if (!this.isAccess('service/update')) return
			// если мы в процессе изменения - ничего не делаем
			if (this.reserveIpProcessing) return

			// ставим флаг начала процесса
			this.reserveIpProcessing = true
			// делаем запрос на изменение
			let _url = this.APIServerUrl + '/service/update/' + this.reserveIpVdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'])
					{
						// данные формы
						let _post = {
							'_csrf': _dt['_csrf']
						}
						_post[_dt['model']] = {
							'reserve_ip': this.reserveIpValue ? 0 : 1
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.reserveIpProcessing = false
								// проверка ответа
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id'])
								{
									// меняем значение
									this.reserveIpValue = !this.reserveIpValue
									// а пока просто сообщим
									this.setLocalSuccessMessage('main/updated')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.reserveIpProcessing = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// обнулим флаг процесса
					this.reserveIpProcessing = false
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// обнулим флаг процесса
					this.reserveIpProcessing = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог удаления записи
		//---------------------------------------------------------------------
		hideDeleteModal() {
			if (this.deleteModalTimerHandle)
			{
				clearInterval(this.deleteModalTimerHandle)
				this.deleteModalTimerHandle = false
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showDeleteModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// удаляет объект CRUD
		//---------------------------------------------------------------------
		deleteCrudObject(data) {
			// ссылка на контекст
			let _this = this

			// нужно вернуть обработчик
			return function(e) {
				// если еще активен таймер
				if (_this.deleteModalTimer && _this.deleteModalTimer > 0)
				{
					if (e) e.preventDefault()
					return
				}

				// обнуляем последную рабочую строку
				if (_this.crud)
				{
					_this.lastWorkedRowID = false
					_this.$store.commit('setLastRow', { 'crud': _this.crud, 'id': false })
				}

				// в любом случае - закрываем диалог
				_this.hideDeleteModal()

				// если нет ID объекта
				let _id = data[_this.listConfig['column_id']]
				if (!_id)
				{
					_this.localErrorMessage = 'main/object_id'
					return
				}

				// если по этому объекту уже запущен процесс удаления - ничего не делаем
				if (_this.deleteRecordIdInProcess && Array.isArray(_this.deleteRecordIdInProcess) && _this.deleteRecordIdInProcess.indexOf(_id) > -1) return
				// ставим метку процесса удаления
				_this.deleteRecordIdInProcess.push(_id)

				// делаем запрос на удаление - формируем URL
				let _url = _this.APIServerUrl + '/' + _this.getRealCrud(_this.crud) + '/delete/' + _id
				// первый запрос - GET
				_this.$http.get(_url).then(
					// успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						// должен быть CSRF-код
						if (_dt && _dt['_csrf'])
						{
							// второй запрос - POST
							// готовим данные
							let _post = {
								'_csrf': _dt['_csrf']
							}
							// производим сам запрос
							_this.$http.post(_url, Helper.toFormData(_post)).then(
								// успешный ответ сервера
								resPost => {
									// ответ
									_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
									// обнуляем метку процесса удаления через некоторое время
									setTimeout(() => {
										if (_this && _this.deleteRecordIdInProcess && Array.isArray(_this.deleteRecordIdInProcess))
										{
											let _pos = _this.deleteRecordIdInProcess.indexOf(_id)
											if (_pos > -1) _this.deleteRecordIdInProcess.splice(_pos, 1)
										}
									}, 500)

									// если ошибки нет
									if (_dt && _dt['status'] === 'ok')
									{
										// просто запрашиваем данные заново
										_this.requestListData()
										// на этом все
										return
									}

									// иная ошибка
									_this.localErrorMessage = _this.formatRequestError(resPost)
								},
								// отрицательный ответ сервера
								resPost => {
									// обнуляем метку процесса удаления
									_this.deleteRecordIdInProcess = false
									// ошибка
									_this.localErrorMessage = _this.formatRequestError(resPost)
								}
							)
							// на этом все
							return
						}

						// обнуляем метку процесса удаления
						_this.deleteRecordIdInProcess = false
						// ошибка получения CSRF-кода
						_this.localErrorMessage = _this.formatRequestError(resGet)
					},
					// отрицательный ответ сервера
					resGet => {
						// обнуляем метку процесса удаления
						_this.deleteRecordIdInProcess = false
						// ошибка
						_this.localErrorMessage = _this.formatRequestError(resGet)
					}
				)
			}
		},
		//---------------------------------------------------------------------
		// делает редирект на управление VDS
		//---------------------------------------------------------------------
		GoToVds(data, what) {
			// если нет ID объекта
			let _idFld = this.listConfig['column_id']
			let _id = data[_idFld]
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// статус
			if (data['service_status_text'] || data['service_status'] !== 'active')
			{
				this.localErrorMessage = 'operation/not_found'
				return
			}

			// записываем команду в состояние Vuex
			this.$store.commit('setVdsCommand', {
				'id': _id,
				'command': what
			})

			// делаем редирект на VDS
			this.$router.push('/vds/view/' + _id)
		},
		//---------------------------------------------------------------------
		// делает редирект с фильтром в историю заявок
		//---------------------------------------------------------------------
		clientToOperationHistory() {
			// это только для клиентов
			if (this.$store.state.user_type !== 'client') return

			// если нет клиентов
			if (!this.clientPartnerData || !('total' in this.clientPartnerData) || this.clientPartnerData.total === 0)
				return

			// готовим объект фильтра
			let _obj = {
				'crud': 'operationClientPurse',
				'object': 'partner'
			}

			// записываем фильтр в состояние Vuex
			this.$store.commit('setCrudFilter', _obj)

			// делаем редирект
			this.$router.push('/operation/list')
		},
		//---------------------------------------------------------------------
		// делает редирект с фильтром
		//---------------------------------------------------------------------
		GoTo(data, where, object, field) {
			// получим поле для хранения ID объекта
			let _idFld = this.listConfig['column_id']

			// частные случаи
			if (this.crud === 'user' && where === 'operation' && field === 'account_id')
			{
				// если установлен глобальный фильтр по аккаунту:
				// просто сразу редирект на список операций
				if (this.accountGlobalFilter) return this.$router.push('/operation/list')
				// иначе - фильтрация по аккаунту
				_idFld = 'account_id'
			}
			if (this.crud === 'request' && where === 'request' && field === 'service_id') _idFld = 'service_id'
			if (this.crud === 'partner' && where === 'partneractions' && field === 'program_id') _idFld = 'program_id'
			if (this.crud === 'partnerprogram' && where === 'partner' && field === 'program_id') _idFld = 'program_id'
			if (this.crud === 'rackdevice' && where === 'rackdevice' && field === 'rack_id') _idFld = 'rack_id'

			// получим ID объекта
			let _id = data[_idFld]

			// фильтр в тикетах
			if (this.crud === 'ticket' && where === 'ticket' && field === 'has_user_id')
				_id = data['id']

			// если так и не получили ID записи
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// если это резервирование IP
			if (this.crud === 'ippool')
			{
				if (data && data.ip_id && data.ip_address && where === 'service-create-18')
				{
					if (data.can_reserve !== true) return
					this.$store.commit('temporaryData', data)
					this.$router.push('/service/create/18')
					return
				}
			}

			let _obj = {
				'crud': where,
				'object': object && object !== '' ? object + '/' + _id : _id,
				'field': field
			}

			this.$store.commit('setCrudFilter', _obj)

			// если это фильрт по услугам в заявках - рефрешим
			if ((this.crud === 'request' && where === 'request') ||
				(this.crud === 'ticket' && where === 'ticket') ||
				(this.crud === 'rackdevice' && where === 'rackdevice'))
			{
				// имитация перехода на компонент
				// инициируем основные данные, в частности и this.crud
				this.initData(this.$route.path)

				// обнулим закешированные данные
				this.listData = false

				// обнулим записи таблицы для рендера
				this.renderRows = false
				this.initRows = false

				// обнулим быстрый поиск
				this.setFastSearchValue('')

				// обнулим колонку сортировки
				this.sortedColumn = false

				// инициализация фильтров по конфигурации
				this.initFilters()

				// получим данные из localStorage
				this.getLocalStorage()

				// получим данные из глобального состояния
				this.getDataFromVuex()

				// обнулим выделенную строку
				this.lastWorkedRowID = false

				// теперь можно запросить данные
				this.requestListData()
			}
			else
			{
				// в иных случаях - просто делаем редирект
				this.$router.push('/' + where + '/list')
			}
		},
		//---------------------------------------------------------------------
		// делает перезагрузку домена
		//---------------------------------------------------------------------
		RebootDomain(data) {
			// проверка входных параметров
			if (!data) return

			// получим ID Записи
			let _id = data[this.listConfig['column_id']]
			if (!_id) return

			// если для этой записи уже запущен процесс перезагрузки
			if (this.domainRebootProcessing === _id) return

			// проверка возможности перегрузить домен
			if (data['service_status'] !== 'active' || data['service_status_text'] || data['can_reboot'] !== true) return

			// заголовок диалога
			this.confirmModalDialogTitle = 'service/reboot'

			// вопрос диалога
			this.confirmModalDialogText = this.localeFtc('service/reboot_domain')
			// замена
			if (data['service_name']) this.confirmModalDialogText = this.confirmModalDialogText.replace('{domain}', data['service_name'])

			// определяем колбак для подтверждающей кнопки диалога
			this.confirmModalDialogCallback = () => this.rebootDomainStart(_id)

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showConfirmModalDialog = true
		},
		//---------------------------------------------------------------------
		// перезагрузка домена
		//---------------------------------------------------------------------
		rebootDomainStart(ID) {
			// получим ID услуги
			let _serviceID = parseInt(ID)
			if (isNaN(_serviceID) || _serviceID <= 0) return

			// если для этой записи уже запущен процесс перезагрузки
			if (this.domainRebootProcessing === _serviceID) return

			// закроем диалог
			this.localErrorMessage = ''
			this.hideConfirmModalDialog()

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + _serviceID + '?additional=setReboot'

			// включаем флаг начала процесса
			this.domainRebootProcessing = _serviceID

			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.domainRebootProcessing = false
								// получим ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// на это все, никаких рефрешей не нужно,
									// ибо придет пуш, и по нему система сама все обновит
									// а пока просто сообщим
									this.setLocalSuccessMessage('service/reboot_queued')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								this.domainRebootProcessing = false
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.domainRebootProcessing = false
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					this.domainRebootProcessing = false
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// пролонгация услуги
		//---------------------------------------------------------------------
		prolongService(row) {
			// проверка параметра
			if (!row || !row['service_id']) return
			// получим ID услуги
			let _serviceID = parseInt(row['service_id'])
			if (isNaN(_serviceID) || _serviceID <= 0) return
			// если мы в процессе изменения - ничего не делаем
			if (this.canProlongProcessing) return

			// ставим флаг начала процесса
			this.canProlongProcessing = true

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + _serviceID + '?additional=setProlong'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг
								this.canProlongProcessing = false
								// проверяем ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// на этом все
									return
								}

								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// обнулим флаг
								this.canProlongProcessing = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// обнулим флаг
					this.canProlongProcessing = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// обнулим флаг
					this.canProlongProcessing = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// очистка отдельного фильтра
		//---------------------------------------------------------------------
		clearCrudFilter() {
			// чистим везде, где этот фильтр есть
			this.$set(this, 'crudFilter', false)
			this.$store.commit('setCrudFilter', false)
			// запросим снова данные при тех же условиях
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// очистка HTTP-GET фильтра
		//---------------------------------------------------------------------
		clearHttpCrudFilter() {
			// чистим везде, где этот фильтр есть
			this.$set(this, 'crudHttpGetFilter', false)
			// запросим снова данные при тех же условиях
			this.setLocalStorage()
			this.requestListData()
		},
		//---------------------------------------------------------------------
		// получаем данные из Vuex
		//---------------------------------------------------------------------
		getDataFromVuex() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// 1. значение отдельного фильтра для логов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.$store.state.crudFilter)
			{
				// частный случай
				if (this.$store.state.crudFilter['crud'] === 'operationClientPurse')
				{
					// получаем значение для фильтра
					let _filterValue = this.$store.state.crudFilter['object']
					// чистим везде, где этот фильтр есть
					this.$set(this, 'crudFilter', false)
					this.$store.commit('setCrudFilter', false)
					// устанавливаем локальный фильтр если он задан
					if (this.filters && this.filters.radio && Array.isArray(this.filters.radio) && this.filters.radio.length)
					{
						// ищем нужный фильтр
						this.filters.radio.some((item, index, arr) => {
							// если нашли - включаем его
							if (item['field'] === 'operation_purse')
							{
								item['value'] = _filterValue
								item['visible'] = true
								return true
							}
						})
					}
				}
				// общий случай
				else
				{
					// если есть глобальный фильтр и локальный тоже по аккаунту
					if (this.$store.state.accountGlobalFilter === true && this.$store.state.crudFilter.field === 'account_id')
					{
						// ничего не нужно делать
					}
					// запоминаем локально
					else
					{
						this.crudFilter = this.$store.state.crudFilter
						this.setLocalStorage()
					}

					// всегда обнуляем в Vuex данные о локальном фильтре
					this.$store.commit('setCrudFilter', false)
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// 2. значение строки списка, с которой ушли из списка
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.lastWorkedRowID = false
			if (this.crud in this.$store.state.lastWorkedRowID && this.$store.state.lastWorkedRowID[this.crud])
			{
				// запоминаем локально
				this.lastWorkedRowID = this.$store.state.lastWorkedRowID[this.crud]
				// обнуляем в глобальном состоянии
				this.$store.commit('setLastRow', { 'crud': this.crud, 'id': false })
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// получаем данные строки URL (http-GET параметр)
		//---------------------------------------------------------------------
		getDataFromUrl() {
			// прописываем только частные случаи
			if ((this.$route.path === '/text/list' || this.$route.path === '/text/list/') &&
				this.$route.fullPath.indexOf('TextSearch') > -1)
			{
				// вычисление входящего GET-параметра
				let _match = /TextSearch%5Bid%5D=(\w+)$/i.exec(this.$route.fullPath)
				if (!_match || !_match[1]) return
				// проверка
				let _id = parseInt(_match[1])
				if (!_id || isNaN(_id)) return
				// все ок - редиректим, готовим объект фильтра
				let _obj = {
					'crud': 'text',
					'object': _id
				}

				this.crudFilter = _obj
			}

			// если есть данные по HTTP-фильтру, которые мы получили из URL
			if (this.httpGetFilter)
			{
				// сохраним
				this.crudHttpGetFilter = {}
				// установим CRUD
				this.crudHttpGetFilter['__crud'] = this.crud
				// скопируем только те поля, которых нет в фильтре
				for (let _prop in this.httpGetFilter) if (this.httpGetFilter.hasOwnProperty(_prop))
				{
					// ищем поле в конфигурации
					let _found = false
					if (this.listConfig && this.listConfig.filters)
					{
						// 1. по периоду - начало
						if (this.listConfig.filters.period &&
							this.listConfig.filters.period.begin_field &&
							this.listConfig.filters.period.begin_field === _prop)
						{
							_found = true
							this.filters.period.visible = true
							this.filters.period.valueBegin = this.httpGetFilter[_prop]
						}
						// 2. по периоду - конец
						if (this.listConfig.filters.period &&
							this.listConfig.filters.period.end_field &&
							this.listConfig.filters.period.end_field === _prop)
						{
							_found = true
							this.filters.period.visible = true
							this.filters.period.valueEnd = this.httpGetFilter[_prop]
						}
						// 3. по select
						if (this.listConfig.filters.select &&
							_prop in this.listConfig.filters.select &&
							this.listConfig.filters.select[_prop])
						{
							_found = true
							for (let _fIdx in this.filters.select)
							{
								if (this.filters.select[_fIdx]['field'] === _prop)
								{
									this.filters.select[_fIdx]['visible'] = true
									this.filters.select[_fIdx]['value'] = {
										id: this.httpGetFilter[_prop]
									}
									break
								}
							}
						}
						// 3. по radio
						if (this.listConfig.filters.radio &&
							_prop in this.listConfig.filters.radio &&
							this.listConfig.filters.radio[_prop])
						{
							_found = true
							for (let _fIdx in this.filters.radio)
							{
								if (this.filters.radio[_fIdx]['field'] === _prop)
								{
									this.filters.radio[_fIdx]['visible'] = true
									this.filters.radio[_fIdx]['value'] = this.httpGetFilter[_prop]
									break
								}
							}
						}
						// 4. по bool
						if (this.listConfig.filters.bool &&
							this.listConfig.filters.bool.field === _prop)
						{
							_found = true
							this.filters.bool.value = Helper.normalizeBooleanValue(this.httpGetFilter[_prop])
						}
					}

					if (!_found) this.crudHttpGetFilter[_prop] = this.httpGetFilter[_prop]
				}
				// если в итоге не осталось полей - обнуляем фильтр
				if (Object.keys(this.crudHttpGetFilter).length <= 1) this.crudHttpGetFilter = false
				// вспомогательную переменную обнулим
				this.httpGetFilter = false

				// в итоге - если получился фильтр по HTTP, нужно его записать
				if (this.crudHttpGetFilter)
					this.setLocalStorage()
			}
		},
		//---------------------------------------------------------------------
		// получаем данные для фильтра из строки URL (http-GET параметр)
		//---------------------------------------------------------------------
		getFilterFromUrl() {
			// фильтра по умолчанию нет
			this.httpGetFilter = false

			// прописываем только частные случаи
			if (this.$route.fullPath.indexOf('?') > -1 && this.$route.fullPath.indexOf('Search') > -1 &&
				this.$route.query && typeof this.$route.query === 'object' && Object.keys(this.$route.query).length)
			{
				// заполним фильтр
				this.httpGetFilter = {}
				for (let _prop in this.$route.query) if (this.$route.query.hasOwnProperty(_prop))
				{
					let _result = _prop.match(/Search\[(.*?)\]/i)
					if (_result && _result[1])
						this.httpGetFilter[_result[1]] = this.$route.query[_prop]
				}
			}
		},
		//---------------------------------------------------------------------
		// поля для отдельного фильтра
		//---------------------------------------------------------------------
		crudFilterField() {
			if (this.crud === 'logs') return 'log_sub'
			else if (this.crud === 'notes') return 'note_object'
			else if (this.crud === 'request' || this.crud === 'serviceRequest') return 'service_id'
			else if (this.crud === 'operation') return 'account_id'
			else if (this.crud === 'user') return 'account_id'
			else if (this.crud === 'partneractions' || this.crud === 'partnerprogram' || this.crud === 'partner') return 'program_id'
			else if (this.crud === 'text') return 'id'

			// по умолчанию - неизвестно
			return false
		},
		//---------------------------------------------------------------------
		// Редирект на форму создания заметки из меню в строке
		//---------------------------------------------------------------------
		createNoteFromMenu(row) {
			// предварительные проверки
			if (!row)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('Lcnfm0: не заданы данные строки')
				return
			}

			if (!this.listConfig['column_id'])
			{
				if (this.$store.state.isDebug) window.DEBUG.error('Lcnfm1: в конфигурации отсутствует column_id')
				return
			}

			// готовим данные
			let _obj = {}

			// ставим тип по умолчанию
			_obj['type'] = this.crud
			// тип для частных случаев
			if (this.crud === 'vds' || this.crud === 'iso' || this.crud === 'additional-services' || this.crud === 'backups' ||
				this.crud === 'certificate' || this.crud === 'dns' || this.crud === 'domains' || this.crud === 'disks')
				_obj['type'] = 'service'

			// ID объекта по умолчанию
			_obj['id'] = row[this.listConfig['column_id']]
			// ID объекта для частных случаев

			// наименование объекта
			let _nameField = this.getRealCrud(this.crud) + '_name_full'
			// если нет полного наименования объекта в данных - пробуем найти простое наименование
			if (!(_nameField in row)) _nameField = this.getRealCrud(this.crud) + '_name'
			// если нет и простого
			if (!(_nameField in row))
			{
				// частные случаи
				if ((this.crud === 'user' || this.crud === 'admin') && 'user_email' in row) _nameField = 'user_email'
				else
				{
					// не нашли - ошибка
					if (this.$store.state.isDebug)
					{
						window.DEBUG.error('Lcnfm2: отсутствует наименование объекта в данных')
						return
					}
				}
			}
			// поле есть - ставим его значение
			_obj['name'] = row[_nameField]

			// еще раз проверяем полученные данные - так как все поля обязательны
			if (!_obj['type'] || !_obj['id'] || !_obj['name'])
			{
				window.DEBUG.error('Lcnfm3: отсутствуют необходимые поля объекта в данных')
				return
			}

			// запишем объект в Vuex
			this.$store.commit('createNoteData', _obj)

			// теперь можно сделать редирект на создание заметки
			this.$router.push('/notes/create')
		},
		//---------------------------------------------------------------------
		// Редирект на форму активации бонуса для сотрудника
		//---------------------------------------------------------------------
		bonusActivateFromMenu(row) {
			// предварительные проверки
			if (!row)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('Lbafm0: не заданы данные строки')
				return
			}

			// получим ID бонуса и аккаунта (должно быть что то одно)
			let bonus = 'bonus_id' in row && row['bonus_id'] ? row['bonus_id'] : null
			let account = 'account_id' in row && 'account_name' in row ? { id: String(row['account_id']), name: row['account_name'] } : null

			// запишем данные в Vuex
			this.$store.commit('bonusActivateData', { bonus, account })

			// теперь можно сделать редирект на активацию бонуса
			this.$router.push('/bonus/activate')
		},
		//---------------------------------------------------------------------
		// объединение тикетов из пункта меню строку
		//---------------------------------------------------------------------
		ticketMergeFromMenu(row) {
			// Обнулим старый ID
			this.$set(this, 'mergeTicketsOldId', null)

			// предварительные проверки
			if (!row)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('Tmfm0: не заданы данные строки')
				return
			}

			// колонка с ID
			if (row['ticket_id'] === undefined || row['ticket_id'] === null || String(row['ticket_id']).trim() === '') return

			// если нет флага
			if (row['can_merge'] !== true) return

			// запоминаем старый ID
			this.$set(this, 'mergeTicketsOldId', row['ticket_id'])

			// ставим URL поиска тикетов
			this.$set(this.mergeTicketsField, 'url', '/ticket/update/' + row['ticket_id'] + '?search=ticket&q=')
			// и обнулим новый ID
			this.$set(this.mergeTicketsField, 'value', null)
			// обнулим ошибку
			this.$set(this.mergeTicketsField, '_errMsg', '')

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showMergeTicketsDialog = true
		},

		// начало объединения тикетов
		mergeTicketsStart() {
			// проверка параметра старый ID
			if (this.mergeTicketsOldId === undefined ||
				this.mergeTicketsOldId === null ||
				String(this.mergeTicketsOldId).trim() === '') return

			// проверка параметра новый ID
			if (this.mergeTicketsField.value === undefined ||
				this.mergeTicketsField.value === null ||
				String(this.mergeTicketsField.value).trim() === '')
			{
				this.mergeTicketsField._errMsg = 'ticket/not_found'
				return
			}

			// закроем диалог
			EventBus.$emit('w5-body-scroll-enable')
			this.showMergeTicketsDialog = false

			// формируем URL
			let _url = this.APIServerUrl + '/ticket/update/' + this.mergeTicketsOldId + '?additional=setMerge&ticket_id=' + this.mergeTicketsField.value
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// покадем сообщение об успехе
									this.setLocalSuccessMessage(this.localeFtc('ticket/ticket_merged').replace('{ticket_from}', this.this.mergeTicketsOldId))
									// просто запрашиваем данные заново
									this.requestListData()
									// на этом все
									return
								}

								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// открытие PDF-документа в новом окне
		//---------------------------------------------------------------------
		goPdfLink(row) {
			// проверка данных
			if (!row || !row.pdf) return
			let win = window.open(row.pdf, '_blank')
			win.focus()
		},
		//---------------------------------------------------------------------
		// открытие XML-документа в новом окне
		//---------------------------------------------------------------------
		goXmlLink(row) {
			// проверка данных
			if (!row || !row.xml) return
			let win = window.open(row.xml, '_blank')
			win.focus()
		},
		//---------------------------------------------------------------------
		// просмотр операции
		//---------------------------------------------------------------------
		goOperLink(row) {
			// проверка данных
			if (!row || !row.operation_id) return
			this.$router.push('/operation/view/' + row.operation_id)
		},
		//---------------------------------------------------------------------
		// отправка на мыло документа
		//---------------------------------------------------------------------
		goMailDocument(row) {
			// проверка данных
			if (!row || !row.document_id) return
			// покажем сообщение об успехе
			this.setLocalSuccessMessage('document/mail_started')
			// проверка прав
			if (!this.isAccess('document/mail')) return

			// формируем URL
			let _url = this.APIServerUrl + '/document/mail/' + row.document_id
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }

						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// эмуляция пуша для рефреша
									EventBus.$emit('w5-push', 'update document ' + row.document_id)
									// покажем сообщение об успехе
									let _msg = 'document/mailed'
									if (_dt.title) _msg = _dt.title
									this.setLocalSuccessMessage(_msg)
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// показ диалога с ссылкой для оплаты
		//---------------------------------------------------------------------
		showPaymentLink(row) {
			// проверка данных
			if (!row || !row.external_hash) return
			// формируем ссылку
			this.paymentLinkUrl = this.CpServerUrl + '/operation/select/' + row.external_hash
			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showPaymentLinkDialog = true
		},
		// закрытие диалога
		hidePaymentLinkDialog() {
			// закроем диалог
			EventBus.$emit('w5-body-scroll-enable')
			this.showPaymentLinkDialog = false
		},
		// копирование ссылки в буфер обмена
		copyPaymentLink() {
			let el = this.$refs['paymentLinkUrl']
			// Copy textarea, pre, div, etc.
			if (document.body.createTextRange)
			{
				// IE
				let textRange = document.body.createTextRange()
				textRange.moveToElementText(el)
				textRange.select()
				textRange.execCommand('Copy')
			}
			else if (window.getSelection && document.createRange)
			{
				// non-IE
				let range = document.createRange()
				range.selectNodeContents(el)
				let sel = window.getSelection()
				sel.removeAllRanges()
				sel.addRange(range)
				try {
					document.execCommand('copy')
				} catch (err) {
				}
			}
		},
		//---------------------------------------------------------------------
		// кликнули по кнопке установки глобального фильтра по аккаунту
		//---------------------------------------------------------------------
		setAccountGlobalFilter(data, column = 'account_name') {
			this.filterListByAccount(data, column)
		},
		//---------------------------------------------------------------------
		// установка глобального фильтра по аккаунту
		//---------------------------------------------------------------------
		filterListByAccount(data, column = 'account_name') {
			// если это не сотрудник
			if (this.$store.state.user_type !== 'admin') return
			// если не задан аккаунт
			let _aid = false
			// фильтр по колонке
			if (column === 'owner_account_name')
			{
				if (!('owner_account_id' in data) || !data['owner_account_id'] || !/\d+/.test(data['owner_account_id'])) return
				else _aid = data['owner_account_id']
			}
			else if (column === 'account_name')
			{
				if (!('account_id' in data) || !data['account_id'] || !/\d+/.test(data['account_id'])) return
				else _aid = data['account_id']
			}
			if (!_aid) return

			// получаем аккаунт
			let _accountID = parseInt(_aid)
			if (isNaN(_accountID) || _accountID < 1) return

			// начинаем установку фильтра - готовим параметры и URL
			let _url = this.APIServerUrl + '/admin/index'
			let _params = {
				'additional': 'addGlobalFilter',
				'type': 'account',
				'object_id': _accountID
			}

			// обнуляем последную рабочую строку
			if (this.crud)
			{
				this.lastWorkedRowID = false
				this.$store.commit('setLastRow', { 'crud': this.crud, 'id': false })
			}

			// обнуляем флаг в Vuex о наличии глобального фильтра
			this.$store.commit('accountGlobalFilter', false)

			// делаем сам запрос
			this.$http.get(_url, { 'params': _params }).then(
				// получили успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					if (_dt && _dt['status'] === 'ok')
					{
						// стафим флаг в Vuex о наличии глобального фильтра
						this.$store.commit('accountGlobalFilter', true)

						// генерируем событие установки глобального фильтра
						if (window && window.localStorage)
							window.localStorage.setItem('__event', 'agf1' + (new Date()).getTime() + '_' + _accountID)

						// запрос счетчиков
						this.$store.dispatch('getTicketCounters')
						this.$store.dispatch('getRequestCounter')

						// просто запрашиваем данные заново
						this.requestListData()

						// на этом все
						return
					}

					// иная ошибка
					this.localErrorMessage = 'error/api_incorrect'
				},
				// получили отрицательный ответ сервера
				resGet => {
					this.localErrorMessage = 'error/api_incorrect'
				}
			)
		},
		//---------------------------------------------------------------------
		// убрать глобальный фильтр по аккаунту
		//---------------------------------------------------------------------
		clearAccountGlobalFilter() {
			// если это не сотрудник
			if (this.$store.state.user_type !== 'admin') return

			// начинаем очистку фильтра - готовим URL согласно API
			let _url = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter'

			// делаем сам запрос
			this.$http.get(_url).then(
				// получили успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					if (_dt && _dt['status'] === 'ok')
					{
						// обнуляем флаг в Vuex о наличии глобального фильтра
						this.$store.commit('accountGlobalFilter', false)

						// генерируем событие снятия глобального фильтра
						if (window && window.localStorage)
							window.localStorage.setItem('__event', 'agf0' + (new Date()).getTime())

						// если это документ - чистим фильтр по плательщику
						if (this.crud === 'document' && this.filters.select && this.filters.select.length)
						{
							// ищем индекс фильтра
							let _fltrIndex = -1
							this.filters.select.some((item, idx) => {
								if (item.field === 'payer_id')
								{
									_fltrIndex = idx
									return true
								}
							})

							if (_fltrIndex > -1)
							{
								this.filters.select[_fltrIndex].value = { id: -1, name: 'main/list_all' }
								this.filters.select[_fltrIndex].visible = false
								this.setLocalStorage(true)
							}
						}

						// запрос счетчиков
						this.$store.dispatch('getTicketCounters')
						this.$store.dispatch('getRequestCounter')

						// просто запрашиваем данные заново
						this.requestListData()

						// на этом все
						return
					}

					// иная ошибка
					this.localErrorMessage = 'error/api_incorrect'
				},
				// получили отрицательный ответ сервера
				resGet => {
					this.localErrorMessage = 'error/api_incorrect'
				}
			)
		},
		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			if (!e || !e.keyCode) return
			// закрытие всех диалогов по ESC
			if (e.keyCode === 27)
			{
				this.hideDeleteModal()
				this.hideConfirmModalDialog()
				this.hideBlockModal()
				this.hideRegisterModal()
				this.hideRemoveFilterModal()
				this.hideMigrateModal()
				this.hideServiceMoveModal()
				this.hideServiceBulkDelModal()
				this.hideTicketMoveModal()
				this.hideTicketBlockModal()
				this.hideISOModal()
				this.hideViewModal()
				this.hidePaymentModal()
				this.hideCalcModal()
				this.hideRackGraphicModal()
				this.hideBalancePopup()
				this.hideTicketLabelBlock()
				this.showMarkTicketsAsReadedDialog = false
				this.showMergeTicketsDialog = false
				this.hidePaymentLinkDialog()
				this.hideDocumentModalDialog()
				this.hideBackupDialog()
				this.hideConnectOuterDiskDialog()
				this.hideCopyToDcModal()
				this.hideVdsCloneModal()
				this.hideVdsCloneProcessInfoModal()
				this.hideDownloadBackupModal()
				this.hideRenameBackupDialog()
				this.hideRestoreBackupOuterDiskDialog()
				this.hideBackupScheduleModal()
			}
		},
		//---------------------------------------------------------------------
		// обработка клика
		//---------------------------------------------------------------------
		clickHandler(e) {
			// блок для выбора метки тикета
			if (this.showChoiceTicketLabelBlock)
			{
				let _el = this.$refs['ticketChoiceLabelBlock']
				if (_el !== e.target && !_el.contains(e.target)) this.hideTicketLabelBlock()
			}
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог блокировки/разблокировки записи
		//---------------------------------------------------------------------
		hideBlockModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showBlockModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог регистрации/нерегистрации серверов
		//---------------------------------------------------------------------
		hideRegisterModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showRegisterModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог отключения фильтров VDS
		//---------------------------------------------------------------------
		hideRemoveFilterModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showRemoveFilterModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог копирования бэкапа в другой ДЦ
		//---------------------------------------------------------------------
		hideCopyToDcModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showCopyToDcModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог клонирования VDS через копирования бэкапа в другой ДЦ
		//---------------------------------------------------------------------
		hideVdsCloneModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showVdsCloneModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог с информацией о клонировании VDS
		//---------------------------------------------------------------------
		hideVdsCloneProcessInfoModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.vdsCloneShowProcessDataValue = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог создания ссылки на скачивание бэкапа
		//---------------------------------------------------------------------
		hideDownloadBackupModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showDownloadBackupModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог миграции VDS
		//---------------------------------------------------------------------
		hideMigrateModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showMigrateModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог переноса услуги
		//---------------------------------------------------------------------
		hideServiceMoveModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showServiceMoveModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог массового удаления услуг
		//---------------------------------------------------------------------
		hideServiceBulkDelModal() {
			// если активен таймер блокировки тикетов
			if (this.serviceBulkDelModalButtonHandler)
			{
				clearInterval(this.serviceBulkDelModalButtonHandler)
				this.serviceBulkDelModalButtonHandler = null
				this.serviceBulkDelModalButtonTitle = this.localeFtc('main/delete') + ' - 10'
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showServiceBulkDelModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог перемещения тикетов
		//---------------------------------------------------------------------
		hideTicketMoveModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showTicketMoveModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// функция закрывает модальный диалог перемещения тикетов
		//---------------------------------------------------------------------
		hideTicketBlockModal() {
			// если активен таймер блокировки тикетов
			if (this.ticketBlockModalTimerHandle)
			{
				clearInterval(this.ticketBlockModalTimerHandle)
				this.ticketBlockModalTimerHandle = null
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showTicketBlockModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			// если нет частей
			if (!_parts || !_parts.length) return
			// если это тикеты - у них больше 3 частей
			if (msg.indexOf(' ticket ') > 0)
			{
				if (_parts.length < 3) return
			}
			// для всех остальных должно быть ровно 3 части
			else if (_parts.length < 3) return

			// если сообщение касается только просмотра
			if (_parts[0] === 'view') return

			// сообщение нужно обработать только если совпадает CRUD
			if (_parts[1] !== this.getRealCrud(this.crud)) return

			// получим ID
			let _id = _parts[2]
			// если не задан ID - ничего не делаем
			if (!_id) return

			// если это волшебная команда
			if (_id === 'refresh')
			{
				// это обновление всего списка
				if (this.silenceRequestTimer)
				{
					// запрос на тихий рефреш уже есть в очереди - обнулим его
					clearTimeout(this.silenceRequestTimer)
					this.silenceRequestTimer = null
				}
				// теперь запроса точно нет - создаем очередь
				this.silenceRequestTimer = setTimeout(() => {
					// обнулим таймер
					this.silenceRequestTimer = null
					// делаем тихий рефреш
					this.requestListData(true)
				}, 500)
				// на этом все
				return
			}

			// частные команды
			if (msg === 'reload operation list')
			{
				// требуется просто рефреш списка
				// имитация перехода на компонент
				// инициируем основные данные, в частности и this.crud
				this.initData(this.$route.path)

				// обнулим закешированные данные
				this.listData = false

				// обнулим записи таблицы для рендера
				this.renderRows = false
				this.initRows = false

				// обнулим быстрый поиск
				this.fastSearchValue = null
				//this.setFastSearchValue('')

				// обнулим колонку сортировки
				this.sortedColumn = false

				// инициализация фильтров по конфигурации
				this.initFilters()

				// получим данные из localStorage
				this.getLocalStorage()

				// получим данные из глобального состояния
				this.getDataFromVuex()

				// обнулим выделенную строку
				this.lastWorkedRowID = false

				// теперь можно запросить данные без очереди, ибо такие команды лоакльны
				this.requestListData()
				return
			}

			// ищем запись с таким ID в строкe для рендеринга
			this.pushFindRecord(_id)
		},
		// 1) ожидание окончания процесса "moveRows"
		// 2) поиск строки в renderRows
		pushFindRecord(ID) {
			// если все записи перелиты в renderRows - можно искать строку
			if (!this.initRows || !this.initRows.length)
			{
				// флаг
				let _found
				// к этому моменту уже может быть не задан массив строк таблицы - не с чем сверять данные
				if (!this.renderRows || !Array.isArray(this.renderRows) || !this.renderRows.length)
				{
					_found = false
				}
				else
				{
					/*
					// перебераем все строки
					_found = this.renderRows.some((item, idx, arr) => {
						if (String(item[this.listConfig['column_id']]) === String(ID))
						{
							// строка найдена - готовим данные для запроса
							let _url = this.APIServerUrl + '/' + this.getRealCrud(this.crud) + '/list'
							let _reqData = {}
							_reqData[this.model] = {}
							_reqData[this.model][this.listConfig['column_id']] = ID

							// для тикетов нужно запрашивать все записи,
							// так как показывается по умолчанию только активные тикеты
							if (this.crud === 'ticket')
								_reqData[this.model]['show_closed'] = true

							// делаем запрос новых данных точно в таком же формате
							this.$http.get(_url, _reqData ? { 'params': _reqData } : null).then(
								// нас интересует только положительный ответ
								response => {
									let _dt = response && response.data && typeof response.data === 'object' ? response.data : false
									if (!_dt || _dt['status'] !== 'ok' || !_dt['rows'] || !_dt['rows'][0])
									{
										// запись не найдена - придется рефрешить всю таблицу, см (*)
										if (this.silenceRequestTimer)
										{
											// запрос на тихий рефреш уже есть в очереди - обнулим его
											clearTimeout(this.silenceRequestTimer)
											this.silenceRequestTimer = null
										}

										// теперь запроса точно нет - создаем очередь
										this.silenceRequestTimer = setTimeout(() => {
											// обнулим таймер
											this.silenceRequestTimer = null
											// делаем тихий рефреш
											this.requestListData(true)
										}, 1000)

										// на этом все
										return
									}

									// запись нашли - обновим запись в renderRows
									this.$set(arr, idx, this.FromViewToList(_dt['rows'][0], item))
									// обработка выделенной строки
									if (item['w5-row-selected'] === true)
										this.$nextTick(() => this.buttonsForSelectedRow())
									// сообщим всем об обновлении записи
									EventBus.$emit('w5-update-row', {
										'column_id': this.listConfig['column_id'],
										'row': arr[idx]
									})
								}
							)
							// заканчиваем перебор
							return true
						}
					})
					*/

					// сначала ищем эту записиь что бы понять - можно ли нам обновить только одну эту запись
					_found = this.renderRows.some((item, idx, arr) => {
						if (String(item[this.listConfig['column_id']]) === String(ID))
						{
							return true
						}
					})

					// если запись найдена - делаем запрос СПИСКА но с фильтром по ЭТОЙ записи
					if (_found)
					{
						// строка найдена - готовим данные для запроса
						let _url = this.APIServerUrl + '/' + this.getRealCrud(this.crud) + '/list'
						let _reqData = {}
						_reqData[this.model] = {}
						_reqData[this.model][this.listConfig['column_id']] = ID

						// для тикетов нужно запрашивать все записи,
						// так как показывается по умолчанию только активные тикеты
						if (this.crud === 'ticket')
						{
							_reqData[this.model]['show_closed'] = true
						}

						// делаем запрос новых данных точно в таком же формате
						this.$http.get(_url, _reqData ? { 'params': _reqData } : null).then(
							// нас интересует только положительный ответ
							response => {
								let _dt = response && response.data && typeof response.data === 'object' ? response.data : false
								if (!_dt || _dt['status'] !== 'ok' || !_dt['rows'] || !_dt['rows'][0])
								{
									// запись не найдена - придется рефрешить всю таблицу, см (*)
									if (this.silenceRequestTimer)
									{
										// запрос на тихий рефреш уже есть в очереди - обнулим его
										clearTimeout(this.silenceRequestTimer)
										this.silenceRequestTimer = null
									}

									// теперь запроса точно нет - создаем очередь
									this.silenceRequestTimer = setTimeout(() => {
										// обнулим таймер
										this.silenceRequestTimer = null
										// делаем тихий рефреш
										this.requestListData(true)
									}, 1000)

									// на этом все
									return
								}

								// запись нашли - обновим запись в renderRows
								// для начала снова ее найдем
								if (!this.renderRows || !this.renderRows.length) this.renderRows = []
								this.renderRows.some((item, idx, arr) => {
									// все еще тут - нашли ее
									if (String(item[this.listConfig['column_id']]) === String(ID))
									{
										// обновим данные
										this.$set(arr, idx, _dt['rows'][0])
										// обработка выделенной строки
										if (item['w5-row-selected'] === true)
											this.$nextTick(() => this.buttonsForSelectedRow())
										// сообщим всем об обновлении записи
										EventBus.$emit('w5-update-row', {
											'column_id': this.listConfig['column_id'],
											'row': arr[idx]
										})
										// на этом все
										return true
									}
								})
							}
						)
					}
				}

				// если запись все таки не нашли (*)
				if (!_found)
				{
					// значит придется перегрузить весь список
					// так как эта запись может быть добавлена в список (новая), удалена,
					// или список был изначально пуст
					// и нужно это сделать тихо, незаметно для UI
					// и нужна очередь - иначе может быть несколько запросов
					// например:
					// update service 605
					// update service 807
					// на эти два пуша нужен только один запрос рефреша
					if (this.silenceRequestTimer)
					{
						// запрос на тихий рефреш уже есть в очереди - обнулим его
						clearTimeout(this.silenceRequestTimer)
						this.silenceRequestTimer = null
					}

					// теперь запроса точно нет - создаем очередь
					this.silenceRequestTimer = setTimeout(() => {
						this.silenceRequestTimerCounter = 0
						// обнулим таймер
						this.silenceRequestTimer = null
						// делаем тихий рефреш
						this.requestListData(true)
					}, 3000)

					// если накопилось уже много запросов
					if (this.silenceRequestTimerCounter > 1000)
					{
						this.silenceRequestTimerCounter = 0
						this.requestListData(true)
					}
				}
				// на этом все
				return
			}

			// еще не все записи находятся в renderRows - повторим попытку через 1000мс
			setTimeout(() => { this.pushFindRecord(ID) }, 1000)
		},
		//---------------------------------------------------------------------
		// приведение данных из формата "view" в формат "list" (*)
		//---------------------------------------------------------------------
		FromViewToList(rowView, rowList) {
			// сначала обновим старые значения, которые уже есть
			for (let p in rowList) if (rowList.hasOwnProperty(p))
			{
				if (p in rowView)
				{
					// обновляем значение
					rowList[p] = rowView[p]
				}
				else
				{
					// значение исчезло - удалим тоже
					// только если это не признак выделенной строки
					if (p !== 'w5-row-selected')
						delete rowList[p]
				}
			}

			// теперь добавим значения которых еще нет
			for (let v in rowView) if (rowView.hasOwnProperty(v))
			{
				if (!(v in rowList))
					rowList[v] = rowView[v]
			}

			return rowList
		},
		//---------------------------------------------------------------------
		// если колонки нет в данных от сервера
		//---------------------------------------------------------------------
		isColumnInData(columnName) {
			// если еще нет строк - то точно нет
			if (!this.renderRows || !Array.isArray(this.renderRows) || !this.renderRows.length) return false

			// если это номер счета
			if (columnName === 'account_id' || columnName === 'account_name')
			{
				// если установлен глобальный фильтр по аккаунту
				if (this.accountGlobalFilter)
				{
					if (this.crud !== 'account' && this.crud !== 'partneractions') return false
					else return true
				}
				else return true
			}

			// если это номер счета в действиях по партнерке
			if (columnName === 'owner_account_id' || columnName === 'owner_account_name')
			{
				// если установлен глобальный фильтр по аккаунту
				if (this.accountGlobalFilter) return false
				else return true
			}

			// если это стойка в оборудовании
			if (this.crud === 'rackdevice')
			{
				if (columnName === 'rack_name')
				{
					// если установлен CRUD фильтр
					if (this.crudFilter &&
						this.crudFilter.crud === 'rackdevice' &&
						this.crudFilter.field === 'rack_id')
						return false
					else
						return true
				}

				if (columnName === 'device_unit')
				{
					return ('device_unit' in this.renderRows[0])
				}
			}

			// если это ДЦ в стойках
			if (this.crud === 'rack' && columnName === 'datacenter_name')
			{
				return ('datacenter_name' in this.renderRows[0])
			}

			// по умолчанию - да
			return true
		},
		//---------------------------------------------------------------------
		// проверка наличия заголовка
		//---------------------------------------------------------------------
		verifyForGlobalFilter(columnName) {
			// если это номер счета
			if (columnName === 'account_id' || columnName === 'account_name')
			{
				// если установлен глобальный фильтр по аккаунту
				if (this.accountGlobalFilter)
				{
					if (this.crud !== 'account' && this.crud !== 'partneractions') return false
					else return true
				}
				else return true
			}

			// если это номер счета в действиях по партнерке
			if (columnName === 'owner_account_id' || columnName === 'owner_account_name')
			{
				// если установлен глобальный фильтр по аккаунту
				if (this.accountGlobalFilter) return false
				else return true
			}

			// если это стойка в оборудовании
			if (this.crud === 'rackdevice')
			{
				if (columnName === 'rack_name')
				{
					// если установлен CRUD фильтр
					if (this.crudFilter &&
						this.crudFilter.crud === 'rackdevice' &&
						this.crudFilter.field === 'rack_id')
						return false
					else
						return true
				}

				if (columnName === 'device_unit')
				{
					// если еще нет строк - то точно нет
					if (!this.renderRows || !Array.isArray(this.renderRows) || !this.renderRows.length) return false
					return ('device_unit' in this.renderRows[0])
				}
			}

			// если это ДЦ в стойках
			if (this.crud === 'rack' && columnName === 'datacenter_name')
			{
				// если еще нет строк - то точно нет
				if (!this.renderRows || !Array.isArray(this.renderRows) || !this.renderRows.length) return false
				return ('datacenter_name' in this.renderRows[0])
			}

			// по умолчанию - да
			return true
		},
		//---------------------------------------------------------------------
		// извлечение ISO из списка (вызов диалога)
		//---------------------------------------------------------------------
		ejectISOOper(data) {
			if (!data) return
			this.ejectISO(data)
		},
		ejectISO(row, e) {
			// проверка ID образа
			if (!row || !row['service_id'] || !row['service_name'] || !row['parent_id']) return
			// если идет какой то процесс
			if (row && row['service_status_text'] && String(row['service_status_text']).length) return
			// проверка прав
			if (!this.isAccess('service/update')) return
			// прерываем всплытие
			if (e) {
				e.preventDefault()
				e.stopPropagation()
			}
			// обнуляем сообщение
			this.localErrorMessage = ''
			// запоминаем ID
			this.isoID = row['service_id']
			this.isoParentID = row['parent_id']
			// ставим сообщение
			this.isoModalTitle = 'service/iso'
			this.isoModalText = this.localeFtc('service/iso_ejecting_confirm')
				.replace('{iso}', row['service_name'])

			// кнопка диалога
			this.blockModalTimer = 5
			this.isoBlockModalButtonTitle = '5 - ' + this.localeFtc('main/detach')

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showISOModal = true

			// запускаем таймер
			this.blockModalTimerHandler = setInterval(() => {
				this.blockModalTimer--
				this.isoBlockModalButtonTitle = this.blockModalTimer + ' - ' + this.localeFtc('main/detach')
				if (this.blockModalTimer <= 0)
				{
					this.isoBlockModalButtonTitle = this.localeFtc('main/detach')
					clearInterval(this.blockModalTimerHandler)
					this.blockModalTimerHandler = null
				}
			}, 1000)
		},
		// закрывает диалог извлечения ISO
		hideISOModal() {
			// если активен таймер блокировки
			if (this.blockModalTimerHandler)
			{
				clearInterval(this.blockModalTimerHandler)
				this.blockModalTimerHandler = null
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showISOModal = false
			this.hideModalMask()
		},
		// непосредственно извлечение ISO
		detachIsoBegin(e) {
			// если таймер еще активен
			if (this.blockModalTimer > 0)
			{
				if (e) e.preventDefault()
				return
			}

			// проверка ID образа
			if (!this.isoID || !this.isoParentID) return
			// проверка прав
			if (!this.isAccess('service/update')) return

			if (this.isoModalTitle === 'service/extdisk') {
				this.detachOuterDiskBegin()
				return
			}

			// закроем диалог
			this.hideISOModal()

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.isoID + '?additional=setDetach'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									this.setLocalSuccessMessage(_dt['title'] || 'main/process_started')
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error')
								{
									// если что то передали
									if (_dt['fields'] && _dt['fields']['iso_id'])
									{
										if (Array.isArray(_dt['fields']['iso_id']))
										{
											if (_dt['fields']['iso_id'].length)
												this.localErrorMessage = this.localeFtc(_dt['fields']['iso_id'][0])
										}
										else
										{
											this.localErrorMessage = this.localeFtc(_dt['fields']['iso_id'])
										}
									}
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// бэкап Внешнего диска из меню операций (вызов диалога)
		//---------------------------------------------------------------------
		async backupOuterDisk(data) {
			if (!data) return
			if (!this.isAccess('service/create')) return

			// получим ID Записи
			let _id = data[this.listConfig['column_id']]
			if (!_id) return

			// проверка статуса
			if (data['service_status'] !== 'active' || data['service_status_text']) return

			// заголовок диалога
			this.confirmModalDialogTitle = 'service/backup_create'

			let _accountID = null
			if (data && 'account_id' in data) _accountID = data['account_id']

			// запрос стоимости
			let _cost = null
			let _size = null
			let _sizeFor = null
			try {
				let _rez = await this.$http.get(this.APIServerUrl + '/service/view/' + _id)
				if (_rez &&
					_rez.data &&
					_rez.data.status === 'ok' &&
					_rez.data.service.service_quantity &&
					'value' in _rez.data.service.service_quantity)
				{
					_size = parseInt(_rez.data.service.service_quantity.value, 10)
					_sizeFor = _rez.data.service.service_quantity.for
				}

				if (!_accountID &&
					_rez &&
					_rez.data &&
					_rez.data.status === 'ok' &&
					_rez.data.account &&
					_rez.data.account.account_id &&
					'value' in _rez.data.account.account_id)
				{
					_accountID = _rez.data.account.account_id.value
				}
			}
			catch (err) {}

			if (!_accountID)
			{
				if (this.$store.state.user_account)
				{
					_accountID = String(this.$store.state.user_account).replace(/[a-z]/ig, '')
				}
			}

			if (!_accountID) return

			try {
				let _rez = await this.$http.get(this.APIServerUrl + '/service/create?search=service_backup&account_id=' + _accountID)
				if (_rez &&
					_rez.data &&
					_rez.data.status === 'ok' &&
					_rez.data.result &&
					_rez.data.result.length)
				{
					_rez.data.result.some(item => {
						if (item && String(item.id) === String(_id))
						{
							_cost = parseFloat(item.cost)
							return true
						}
					})
				}
			}
			catch (err) {}

			// если не получилось получить стоимость
			if (_cost === null || _size === null) return

			// вопрос диалога
			this.confirmModalDialogText = this.localeFtc('service/creating_backup_cost <b>main/ruble</b> / <b>{size}</b>')
				.replace('{cost}', Helper.FormatMoney2(_cost/* * _size*/, 2))
				.replace('{size}', _size + ' ' + this.localeFtc(_sizeFor))

			// определяем колбак для подтверждающей кнопки диалога
			this.confirmModalDialogCallback = () => this.backupOuterDiskStart(_id, _accountID)

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showConfirmModalDialog = true
		},
		//---------------------------------------------------------------------
		// клонирование Внешнего диска из меню операций - сама операция
		//---------------------------------------------------------------------
		backupOuterDiskStart(serviceId, accountId) {
			// проверки
			if (!serviceId || !accountId || !this.isAccess('service/create')) return

			// закроем диалог
			this.localErrorMessage = ''
			this.hideConfirmModalDialog()

			// формируем URL
			let _url = this.APIServerUrl + '/service/create/' + Vue.Constants.SERVICE_TYPE_BACKUP_VDS

			// начинаем запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false

					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['status'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'service_id': serviceId,
							'account_id': accountId,
							'reinstall': 0
						}

						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.setLocalSuccessMessage('service/creating_backup_begin_process')
									// на этом все
									return
								}
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// клонирование Внешнего диска из меню операций (вызов диалога)
		//---------------------------------------------------------------------
		async cloneOuterDisk(data) {
			if (!data) return
			if (!this.isAccess('service/clone')) return

			// получим ID Записи
			let _id = data[this.listConfig['column_id']]
			if (!_id) return

			// если для этой записи уже запущен процесс перезагрузки
			if (this.outerDiskCloneProcessing[_id]) return

			// проверка статуса
			if (data['service_status'] !== 'active' || data['service_status_text']) return

			// заголовок диалога
			this.confirmModalDialogTitle = 'main/clone'

			// запрос стоимости
			let _cost = null
			let _size = null
			let _sizeFor = null
			try {
				let _rez = await this.$http.get(this.APIServerUrl + '/service/view/' + _id)
				if (_rez &&
					_rez.data &&
					_rez.data.status === 'ok' &&
					_rez.data.service.service_quantity &&
					'value' in _rez.data.service.service_quantity)
				{
					_size = parseInt(_rez.data.service.service_quantity.value, 10)
					_sizeFor = _rez.data.service.service_quantity.for
				}

				if (_rez &&
					_rez.data &&
					_rez.data.status === 'ok' &&
					_rez.data.service_type &&
					_rez.data.service_type.service_type_id &&
					_rez.data.service_type.service_type_id.value)
				{
					const _type = _rez.data.service_type.service_type_id.value
					_rez = await this.$http.get(this.APIServerUrl + '/service/create/' + _type)
					if (_rez && _rez.data && _rez.data.info && _rez.data.info.for)
					{
						_cost = parseFloat(_rez.data.info.cost)
					}
				}
			}
			catch (err) {}

			// если не получилось получить стоимость
			if (_cost === null || _size === null) return

			// вопрос диалога
			this.confirmModalDialogText = this.localeFtc('service/extdisk_clone_confirm')
				.replace('{name}', data['service_name_full'])
				.replace('{price}', Helper.FormatMoney2(_cost * _size, 2) + ' ' + this.localeFtc('main/ruble'))
				.replace('{size}', _size + ' ' + _sizeFor)

			// определяем колбак для подтверждающей кнопки диалога
			this.confirmModalDialogCallback = () => this.cloneOuterDiskStart(_id)

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showConfirmModalDialog = true
		},
		//---------------------------------------------------------------------
		// клонирование Внешнего диска из меню операций - сама операция
		//---------------------------------------------------------------------
		cloneOuterDiskStart(id) {
			// проверки
			if (this.outerDiskCloneProcessing[id]) return
			if (!this.isAccess('service/clone')) return

			// закроем диалог
			this.localErrorMessage = ''
			this.hideConfirmModalDialog()

			// формируем URL
			let _url = this.APIServerUrl + '/service/clone/' + id

			// включаем флаг начала процесса
			this.outerDiskCloneProcessing[id] = true

			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг процесса
								delete this.outerDiskCloneProcessing[id]
								// получим ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// на это все, никаких рефрешей не нужно,
									// ибо придет пуш, и по нему система сама все обновит
									// а пока просто сообщим
									this.setLocalSuccessMessage('main/vds_clone_process_started')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								delete this.outerDiskCloneProcessing[id]
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					delete this.outerDiskCloneProcessing[id]
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					delete this.outerDiskCloneProcessing[id]
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// извлечение Внешнего диска из меню операций (вызов диалога)
		//---------------------------------------------------------------------
		ejectOuterDisk(data) {
			if (!data) return
			this.ejectOuterDiskFromTable(data)
		},
		//---------------------------------------------------------------------
		// извлечение Внешнего диска из таблицы (вызов диалога)
		//---------------------------------------------------------------------
		ejectOuterDiskFromTable(row, e) {
			// проверка ID образа
			if (!row || !row['service_id'] || !row['service_name'] || !row['parent_id']) return
			// если идет какой то процесс
			if (row && row['service_status_text'] && String(row['service_status_text']).length) return
			// проверка прав
			if (!this.isAccess('service/update')) return
			// прерываем всплытие
			if (e) {
				e.preventDefault()
				e.stopPropagation()
			}
			// обнуляем сообщение
			this.localErrorMessage = ''
			// запоминаем ID
			this.isoID = row['service_id']
			this.isoParentID = row['parent_id']
			// ставим сообщение
			this.isoModalTitle = 'service/extdisk'
			this.isoModalText = this.localeFtc('service/extdisk_ejecting_confirm')
				.replace('{disk}', row['service_name'])

			// кнопка диалога
			this.blockModalTimer = 5
			this.isoBlockModalButtonTitle = '5 - ' + this.localeFtc('main/detach')

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showISOModal = true

			// запускаем таймер
			this.blockModalTimerHandler = setInterval(() => {
				this.blockModalTimer--
				this.isoBlockModalButtonTitle = this.blockModalTimer + ' - ' + this.localeFtc('main/detach')
				if (this.blockModalTimer <= 0)
				{
					this.isoBlockModalButtonTitle = this.localeFtc('main/detach')
					clearInterval(this.blockModalTimerHandler)
					this.blockModalTimerHandler = null
				}
			}, 1000)
		},
		// непосредственно извлечение внешнего диска
		detachOuterDiskBegin(e) {
			// если таймер еще активен
			if (this.blockModalTimer > 0)
			{
				if (e) e.preventDefault()
				return
			}

			// проверка ID образа
			if (!this.isoID || !this.isoParentID) return
			// проверка прав
			if (!this.isAccess('service/update')) return

			// закроме диалога
			this.hideISOModal()

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.isoID + '?additional=setDetach'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									this.setLocalSuccessMessage(_dt['title'] || 'main/process_started')
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error')
								{
									// если что то передали
									if (_dt['fields'] && _dt['fields']['iso_id'])
									{
										if (Array.isArray(_dt['fields']['iso_id']))
										{
											if (_dt['fields']['iso_id'].length)
												this.localErrorMessage = this.localeFtc(_dt['fields']['iso_id'][0])
										}
										else
										{
											this.localErrorMessage = this.localeFtc(_dt['fields']['iso_id'])
										}
									}
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// калькулятор
		//---------------------------------------------------------------------
		// закрытие
		hideCalcModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showCalcModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// конвертации
		//---------------------------------------------------------------------
		// закрытие диалога конвертации
		hidePaymentModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showPaymentModal = false
			this.hideModalMask()
		},
		// старт конвертации
		paymentConvertBegin() {
			// обнулим сообщения
			this.localErrorMessage = ''
			// если кнопка задизаюлена
			if (this.isPaymentModalButtonDisabled) return
			// проверим - есть ли поля с ошибками
			let _isErr = this.paymentFields.fields.some(row => {
				let _found = false
				if (row && Array.isArray(row) && row.length)
				{
					_found = row.some(fld => {
						if (!fld['_visible']) return false
						// обязательное поле?
						if (fld['required'] === true)
						{
							// если значение вообще не задано
							if (fld.value === undefined || fld.value === null)
							{
								fld['_errMsg'] = 'error/required_field'
								return true
							}
						}
					})
				}

				if (_found) return true
			})
			if (_isErr) return
			// все в порядке - делаем запрос
			// формируем URL
			let _url = this.APIServerUrl + '/operation/convert'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {}
						// соберем значения всех полей
						this.paymentFields.fields.forEach(row => {
							if (row && Array.isArray(row) && row.length)
							{
								row.forEach(fld => {
									let _value = fld['value']
									if (fld['type'] === 'boolean')
									{
										_value = Helper.normalizeBooleanValue(fld['value']) ? 1 : 0
									}
									_post[_dt['model']][fld['_field_name']] = _value
								})
							}
						})
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// эмуляция пуша для рефреша
									EventBus.$emit('w5-push', 'update partner 0')
									// успешное сообщение
									this.setLocalSuccessMessage('operation/converted')
									// закроме диалог
									this.hidePaymentModal()
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error' && _dt['fields'] && typeof _dt['fields'] === 'object')
								{
									// бежим по всем полям
									for (let f in _dt['fields']) if (_dt['fields'].hasOwnProperty(f))
									{
										// сразу ищме поле
										let _fld = this.findField(f)
										if (_fld)
										{
											// сообщение по умолчанию
											_fld['_errMsg'] = this.localeFtc('main/error_desc').replace(':', '')
											// если пришел массив - берем первое сообщение
											if (Array.isArray(_dt['fields'][f]))
											{
												if (_dt['fields'][f].length)
													_fld['_errMsg'] = this.localeFtc(_dt['fields'][f][0])
											}
											else _fld['_errMsg'] = this.localeFtc(_dt['fields'][f])
										}
									}

									return
								}

								// закроме диалог
								this.hidePaymentModal()
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// закроме диалог
								this.hidePaymentModal()
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// закроме диалог
					this.hidePaymentModal()
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// закроме диалог
					this.hidePaymentModal()
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// уход фокуса с поля формы конвертации
		onBlurPayment(field) {
			// проверка значения поля
			this.verifyFieldPayment(field)
		},
		// фокус не поле формы конвертации
		onFocusPayment(field) {
			if (field) field['_errMsg'] = ''
		},
		// нажали ENTER на поле формы конвертации
		onEnterKeyDownPayment() {
			this.paymentConvertBegin()
		},
		// проверка значения поля !!!!!
		verifyFieldPayment(field) {
		},
		// видимость строки
		isVisiblePaymentField(row) {
			// проверка данных
			if (!row || !Array.isArray(row) || !row.length) return false
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden')
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		// сменилось значение поля
		fieldChangedPayment(field) {
			if (!field) return

			if (field['_field_name'] === 'type' && field['listValue'])
			{
				this.paymentMax = field['listValue']['max']
				this.paymentMin = field['listValue']['min']

				// поле сумма
				if (this.paymentMax > 0)
				{
					EventBus.$emit('w5-set-money-field-value', {
						'type': 'money',
						'name': 'summa',
						'value': this.paymentMax
					})
				}
			}

			// запрещаем делать вывод на Вебмани если у партнёра лишь 1 приведённый клиент
			this.isPaymentModalButtonDisabled = false
			this.PaymentWarrningAdditional = false
			if (!this.clientPartnerData ||
				!('total' in this.clientPartnerData) ||
				!this.clientPartnerData.total ||
				this.clientPartnerData.total <= 1)
			{
				// проверка типа
				let _f = this.findField('type')
				if (_f && _f.listValue)
				{
					let _name = String(_f.listValue.name)
					if (_name.toLowerCase().indexOf('webmoney') > -1)
					{
						this.isPaymentModalButtonDisabled = true
						this.PaymentWarrningAdditional = 'payment/partner_limits'
					}
				}
			}

			// каждый раз вычисляем условия "showif" для всех полей с таким условием
			this.showifPayment()
		},
		// изменение поля
		fieldPaymentInput(field) {
			// всегда обнуляем предупреждение
			this.PaymentWarrning = false
			if (!field) return
			// если это изменение суммы
			if (field['_field_name'] === 'summa')
			{
				// проверим границу
				let _val = field.value
				if (_val < this.paymentMin)
					this.PaymentWarrning = 'payment/not_available'
			}
		},
		// условия showif
		showifPayment() {
			// бежим по всем полям
			let _rows = this.paymentFields.fields
			if (!_rows || !Array.isArray(_rows)) return

			// готовим объекты, где собираем значения и выражения
			let _values = {}
			let _expressions = {}

			// бежим по всем полям - собираем значения и выражения
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// смотрим только поля с названиями
						if (field['_field_name'])
						{
							// заполняем объект со значениями
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value']

							// если есть выражение для данного поля
							if (field['showif'])
							{
								// получим выражение
								let _expr = field['showif']
								// подменяем в выражении переменные
								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf('in') !== -1)
								{
									// var in [1,2,3,4,5] => $.inArray(var, [1,2,3,4,5])
									var reg = new RegExp(/(\w+) in (\[[0-9,\s]+\])/gi)
									_expr = _expr.replace(reg, '$.inArray($1, $2) !== -1')
								}
								// type[period] == 0    =>    type__period__ == 0
								else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__')
								_expressions[field['_field_name']] = _expr
							}
						}
					})
				}
			})

			// теперь бежим по всем полученным выражениям
			for (let e in _expressions)
			{
				// подменяем поля на свойства объекта
				let _exp = _expressions[e]
				for (let v in _values)
				{
					let reg = new RegExp('\\b' + v + '\\b', 'gi')
					_exp = _exp.replace(reg, (str, offset, src) => {
						// если в начале строки - это точно поле
						if (offset <= 0) return 'obj.' + v
						// если не в начале, и сразу перед ним стоит кавычка - это точно не поле
						else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v
						// по умолчанию это все таки поле
						return 'obj.' + v
					})
				}

				// формируем функцию
				// eslint-disable-next-line
				let _func = new Function('obj', ' return ' + _exp)

				// ищем поле
				let _field = this.findField(e)
				if (_field)
				{
					// обнулим ошибку в любом случае
					this.$set(_field, '_errMsg', '')
					// установим видимость поля
					this.$set(_field, '_visible', _func(_values))
				}
			}
		},
		// поиск поля
		findField(name) {
			// бежим по всем полям
			let _rows = this.paymentFields.fields
			if (!_rows || !Array.isArray(_rows)) return

			// поля есть - пробежимся по ним
			let _field = null
			_rows.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		//---------------------------------------------------------------------
		// закрытие мини-диалога пополнения баланса клиентом
		//---------------------------------------------------------------------
		hideBalancePopup(forceClose = true) {
			if (!forceClose)
			{
				// если это просто выход мыши за пределы даилога, например
				// при выделении мышью
				if (!this.maskModalFlag) return
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showBalancePopup = false
			this.hideModalMask()
		},
		// подтверждение пополнения баланса - переход в форму пополнения
		onBalanceSubmit() {
			// сумма должна быть задана
			if (this.balanceValue <= 0)
			{
				this.balanceField['_errMsg'] = 'error/required_field'
				return
			}
			// запоминаем сумму
			this.$store.commit('setOperationSumNew', this.balanceValue)
			// переходим в форму пополнения
			this.$router.push('/operation/create')
		},
		//---------------------------------------------------------------------
		// установка успешного сообщения
		//---------------------------------------------------------------------
		setLocalSuccessMessage(msg) {
			EventBus.$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			})
		},
		//---------------------------------------------------------------------
		// смена метки у тикета в таблице
		//---------------------------------------------------------------------
		// вызов диалога
		changeTicketLabel(row) {
			// по умолчанию - закрываем блок выбора метки
			this.hideTicketLabelBlock()
			// обнуляем ID тикета
			this.ticketLabelId = null

			// доступно только сотрунику
			if (this.$store.state.user_type !== 'admin') return
			// если тикет уже закрыт
			//if (row['ticket_status'] === 'closed') return
			// если нет прав
			if (!this.isAccess('ticket/update')) return

			// запоминаем ID тикета
			this.ticketLabelId = row['ticket_id']
			if (!this.ticketLabelId) return

			// заполняем список меток заново
			this.ticketLabelItems = {}
			if (this.listData && this.listData['filters'] &&
				this.listData['filters']['ticket_label'] &&
				this.listData['filters']['ticket_label']['list'] &&
				typeof this.listData['filters']['ticket_label']['list'] === 'object' &&
				Object.keys(this.listData['filters']['ticket_label']['list']).length)
			{
				let _old = row['ticket_label'] === undefined || row['ticket_label'] === null || row['ticket_label'] === '' || row['ticket_label'] === false ? null : row['ticket_label']
				let _list = this.listData['filters']['ticket_label']['list']
				for (let _val in _list) if (_list.hasOwnProperty(_val))
				{
					// форматируем новое значение
					let _new = _val === undefined || _val === null || _val === '' || _val === false ? null : _val
					// старое значение пропускаем
					if (_old === _new) continue
					// добавляем в список значения
					if (_new === null) this.ticketLabelItems[''] = null
					else this.ticketLabelItems[_new] = _new
				}
			}

			// расчитаем положение ячейки
			let _cellEl = this.$refs['ticket-label-' + row['ticket_id']]
			let _coord = this.getElementOffset(_cellEl[0])
			this.ticketLabelBlockStyle = 'top: ' + (_coord.top - 59) + 'px; left: 12px;'

			// показываем
			this.showChoiceTicketLabelBlock = true
		},
		// закрытие диалога
		hideTicketLabelBlock() {
			this.showChoiceTicketLabelBlock = false
		},
		// смена метки
		onChangeTicketLabel(value) {
			// сразу закрываем блок выбора метки
			this.hideTicketLabelBlock()

			// доступно только сотрунику
			if (this.$store.state.user_type !== 'admin') return
			// если нет прав
			if (!this.isAccess('ticket/update')) return
			// если нет ID
			if (!this.ticketLabelId) return

			// ищем строку с указанным ID
			let _index = -1
			if (!this.renderRows || !this.renderRows.length) this.renderRows = []
			this.renderRows.some((item, idx, arr) => {
				if (String(item['ticket_id']) === String(this.ticketLabelId))
				{
					_index = idx
					return true
				}
			})

			// если не нашли строку
			if (_index === -1) return

			// строка найдена, можно менять - для начала ставим признак запроса
			let _oldLabel = this.renderRows[_index]['ticket_label']
			this.renderRows[_index]['ticket_label'] = 'loading'

			// форматируем новую метку
			let _label = value === undefined || value === null || value === '' || value === false ? '' : value

			// формируем URL
			let _url = this.APIServerUrl + '/ticket/update/' + this.ticketLabelId + '?additional=setLabel&label=' + _label
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// эмулируем пуш для обновления
									EventBus.$emit('w5-push', 'update ticket ' + this.ticketLabelId)
									// на этом все
									return
								}

								// просто возвращаем старое значение
								this.renderRows[_index]['ticket_label'] = _oldLabel
							},
							// отрицательный ответ сервера
							resPost => {
								// просто возвращаем старое значение
								this.renderRows[_index]['ticket_label'] = _oldLabel
							}
						)

						// на этом все
						return
					}

					// просто возвращаем старое значение
					this.renderRows[_index]['ticket_label'] = _oldLabel
				},
				// отрицательный ответ
				resGet => {
					// просто возвращаем старое значение
					this.renderRows[_index]['ticket_label'] = _oldLabel
				}
			)
		},
		//---------------------------------------------------------------------
		// показывает диалог отметки всех тикетов как прочитанные
		//---------------------------------------------------------------------
		markTicketsAsReaded() {
			// проверка условий
			if (this.crud !== 'ticket' || this.$store.state.user_type !== 'client' || !this.isUnreadedTickets || !this.isAccess('ticket/update')) return
			// просто показываем диалог
			this.showMarkTicketsAsReadedDialog = true
		},
		markTicketsAsReadedStart() {
			// проверка условий
			if (this.crud !== 'ticket' || this.$store.state.user_type !== 'client' || !this.isUnreadedTickets || !this.isAccess('ticket/update')) return

			// собираем все ID непрочитанных тикетов
			/* 2021 - теперь не требуется передавать ID тикетов
			let _ids = []
			this.renderRows.forEach(row => {
				if ('message_unread_count' in row && row['message_unread_count'] > 0)
					_ids.push(row['ticket_id'])
			})

			if (!_ids.length) return
			*/

			// закрываем диалог
			this.showMarkTicketsAsReadedDialog = false

			// делаем запрос - формируем URL
			let _url = this.APIServerUrl + '/ticket/update'

			// параметры
			let _params = {
				additional: 'setRead'
			}

			/*
			let tickets = {}
			_ids.forEach(id => { tickets[id] = 1 })
			*/

			// это мы меняем
			this.$store.commit('ItIsMe', true)

			// запрос на установку метки что сообщение прочитано
			this.$http.get(_url, { 'params': _params }).then(
				// данные успешно получены
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						//let _post = { '_csrf': _dt['_csrf'], tickets }
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(resGet.url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// на этом все
									return
								}
							}
						)
					}
				}
			)
		},
		//---------------------------------------------------------------------
		// форматирование суммы
		//---------------------------------------------------------------------
		totalSummFormat(sum) {
			let _str = String(sum)
			_str = _str.replace(',', '.')
			let _params = _str.split('.')
			let digs = 2
			if (_params.length > 1 && _params[1].length > 2)
				digs = _params[1].length
			return Helper.FormatMoney2(sum, digs)
		},
		//---------------------------------------------------------------------
		// безопасное форматирование тегов
		//---------------------------------------------------------------------
		safeTagsReplace(str) {
			return Helper.safe_tags_replace(str)
		},
		//---------------------------------------------------------------------
		// подсчет количества знаков после запятой
		//---------------------------------------------------------------------
		recountDigitsForString(value) {
			let _str = String(parseFloat(value))
			_str = _str.replace(',', '.')
			let _params = _str.split('.')

			if (_params.length > 1 && _params[1].length > 2)
				this.countDigits = Math.max(_params[1].length, this.countDigits)
		},
		//---------------------------------------------------------------------
		// установка значения быстрого поиска
		//---------------------------------------------------------------------
		setFastSearchValue(value) {
			this.fastSearchValue = value
			setTimeout(() => {
				EventBus.$emit('w5-set-text-field-value', {
					'name': 'fastSearch',
					'value': value
				})
			}, 100)
		},
		//---------------------------------------------------------------------
		// последний комментатор в тикете
		//---------------------------------------------------------------------
		ticketLastCommentatorShow(Row, event) {
			if (!Row || !event || !event.target)
			{
				this.ticketLastCommentator = ''
				this.ticketLastCommentatorStyle = { display: 'none', top: 0, left: 0 }
				return
			}

			let _coor = this.getElementOffset(event.target, true)
			this.$set(this, 'ticketLastCommentatorStyle', {
				display: 'block',
				top: (_coor.top - 7) + 'px',
				left: (_coor.left + 30) + 'px'
			})

			let _text = ''
			if (Row && Row['ticket_last_user_name'])
				_text += Row['ticket_last_user_name']

			this.ticketLastCommentator = _text
		},
		ticketLastCommentatorHide() {
			this.ticketLastCommentator = ''
			this.ticketLastCommentatorStyle = { display: 'none', top: 0, left: 0 }
		},
		//---------------------------------------------------------------------
		// диалог подключения внешнего диска
		//---------------------------------------------------------------------
		// закрыть диалог
		hideConnectOuterDiskDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showConnectOuterDiskDialog = false
			this.hideModalMask()
		},
		// показ диалога
		connectOuterDisk(data) {
			// проверка входных параметров
			if (!data) return

			// получим ID Записи
			let _id = data[this.listConfig['column_id']]
			if (!_id) return

			// проверка
			if (data['service_status'] !== 'active' || data['service_status_text']) return

			// данные
			this.connectOuterDiskDialogMode = 'disk'
			this.connectOuterDiskDialogId = _id

			// обнулим ошибку
			this.localErrorMessage = ''

			// запросим список вдс к которым можно подключить диск
			// не нужно показывать лоадер
			this.$store.commit('needShowLoader', false)
			this.$http.get(this.APIServerUrl + '/service/update/' + _id + '?search=server_disk').then(
				resGet => {
					// лодаер снова нужен
					this.$store.commit('needShowLoader', true)
					// рассмотрим ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					if (_dt && _dt['status'] === 'ok' && _dt['result'] && Array.isArray(_dt['result']))
					{
						if (_dt['result'].length)
						{
							// обновляем список серверов
							this.$set(this.connectOuterDiskField, 'list', _dt['result'].map(el => {
								return {
									id: el.id,
									name: this.localeFtc(el.name),
									active: el.active === true && el.enable === true
								}
							}))

							// устанавливаем первое значение из списка со всеми включенными флагами
							_dt['result'].some(_srv => {
								if (_srv && _srv['id'] && _srv['active'] === true && _srv['enable'] === true) {
									const _newValue = {
										id: _srv['id'],
										name: this.localeFtc(_srv['name']),
										active: _srv['active'] === true && _srv['enable'] === true
									}

									this.$set(this.connectOuterDiskField, 'listValue', _newValue)
									this.$set(this, 'connectOuterDiskValue', _srv['id'])

									this.$nextTick(() => {
										EventBus.$emit('w5-set-list-field-value', {
											name: 'vdsId',
											value: _newValue
										})
									})
									return true
								}
							})

							// теперь можно показать диалог
							EventBus.$emit('w5-body-scroll-disable')
							this.showConnectOuterDiskDialog = true
						}
						// пишем что список пуст и все
						else this.localErrorMessage = 'main/data_not_found'

						// на этом все
						return
					}

					// иная ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				resGet => {
					// лодаер снова нужен
					this.$store.commit('needShowLoader', true)
					// ошибка запроса
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// начать процесс подключения диска
		connectOuterDiskDialogStartProcess() {
			// проверки
			if (!this.connectOuterDiskDialogId || !this.connectOuterDiskValue) {
				return
			}
			if (!this.isAccess('service/update')) return

			// можно закрывать диалог
			this.hideConnectOuterDiskDialog()

			// обнулим сообщения
			this.localErrorMessage = ''

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.connectOuterDiskDialogId + '?additional=setAttach&service_id=' + this.connectOuterDiskValue

			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									this.setLocalSuccessMessage(_dt['title'] || 'main/process_started')
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// показ диалога
		//---------------------------------------------------------------------
		connectISOOper(data) {
			// проверка входных параметров
			if (!data) return

			// получим ID Записи
			let _id = data[this.listConfig['column_id']]
			if (!_id) return

			// проверка
			if (data['service_status'] !== 'active' || data['service_status_text']) return

			// данные
			this.connectOuterDiskDialogMode = 'iso'
			this.connectOuterDiskDialogId = _id

			// обнулим ошибку
			this.localErrorMessage = ''

			// запросим список вдс к которым можно подключить ISO
			// не нужно показывать лоадер
			this.$store.commit('needShowLoader', false)
			this.$http.get(this.APIServerUrl + '/service/update/' + _id + '?search=server_iso').then(
				resGet => {
					// лодаер снова нужен
					this.$store.commit('needShowLoader', true)
					// рассмотрим ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					if (_dt && _dt['status'] === 'ok' && _dt['result'] && Array.isArray(_dt['result']))
					{
						if (_dt['result'].length)
						{
							// обновляем список серверов
							this.$set(this.connectOuterDiskField, 'list', _dt['result'].map(el => {
								return {
									id: el.id,
									name: el.name,
									active: el.active === true && el.enable === true
								}
							}))

							// устанавливаем первое значение из списка со всеми включенными флагами
							_dt['result'].some(_srv => {
								if (_srv && _srv['id'] && _srv['active'] === true && _srv['enable'] === true) {
									const _newValue = {
										id: _srv['id'],
										name: _srv['name'],
										active: _srv['active'] === true && _srv['enable'] === true
									}

									this.$set(this.connectOuterDiskField, 'listValue', _newValue)
									this.$set(this, 'connectOuterDiskValue', _srv['id'])

									this.$nextTick(() => {
										EventBus.$emit('w5-set-list-field-value', {
											name: 'vdsId',
											value: _newValue
										})
									})
									return true
								}
							})

							// теперь можно показать диалог
							EventBus.$emit('w5-body-scroll-disable')
							this.showConnectOuterDiskDialog = true
						}
						// пишем что список пуст и все
						else this.localErrorMessage = 'main/data_not_found'

						// на этом все
						return
					}

					// иная ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				resGet => {
					// лодаер снова нужен
					this.$store.commit('needShowLoader', true)
					// ошибка запроса
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// начать процесс подключения диска
		connectISOOperDialogStartProcess() {
			// проверки
			if (!this.connectOuterDiskDialogId || !this.connectOuterDiskValue) {
				return
			}
			if (!this.isAccess('service/update')) return

			// можно закрывать диалог
			this.hideConnectOuterDiskDialog()

			// обнулим сообщения
			this.localErrorMessage = ''

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.connectOuterDiskDialogId + '?additional=setAttach&service_id=' + this.connectOuterDiskValue

			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									this.setLocalSuccessMessage(_dt['title'] || 'main/process_started')
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// диалог создания/восстановления бэкапа
		//---------------------------------------------------------------------
		// показ диалога
		showingBackupDialog() {
			EventBus.$emit('w5-body-scroll-disable')
			this.showBackupDialog = true
		},
		// показать диалог с предварительной подготовкой
		openBackupDialog() {
			// если это создание бэкапа
			if (this.backupDialogType === 'create-backup')
			{
				// и нет еще CSRF - запросим его
				if (!this.backupDialogCsrf)
				{
					// запросим CSRF
					let _url = this.APIServerUrl +
						'/service/create/' +
						Vue.Constants.SERVICE_TYPE_BACKUP_VDS
					this.$http.get(_url).then(
						resGet => {
							// получаем ответ
							let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
							// если ответ корректный
							if (_dt && _dt['_csrf'])
							{
								// запоминаем CSRF
								this.backupDialogCsrf = _dt['_csrf']

								// если есть поля
								if (_dt['fields'])
								{
									EventBus.$emit('w5-backup-dialog-fields', _dt['fields'])
								}
							}

							// показываем диалог
							this.showingBackupDialog()
						},
						() => {
							// показываем диалог
							this.showingBackupDialog()
						}
					)
				}
			}

			// можно показывать даилог
			this.showingBackupDialog()
		},
		// закрыть диалог
		hideBackupDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showBackupDialog = false
			this.hideModalMask()
		},
		// восстановление бэкапа - показ диалога
		restoreBackup(data) {
			// проверка входных параметров
			if (!data) return

			// получим ID Записи
			let _id = data[this.listConfig['column_id']]
			if (!_id) return

			// проверка
			if (data['service_status'] !== 'active' || data['service_status_text']) return

			// данные
			this.backupDialogId = _id
			this.backupDialogName = data['service_name']
			this.backupDialogType = 'restore-backup'

			// если это сотрудник
			if (this.$store.state.user_type === 'admin')
			{
				// если установлен глобальный фильтр
				if (this.accountGlobalFilter && this.accountGlobalFilter.text)
				{
					let _numStr = String(this.accountGlobalFilter.text).replace(/\D/g, '')
					let _num = parseInt(_numStr)
					if (!isNaN(_num))
						this.backupDialogAccount = _num
				}
				// глобального фильтра нет
				else
				{
					// если указан аккаунт в строке
					if (data.account_id)
						this.backupDialogAccount = data.account_id
					// если не указан - ничего не делаем
					else
						return
				}
			}

			// если это клиент
			if (this.$store.state.user_type !== 'admin')
				this.backupDialogAccount = true

			// показываем диалог
			this.openBackupDialog()
		},
		// начать процесс бэкапа/восстановления
		backupDialogStartProcess(data) {
			// проверки
			if (!data || !data.service) return

			// можно закрывать диалог
			this.hideBackupDialog()

			// обнулим сообщения
			this.localErrorMessage = ''

			// все в порядке - формируем URL
			let _url = null
			if (this.backupDialogType === 'create-backup')
			{
				if (!this.isAccess('service/create')) return

				_url = this.APIServerUrl +
					'/service/create/' +
					Vue.Constants.SERVICE_TYPE_BACKUP_VDS
			}
			else
			{
				if (!this.isAccess('service/update')) return

				_url = this.APIServerUrl +
					'/service/update/' +
					data.service +
					'?additional=setRestore&service_id=' +
					this.backupDialogId
			}

			// начинаем запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false

					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['status'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }

						if (this.backupDialogType === 'create-backup')
						{
							let _account = data.account
							if (!_account)
							{
								if (_dt['fields'] && _dt['fields']['account_id'] && _dt['fields']['account_id']['value'])
								{
									_account = _dt['fields']['account_id']['value']
								}
								else
								{
									if (this.$store.state.user_account)
									{
										_account = String(this.$store.state.user_account).replace(/[a-z]/ig, '')
									}
								}
							}

							_post[_dt['model']] = {
								'service_id': data.service,
								'account_id': _account,
								'reinstall': 0
							}
						}
						else
						{
							// for restore - do nothing
						}

						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.setLocalSuccessMessage(this.backupDialogType === 'create-backup' ? 'service/creating_backup_begin_process' : 'service/restore_queued')
									// обновляем список
									this.requestListData()
									// на этом все
									return
								}
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// даилог бэкапа по расписанию
		//---------------------------------------------------------------------
		hideBackupScheduleModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showBackupScheduleModal = false
			this.hideModalMask()
		},
		isVisibleScheduleField(row) {
			if (!row) return false
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden' && item['_visible'] === true)
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		fieldScheduleChanged(field) {
			this.showIfForSchedule()
		},
		// поиск поля в formData
		findScheduleField(name) {
			// если нет вообще полей
			if (!this.backupScheduleForm.fields) return null

			// поля есть - пробежимся по ним
			let _field = null
			this.backupScheduleForm.fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		// вычисляем значение "showif" для всех полей
		showIfForSchedule() {
			// бежим по всем полям
			let _rows = this.backupScheduleForm['fields']
			if (!_rows || !Array.isArray(_rows)) return

			// готовим объекты, где собираем значения и выражения
			let _values = {}
			let _expressions = {}

			// бежим по всем полям - собираем значения и выражения
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// смотрим только поля с названиями
						if (field['_field_name'])
						{
							// заполняем объект со значениями
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value']

							// если есть выражение для данного поля
							if (field['showif'])
							{
								// получим выражение
								let _expr = field['showif']
								// подменяем в выражении переменные
								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1)
								{
									// условие: var not in [array]
									if (_expr.indexOf(' not in ') !== -1)
									{
										// var not in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5]) < 0
										let reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0')
										}
										else
										{
											// var[idx] not in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5]) < 0
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') < 0')
											}
										}
									}
									// условие: var in [array]
									else
									{
										// var in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5])
										let reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) !== -1')
										}
										else
										{
											// var[idx] in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5])
											reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') !== -1')
											}
										}
									}
								}
								// type[period] == 0    =>    type__period__ == 0
								else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__')
								_expressions[field['_field_name']] = _expr
							}
						}
					})
				}
			})

			// теперь бежим по всем полученным выражениям
			for (let e in _expressions)
			{
				// подменяем поля на свойства объекта
				let _exp = _expressions[e]
				for (let v in _values)
				{
					let reg = new RegExp('\\b' + v + '\\b', 'gi')
					_exp = _exp.replace(reg, (str, offset, src) => {
						// если в начале строки - это точно поле
						if (offset <= 0) return 'obj.' + v
						// если не в начале, и сразу перед ним стоит кавычка - это точно не поле
						else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v
						// по умолчанию это все таки поле
						return 'obj.' + v
					})
				}

				// формируем функцию
				// eslint-disable-next-line
				let _func = new Function('obj', ' return ' + _exp)

				// ищем поле
				let _field = this.findScheduleField(e)
				if (_field)
				{
					// обнулим ошибку в любом случае
					this.$set(_field, '_errMsg', '')
					// установим видимость поля
					this.$set(_field, '_visible', _func(_values))
				}
			}
		},
		// локальная проверка полей
		localScheduleValidation(field) {
			// проверяем только определенные типы
			// если поле невидно - то и проверять нет смысла, передаваться будет как есть
			if (!field['_visible']) return true
			// если значение поля не задано - то и проверять нет смысла, передаваться будет как есть
			if (field['value'] === undefined || field['value'] === null) return true

			// INTEGRE
			if (field.type === 'integer' || field.type === 'int')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в INT
				let r = parseInt(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_int'
					return false
				}

				// если значение не изменилось
				if (v === String(r)) return true
				// значение изменилось
				field['_errMsg'] = 'validators/error_int'
				return false
			}

			// FLOAT || MONEY
			if (field.type === 'float' || field.type === 'money')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в FLOAT
				let r = parseFloat(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_float'
					return false
				}

				// доп.проверка
				if (!Helper.isNumeric(String(r)))
				{
					// значение не число
					field['_errMsg'] = 'validators/error_float'
					return false
				}
			}

			// EMAIL
			if (field.type === 'email')
			{
				if (Helper.validateEmail(field.value)) return true
				// проверка не пройдена
				field['_errMsg'] = 'validators/error_email'
				return false
			}

			// для остальных типов все ОК
			return true
		},
		scheduleOuterDiskUpdate(data) {
			this.scheduleOuterDisk(data)
		},
		scheduleOuterDisk(data) {
			// проверка данных
			if (!data || !data.service_id || !data.service_data) return

			this.backupScheduleId = data.service_id
			this.backupScheduleMode = data.service_data && data.service_data.has_schedule === true
				? 'update'
				: 'create'

			// запускаем показ диалога
			if (this.backupScheduleMode === 'create')
				this.createBackupSchedule()
			else
				this.updateBackupSchedule()
		},
		// создание нового
		createBackupSchedule() {
			if (!this.backupScheduleId) return
			if (!this.isAccess('backupschedule/create')) return

			// всегда запрашиваем свежую форму
			this.backupScheduleForm = null
			let _url = this.APIServerUrl + '/backupschedule/create/' + this.backupScheduleId

			this.$http.get(_url)
			.then(
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'form')
					{
						this.backupScheduleForm = this.parseFormData(_dt)
						this.$nextTick(() => {
							this.showIfForSchedule()
						})

						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showBackupScheduleModal = true
					}
				},
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// редактирование расписания
		updateBackupSchedule() {
			if (!this.backupScheduleId) return
			if (!this.isAccess('backupschedule/update')) return

			// всегда запрашиваем свежую форму
			this.backupScheduleForm = null
			let _url = this.APIServerUrl + '/backupschedule/update/' + this.backupScheduleId

			this.$http.get(_url)
			.then(
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'form')
					{
						this.backupScheduleForm = this.parseFormData(_dt)
						this.$nextTick(() => {
							this.showIfForSchedule()
						})
						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showBackupScheduleModal = true
					}
				},
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// начало процесса
		createBackupScheduleBegin() {
			// проверка кнопки
			if (this.createScheduleEmpty) return

			// обнулим ошибку
			this.localErrorMessage = ''

			// проверки
			if (!this.backupScheduleId)
			{
				this.localErrorMessage = 'error/app_internal'
				this.hideBackupScheduleModal()
				return
			}

			// проверка прав доступа
			let _access = true
			if (this.backupScheduleMode === 'create')
				_access = this.isAccess('backupschedule/create')
			else
				_access = this.isAccess('backupschedule/update')

			// если доступа нет
			if (!_access)
			{
				this.localErrorMessage = 'main/access_denied'
				this.hideBackupScheduleModal()
				return
			}

			// бежим по всем полям
			let _rows = this.backupScheduleForm['fields']

			// если полей нет
			if (!_rows || !Array.isArray(_rows))
			{
				this.localErrorMessage = 'error/app_internal'
				this.hideBackupScheduleModal()
				return
			}

			let _data = this.collectFormData(_rows, this.localScheduleValidation)
			// если данные по каким либо причинам собрать не удалось
			if (_data === false) return

			// можем закрыть диалог
			this.hideBackupScheduleModal()

			// данные собраны - отправляем их
			let _url = '/backupschedule/' + this.backupScheduleMode + '/' + this.backupScheduleId
			this.$http.get(this.APIServerUrl + _url)
			.then(resGet => {
				// получаем ответ
				let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
				// если ответ корректный
				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model'])
					return { csrf: _dt['_csrf'], model: _dt['model'] }

				throw new Error(_dt)
			})
			.then(getDate => {
				_data = this.FormDataRePack(_data)

				// готовим данные
				let _post = {
					'_csrf': getDate.csrf
				}
				_post[getDate.model] = _data

				// готовим данные в виде FormData
				this.FD = new FormData()
				this.FD_count = 0
				this.FD_prepare(_post)

				// производим сам запрос
				this.$http.post(this.APIServerUrl + _url, this.FD_count > 0 ? this.FD : null).then(
					// успешный ответ сервера
					resPost => {
						// данные
						let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
						// если ошибки нет
						if (_dt && _dt['status'] === 'ok')
						{
							// установим успешное сообщение
							this.setLocalSuccessMessage(this.backupScheduleMode === 'create' ? 'schedule/created' : 'schedule/updated')
							// обновляем список
							this.requestListData()
							// на этом все
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resPost)
					},
					// отрицательный ответ сервера
					resPost => {
						this.localErrorMessage = this.formatRequestError(resPost)
					}
				)
			})
			.catch(error => {
				this.localErrorMessage = this.formatRequestError(error)
			})
		},
		//---------------------------------------------------------------------
		// диалог восстановление бэкапа во внешний диск
		//---------------------------------------------------------------------
		hideRestoreBackupOuterDiskDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showRestoreBackupOuterDiskDialog = false
			this.hideModalMask()
		},
		// восстановление из бэкап Внешнего диска из меню операций (вызов диалога)
		async restoreBackupOuterDisk(data) {
			this.restoreBackupOuterDiskData = null
			this.restoreBackupOuterDiskWarning = ''
			this.restoreBackupOuterDiskNotice = ''

			if (!data) return
			if (!this.isAccess('service/create')) return

			// получим ID Записи
			let _id = data[this.listConfig['column_id']]
			if (!_id) return

			// проверка статуса
			if (data['service_status'] !== 'active' || data['service_status_text']) return

			// запросим список бэкапов для данного диска
			let _url = this.APIServerUrl + '/service/update/' + _id + '?search=backup'
			let resGet = null
			try {
				resGet = await this.$http.get(_url)
			}
			catch (err) {
				// ошибка сервера
				this.localErrorMessage = this.formatRequestError(err)
				return
			}

			// получаем ответ
			let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
			// если ответ корректный
			if (_dt && _dt['status'] === 'ok' && _dt['result'] && _dt['result'].length)
			{
				this.$set(this.restoreBackupOuterDiskField, 'list', _dt['result'].map(el => {
					return {
						id: el.id,
						name: el.name,
						active: el.active,
						enable: el.enable
					}
				}))

				// устанавливаем первое значение из списка со всеми включенными флагами
				_dt['result'].some(el => {
					if (el && el['id'] && el['active'] === true && el['enable'] === true) {
						const _newValue = {
							id: el['id'],
							name: el['name'],
							active: true,
							enable: true
						}

						this.$set(this.restoreBackupOuterDiskField, 'listValue', _newValue)
						this.$set(this, 'restoreBackupOuterDiskValue', el['id'])
						this.restoreBackupOuterDiskWarning = this.localeFtc('service/extdisk_restore_warning')

						this.$nextTick(() => {
							EventBus.$emit('w5-set-list-field-value', {
								name: 'backup_id_for_outer_disk',
								value: _newValue
							})
						})
						return true
					}
				})
			}

			// данные
			this.restoreBackupOuterDiskData = data

			// если диск подключен - предупреждение
			if (data && data.service_data && data.service_data.extdisk && data.service_data.extdisk.attached === true)
			{
				if (this.restoreBackupOuterDiskWarning) this.restoreBackupOuterDiskWarning += '<br><br>' + this.localeFtc('service/reboot_warning')
				else this.restoreBackupOuterDiskWarning = this.localeFtc('service/reboot_warning')
			}

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showRestoreBackupOuterDiskDialog = true
		},
		restoreBackupOuterDiskStart() {
			// проверки
			if (!this.restoreBackupOuterDiskData || !this.restoreBackupOuterDiskData.service_id) return
			if (!this.isAccess('service/update')) return

			if (!this.restoreBackupOuterDiskValue)
			{
				this.restoreBackupOuterDiskField._errMsg = 'error/required_field'
				return
			}

			let _isSmall = false
			this.restoreBackupOuterDiskField.list.some(item => {
				if (String(item.id) === String(this.restoreBackupOuterDiskValue))
				{
					if (!item.active || !item.enable)
					{
						_isSmall = true
					}

					return true
				}
			})

			if (_isSmall) return

			// можно закрывать диалог
			this.hideRestoreBackupOuterDiskDialog()

			// обнулим сообщения
			this.localErrorMessage = ''

			let _url = this.APIServerUrl +
				'/service/update/' +
				this.restoreBackupOuterDiskData.service_id +
				'?additional=setRestore&service_id=' +
				this.restoreBackupOuterDiskValue

			// начинаем запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false

					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['status'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.setLocalSuccessMessage('service/restore_queued')
									// обновляем список
									this.requestListData()
									// на этом все
									return
								}
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		restoreBackupOuterDiskFieldChanged(value) {
			if (!value ||
				!this.restoreBackupOuterDiskField.list ||
				!this.restoreBackupOuterDiskField.list.length)
				return

			this.restoreBackupOuterDiskField.list.some(item => {
				if (String(item.id) === String(value))
				{
					this.restoreBackupOuterDiskWarning = this.localeFtc('service/extdisk_restore_warning')

					if (!item.active || !item.enable)
					{
						this.restoreBackupOuterDiskWarning = this.localeFtc('service/backup_error')
						return true
					}

					const data = this.restoreBackupOuterDiskData
					// если диск подключен - предупреждение
					if (data && data.service_data && data.service_data.extdisk && data.service_data.extdisk.attached === true)
					{
						if (this.restoreBackupOuterDiskWarning) this.restoreBackupOuterDiskWarning += '<br><br>' + this.localeFtc('service/reboot_warning')
						else this.restoreBackupOuterDiskWarning = this.localeFtc('service/reboot_warning')
					}

					return true
				}
			})
		},
		//---------------------------------------------------------------------
		// диалог переименования бэкапа
		//---------------------------------------------------------------------
		// закрыть диалог
		hideRenameBackupDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showRenameBackupDialog = false
			this.hideModalMask()
		},
		// enter на поле
		renameBackupKeyDown(e) {
			if (e) e.preventDefault()
			this.renameBackupStart()
		},
		// переименование бэкапа - показ диалога
		renameBackup(data) {
			// проверка входных параметров
			if (!data) return

			// получим ID Записи
			let _id = data[this.listConfig['column_id']]
			if (!_id) return

			// проверка
			if (data['service_status'] !== 'active' || data['service_status_text']) return

			// данные
			this.renameBackupId = _id
			this.renameBackupValue = data['service_name']

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showRenameBackupDialog = true
		},
		// начать процесс бэкапа/восстановления
		renameBackupStart() {
			// проверки
			if (!this.renameBackupId) return
			if (!this.isAccess('service/update')) return

			if (!this.renameBackupValue)
			{
				this.renameBackupField._errMsg = 'error/required_field'
				return
			}

			// можно закрывать диалог
			this.hideRenameBackupDialog()

			// обнулим сообщения
			this.localErrorMessage = ''

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.renameBackupId

			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false

					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'name': this.renameBackupValue
						}

						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.setLocalSuccessMessage('forget/success')
									// обновляем список
									this.requestListData(true)
									// на этом все
									return
								}
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// переход в форму создания VDS с определенного бэкапа
		createFromBackup(data) {
			// проверка
			if (!window || !window.sessionStorage || !data || !data.service_id) return
			// формируем данные
			let _store = {
				service_id: data.service_id
			}
			if (data.account_id)
				_store.account_id = data.account_id
			// сохраним в сессии
			window.sessionStorage.setItem('create-vds-from-backup', JSON.stringify(_store))
			// переход в форму создания
			this.$router.push('/vds/create')
		},
		//---------------------------------------------------------------------
		// переход в форму создания Outer Disk с определенного бэкапа
		//---------------------------------------------------------------------
		createFromBackupOuterDisk(data) {
			// проверка
			if (!window || !window.sessionStorage || !data || !data.service_id) return
			// формируем данные
			let _store = {
				service_id: data.service_id
			}
			if (data.account_id)
				_store.account_id = data.account_id
			// сохраним в сессии
			window.sessionStorage.setItem('create-outer-disk-from-backup', JSON.stringify(_store))
			// переход в форму создания
			this.$router.push('/disks/create')
		},
		//---------------------------------------------------------------------
		// открытие вкладки с отчетом по аккаунту
		//---------------------------------------------------------------------
		accountReport(data) {
			// проверка данных
			if (!data || !data.account_id || !data.w) return
			if (!this.isAccess('account/report')) return

			// обнулим сообщения
			this.localErrorMessage = ''

			// все в порядке - формируем URL
			let _url = `${this.APIServerUrl}/account/report/${data.account_id}`

			data.w.location.href = _url
			data.w.focus()

			/*
			// начинаем запрос
			this.$http.get(_url)
			.then(
				// положительный ответ
				rez => {
					if (rez && rez.status === 200 && rez.body && rez.body.length)
					{
						// открываем отчет в новом окошке
						data.w.document.open()
						data.w.document.write(rez.body)
						data.w.document.close()
						data.w.focus()

						return
					}

					// иная ошибка
					this.localErrorMessage = this.formatRequestError(rez)
				},
				// отрицательный ответ
				rez => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(rez)
				}
			)
			*/
		},
		//---------------------------------------------------------------------
		// переход в форму создания тикета для определенного аккаунта
		//---------------------------------------------------------------------
		clientTicket(data) {
			// проверка
			if (!window || !window.sessionStorage) return

			// получим аккаунт
			let _acc = null
			if (data && data.account_id)
				_acc = data.account_id
			else
			{
				// может установлен глобальный фильтр?
				if (this.accountGlobalFilter && this.accountGlobalFilter.text)
				{
					let _numStr = String(this.accountGlobalFilter.text).replace(/\D/g, '')
					let _num = parseInt(_numStr)
					if (!isNaN(_num))
						_acc = _num
				}
			}

			// если так и не получили аккаунт
			if (!_acc) return

			// формируем данные
			let _store = {
				account_id: _acc
			}

			// сохраним в сессии
			window.sessionStorage.setItem('create-ticket-for-account', JSON.stringify(_store))

			// переход в форму создания
			this.$router.push('/ticket/create')
		},
		//---------------------------------------------------------------------
		// отключеие фильтра
		//---------------------------------------------------------------------
		removeFilter(row) {
			// если мы в процессе изменения - ничего не делаем
			if (this.removeFilterProcess) return

			// проверка параметра
			if (!row || !row['service_id']) return

			// если статус не тот
			if (row['service_status'] !== 'active' || row['service_status_text']) return

			// если нет прав
			if (!this.isAccess('service/update')) return

			// получим ID услуги
			let _serviceID = parseInt(row['service_id'])
			if (isNaN(_serviceID) || _serviceID <= 0) return
			this.removeFilterID = _serviceID

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showRemoveFilterModal = true
		},
		//---------------------------------------------------------------------
		// отключение фильтра - сам запрос
		//---------------------------------------------------------------------
		removeFilterProcessStart(data) {
			// если мы в процессе изменения - ничего не делаем
			if (this.removeFilterProcess) return

			// если не выбран ID услуги
			if (!this.removeFilterID) return

			// если не выбрано значение
			if (!this.removeFilterValue) return

			// если нет прав
			if (!this.isAccess('service/update')) return

			// закрываем диалог
			this.hideRemoveFilterModal()

			// ставим флаг начала процесса
			this.removeFilterProcess = true

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.removeFilterID + '?additional=setRemoveFilter&filter=' + this.removeFilterValue
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг
								this.removeFilterProcess = false
								// проверяем ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// на этом все
									return
								}

								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// обнулим флаг
								this.removeFilterProcess = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// обнулим флаг
					this.removeFilterProcess = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// обнулим флаг
					this.removeFilterProcess = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// функция редиректа
		//---------------------------------------------------------------------
		redirectUrl(row, url, idField) {
			if (!row || !url) return
			let _url = url
			if (idField && row[idField])
				_url += '/' + String(row[idField])

			if (!this.isAccess(url)) return

			this.$router.push(_url)
		},
		//---------------------------------------------------------------------
		// диалог графического представления стойки
		//---------------------------------------------------------------------
		// показ
		showRackGraphic(row) {
			if (!row || !row.rack_id) return

			this.rackGraphicModalData = row
			EventBus.$emit('w5-body-scroll-disable')
			this.showRackGraphicModal = true
		},
		// закрытие
		hideRackGraphicModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showRackGraphicModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// Многоходовое клонирование VDS
		//
		// процесс делится на следующие шаги:
		// 1. получим основные параметры процесса
		// 2. создаем бэкап VDS
		// 3. если требуется - переносим его в другой ДЦ
		// 4. создаем из этого бэкапа новый VDS
		// 5. если требуется - удаляем бэкап
		//---------------------------------------------------------------------
		// ищем процесс по ID VDS
		vdsCloneFindProcessById(id) {
			if (!this.vdsCloneProcessData || !this.vdsCloneProcessData.length)
			{
				return null
			}

			let _answer = null
			this.vdsCloneProcessData.some((p, i) => {
				if (p && String(p.id) === String(id))
				{
					_answer = {
						data: p,
						index: i
					}
					return true
				}
			})

			return _answer
		},
		// удаление процесса из спика
		deleteVdsCloneProcess(id) {
			let _result = this.vdsCloneFindProcessById(id)
			if (!_result || !_result.data) return

			// сразу даем команду убрать задачу
			EventBus.$emit('w5-cron-task-start', {
				id,
				task: 'remove-task'
			})

			let _idx = _result.index
			let _key = 'vds_clone_process_' + id

			// удаляем из массива
			this.vdsCloneProcessData.splice(_idx, 1)
			// удаляем из localStorage
			window.localStorage.removeItem(_key)

			// в любом случае закрываем диалог
			this.hideVdsCloneProcessInfoModal()
			this.vdsCloneShowProcessDataInfo = null
		},
		// показать диалог с конкретным процессом
		vdsCloneShowProcessData(id) {
			// ищем процесс в списке
			let _result = this.vdsCloneFindProcessById(id)
			if (!_result || !_result.data) return
			this.vdsCloneShowProcessDataInfo = _result.data

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.vdsCloneShowProcessDataValue = true
		},
		//---------------------------------------------------------------------
		// Многоходовое клонирование VDS
		//
		// функция сохраняет данные процесса в localStorage
		//---------------------------------------------------------------------
		vdsCloneProcessDataSave(data) {
			if (!data || !data.id) return

			if (window.localStorage)
			{
				let _key = 'vds_clone_process_' + data.id

				try {
					// все храним в виде строки
					let _str = JSON.stringify(data)
					// записываем
					window.localStorage.setItem(_key, _str)
				}
				catch (_err) {}
			}

			let _find = -1
			if (this.vdsCloneProcessData && this.vdsCloneProcessData.length)
			{
				this.vdsCloneProcessData.some((p, i) => {
					if (p && p.id === data.id)
					{
						_find = i
						return true
					}
				})
			}

			if (_find < 0)
			{
				this.vdsCloneProcessData.push(data)
			}
			else
			{
				this.$set(this.vdsCloneProcessData, _find, data)
			}
		},
		//---------------------------------------------------------------------
		// Многоходовое клонирование VDS
		//
		// функция получает данные процесса из localStorage
		//---------------------------------------------------------------------
		vdsCloneProcessDataGet() {
			this.vdsCloneProcessData = []

			let _keys = Object.keys(window.localStorage)
			for (let i = 0; i < _keys.length; i++)
			{
				let _key = _keys[i]

				if (!_key || !_key.length || _key.indexOf('vds_clone_process_') !== 0)
				{
					continue
				}

				try {
					const _str = window.localStorage.getItem(_key)
					const _obj = JSON.parse(_str)
					if (_obj && _obj.id)
					{
						// ищем в списке - может уже есть
						let _found = false
						if (this.vdsCloneProcessData && this.vdsCloneProcessData.length)
						{
							this.vdsCloneProcessData.some(p => {
								if (p && String(p.id) === String(_obj.id))
								{
									_found = true
									return true
								}
							})
						}

						if (!_found)
						{
							this.vdsCloneProcessData.push(_obj)

							// сразу передаем задание планировщику
							if (!_obj.error && !_obj.finish)
							{
								EventBus.$emit('w5-cron-task-start', _obj)
							}
						}
					}
				}
				catch (e) {}
			}
		},
		//---------------------------------------------------------------------
		// Многоходовое клонирование VDS
		//
		// 1. шаг - основные параметры
		// - удалять/оставлять после процесса бэкап
		// - в каком ДЦ создать VDS
		//---------------------------------------------------------------------
		async vdsClone(row) {
			// проверка параметра
			if (!row || !row['service_id']) return

			// если статус не тот
			if (row['service_status'] !== 'active' ||
				row['service_status_text'] ||
				!row['service_name'])
			{
				return
			}

			// если архивный тариф
			if (row['service_data'] && row['service_data']['plan'])
			{
				if (String(row['service_data']['plan']['status']) !== 'active') return
				if (String(row['service_data']['plan']['name']).toLowerCase().indexOf('архивный') > -1) return
			}

			// если нет прав
			if (!this.isAccess('service/copy')) return

			// получим ID услуги
			let _serviceID = parseInt(row['service_id'])
			if (isNaN(_serviceID) || _serviceID <= 0) return
			this.vdsCloneID = _serviceID
			this.vdsCloneName = row['service_name']

			// если по нему уже есть процесс
			let _process = this.vdsCloneFindProcessById(_serviceID)
			if (_process && _process.data)
			{
				this.localErrorMessage = 'service/already_queued'
				return
			}

			// если тариф архивный
			if (row['service_data'] && row['service_data']['plan'] && row['service_data']['plan']['plan_status'] === 'deleted')
			{
				this.localErrorMessage = 'plan/archive_title'
				return
			}

			// получим тарифный план VDS
			let _plandId = null
			if (row['service_data'] && row['service_data']['plan'] && row['service_data']['plan']['id'])
			{
				_plandId = row['service_data']['plan']['id']
			}

			// параметры плана
			let _planParams = null
			if (row['service_data'] && row['service_data']['plan'] && row['service_data']['plan']['data'] &&
				row['service_data']['plan']['data']['cpu'] &&
				row['service_data']['plan']['data']['ram'] &&
				row['service_data']['plan']['data']['disk'])
			{
				_planParams = {
					cpu: 'total' in row['service_data']['plan']['data']['cpu']
						? row['service_data']['plan']['data']['cpu']['total']
						: row['service_data']['plan']['data']['cpu']['value'],

					ram: 'total' in row['service_data']['plan']['data']['ram']
						? row['service_data']['plan']['data']['ram']['total']
						: row['service_data']['plan']['data']['ram']['value'],

					disk: 'total' in row['service_data']['plan']['data']['disk']
						? row['service_data']['plan']['data']['disk']['total']
						: row['service_data']['plan']['data']['disk']['value'],

					ip4: 0
				}
			}

			// IP адрес в параметрах тарифа
			if (_planParams && row['service_data'] && row['service_data']['ip'] && row['service_data']['ip']['type'] === '4')
			{
				_planParams['ip4'] = 1
			}

			// группу тарифного плана
			let _planGroupId = null
			if (row['service_data'] && row['service_data']['plangroup'] && row['service_data']['plangroup']['id'])
			{
				_planGroupId = row['service_data']['plangroup']['id']
			}

			// аккаунт
			let _accountID = null
			if (row['account_id'])
			{
				_accountID = row['account_id']
			}

			// запрос лимитов по аккаунту
			if (_accountID || this.$store.state.user_account) {
				// нужен чистый аккаунт
				let _acc = String(_accountID || this.$store.state.user_account).replace(/[a-z]/ig, '')
				// запрос лимитов
				let _rez = await this.$http.get(this.APIServerUrl + `/account/view${this.$store.state.user_type === 'client' ? '' : '/' + _acc}`)
				// можно проверять лимиты
				if (_acc && _rez && _rez.data && _rez.data.limits && _rez.data.limits.servicetype) {
					// сохраним аккаунт
					_accountID = _acc
					// данные
					const _data = _rez.data.limits.servicetype
					// лимиты
					const _limitVds = _data[`limit_max_count[${Vue.Constants.SERVICE_TYPE_VDS}]`]
					const _limitBck = _data[`limit_max_count[${Vue.Constants.SERVICE_TYPE_BACKUP_VDS}]`]
					// текущие значения
					const _valueVds = _data[`ordered[${Vue.Constants.SERVICE_TYPE_VDS}]`]
					const _valueBck = _data[`ordered[${Vue.Constants.SERVICE_TYPE_BACKUP_VDS}]`]

					// лимит по количеству ВДС
					if (_limitVds && 'value' in _limitVds && _valueVds && 'value' in _valueVds) {
						const _l = parseInt(_limitVds.value, 10)
						const _v = parseInt(_valueVds.value, 10)

						if (!isNaN(_v) && !isNaN(_l) && _v >= _l) {
							this.localErrorMessage = this.localeFtc('service/limit_is_exceeded').replace('{service}', 'server/title')
							return
						}
					}

					// лимит по количеству Резервных копий
					if (_limitBck && 'value' in _limitBck && _valueBck && 'value' in _valueBck) {
						const _l = parseInt(_limitBck.value, 10)
						const _v = parseInt(_valueBck.value, 10)

						if (!isNaN(_v) && !isNaN(_l) && _v >= _l) {
							this.localErrorMessage = this.localeFtc('service/limit_is_exceeded').replace('{service}', 'service/backups')
							return
						}
					}
				}
			}

			// текущий ДЦ
			let _datacenterId = null
			if (row['service_data'] && row['service_data']['datacenter'] && row['service_data']['datacenter']['id'])
			{
				_datacenterId = row['service_data']['datacenter']['id']
			}

			// без этих данных - дальше не получится
			if (!_plandId || !_planGroupId || !_datacenterId || !_accountID) return

			// это самый первый шаг - обнуляем все данные
			this.localErrorMessage = ''

			// запоминаем старые данные
			this.$set(this.vdsCloneModalFieldList, '__oldAccValue', _accountID)
			this.$set(this.vdsCloneModalFieldList, '__oldDcValue', _datacenterId)
			this.$set(this.vdsCloneModalFieldList, '__oldPlgrpValue', _planGroupId)
			this.$set(this.vdsCloneModalFieldList, '__oldPlValue', _plandId)
			this.$set(this.vdsCloneModalFieldList, '__oldPlPrmsValue', _planParams)

			// запросим список доступных ДЦ
			this.$http.get(this.APIServerUrl + '/service/create?search=plan_datacenter&plan_id=' + _plandId)
			// положительный ответ
			.then(resGet => {
				// получаем ответ
				let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
				// если ответ корректный
				if (_dt && _dt.result && Array.isArray(_dt.result) && _dt.result.length)
				{
					// формируем список ДЦ
					const _dcList = _dt.result
						.filter(dc => dc && dc.active)
						.map(dc => ({
							id: dc.id,
							name: this.localeFtc(dc.name),
							country: dc.country
						}))

					this.$set(this.vdsCloneModalFieldList, 'list', _dcList)

					if (!_dcList.length) {
						this.localErrorMessage = 'main/vds_clone_no_active_datacenters'
						return
					}

					// установим значение в соответствующем поле
					_dcList.some(dc => {
						if (dc && String(dc.id) === String(_datacenterId))
						{
							this.$set(this.vdsCloneModalFieldList, 'value', _datacenterId)
							this.$set(this, 'vdsCloneModalFieldListValue', Object.assign({}, dc))
							return true
						}
					})

					// показываем диалог
					EventBus.$emit('w5-body-scroll-disable')
					this.showVdsCloneModal = true

					// на этом все
					return
				}

				// ошибка
				this.localErrorMessage = this.formatRequestError(resGet)
			})
			// отрицательный ответ
			.catch(res => {
				// ошибка
				this.localErrorMessage = this.formatRequestError(res)
			})
		},
		//---------------------------------------------------------------------
		// Многоходовое клонирование VDS
		//
		// 2. шаг - создание бэкапа VDS
		// если запрос принят - формирование данных о текущем процессе
		// иначе - вывод об ошибке
		//---------------------------------------------------------------------
		async vdsCloneProcessStep2() {
			// чистим сообщение об ошибке
			this.localErrorMessage = ''

			// скроем диалог
			this.hideVdsCloneModal()

			// основные проверки
			if (!this.vdsCloneID)
			{
				this.localErrorMessage = this.localeFtc('server/choice')
				return
			}

			// формируем задачу клонирования vds
			const _obj = {
				id: this.vdsCloneID,
				nm: this.vdsCloneName,
				hl: this.vdsCloneModalFieldBooleanValue,
				dc: this.vdsCloneModalFieldList.__oldDcValue,
				plgrp: this.vdsCloneModalFieldList.__oldPlgrpValue,
				pl: this.vdsCloneModalFieldList.__oldPlValue,
				plPrms: this.vdsCloneModalFieldList.__oldPlPrmsValue,
				acc: this.vdsCloneModalFieldList.__oldAccValue
			}
			const _dcValue = this.vdsCloneModalFieldListValue && this.vdsCloneModalFieldListValue.id
				? this.vdsCloneModalFieldListValue.id
				: this.vdsCloneModalFieldListValue
			if (String(this.vdsCloneModalFieldList.__oldDcValue) !== String(_dcValue))
			{
				_obj.dcToMove = _dcValue
			}

			const _cronTask = {
				id: _obj.id,
				task: 'clone-vds',
				apiUrl: this.APIServerUrl,
				step: 'service/creating_backup',
				status: 'request/type_unblock',
				params: _obj
			}

			// нужно получить параметра тарифного плана
			let _url = this.APIServerUrl + '/service/create/' + Vue.Constants.SERVICE_TYPE_VDS
			let resGet = null
			try {
				resGet = await this.$http.get(_url + '?search=plan&plan_group_id=' + _obj.plgrp)
			}
			catch (err) {
				// ошибка сервера
				this.localErrorMessage = this.formatRequestError(err)
				return
			}

			// получаем ответ
			let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
			// если ответ корректный
			if (_dt && _dt['status'] === 'ok' && _dt['result'] && _dt['result'].length)
			{
				// ищем в списке тарифный план
				let _plan = _dt['result'].find(item => {
					if (item && String(item.id) === String(_obj.pl))
					{
						return true
					}
				})

				// если нашли и это конструктор
				if (_plan && _plan.has_params)
				{
					// формируем параметры тарифного плана в точности такие же как у исходного vds
					_obj.vdsPlanParams = true
				}
			}

			// сохраним задачу
			this.vdsCloneProcessDataSave(_cronTask)
			// передадим планировщику
			EventBus.$emit('w5-cron-task-start', _cronTask)
		},
		//---------------------------------------------------------------------
		//
		// копирование бэкапа в другой ДЦ
		//
		//---------------------------------------------------------------------
		copyToDc(row) {
			// проверка параметра
			if (!row || !row['service_id']) return

			// если статус не тот
			if (row['service_status'] !== 'active' || row['service_status_text']) return

			// если нет прав
			if (!this.isAccess('service/copy')) return

			// получим ID услуги
			let _serviceID = parseInt(row['service_id'])
			if (isNaN(_serviceID) || _serviceID <= 0) return
			this.copyToDcID = _serviceID

			this.copyToDcForm = null
			this.copyToDcFields = null
			this.copyToDcCostInfo = ''
			this.localErrorMessage = ''
			this.copyToDcErrorMessage = ''

			// запросим форму
			this.$http.get(this.APIServerUrl + '/service/copy/' + this.copyToDcID)
			// положительный ответ
			.then(resGet => {
				// получаем ответ
				let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
				// если ответ корректный
				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['fields'] && _dt['info'])
				{
					// запоминаем форму
					this.copyToDcForm = _dt
					// поля
					this.copyToDcFields = this.parseFormData(_dt)
					// стоимость
					if (this.copyToDcForm['info']['cost'] > 0)
					{
						this.copyToDcCostInfo = this.localeFtc('service/creating_backup_cost <b>main/ruble</b> / <b>{period}</b> / <b>{size}</b>')
							.replace('{cost}', this.copyToDcForm['info']['cost'])
							.replace('{period}', this.localeFtc(this.copyToDcForm['info']['period']))
							.replace('{size}', this.localeFtc(this.copyToDcForm['info']['for']))
					}
					// показываем диалог
					EventBus.$emit('w5-body-scroll-disable')
					this.showCopyToDcModal = true
					// на этом все
					return
				}

				// ошибка
				this.localErrorMessage = this.formatRequestError(resGet)
			})
			// отрицательный ответ
			.catch(res => {
				// ошибка
				this.localErrorMessage = this.formatRequestError(res)
			})
		},
		//---------------------------------------------------------------------
		// копирование бэкапа - сам запрос
		//---------------------------------------------------------------------
		copyToDcProcessStart(data) {
			this.copyToDcErrorMessage = ''

			// если не выбран ID услуги
			if (!this.copyToDcID) return

			// если нет полей
			if (!this.copyToDcFields ||
				!this.copyToDcFields.fields ||
				!this.copyToDcFields.fields.length)
			{
				return
			}

			// если нет прав
			if (!this.isAccess('service/copy')) return

			// собираем данные
			let _data = this.collectFormData(this.copyToDcFields.fields)
			if (!_data) return

			// переупакуем данные: NameForm[data[disk]] => NameForm[data][disk]
			_data = this.FD_rePack(_data)

			// готовим данные
			let _post = {
				'_csrf': this.copyToDcForm['_csrf']
			}
			_post[this.copyToDcForm['model']] = _data

			// готовим данные в виде FormData
			this.FD = new FormData()
			this.FD_count = 0
			this.FD_prepare(_post)

			// производим сам запрос
			this.$http.post(this.APIServerUrl + '/service/copy/' + this.copyToDcID, this.FD_count > 0 ? this.FD : null)
			// успешный ответ сервера
			.then(resPost => {
				// данные
				let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
				// если ошибки нет
				if (_dt && _dt['status'] === 'ok' && _dt['service'] && _dt['service']['service_id'])
				{
					// закрываем диалог
					this.hideCopyToDcModal()

					// запрашиваем данные заново
					this.requestListData()
					return
				}

				throw _dt
			})
			// отрицательный ответ сервера
			.catch(resPost => {
				let msg = 'error/api_incorrect'

				if (resPost && resPost.status === 'error' && resPost.title)
					msg = resPost.title

				if (resPost &&
					resPost.status === 'error' &&
					resPost.fields &&
					typeof resPost.fields === 'object' &&
					Object.keys(resPost.fields).length)
				{
					msg = ''
					for (let prop in resPost.fields) if (resPost.fields.hasOwnProperty(prop))
					{
						// получим поле
						let _errField = resPost.fields[prop]
						// проверим - могут быть пустые ошибки
						if (_errField)
						{
							// получим саму ошибку
							let _txt = ''
							if (Array.isArray(_errField) && _errField.length) _txt = _errField[0]
							else if (typeof _errField === 'object') _txt = 'error/unknown'
							else _txt = String(_errField)

							// ищем поле в форме
							let _formField = this.findFormField(prop, this.copyToDcFields.fields)
							// 	если нашли
							if (_formField)
							{
								_formField['_errMsg'] = _txt
							}
							else
							{
								if (msg) msg += '<br> ' + _txt
								else msg = _txt
							}
						}
					}
				}

				this.copyToDcErrorMessage = msg
			})
		},
		//---------------------------------------------------------------------
		// генерация ссылки на скачивания бэкапа
		//---------------------------------------------------------------------
		downloadBackup(row) {
			this.localErrorMessage = ''

			// проверка параметра
			if (!row || !row['service_id']) return

			// если статус не тот
			if (row['service_status'] !== 'active' || row['service_status_text']) return

			// если нет прав
			if (!this.isAccess('service/update')) return

			// получим ID услуги
			let _serviceID = parseInt(row['service_id'])
			if (isNaN(_serviceID) || _serviceID <= 0) return
			this.downloadBackupID = _serviceID

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDownloadBackupModal = true
		},
		//---------------------------------------------------------------------
		// копирование бэкапа - сам запрос
		//---------------------------------------------------------------------
		downloadBackupProcessStart() {
			this.localErrorMessage = ''

			// если не выбран ID услуги
			if (!this.downloadBackupID) return

			// если нет прав
			if (!this.isAccess('service/update')) return

			// закроем диалог
			this.hideDownloadBackupModal()

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.downloadBackupID + '?additional=setDownload'

			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								// получим ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// на это все, никаких рефрешей не нужно,
									// ибо придет пуш, и по нему система сама все обновит
									// а пока просто сообщим
									this.setLocalSuccessMessage('service/download_queued')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// видимость строки в форме в диалоге
		//---------------------------------------------------------------------
		isVisibleField(row) {
			// проверка данных
			if (!row || !Array.isArray(row) || !row.length) return false
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden')
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// нажали ENTER на поле формы в диалоге
		//---------------------------------------------------------------------
		onEnterKeyDownForm(func) {
			if (func && func in this && typeof this[func] === 'function')
				this[func]()
		},
		//---------------------------------------------------------------------
		// поле формы в диалоге поменяло значение
		//---------------------------------------------------------------------
		onChangedField(field) {

		},
		//---------------------------------------------------------------------
		// уход фокуса с поля формы в диалоге
		//---------------------------------------------------------------------
		onBlurField(field) {
			// проверка значения поля
			this.verifyFormField(field)
		},
		//---------------------------------------------------------------------
		// фокус на поле формы в диалоге
		//---------------------------------------------------------------------
		onFocusField(field) {
			if (field) field['_errMsg'] = ''
		},
		//---------------------------------------------------------------------
		// проверка значения поля формы в диалоге
		//---------------------------------------------------------------------
		verifyFormField(field) {
		},
		//---------------------------------------------------------------------
		// поиск поля по имени в заданном наборе
		//---------------------------------------------------------------------
		findFormField(name, fields) {
			// бежим по всем полям
			let _rows = fields
			if (!_rows || !Array.isArray(_rows)) return null

			// поля есть - пробежимся по ним
			let _field = null
			_rows.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		//---------------------------------------------------------------------
		// сбор данных для формы
		//---------------------------------------------------------------------
		collectFormData(rows) {
			// обнуляем данные
			let data = {}

			// смотрим каждое поле простым циклом - что бы прервать его в любой момент
			for (let idx in rows)
			{
				// если нет значения - пропускаем
				if (!rows[idx] || !Array.isArray(rows[idx])) continue

				// бежим по всей строке формы
				let row = rows[idx]
				for (let k in row)
				{
					// получим объект - поле
					let field = row[k]

					// рассматриваем только поля с наименованиями
					if (!field['_field_name']) continue

					// если есть хотя бы одно видимое поле с ошибкой - прерываем
					if (field['_errMsg'] && field['_visible'])
						return false

					// значение по умолчанию
					let _val = field['value']

					// если это "file" или "image"
					if (field['type'] === 'file' || field['type'] === 'image')
					{
						// если есть метка удаления файла
						if (field['_deleteFile'] === true)
						{
							// добавляем еще параметр
							data[field['_field_name'] + '_delete'] = 1
						}

						// если это одиночное значение
						if (field['multifile'] !== true)
						{
							// если задан URl - значит ничего нового не задавали, не нужно пересылать это
							if (_val && (_val.indexOf('.') > -1 || _val.indexOf('/') > -1)) _val = null
						}
					}

					// если это массив
					if (Array.isArray(field['value']))
					{
						// если это пустой массив
						if (!field['value'].length) _val = null
						else
						{
							// масив имеет значения
							_val = []
							// бежим по нему, для конвертации
							field['value'].forEach(item => {
								// если элемент массива - это объект c id
								if (typeof item === 'object' && item['id'])
								{
									_val.push(item['id'])
								}
								// если простой тип
								else _val.push(item)
							})
						}
					}

					// обязательное поле?
					if (field['required'] === true && field['_visible'])
					{
						// если значение вообще не задано
						if (_val === undefined || _val === null)
						{
							field['_errMsg'] = 'error/required_field'
							return false
						}

						// если это пустой массив
						if (Array.isArray(_val) && _val.length === 0)
						{
							field['_errMsg'] = 'error/required_field'
							return false
						}
					}

					// если пустые поля
					if (_val === undefined || _val === null)
					{
						// если это поле массива - все равно передаем
						if (/^\w+\[\w+\]/i.test(field['_field_name']))
							data[field['_field_name']] = ''
						// остальное игнорируем
						continue
					}

					// конвертация значения
					if (field['type'] === 'boolean')
						_val = Helper.normalizeBooleanValue(_val) ? 1 : 0

					// если это дата с заданным форматом
					if (field['type'] === 'date' && field['format'])
					{
						// требуется преобразование
						_val = String(_val)
						if (/^\d{4}-\d{2}-\d{2}$/.test(_val) || /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_val))
							_val = Helper.FormatDateTime(_val, field['format'])
					}

					// все проверки пройдены - запоминаем значение
					data[field['_field_name']] = _val
				}
			}

			// возвращаем полученный ответ
			return data
		},
		//---------------------------------------------------------------------
		// NameForm[data[disk]] => NameForm[data][disk]
		//---------------------------------------------------------------------
		FD_rePack(data) {
			let k
			let n1
			let n2
			let key1
			let key2

			for (k in data) if (data.hasOwnProperty(k))
			{
				n1 = k.indexOf('[')
				if (n1 < 0) continue

				n2 = k.indexOf(']', n1)
				if (n2 < 0) continue

				key1 = k.substr(0, n1)
				key2 = k.substring(n1 + 1, n2)

				if (n2 + 1 < k.length) key2 += k.substr(n2 + 1)

				if (!data[key1]) data[key1] = {}

				data[key1][key2] = data[k]

				delete data[k]

				data[key1] = this.FD_rePack(data[key1])
			}

			return data
		},
		//---------------------------------------------------------------------
		// конвертация данных в FormData
		//---------------------------------------------------------------------
		FD_prepare(d, key) {
			let k

			for (k in d) if (d.hasOwnProperty(k))
			{
				// если пересылают файл в форме - патч для safari 10+
				if (d[k] && key &&
					k === 'file' &&
					typeof d[k] === 'object' &&
					'name' in d[k] &&
					'size' in d[k] &&
					'type' in d[k])
				{
					this.FD.append(key + '[' + k + ']', d[k])
					this.FD_count++
					continue
				}

				// остальные поля обрабатываем по старому
				if (typeof d[k] === 'object' && d[k] && !('lastModifiedDate' in d[k]))
				{
					if (key)
					{
						this.FD_prepare(d[k], key + '[' + k + ']')
					}
					else
					{
						this.FD_prepare(d[k], k)
					}
				}
				else
				{
					if (key)
					{
						this.FD.append(key + '[' + k + ']', d[k])
					}
					else
					{
						this.FD.append(k, d[k])
					}

					this.FD_count++
				}
			}
		},
		//---------------------------------------------------------------------
		// отслеживает позицию окна
		//---------------------------------------------------------------------
		windowScroll(event) {
			let doc = document.documentElement
			let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
			this.curWindowY = top

			// выравниваем положение диалога пополнения баланса
			if (this.$refs && this.$refs['buttonBalance'] && this.$refs['buttonBalance'][0])
			{
				let _coord = this.getElementOffset(this.$refs['buttonBalance'][0])
				this.balanceContainerStyle = 'left:' + _coord.left + 'px; top:' + (_coord.top + 50 - this.curWindowY) + 'px;'
			}
		},
		//---------------------------------------------------------------------
		// вызывает функцию
		//---------------------------------------------------------------------
		windowResize() {
			if (!document || !document.documentElement) return
			let height = document.documentElement.clientHeight - 200
			let frame = document.getElementById('documentFrame')
			if (frame && frame.style)
				frame.style.height = height + 'px'
		},
		//---------------------------------------------------------------------
		// обработчик события "storage"
		//---------------------------------------------------------------------
		onLocalStorageEvent(event) {
			// только для сотрудников
			if (this.$store.state.user_type !== 'admin') return
			// проверка события
			if (!event || event.key !== '__event' || !event.newValue) return

			if (event.newValue.indexOf('agf1') === 0 ||
				event.newValue.indexOf('agf0') === 0)
			{
				// запрос счетчиков
				this.$store.dispatch('getTicketCounters')
				this.$store.dispatch('getRequestCounter')

				// просто запрашиваем данные заново
				this.requestListData()
			}
		},
		//---------------------------------------------------------------------
		// обработчик события "пришло сообщени от планировщика"
		//---------------------------------------------------------------------
		cronTaskAnswer(data) {
			if (!data || !data.id) return
			const _result = this.vdsCloneFindProcessById(data.id)
			if (!_result || !_result.data || !_result.data.id) return

			// процесс найден
			const _data = _result.data

			if (data.step) _data.step = data.step
			if (data.status) _data.status = data.status
			if (data.error) _data.error = typeof data.error === 'string' ? data.error : this.formatRequestError({ data: data.error })

			if (data.BackupId) _data.BackupId = data.BackupId
			if (data.CopyBackupId) _data.CopyBackupId = data.CopyBackupId
			if (data.CreateVdsId) _data.CreateVdsId = data.CreateVdsId

			this.vdsCloneProcessDataSave(_data)

			if (data.finish)
			{
				_data.finish = data.finish
				this.deleteVdsCloneProcess(data.id)
			}
		},
		//---------------------------------------------------------------------
		// конвертирует функцию в строку
		// что бы развернуть ее внутри планировщика
		//---------------------------------------------------------------------
		functionToString(func) {
			const _fn = func.toString()
			return _fn.substring(_fn.indexOf('{') + 1, _fn.lastIndexOf('}'))
		},
		//---------------------------------------------------------------------
		// берет массив коллбаков и вызывает каждый с удалением из массива
		// данная функция вызывается только при успешном запросе
		//---------------------------------------------------------------------
		afterRequestListData() {
			if (!this.afterRequestDataCallbacks ||
				!this.afterRequestDataCallbacks.length) {
				return
			}

			while (this.afterRequestDataCallbacks.length)
			{
				const callback = this.afterRequestDataCallbacks.pop()
				if (callback && typeof callback === 'function') {
					callback()
				}
			}
		},
		//---------------------------------------------------------------------
		// для определенных crud формирует HTTP-GET параметры
		//---------------------------------------------------------------------
		getAllQueryParams() {
			if (this.crud !== 'ipptrpool' &&
				this.crud !== 'iphistory')
			{
				return ''
			}

			let str = ''
			if (this.$route.query && this.$route.query.id)
			{
				str += '?id=' + this.$route.query.id
			}

			return str
		}
		//---------------------------------------------------------------------
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		filterPeriod,
		filterRadio,
		filterBool,
		filterSelect,
		filterLogs,
		filterLabel,
		filterDisk,
		filterParams,
		paginator,
		dropDownButton,
		oneOperButton,
		Field,
		Money,
		backupDialog,
		calculator,
		rackGraphic,
		radioListComponent,
		viewComponent,
		notice
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-table-wrapper {
	opacity: 1;
}

.w5-table-wrapper-loading {
	opacity: 0.3;
}

.widget-page-size {
	float: right;
}

table {	
	border-collapse: collapse;
	margin: 0;
	padding: 0;
	table-layout: fixed;
	width: 100%;
}
table thead {
	border-bottom: 2px solid #eee;
}

table tr {	
	border-bottom: 1px solid #eee;
}
table th, table td {
	padding: 6px 4px;
	font-size: 13px;
}

table > tbody > tr:nth-of-type(odd) {
	background-color: #fdfdfd;
}

table th {
	font-weight: 500;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

table td {
	vertical-align: top;
}

table .w5-table-cell {
	display: block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-height: 30px;
}

/*===== migrate VDS =====*/
.w5-migrate-wrapper {
	display: flex;
	justify-content: space-between;
	align-items: center;
	-webkit-align-items: center;
	padding: 10px;
	width: 100%;
}

.w5-migrate-vds-list {
	width: 40%;
	min-height: 48px;
	max-height: 252px;
	overflow: auto;
	border: 1px solid #ddd;
	border-radius: 4px;
}

.w5-migrate-arrow {
	padding: 5px 0 5px 5px;
	font-size: 100%;
	color: #3ba3ff;
}
@media screen and (max-width: 767px) {
	.w5-migrate-arrow { margin-top: 10px; font-size: 20px }
}

.w5-migrate-server-list {
	width: 55%;
	min-height: 48px;
}

.w5-migrate-vds-list-item {
	font-size: 90%;
	color: #ccc;
}

.w5-migrate-vds-list-item-selected {
	color: black !important;
}

/*==== TicketMove =====*/
.w5-ticket-move-wrapper {
	display: flex;
	justify-content: space-between;
	align-items: center;
	-webkit-align-items: center;
	padding: 10px;
	width: 100%;
}

.w5-ticket-move-tickets-list {
	width: 40%;
	min-height: 48px;
	max-height: 252px;
	overflow: auto;
	border: 1px solid #ddd;
	border-radius: 4px;
}

.w5-ticket-move-arrow {
	padding: 5px 0 5px 5px;
	font-size: 100%;
	color: #3ba3ff;
}

@media screen and (max-width: 767px) {
	.w5-ticket-move-arrow { margin-top: 10px; font-size: 20px }
}

.w5-ticket-move-departments-list {
	width: 55%;
	min-height: 48px;
}

.w5-ticket-move-tickets-list-item {
	font-size: 90%;
	color: #ccc;
}

.w5-ticket-move-tickets-list-item-selected {
	color: black !important;
}

/*==== ISO ====*/
.w5-eject-iso-button {
	margin-right: 2px;
	height: 18px !important;
	line-height: 18px !important;
	font-size: 10px;
	padding: 0 5px !important;
}

@media screen and (max-width: 767px) {
	table:not(.report-table) thead {
		display: none;
	}	
	table:not(.report-table) tr:first-of-type {		
		border-top: 3px solid #eee;		
	}
	table:not(.report-table) tr {		
		border-bottom: 3px solid #eee;
		display: block;
		font-size: 13px;
	}
	table:not(.report-table) td {
		border-bottom: 1px solid #eee;
		display: block;
		text-align: right;
		font-size: 12px;
		min-height: 45px;
	}
	/* tickets */
	table.w5-ticket-view-table td {
		text-align: inherit;
		min-height: 32px;
	}
	table:not(.report-table) td.w5-column-opers {
		border: none;
	}
	table:not(.report-table) td:before {
		font-weight: bold;
		content: attr(aria-label);
		float: left;
		width: 32%;
		text-align: left;
		font-size: 11px;
	}

	table:not(.report-table) .w5-table-cell {
		display: inline-block;
		width: 65%;
		text-align: left;
		white-space: normal;
	}

	/*
	table td.text-center {
		text-align: center
	}
	*/

	.widget-page-size {
		margin: 30px 0;
		position: absolute;
    	left: 15px;
	}

	.list-total {
		float: left;
	}

	.w5-crud-filter-object, .w5-account-global-filter {
		font-size: 90%;
	}

	.w5-migrate-wrapper, .w5-ticket-move-wrapper {
		flex-direction: column;
	}

	.w5-migrate-vds-list, .w5-migrate-server-list,
	.w5-ticket-move-tickets-list, .w5-ticket-move-departments-list {
		width: 100%;
	}
}

/* баланс партнерки у клиента */
.w5-partner-balance {
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;

	flex-direction: column;
	justify-content: center;

	height: 48px !important;
}

@media screen and (max-width: 767px) {
	.w5-partner-balance {
		font-size: 10px;
	}
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
	.w5-partner-balance {
		font-size: 12px;
	}
}

/* враппер фильтров */
.widgets-filters-wrapper {
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;

    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
}

span.ticket-message-count-badge {
	position: relative;
	font-size: 10px !important;
	font-weight: normal !important;
	background-color: #ccc;
}
span.ticket-message-count-badge.admin {
	cursor: help;
}

/* разрешаем выделение ссылок в таблице со списком */
.w5-table-cell > a, .w5-table-cell > span, .w5-table-cell > div {
	user-select: auto;
}

/* в списке ISO */
.w5-list-iso {
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;	

    justify-content: flex-start;
	-webkit-justify-content: flex-start;
}

/* блок трансфера у клиента */
.w5-transfer-wrapper {
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;	

    justify-content: space-between;
	-webkit-justify-content: space-between;

	margin: 10px 0;
    padding: 10px;
    font-size: 95%;
    border: 1px solid #eee;
    border-radius: 4px;
}

@media screen and (max-width: 767px) {
	.w5-transfer-wrapper {
		flex-direction: column
	}
	/*
	.w5-transfer-wrapper .btn {
		font-size: 10px;		
		height: 24px;
    	line-height: 24px;
	}
	*/
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
	.w5-transfer-wrapper .btn {
		font-size: 12px;
		padding: 0 4px;
	}
}

/* тикеты */
.mark-all-as-readed {
	color: #ccc;
	font-size: 11px;
	transition: color .2s;
	cursor: pointer;
}

.mark-all-as-readed:hover {
	color: green;
}


.remove-all-filters {
	position: relative;
	top: 3px;
	cursor: pointer;
	color: #999;
	transition: all 0.2s;
	font-size: 16px;
}

.remove-all-filters:hover,
.remove-all-filters:focus {
	color: #333;
}

.register-server {
	position: relative;
	top: 7px;
	color: #999;
	font-size: 20px !important;
	font-weight: 500;
	width: 30px;
	text-align: center;
}
.register-server.r_on { margin-right: 10px; }
.register-server.w5-list-button-active {
	cursor: pointer;
}
.register-server > svg {
	position: relative;	
	left: 1px;
	top: 5px;
	margin: 0 !important;
	width: 12px !important;
	height: 12px !important;
}
.register-server > svg.fa-play {
	top: 4px;
	width: 11px !important;
	height: 11px !important;
}

a.payment-link {
	font-size: 12px;
	word-break: break-all;	
    padding: 0;
    font-weight: 500;
    user-select: auto;
}
span.payment-link {
	font-size: 16px;
	color: #ccc;
	margin-left: 10px;
}
p.payment-link {
	font-size: 14px;
	font-weight: 400;
	line-height: 1;
	margin-bottom: 10px;
	color: #333;
}

span.ticket-last-commentator {
	position: fixed;
	padding: 5px 10px;
    border-radius: 4px;
	color: #333;
    font-size: 80%;
    font-weight: 300;
    background: #fff5ee;
    border: 1px solid #f9caa7;
}
span.ticket-last-commentator:after {
	content: ''; 
    position: absolute;
    left: -10px; top: 9px;
    border: 5px solid transparent;
    border-right: 5px solid #f9caa7;
}

.document-wrapper {
	width: 100%;
}

.btn-calc {
	margin-left: 20px;
	padding: 0 20px;
}

@media screen and (max-width: 767px) {
	.btn-calc {
		margin-left: 10px;
		padding: 0 6px !important;
		font-size: 10px !important;
	}
	.btn-client-balance {
		padding: 0 6px !important;
		font-size: 10px !important;
	}
}

@media screen and (max-width: 410px) {
	.btn-calc {
		margin-left: 6px;
		padding: 0 4px !important;
	}
	.btn-client-balance {
		padding: 0 4px !important;
	}
}

.payment-warrning-text {
	color: red;
	font-size: 80%
}

.form-inline.fast-search {
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;
    justify-content: space-between;
	-webkit-justify-content: space-between;
}
.form-inline.fast-search .fast-search-input {
	flex: 0 0 100%;
}
.form-inline.fast-search .fast-search-input.logs {
	flex: 0 0 calc(100% - 200px);
}
.form-inline.fast-search .ip-list-input {
	flex: 0 0 180px;
}

@media screen and (max-width: 767px) {
	.form-inline.fast-search {
		flex-direction: column
	}
	.form-inline.fast-search .ip-list-input {
		flex: 0 0 auto;
	}
}

.vds-clone-processes {
	position: fixed;
	z-index: 9999;
	bottom: 0;
	left: 50%;
	margin-left: -20px;
	width:  40px;
	height: 40px;
	background-color: green;
	cursor: pointer;
	border-radius: 10px 10px 0 0;
	font-size:  11px;
	font-weight: 500;
	text-align: center;
	color:  white;
	padding-top: 12px;
	box-shadow: 0 0 5px rgba(0,0,0,0.5);
}
.vds-clone-processes:before {
	content: "";
	height: 36px;
	width: 36px;
	position: absolute;
	top: calc(50% - 18px);
	left: calc(50% - 18px);
	border-width: 2px;
	border-style: solid;
	border-color: #999 #fff #fff;
	border-radius: 100%;
	animation: _rotation 2s infinite linear;
}
.vds-clone-processes.with-error:before {
	border-color: #999 #d98e8e #d98e8e;
}

@keyframes _rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.vds-clone-process-item {
	display: block;
	position: relative;
	padding: 5px 10px;
}
.vds-clone-process-item__name {
	display: inline-block;
	position: relative;
	line-height: 1;
	width: 29%;
	font-size: 12px;
	font-weight: 500;
	vertical-align: top;
}
.vds-clone-process-item__step {
	display: inline-block;
	position: relative;
	line-height: 1;
	width: 29%;
	font-size: 12px;
	vertical-align: top;
}
.vds-clone-process-item__status {
	display: inline-block;
	position: relative;
	line-height: 1;
	width: 39%;
	font-size: 12px;
	vertical-align: top;
}

.vds-clone-status-in-table {
	display: flex;
	align-content: center;
}
.vds-clone-status-in-table img {
	margin-left: 16px;
	width: 8px;
	height: 8px;
	position: relative;
	top: 2px;
}
.vds-clone-status-in-table .error {
	display: inline-block;
	color: red;
	z-index: 2;
	left: 16px;
	position: relative;
	cursor: pointer;
}

.vds-clone-status {
	display: flex;
	cursor: pointer;
}

.vds-clone-status .fa-server {
	color: #2880da;
	font-size: 10px !important;
}

.w5-application.mc .vds-clone-status .fa-server {
	color: #3250ba;
}

.vds-clone-status .fa-clone {
	color: #33cc66;
	left: 14px !important;
	font-size: 10px !important;
	transform: rotate(45deg);
	top: -6px !important;
}

.screenReaderText { 
  border: 0; 
  clip: rect(0 0 0 0); 
  height: 1px; 
  margin: -1px; 
  overflow: hidden; 
  padding: 0; 
  position: absolute; 
  width: 1px; 
}

</style>



// WEBPACK FOOTER //
// List.vue?00060122